(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // node_modules/jquery/dist/jquery.js
  var require_jquery = __commonJS({
    "node_modules/jquery/dist/jquery.js"(exports, module) {
      (function(global2, factory) {
        if (typeof module === "object" && typeof module.exports === "object") {
          module.exports = global2.document ? factory(global2, true) : function(w) {
            if (!w.document) {
              throw new Error("jQuery requires a window with a document");
            }
            return factory(w);
          };
        } else {
          factory(global2);
        }
      })(typeof window !== "undefined" ? window : exports, function(window2, noGlobal) {
        var deletedIds = [];
        var slice = deletedIds.slice;
        var concat = deletedIds.concat;
        var push = deletedIds.push;
        var indexOf = deletedIds.indexOf;
        var class2type = {};
        var toString = class2type.toString;
        var hasOwn = class2type.hasOwnProperty;
        var support = {};
        var version = "1.11.2", jQuery2 = function(selector, context) {
          return new jQuery2.fn.init(selector, context);
        }, rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, rmsPrefix = /^-ms-/, rdashAlpha = /-([\da-z])/gi, fcamelCase = function(all, letter) {
          return letter.toUpperCase();
        };
        jQuery2.fn = jQuery2.prototype = {
          // The current version of jQuery being used
          jquery: version,
          constructor: jQuery2,
          // Start with an empty selector
          selector: "",
          // The default length of a jQuery object is 0
          length: 0,
          toArray: function() {
            return slice.call(this);
          },
          // Get the Nth element in the matched element set OR
          // Get the whole matched element set as a clean array
          get: function(num) {
            return num != null ? (
              // Return just the one element from the set
              num < 0 ? this[num + this.length] : this[num]
            ) : (
              // Return all the elements in a clean array
              slice.call(this)
            );
          },
          // Take an array of elements and push it onto the stack
          // (returning the new matched element set)
          pushStack: function(elems) {
            var ret = jQuery2.merge(this.constructor(), elems);
            ret.prevObject = this;
            ret.context = this.context;
            return ret;
          },
          // Execute a callback for every element in the matched set.
          // (You can seed the arguments with an array of args, but this is
          // only used internally.)
          each: function(callback, args) {
            return jQuery2.each(this, callback, args);
          },
          map: function(callback) {
            return this.pushStack(jQuery2.map(this, function(elem, i2) {
              return callback.call(elem, i2, elem);
            }));
          },
          slice: function() {
            return this.pushStack(slice.apply(this, arguments));
          },
          first: function() {
            return this.eq(0);
          },
          last: function() {
            return this.eq(-1);
          },
          eq: function(i2) {
            var len = this.length, j = +i2 + (i2 < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
          },
          end: function() {
            return this.prevObject || this.constructor(null);
          },
          // For internal use only.
          // Behaves like an Array's method, not like a jQuery method.
          push,
          sort: deletedIds.sort,
          splice: deletedIds.splice
        };
        jQuery2.extend = jQuery2.fn.extend = function() {
          var src, copyIsArray, copy, name, options, clone, target = arguments[0] || {}, i2 = 1, length = arguments.length, deep = false;
          if (typeof target === "boolean") {
            deep = target;
            target = arguments[i2] || {};
            i2++;
          }
          if (typeof target !== "object" && !jQuery2.isFunction(target)) {
            target = {};
          }
          if (i2 === length) {
            target = this;
            i2--;
          }
          for (; i2 < length; i2++) {
            if ((options = arguments[i2]) != null) {
              for (name in options) {
                src = target[name];
                copy = options[name];
                if (target === copy) {
                  continue;
                }
                if (deep && copy && (jQuery2.isPlainObject(copy) || (copyIsArray = jQuery2.isArray(copy)))) {
                  if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && jQuery2.isArray(src) ? src : [];
                  } else {
                    clone = src && jQuery2.isPlainObject(src) ? src : {};
                  }
                  target[name] = jQuery2.extend(deep, clone, copy);
                } else if (copy !== void 0) {
                  target[name] = copy;
                }
              }
            }
          }
          return target;
        };
        jQuery2.extend({
          // Unique for each copy of jQuery on the page
          expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
          // Assume jQuery is ready without the ready module
          isReady: true,
          error: function(msg) {
            throw new Error(msg);
          },
          noop: function() {
          },
          // See test/unit/core.js for details concerning isFunction.
          // Since version 1.3, DOM methods and functions like alert
          // aren't supported. They return false on IE (#2968).
          isFunction: function(obj) {
            return jQuery2.type(obj) === "function";
          },
          isArray: Array.isArray || function(obj) {
            return jQuery2.type(obj) === "array";
          },
          isWindow: function(obj) {
            return obj != null && obj == obj.window;
          },
          isNumeric: function(obj) {
            return !jQuery2.isArray(obj) && obj - parseFloat(obj) + 1 >= 0;
          },
          isEmptyObject: function(obj) {
            var name;
            for (name in obj) {
              return false;
            }
            return true;
          },
          isPlainObject: function(obj) {
            var key;
            if (!obj || jQuery2.type(obj) !== "object" || obj.nodeType || jQuery2.isWindow(obj)) {
              return false;
            }
            try {
              if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
                return false;
              }
            } catch (e) {
              return false;
            }
            if (support.ownLast) {
              for (key in obj) {
                return hasOwn.call(obj, key);
              }
            }
            for (key in obj) {
            }
            return key === void 0 || hasOwn.call(obj, key);
          },
          type: function(obj) {
            if (obj == null) {
              return obj + "";
            }
            return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
          },
          // Evaluates a script in a global context
          // Workarounds based on findings by Jim Driscoll
          // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
          globalEval: function(data) {
            if (data && jQuery2.trim(data)) {
              (window2.execScript || function(data2) {
                window2["eval"].call(window2, data2);
              })(data);
            }
          },
          // Convert dashed to camelCase; used by the css and data modules
          // Microsoft forgot to hump their vendor prefix (#9572)
          camelCase: function(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
          },
          nodeName: function(elem, name) {
            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
          },
          // args is for internal usage only
          each: function(obj, callback, args) {
            var value, i2 = 0, length = obj.length, isArray = isArraylike(obj);
            if (args) {
              if (isArray) {
                for (; i2 < length; i2++) {
                  value = callback.apply(obj[i2], args);
                  if (value === false) {
                    break;
                  }
                }
              } else {
                for (i2 in obj) {
                  value = callback.apply(obj[i2], args);
                  if (value === false) {
                    break;
                  }
                }
              }
            } else {
              if (isArray) {
                for (; i2 < length; i2++) {
                  value = callback.call(obj[i2], i2, obj[i2]);
                  if (value === false) {
                    break;
                  }
                }
              } else {
                for (i2 in obj) {
                  value = callback.call(obj[i2], i2, obj[i2]);
                  if (value === false) {
                    break;
                  }
                }
              }
            }
            return obj;
          },
          // Support: Android<4.1, IE<9
          trim: function(text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
          },
          // results is for internal usage only
          makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
              if (isArraylike(Object(arr))) {
                jQuery2.merge(
                  ret,
                  typeof arr === "string" ? [arr] : arr
                );
              } else {
                push.call(ret, arr);
              }
            }
            return ret;
          },
          inArray: function(elem, arr, i2) {
            var len;
            if (arr) {
              if (indexOf) {
                return indexOf.call(arr, elem, i2);
              }
              len = arr.length;
              i2 = i2 ? i2 < 0 ? Math.max(0, len + i2) : i2 : 0;
              for (; i2 < len; i2++) {
                if (i2 in arr && arr[i2] === elem) {
                  return i2;
                }
              }
            }
            return -1;
          },
          merge: function(first, second) {
            var len = +second.length, j = 0, i2 = first.length;
            while (j < len) {
              first[i2++] = second[j++];
            }
            if (len !== len) {
              while (second[j] !== void 0) {
                first[i2++] = second[j++];
              }
            }
            first.length = i2;
            return first;
          },
          grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i2 = 0, length = elems.length, callbackExpect = !invert;
            for (; i2 < length; i2++) {
              callbackInverse = !callback(elems[i2], i2);
              if (callbackInverse !== callbackExpect) {
                matches.push(elems[i2]);
              }
            }
            return matches;
          },
          // arg is for internal usage only
          map: function(elems, callback, arg) {
            var value, i2 = 0, length = elems.length, isArray = isArraylike(elems), ret = [];
            if (isArray) {
              for (; i2 < length; i2++) {
                value = callback(elems[i2], i2, arg);
                if (value != null) {
                  ret.push(value);
                }
              }
            } else {
              for (i2 in elems) {
                value = callback(elems[i2], i2, arg);
                if (value != null) {
                  ret.push(value);
                }
              }
            }
            return concat.apply([], ret);
          },
          // A global GUID counter for objects
          guid: 1,
          // Bind a function to a context, optionally partially applying any
          // arguments.
          proxy: function(fn, context) {
            var args, proxy, tmp;
            if (typeof context === "string") {
              tmp = fn[context];
              context = fn;
              fn = tmp;
            }
            if (!jQuery2.isFunction(fn)) {
              return void 0;
            }
            args = slice.call(arguments, 2);
            proxy = function() {
              return fn.apply(context || this, args.concat(slice.call(arguments)));
            };
            proxy.guid = fn.guid = fn.guid || jQuery2.guid++;
            return proxy;
          },
          now: function() {
            return +/* @__PURE__ */ new Date();
          },
          // jQuery.support is not used in Core but other projects attach their
          // properties to it so it needs to exist.
          support
        });
        jQuery2.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i2, name) {
          class2type["[object " + name + "]"] = name.toLowerCase();
        });
        function isArraylike(obj) {
          var length = obj.length, type = jQuery2.type(obj);
          if (type === "function" || jQuery2.isWindow(obj)) {
            return false;
          }
          if (obj.nodeType === 1 && length) {
            return true;
          }
          return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
        }
        var Sizzle = (
          /*!
           * Sizzle CSS Selector Engine v2.2.0-pre
           * http://sizzlejs.com/
           *
           * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
           * Released under the MIT license
           * http://jquery.org/license
           *
           * Date: 2014-12-16
           */
          function(window3) {
            var i2, support2, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document3, docElem2, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, expando = "sizzle" + 1 * /* @__PURE__ */ new Date(), preferredDoc = window3.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function(a, b) {
              if (a === b) {
                hasDuplicate = true;
              }
              return 0;
            }, MAX_NEGATIVE = 1 << 31, hasOwn2 = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push2 = arr.push, slice2 = arr.slice, indexOf2 = function(list, elem) {
              var i3 = 0, len = list.length;
              for (; i3 < len; i3++) {
                if (list[i3] === elem) {
                  return i3;
                }
              }
              return -1;
            }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", whitespace = "[\\x20\\t\\r\\n\\f]", characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", identifier = characterEncoding.replace("w", "w#"), attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace + // Operator (capture 2)
            "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
            `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + characterEncoding + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rtrim2 = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rattributeQuotes = new RegExp("=" + whitespace + `*([^\\]'"]*?)` + whitespace + "*\\]", "g"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
              "ID": new RegExp("^#(" + characterEncoding + ")"),
              "CLASS": new RegExp("^\\.(" + characterEncoding + ")"),
              "TAG": new RegExp("^(" + characterEncoding.replace("w", "w*") + ")"),
              "ATTR": new RegExp("^" + attributes),
              "PSEUDO": new RegExp("^" + pseudos),
              "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
              "bool": new RegExp("^(?:" + booleans + ")$", "i"),
              // For use in libraries implementing .is()
              // We use this for POS matching in `select`
              "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
            }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"), funescape = function(_, escaped, escapedWhitespace) {
              var high = "0x" + escaped - 65536;
              return high !== high || escapedWhitespace ? escaped : high < 0 ? (
                // BMP codepoint
                String.fromCharCode(high + 65536)
              ) : (
                // Supplemental Plane codepoint (surrogate pair)
                String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320)
              );
            }, unloadHandler = function() {
              setDocument();
            };
            try {
              push2.apply(
                arr = slice2.call(preferredDoc.childNodes),
                preferredDoc.childNodes
              );
              arr[preferredDoc.childNodes.length].nodeType;
            } catch (e) {
              push2 = {
                apply: arr.length ? (
                  // Leverage slice if possible
                  function(target, els) {
                    push_native.apply(target, slice2.call(els));
                  }
                ) : (
                  // Support: IE<9
                  // Otherwise append directly
                  function(target, els) {
                    var j = target.length, i3 = 0;
                    while (target[j++] = els[i3++]) {
                    }
                    target.length = j - 1;
                  }
                )
              };
            }
            function Sizzle2(selector, context, results, seed) {
              var match, elem, m, nodeType, i3, groups, old, nid, newContext, newSelector;
              if ((context ? context.ownerDocument || context : preferredDoc) !== document3) {
                setDocument(context);
              }
              context = context || document3;
              results = results || [];
              nodeType = context.nodeType;
              if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
                return results;
              }
              if (!seed && documentIsHTML) {
                if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
                  if (m = match[1]) {
                    if (nodeType === 9) {
                      elem = context.getElementById(m);
                      if (elem && elem.parentNode) {
                        if (elem.id === m) {
                          results.push(elem);
                          return results;
                        }
                      } else {
                        return results;
                      }
                    } else {
                      if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains(context, elem) && elem.id === m) {
                        results.push(elem);
                        return results;
                      }
                    }
                  } else if (match[2]) {
                    push2.apply(results, context.getElementsByTagName(selector));
                    return results;
                  } else if ((m = match[3]) && support2.getElementsByClassName) {
                    push2.apply(results, context.getElementsByClassName(m));
                    return results;
                  }
                }
                if (support2.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                  nid = old = expando;
                  newContext = context;
                  newSelector = nodeType !== 1 && selector;
                  if (nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
                    groups = tokenize(selector);
                    if (old = context.getAttribute("id")) {
                      nid = old.replace(rescape, "\\$&");
                    } else {
                      context.setAttribute("id", nid);
                    }
                    nid = "[id='" + nid + "'] ";
                    i3 = groups.length;
                    while (i3--) {
                      groups[i3] = nid + toSelector(groups[i3]);
                    }
                    newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                    newSelector = groups.join(",");
                  }
                  if (newSelector) {
                    try {
                      push2.apply(
                        results,
                        newContext.querySelectorAll(newSelector)
                      );
                      return results;
                    } catch (qsaError) {
                    } finally {
                      if (!old) {
                        context.removeAttribute("id");
                      }
                    }
                  }
                }
              }
              return select(selector.replace(rtrim2, "$1"), context, results, seed);
            }
            function createCache() {
              var keys = [];
              function cache(key, value) {
                if (keys.push(key + " ") > Expr.cacheLength) {
                  delete cache[keys.shift()];
                }
                return cache[key + " "] = value;
              }
              return cache;
            }
            function markFunction(fn) {
              fn[expando] = true;
              return fn;
            }
            function assert(fn) {
              var div = document3.createElement("div");
              try {
                return !!fn(div);
              } catch (e) {
                return false;
              } finally {
                if (div.parentNode) {
                  div.parentNode.removeChild(div);
                }
                div = null;
              }
            }
            function addHandle(attrs, handler) {
              var arr2 = attrs.split("|"), i3 = attrs.length;
              while (i3--) {
                Expr.attrHandle[arr2[i3]] = handler;
              }
            }
            function siblingCheck(a, b) {
              var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
              if (diff) {
                return diff;
              }
              if (cur) {
                while (cur = cur.nextSibling) {
                  if (cur === b) {
                    return -1;
                  }
                }
              }
              return a ? 1 : -1;
            }
            function createInputPseudo(type) {
              return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
              };
            }
            function createButtonPseudo(type) {
              return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
              };
            }
            function createPositionalPseudo(fn) {
              return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches2) {
                  var j, matchIndexes = fn([], seed.length, argument), i3 = matchIndexes.length;
                  while (i3--) {
                    if (seed[j = matchIndexes[i3]]) {
                      seed[j] = !(matches2[j] = seed[j]);
                    }
                  }
                });
              });
            }
            function testContext(context) {
              return context && typeof context.getElementsByTagName !== "undefined" && context;
            }
            support2 = Sizzle2.support = {};
            isXML = Sizzle2.isXML = function(elem) {
              var documentElement = elem && (elem.ownerDocument || elem).documentElement;
              return documentElement ? documentElement.nodeName !== "HTML" : false;
            };
            setDocument = Sizzle2.setDocument = function(node) {
              var hasCompare, parent, doc = node ? node.ownerDocument || node : preferredDoc;
              if (doc === document3 || doc.nodeType !== 9 || !doc.documentElement) {
                return document3;
              }
              document3 = doc;
              docElem2 = doc.documentElement;
              parent = doc.defaultView;
              if (parent && parent !== parent.top) {
                if (parent.addEventListener) {
                  parent.addEventListener("unload", unloadHandler, false);
                } else if (parent.attachEvent) {
                  parent.attachEvent("onunload", unloadHandler);
                }
              }
              documentIsHTML = !isXML(doc);
              support2.attributes = assert(function(div) {
                div.className = "i";
                return !div.getAttribute("className");
              });
              support2.getElementsByTagName = assert(function(div) {
                div.appendChild(doc.createComment(""));
                return !div.getElementsByTagName("*").length;
              });
              support2.getElementsByClassName = rnative.test(doc.getElementsByClassName);
              support2.getById = assert(function(div) {
                docElem2.appendChild(div).id = expando;
                return !doc.getElementsByName || !doc.getElementsByName(expando).length;
              });
              if (support2.getById) {
                Expr.find["ID"] = function(id, context) {
                  if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var m = context.getElementById(id);
                    return m && m.parentNode ? [m] : [];
                  }
                };
                Expr.filter["ID"] = function(id) {
                  var attrId = id.replace(runescape, funescape);
                  return function(elem) {
                    return elem.getAttribute("id") === attrId;
                  };
                };
              } else {
                delete Expr.find["ID"];
                Expr.filter["ID"] = function(id) {
                  var attrId = id.replace(runescape, funescape);
                  return function(elem) {
                    var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                    return node2 && node2.value === attrId;
                  };
                };
              }
              Expr.find["TAG"] = support2.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") {
                  return context.getElementsByTagName(tag);
                } else if (support2.qsa) {
                  return context.querySelectorAll(tag);
                }
              } : function(tag, context) {
                var elem, tmp = [], i3 = 0, results = context.getElementsByTagName(tag);
                if (tag === "*") {
                  while (elem = results[i3++]) {
                    if (elem.nodeType === 1) {
                      tmp.push(elem);
                    }
                  }
                  return tmp;
                }
                return results;
              };
              Expr.find["CLASS"] = support2.getElementsByClassName && function(className, context) {
                if (documentIsHTML) {
                  return context.getElementsByClassName(className);
                }
              };
              rbuggyMatches = [];
              rbuggyQSA = [];
              if (support2.qsa = rnative.test(doc.querySelectorAll)) {
                assert(function(div) {
                  docElem2.appendChild(div).innerHTML = "<a id='" + expando + "'></a><select id='" + expando + "-\f]' msallowcapture=''><option selected=''></option></select>";
                  if (div.querySelectorAll("[msallowcapture^='']").length) {
                    rbuggyQSA.push("[*^$]=" + whitespace + `*(?:''|"")`);
                  }
                  if (!div.querySelectorAll("[selected]").length) {
                    rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                  }
                  if (!div.querySelectorAll("[id~=" + expando + "-]").length) {
                    rbuggyQSA.push("~=");
                  }
                  if (!div.querySelectorAll(":checked").length) {
                    rbuggyQSA.push(":checked");
                  }
                  if (!div.querySelectorAll("a#" + expando + "+*").length) {
                    rbuggyQSA.push(".#.+[+~]");
                  }
                });
                assert(function(div) {
                  var input = doc.createElement("input");
                  input.setAttribute("type", "hidden");
                  div.appendChild(input).setAttribute("name", "D");
                  if (div.querySelectorAll("[name=d]").length) {
                    rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                  }
                  if (!div.querySelectorAll(":enabled").length) {
                    rbuggyQSA.push(":enabled", ":disabled");
                  }
                  div.querySelectorAll("*,:x");
                  rbuggyQSA.push(",.*:");
                });
              }
              if (support2.matchesSelector = rnative.test(matches = docElem2.matches || docElem2.webkitMatchesSelector || docElem2.mozMatchesSelector || docElem2.oMatchesSelector || docElem2.msMatchesSelector)) {
                assert(function(div) {
                  support2.disconnectedMatch = matches.call(div, "div");
                  matches.call(div, "[s!='']:x");
                  rbuggyMatches.push("!=", pseudos);
                });
              }
              rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
              rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
              hasCompare = rnative.test(docElem2.compareDocumentPosition);
              contains = hasCompare || rnative.test(docElem2.contains) ? function(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
              } : function(a, b) {
                if (b) {
                  while (b = b.parentNode) {
                    if (b === a) {
                      return true;
                    }
                  }
                }
                return false;
              };
              sortOrder = hasCompare ? function(a, b) {
                if (a === b) {
                  hasDuplicate = true;
                  return 0;
                }
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) {
                  return compare;
                }
                compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : (
                  // Otherwise we know they are disconnected
                  1
                );
                if (compare & 1 || !support2.sortDetached && b.compareDocumentPosition(a) === compare) {
                  if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
                    return -1;
                  }
                  if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
                    return 1;
                  }
                  return sortInput ? indexOf2(sortInput, a) - indexOf2(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
              } : function(a, b) {
                if (a === b) {
                  hasDuplicate = true;
                  return 0;
                }
                var cur, i3 = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
                if (!aup || !bup) {
                  return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf2(sortInput, a) - indexOf2(sortInput, b) : 0;
                } else if (aup === bup) {
                  return siblingCheck(a, b);
                }
                cur = a;
                while (cur = cur.parentNode) {
                  ap.unshift(cur);
                }
                cur = b;
                while (cur = cur.parentNode) {
                  bp.unshift(cur);
                }
                while (ap[i3] === bp[i3]) {
                  i3++;
                }
                return i3 ? (
                  // Do a sibling check if the nodes have a common ancestor
                  siblingCheck(ap[i3], bp[i3])
                ) : (
                  // Otherwise nodes in our document sort first
                  ap[i3] === preferredDoc ? -1 : bp[i3] === preferredDoc ? 1 : 0
                );
              };
              return doc;
            };
            Sizzle2.matches = function(expr, elements) {
              return Sizzle2(expr, null, null, elements);
            };
            Sizzle2.matchesSelector = function(elem, expr) {
              if ((elem.ownerDocument || elem) !== document3) {
                setDocument(elem);
              }
              expr = expr.replace(rattributeQuotes, "='$1']");
              if (support2.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
                try {
                  var ret = matches.call(elem, expr);
                  if (ret || support2.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                  // fragment in IE 9
                  elem.document && elem.document.nodeType !== 11) {
                    return ret;
                  }
                } catch (e) {
                }
              }
              return Sizzle2(expr, document3, null, [elem]).length > 0;
            };
            Sizzle2.contains = function(context, elem) {
              if ((context.ownerDocument || context) !== document3) {
                setDocument(context);
              }
              return contains(context, elem);
            };
            Sizzle2.attr = function(elem, name) {
              if ((elem.ownerDocument || elem) !== document3) {
                setDocument(elem);
              }
              var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn2.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : void 0;
              return val !== void 0 ? val : support2.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
            };
            Sizzle2.error = function(msg) {
              throw new Error("Syntax error, unrecognized expression: " + msg);
            };
            Sizzle2.uniqueSort = function(results) {
              var elem, duplicates = [], j = 0, i3 = 0;
              hasDuplicate = !support2.detectDuplicates;
              sortInput = !support2.sortStable && results.slice(0);
              results.sort(sortOrder);
              if (hasDuplicate) {
                while (elem = results[i3++]) {
                  if (elem === results[i3]) {
                    j = duplicates.push(i3);
                  }
                }
                while (j--) {
                  results.splice(duplicates[j], 1);
                }
              }
              sortInput = null;
              return results;
            };
            getText = Sizzle2.getText = function(elem) {
              var node, ret = "", i3 = 0, nodeType = elem.nodeType;
              if (!nodeType) {
                while (node = elem[i3++]) {
                  ret += getText(node);
                }
              } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                if (typeof elem.textContent === "string") {
                  return elem.textContent;
                } else {
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    ret += getText(elem);
                  }
                }
              } else if (nodeType === 3 || nodeType === 4) {
                return elem.nodeValue;
              }
              return ret;
            };
            Expr = Sizzle2.selectors = {
              // Can be adjusted by the user
              cacheLength: 50,
              createPseudo: markFunction,
              match: matchExpr,
              attrHandle: {},
              find: {},
              relative: {
                ">": { dir: "parentNode", first: true },
                " ": { dir: "parentNode" },
                "+": { dir: "previousSibling", first: true },
                "~": { dir: "previousSibling" }
              },
              preFilter: {
                "ATTR": function(match) {
                  match[1] = match[1].replace(runescape, funescape);
                  match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                  if (match[2] === "~=") {
                    match[3] = " " + match[3] + " ";
                  }
                  return match.slice(0, 4);
                },
                "CHILD": function(match) {
                  match[1] = match[1].toLowerCase();
                  if (match[1].slice(0, 3) === "nth") {
                    if (!match[3]) {
                      Sizzle2.error(match[0]);
                    }
                    match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                    match[5] = +(match[7] + match[8] || match[3] === "odd");
                  } else if (match[3]) {
                    Sizzle2.error(match[0]);
                  }
                  return match;
                },
                "PSEUDO": function(match) {
                  var excess, unquoted = !match[6] && match[2];
                  if (matchExpr["CHILD"].test(match[0])) {
                    return null;
                  }
                  if (match[3]) {
                    match[2] = match[4] || match[5] || "";
                  } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                  (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                  (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                    match[0] = match[0].slice(0, excess);
                    match[2] = unquoted.slice(0, excess);
                  }
                  return match.slice(0, 3);
                }
              },
              filter: {
                "TAG": function(nodeNameSelector) {
                  var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                  return nodeNameSelector === "*" ? function() {
                    return true;
                  } : function(elem) {
                    return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                  };
                },
                "CLASS": function(className) {
                  var pattern = classCache[className + " "];
                  return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                  });
                },
                "ATTR": function(name, operator, check) {
                  return function(elem) {
                    var result = Sizzle2.attr(elem, name);
                    if (result == null) {
                      return operator === "!=";
                    }
                    if (!operator) {
                      return true;
                    }
                    result += "";
                    return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                  };
                },
                "CHILD": function(type, what, argument, first, last) {
                  var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                  return first === 1 && last === 0 ? (
                    // Shortcut for :nth-*(n)
                    function(elem) {
                      return !!elem.parentNode;
                    }
                  ) : function(elem, context, xml) {
                    var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
                    if (parent) {
                      if (simple) {
                        while (dir) {
                          node = elem;
                          while (node = node[dir]) {
                            if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                              return false;
                            }
                          }
                          start = dir = type === "only" && !start && "nextSibling";
                        }
                        return true;
                      }
                      start = [forward ? parent.firstChild : parent.lastChild];
                      if (forward && useCache) {
                        outerCache = parent[expando] || (parent[expando] = {});
                        cache = outerCache[type] || [];
                        nodeIndex = cache[0] === dirruns && cache[1];
                        diff = cache[0] === dirruns && cache[2];
                        node = nodeIndex && parent.childNodes[nodeIndex];
                        while (node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                        (diff = nodeIndex = 0) || start.pop()) {
                          if (node.nodeType === 1 && ++diff && node === elem) {
                            outerCache[type] = [dirruns, nodeIndex, diff];
                            break;
                          }
                        }
                      } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
                        diff = cache[1];
                      } else {
                        while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                          if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                            if (useCache) {
                              (node[expando] || (node[expando] = {}))[type] = [dirruns, diff];
                            }
                            if (node === elem) {
                              break;
                            }
                          }
                        }
                      }
                      diff -= last;
                      return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                  };
                },
                "PSEUDO": function(pseudo, argument) {
                  var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle2.error("unsupported pseudo: " + pseudo);
                  if (fn[expando]) {
                    return fn(argument);
                  }
                  if (fn.length > 1) {
                    args = [pseudo, pseudo, "", argument];
                    return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
                      var idx, matched = fn(seed, argument), i3 = matched.length;
                      while (i3--) {
                        idx = indexOf2(seed, matched[i3]);
                        seed[idx] = !(matches2[idx] = matched[i3]);
                      }
                    }) : function(elem) {
                      return fn(elem, 0, args);
                    };
                  }
                  return fn;
                }
              },
              pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                  var input = [], results = [], matcher = compile(selector.replace(rtrim2, "$1"));
                  return matcher[expando] ? markFunction(function(seed, matches2, context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i3 = seed.length;
                    while (i3--) {
                      if (elem = unmatched[i3]) {
                        seed[i3] = !(matches2[i3] = elem);
                      }
                    }
                  }) : function(elem, context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    input[0] = null;
                    return !results.pop();
                  };
                }),
                "has": markFunction(function(selector) {
                  return function(elem) {
                    return Sizzle2(selector, elem).length > 0;
                  };
                }),
                "contains": markFunction(function(text) {
                  text = text.replace(runescape, funescape);
                  return function(elem) {
                    return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
                  };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                  if (!ridentifier.test(lang || "")) {
                    Sizzle2.error("unsupported lang: " + lang);
                  }
                  lang = lang.replace(runescape, funescape).toLowerCase();
                  return function(elem) {
                    var elemLang;
                    do {
                      if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                      }
                    } while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                  };
                }),
                // Miscellaneous
                "target": function(elem) {
                  var hash = window3.location && window3.location.hash;
                  return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                  return elem === docElem2;
                },
                "focus": function(elem) {
                  return elem === document3.activeElement && (!document3.hasFocus || document3.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": function(elem) {
                  return elem.disabled === false;
                },
                "disabled": function(elem) {
                  return elem.disabled === true;
                },
                "checked": function(elem) {
                  var nodeName = elem.nodeName.toLowerCase();
                  return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                  if (elem.parentNode) {
                    elem.parentNode.selectedIndex;
                  }
                  return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    if (elem.nodeType < 6) {
                      return false;
                    }
                  }
                  return true;
                },
                "parent": function(elem) {
                  return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                  return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                  return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                  var name = elem.nodeName.toLowerCase();
                  return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                  var attr;
                  return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                  // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                  ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                  return [0];
                }),
                "last": createPositionalPseudo(function(matchIndexes, length) {
                  return [length - 1];
                }),
                "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
                  return [argument < 0 ? argument + length : argument];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                  var i3 = 0;
                  for (; i3 < length; i3 += 2) {
                    matchIndexes.push(i3);
                  }
                  return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                  var i3 = 1;
                  for (; i3 < length; i3 += 2) {
                    matchIndexes.push(i3);
                  }
                  return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                  var i3 = argument < 0 ? argument + length : argument;
                  for (; --i3 >= 0; ) {
                    matchIndexes.push(i3);
                  }
                  return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                  var i3 = argument < 0 ? argument + length : argument;
                  for (; ++i3 < length; ) {
                    matchIndexes.push(i3);
                  }
                  return matchIndexes;
                })
              }
            };
            Expr.pseudos["nth"] = Expr.pseudos["eq"];
            for (i2 in { radio: true, checkbox: true, file: true, password: true, image: true }) {
              Expr.pseudos[i2] = createInputPseudo(i2);
            }
            for (i2 in { submit: true, reset: true }) {
              Expr.pseudos[i2] = createButtonPseudo(i2);
            }
            function setFilters() {
            }
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();
            tokenize = Sizzle2.tokenize = function(selector, parseOnly) {
              var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
              if (cached) {
                return parseOnly ? 0 : cached.slice(0);
              }
              soFar = selector;
              groups = [];
              preFilters = Expr.preFilter;
              while (soFar) {
                if (!matched || (match = rcomma.exec(soFar))) {
                  if (match) {
                    soFar = soFar.slice(match[0].length) || soFar;
                  }
                  groups.push(tokens = []);
                }
                matched = false;
                if (match = rcombinators.exec(soFar)) {
                  matched = match.shift();
                  tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrim2, " ")
                  });
                  soFar = soFar.slice(matched.length);
                }
                for (type in Expr.filter) {
                  if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,
                      type,
                      matches: match
                    });
                    soFar = soFar.slice(matched.length);
                  }
                }
                if (!matched) {
                  break;
                }
              }
              return parseOnly ? soFar.length : soFar ? Sizzle2.error(selector) : (
                // Cache the tokens
                tokenCache(selector, groups).slice(0)
              );
            };
            function toSelector(tokens) {
              var i3 = 0, len = tokens.length, selector = "";
              for (; i3 < len; i3++) {
                selector += tokens[i3].value;
              }
              return selector;
            }
            function addCombinator(matcher, combinator, base) {
              var dir = combinator.dir, checkNonElements = base && dir === "parentNode", doneName = done++;
              return combinator.first ? (
                // Check against closest ancestor/preceding element
                function(elem, context, xml) {
                  while (elem = elem[dir]) {
                    if (elem.nodeType === 1 || checkNonElements) {
                      return matcher(elem, context, xml);
                    }
                  }
                }
              ) : (
                // Check against all ancestor/preceding elements
                function(elem, context, xml) {
                  var oldCache, outerCache, newCache = [dirruns, doneName];
                  if (xml) {
                    while (elem = elem[dir]) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) {
                          return true;
                        }
                      }
                    }
                  } else {
                    while (elem = elem[dir]) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                          return newCache[2] = oldCache[2];
                        } else {
                          outerCache[dir] = newCache;
                          if (newCache[2] = matcher(elem, context, xml)) {
                            return true;
                          }
                        }
                      }
                    }
                  }
                }
              );
            }
            function elementMatcher(matchers) {
              return matchers.length > 1 ? function(elem, context, xml) {
                var i3 = matchers.length;
                while (i3--) {
                  if (!matchers[i3](elem, context, xml)) {
                    return false;
                  }
                }
                return true;
              } : matchers[0];
            }
            function multipleContexts(selector, contexts, results) {
              var i3 = 0, len = contexts.length;
              for (; i3 < len; i3++) {
                Sizzle2(selector, contexts[i3], results);
              }
              return results;
            }
            function condense(unmatched, map, filter, context, xml) {
              var elem, newUnmatched = [], i3 = 0, len = unmatched.length, mapped = map != null;
              for (; i3 < len; i3++) {
                if (elem = unmatched[i3]) {
                  if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) {
                      map.push(i3);
                    }
                  }
                }
              }
              return newUnmatched;
            }
            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
              if (postFilter && !postFilter[expando]) {
                postFilter = setMatcher(postFilter);
              }
              if (postFinder && !postFinder[expando]) {
                postFinder = setMatcher(postFinder, postSelector);
              }
              return markFunction(function(seed, results, context, xml) {
                var temp, i3, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? (
                  // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                  postFinder || (seed ? preFilter : preexisting || postFilter) ? (
                    // ...intermediate processing is necessary
                    []
                  ) : (
                    // ...otherwise use results directly
                    results
                  )
                ) : matcherIn;
                if (matcher) {
                  matcher(matcherIn, matcherOut, context, xml);
                }
                if (postFilter) {
                  temp = condense(matcherOut, postMap);
                  postFilter(temp, [], context, xml);
                  i3 = temp.length;
                  while (i3--) {
                    if (elem = temp[i3]) {
                      matcherOut[postMap[i3]] = !(matcherIn[postMap[i3]] = elem);
                    }
                  }
                }
                if (seed) {
                  if (postFinder || preFilter) {
                    if (postFinder) {
                      temp = [];
                      i3 = matcherOut.length;
                      while (i3--) {
                        if (elem = matcherOut[i3]) {
                          temp.push(matcherIn[i3] = elem);
                        }
                      }
                      postFinder(null, matcherOut = [], temp, xml);
                    }
                    i3 = matcherOut.length;
                    while (i3--) {
                      if ((elem = matcherOut[i3]) && (temp = postFinder ? indexOf2(seed, elem) : preMap[i3]) > -1) {
                        seed[temp] = !(results[temp] = elem);
                      }
                    }
                  }
                } else {
                  matcherOut = condense(
                    matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
                  );
                  if (postFinder) {
                    postFinder(null, results, matcherOut, xml);
                  } else {
                    push2.apply(results, matcherOut);
                  }
                }
              });
            }
            function matcherFromTokens(tokens) {
              var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i3 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
                return elem === checkContext;
              }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf2(checkContext, elem) > -1;
              }, implicitRelative, true), matchers = [function(elem, context, xml) {
                var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                checkContext = null;
                return ret;
              }];
              for (; i3 < len; i3++) {
                if (matcher = Expr.relative[tokens[i3].type]) {
                  matchers = [addCombinator(elementMatcher(matchers), matcher)];
                } else {
                  matcher = Expr.filter[tokens[i3].type].apply(null, tokens[i3].matches);
                  if (matcher[expando]) {
                    j = ++i3;
                    for (; j < len; j++) {
                      if (Expr.relative[tokens[j].type]) {
                        break;
                      }
                    }
                    return setMatcher(
                      i3 > 1 && elementMatcher(matchers),
                      i3 > 1 && toSelector(
                        // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                        tokens.slice(0, i3 - 1).concat({ value: tokens[i3 - 2].type === " " ? "*" : "" })
                      ).replace(rtrim2, "$1"),
                      matcher,
                      i3 < j && matcherFromTokens(tokens.slice(i3, j)),
                      j < len && matcherFromTokens(tokens = tokens.slice(j)),
                      j < len && toSelector(tokens)
                    );
                  }
                  matchers.push(matcher);
                }
              }
              return elementMatcher(matchers);
            }
            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
              var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i3 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find["TAG"]("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) {
                  outermostContext = context !== document3 && context;
                }
                for (; i3 !== len && (elem = elems[i3]) != null; i3++) {
                  if (byElement && elem) {
                    j = 0;
                    while (matcher = elementMatchers[j++]) {
                      if (matcher(elem, context, xml)) {
                        results.push(elem);
                        break;
                      }
                    }
                    if (outermost) {
                      dirruns = dirrunsUnique;
                    }
                  }
                  if (bySet) {
                    if (elem = !matcher && elem) {
                      matchedCount--;
                    }
                    if (seed) {
                      unmatched.push(elem);
                    }
                  }
                }
                matchedCount += i3;
                if (bySet && i3 !== matchedCount) {
                  j = 0;
                  while (matcher = setMatchers[j++]) {
                    matcher(unmatched, setMatched, context, xml);
                  }
                  if (seed) {
                    if (matchedCount > 0) {
                      while (i3--) {
                        if (!(unmatched[i3] || setMatched[i3])) {
                          setMatched[i3] = pop.call(results);
                        }
                      }
                    }
                    setMatched = condense(setMatched);
                  }
                  push2.apply(results, setMatched);
                  if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                    Sizzle2.uniqueSort(results);
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                  outermostContext = contextBackup;
                }
                return unmatched;
              };
              return bySet ? markFunction(superMatcher) : superMatcher;
            }
            compile = Sizzle2.compile = function(selector, match) {
              var i3, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
              if (!cached) {
                if (!match) {
                  match = tokenize(selector);
                }
                i3 = match.length;
                while (i3--) {
                  cached = matcherFromTokens(match[i3]);
                  if (cached[expando]) {
                    setMatchers.push(cached);
                  } else {
                    elementMatchers.push(cached);
                  }
                }
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                cached.selector = selector;
              }
              return cached;
            };
            select = Sizzle2.select = function(selector, context, results, seed) {
              var i3, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
              results = results || [];
              if (match.length === 1) {
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support2.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                  context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                  if (!context) {
                    return results;
                  } else if (compiled) {
                    context = context.parentNode;
                  }
                  selector = selector.slice(tokens.shift().value.length);
                }
                i3 = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while (i3--) {
                  token = tokens[i3];
                  if (Expr.relative[type = token.type]) {
                    break;
                  }
                  if (find = Expr.find[type]) {
                    if (seed = find(
                      token.matches[0].replace(runescape, funescape),
                      rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
                    )) {
                      tokens.splice(i3, 1);
                      selector = seed.length && toSelector(tokens);
                      if (!selector) {
                        push2.apply(results, seed);
                        return results;
                      }
                      break;
                    }
                  }
                }
              }
              (compiled || compile(selector, match))(
                seed,
                context,
                !documentIsHTML,
                results,
                rsibling.test(selector) && testContext(context.parentNode) || context
              );
              return results;
            };
            support2.sortStable = expando.split("").sort(sortOrder).join("") === expando;
            support2.detectDuplicates = !!hasDuplicate;
            setDocument();
            support2.sortDetached = assert(function(div1) {
              return div1.compareDocumentPosition(document3.createElement("div")) & 1;
            });
            if (!assert(function(div) {
              div.innerHTML = "<a href='#'></a>";
              return div.firstChild.getAttribute("href") === "#";
            })) {
              addHandle("type|href|height|width", function(elem, name, isXML2) {
                if (!isXML2) {
                  return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
                }
              });
            }
            if (!support2.attributes || !assert(function(div) {
              div.innerHTML = "<input/>";
              div.firstChild.setAttribute("value", "");
              return div.firstChild.getAttribute("value") === "";
            })) {
              addHandle("value", function(elem, name, isXML2) {
                if (!isXML2 && elem.nodeName.toLowerCase() === "input") {
                  return elem.defaultValue;
                }
              });
            }
            if (!assert(function(div) {
              return div.getAttribute("disabled") == null;
            })) {
              addHandle(booleans, function(elem, name, isXML2) {
                var val;
                if (!isXML2) {
                  return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
                }
              });
            }
            return Sizzle2;
          }(window2)
        );
        jQuery2.find = Sizzle;
        jQuery2.expr = Sizzle.selectors;
        jQuery2.expr[":"] = jQuery2.expr.pseudos;
        jQuery2.unique = Sizzle.uniqueSort;
        jQuery2.text = Sizzle.getText;
        jQuery2.isXMLDoc = Sizzle.isXML;
        jQuery2.contains = Sizzle.contains;
        var rneedsContext = jQuery2.expr.match.needsContext;
        var rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
        var risSimple = /^.[^:#\[\.,]*$/;
        function winnow(elements, qualifier, not) {
          if (jQuery2.isFunction(qualifier)) {
            return jQuery2.grep(elements, function(elem, i2) {
              return !!qualifier.call(elem, i2, elem) !== not;
            });
          }
          if (qualifier.nodeType) {
            return jQuery2.grep(elements, function(elem) {
              return elem === qualifier !== not;
            });
          }
          if (typeof qualifier === "string") {
            if (risSimple.test(qualifier)) {
              return jQuery2.filter(qualifier, elements, not);
            }
            qualifier = jQuery2.filter(qualifier, elements);
          }
          return jQuery2.grep(elements, function(elem) {
            return jQuery2.inArray(elem, qualifier) >= 0 !== not;
          });
        }
        jQuery2.filter = function(expr, elems, not) {
          var elem = elems[0];
          if (not) {
            expr = ":not(" + expr + ")";
          }
          return elems.length === 1 && elem.nodeType === 1 ? jQuery2.find.matchesSelector(elem, expr) ? [elem] : [] : jQuery2.find.matches(expr, jQuery2.grep(elems, function(elem2) {
            return elem2.nodeType === 1;
          }));
        };
        jQuery2.fn.extend({
          find: function(selector) {
            var i2, ret = [], self2 = this, len = self2.length;
            if (typeof selector !== "string") {
              return this.pushStack(jQuery2(selector).filter(function() {
                for (i2 = 0; i2 < len; i2++) {
                  if (jQuery2.contains(self2[i2], this)) {
                    return true;
                  }
                }
              }));
            }
            for (i2 = 0; i2 < len; i2++) {
              jQuery2.find(selector, self2[i2], ret);
            }
            ret = this.pushStack(len > 1 ? jQuery2.unique(ret) : ret);
            ret.selector = this.selector ? this.selector + " " + selector : selector;
            return ret;
          },
          filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
          },
          not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
          },
          is: function(selector) {
            return !!winnow(
              this,
              // If this is a positional/relative selector, check membership in the returned set
              // so $("p:first").is("p:last") won't return true for a doc with two "p".
              typeof selector === "string" && rneedsContext.test(selector) ? jQuery2(selector) : selector || [],
              false
            ).length;
          }
        });
        var rootjQuery, document2 = window2.document, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, init = jQuery2.fn.init = function(selector, context) {
          var match, elem;
          if (!selector) {
            return this;
          }
          if (typeof selector === "string") {
            if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
              match = [null, selector, null];
            } else {
              match = rquickExpr.exec(selector);
            }
            if (match && (match[1] || !context)) {
              if (match[1]) {
                context = context instanceof jQuery2 ? context[0] : context;
                jQuery2.merge(this, jQuery2.parseHTML(
                  match[1],
                  context && context.nodeType ? context.ownerDocument || context : document2,
                  true
                ));
                if (rsingleTag.test(match[1]) && jQuery2.isPlainObject(context)) {
                  for (match in context) {
                    if (jQuery2.isFunction(this[match])) {
                      this[match](context[match]);
                    } else {
                      this.attr(match, context[match]);
                    }
                  }
                }
                return this;
              } else {
                elem = document2.getElementById(match[2]);
                if (elem && elem.parentNode) {
                  if (elem.id !== match[2]) {
                    return rootjQuery.find(selector);
                  }
                  this.length = 1;
                  this[0] = elem;
                }
                this.context = document2;
                this.selector = selector;
                return this;
              }
            } else if (!context || context.jquery) {
              return (context || rootjQuery).find(selector);
            } else {
              return this.constructor(context).find(selector);
            }
          } else if (selector.nodeType) {
            this.context = this[0] = selector;
            this.length = 1;
            return this;
          } else if (jQuery2.isFunction(selector)) {
            return typeof rootjQuery.ready !== "undefined" ? rootjQuery.ready(selector) : (
              // Execute immediately if ready is not present
              selector(jQuery2)
            );
          }
          if (selector.selector !== void 0) {
            this.selector = selector.selector;
            this.context = selector.context;
          }
          return jQuery2.makeArray(selector, this);
        };
        init.prototype = jQuery2.fn;
        rootjQuery = jQuery2(document2);
        var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
          children: true,
          contents: true,
          next: true,
          prev: true
        };
        jQuery2.extend({
          dir: function(elem, dir, until) {
            var matched = [], cur = elem[dir];
            while (cur && cur.nodeType !== 9 && (until === void 0 || cur.nodeType !== 1 || !jQuery2(cur).is(until))) {
              if (cur.nodeType === 1) {
                matched.push(cur);
              }
              cur = cur[dir];
            }
            return matched;
          },
          sibling: function(n, elem) {
            var r = [];
            for (; n; n = n.nextSibling) {
              if (n.nodeType === 1 && n !== elem) {
                r.push(n);
              }
            }
            return r;
          }
        });
        jQuery2.fn.extend({
          has: function(target) {
            var i2, targets = jQuery2(target, this), len = targets.length;
            return this.filter(function() {
              for (i2 = 0; i2 < len; i2++) {
                if (jQuery2.contains(this, targets[i2])) {
                  return true;
                }
              }
            });
          },
          closest: function(selectors, context) {
            var cur, i2 = 0, l = this.length, matched = [], pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? jQuery2(selectors, context || this.context) : 0;
            for (; i2 < l; i2++) {
              for (cur = this[i2]; cur && cur !== context; cur = cur.parentNode) {
                if (cur.nodeType < 11 && (pos ? pos.index(cur) > -1 : (
                  // Don't pass non-elements to Sizzle
                  cur.nodeType === 1 && jQuery2.find.matchesSelector(cur, selectors)
                ))) {
                  matched.push(cur);
                  break;
                }
              }
            }
            return this.pushStack(matched.length > 1 ? jQuery2.unique(matched) : matched);
          },
          // Determine the position of an element within
          // the matched set of elements
          index: function(elem) {
            if (!elem) {
              return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            }
            if (typeof elem === "string") {
              return jQuery2.inArray(this[0], jQuery2(elem));
            }
            return jQuery2.inArray(
              // If it receives a jQuery object, the first element is used
              elem.jquery ? elem[0] : elem,
              this
            );
          },
          add: function(selector, context) {
            return this.pushStack(
              jQuery2.unique(
                jQuery2.merge(this.get(), jQuery2(selector, context))
              )
            );
          },
          addBack: function(selector) {
            return this.add(
              selector == null ? this.prevObject : this.prevObject.filter(selector)
            );
          }
        });
        function sibling(cur, dir) {
          do {
            cur = cur[dir];
          } while (cur && cur.nodeType !== 1);
          return cur;
        }
        jQuery2.each({
          parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
          },
          parents: function(elem) {
            return jQuery2.dir(elem, "parentNode");
          },
          parentsUntil: function(elem, i2, until) {
            return jQuery2.dir(elem, "parentNode", until);
          },
          next: function(elem) {
            return sibling(elem, "nextSibling");
          },
          prev: function(elem) {
            return sibling(elem, "previousSibling");
          },
          nextAll: function(elem) {
            return jQuery2.dir(elem, "nextSibling");
          },
          prevAll: function(elem) {
            return jQuery2.dir(elem, "previousSibling");
          },
          nextUntil: function(elem, i2, until) {
            return jQuery2.dir(elem, "nextSibling", until);
          },
          prevUntil: function(elem, i2, until) {
            return jQuery2.dir(elem, "previousSibling", until);
          },
          siblings: function(elem) {
            return jQuery2.sibling((elem.parentNode || {}).firstChild, elem);
          },
          children: function(elem) {
            return jQuery2.sibling(elem.firstChild);
          },
          contents: function(elem) {
            return jQuery2.nodeName(elem, "iframe") ? elem.contentDocument || elem.contentWindow.document : jQuery2.merge([], elem.childNodes);
          }
        }, function(name, fn) {
          jQuery2.fn[name] = function(until, selector) {
            var ret = jQuery2.map(this, fn, until);
            if (name.slice(-5) !== "Until") {
              selector = until;
            }
            if (selector && typeof selector === "string") {
              ret = jQuery2.filter(selector, ret);
            }
            if (this.length > 1) {
              if (!guaranteedUnique[name]) {
                ret = jQuery2.unique(ret);
              }
              if (rparentsprev.test(name)) {
                ret = ret.reverse();
              }
            }
            return this.pushStack(ret);
          };
        });
        var rnotwhite = /\S+/g;
        var optionsCache = {};
        function createOptions(options) {
          var object = optionsCache[options] = {};
          jQuery2.each(options.match(rnotwhite) || [], function(_, flag) {
            object[flag] = true;
          });
          return object;
        }
        jQuery2.Callbacks = function(options) {
          options = typeof options === "string" ? optionsCache[options] || createOptions(options) : jQuery2.extend({}, options);
          var firing, memory, fired, firingLength, firingIndex, firingStart, list = [], stack = !options.once && [], fire = function(data) {
            memory = options.memory && data;
            fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; firingIndex++) {
              if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                memory = false;
                break;
              }
            }
            firing = false;
            if (list) {
              if (stack) {
                if (stack.length) {
                  fire(stack.shift());
                }
              } else if (memory) {
                list = [];
              } else {
                self2.disable();
              }
            }
          }, self2 = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
              if (list) {
                var start = list.length;
                (function add(args) {
                  jQuery2.each(args, function(_, arg) {
                    var type = jQuery2.type(arg);
                    if (type === "function") {
                      if (!options.unique || !self2.has(arg)) {
                        list.push(arg);
                      }
                    } else if (arg && arg.length && type !== "string") {
                      add(arg);
                    }
                  });
                })(arguments);
                if (firing) {
                  firingLength = list.length;
                } else if (memory) {
                  firingStart = start;
                  fire(memory);
                }
              }
              return this;
            },
            // Remove a callback from the list
            remove: function() {
              if (list) {
                jQuery2.each(arguments, function(_, arg) {
                  var index;
                  while ((index = jQuery2.inArray(arg, list, index)) > -1) {
                    list.splice(index, 1);
                    if (firing) {
                      if (index <= firingLength) {
                        firingLength--;
                      }
                      if (index <= firingIndex) {
                        firingIndex--;
                      }
                    }
                  }
                });
              }
              return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
              return fn ? jQuery2.inArray(fn, list) > -1 : !!(list && list.length);
            },
            // Remove all callbacks from the list
            empty: function() {
              list = [];
              firingLength = 0;
              return this;
            },
            // Have the list do nothing anymore
            disable: function() {
              list = stack = memory = void 0;
              return this;
            },
            // Is it disabled?
            disabled: function() {
              return !list;
            },
            // Lock the list in its current state
            lock: function() {
              stack = void 0;
              if (!memory) {
                self2.disable();
              }
              return this;
            },
            // Is it locked?
            locked: function() {
              return !stack;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
              if (list && (!fired || stack)) {
                args = args || [];
                args = [context, args.slice ? args.slice() : args];
                if (firing) {
                  stack.push(args);
                } else {
                  fire(args);
                }
              }
              return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
              self2.fireWith(this, arguments);
              return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
              return !!fired;
            }
          };
          return self2;
        };
        jQuery2.extend({
          Deferred: function(func) {
            var tuples = [
              // action, add listener, listener list, final state
              ["resolve", "done", jQuery2.Callbacks("once memory"), "resolved"],
              ["reject", "fail", jQuery2.Callbacks("once memory"), "rejected"],
              ["notify", "progress", jQuery2.Callbacks("memory")]
            ], state = "pending", promise = {
              state: function() {
                return state;
              },
              always: function() {
                deferred.done(arguments).fail(arguments);
                return this;
              },
              then: function() {
                var fns = arguments;
                return jQuery2.Deferred(function(newDefer) {
                  jQuery2.each(tuples, function(i2, tuple) {
                    var fn = jQuery2.isFunction(fns[i2]) && fns[i2];
                    deferred[tuple[1]](function() {
                      var returned = fn && fn.apply(this, arguments);
                      if (returned && jQuery2.isFunction(returned.promise)) {
                        returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
                      } else {
                        newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
                      }
                    });
                  });
                  fns = null;
                }).promise();
              },
              // Get a promise for this deferred
              // If obj is provided, the promise aspect is added to the object
              promise: function(obj) {
                return obj != null ? jQuery2.extend(obj, promise) : promise;
              }
            }, deferred = {};
            promise.pipe = promise.then;
            jQuery2.each(tuples, function(i2, tuple) {
              var list = tuple[2], stateString = tuple[3];
              promise[tuple[1]] = list.add;
              if (stateString) {
                list.add(function() {
                  state = stateString;
                }, tuples[i2 ^ 1][2].disable, tuples[2][2].lock);
              }
              deferred[tuple[0]] = function() {
                deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments);
                return this;
              };
              deferred[tuple[0] + "With"] = list.fireWith;
            });
            promise.promise(deferred);
            if (func) {
              func.call(deferred, deferred);
            }
            return deferred;
          },
          // Deferred helper
          when: function(subordinate) {
            var i2 = 0, resolveValues = slice.call(arguments), length = resolveValues.length, remaining = length !== 1 || subordinate && jQuery2.isFunction(subordinate.promise) ? length : 0, deferred = remaining === 1 ? subordinate : jQuery2.Deferred(), updateFunc = function(i3, contexts, values) {
              return function(value) {
                contexts[i3] = this;
                values[i3] = arguments.length > 1 ? slice.call(arguments) : value;
                if (values === progressValues) {
                  deferred.notifyWith(contexts, values);
                } else if (!--remaining) {
                  deferred.resolveWith(contexts, values);
                }
              };
            }, progressValues, progressContexts, resolveContexts;
            if (length > 1) {
              progressValues = new Array(length);
              progressContexts = new Array(length);
              resolveContexts = new Array(length);
              for (; i2 < length; i2++) {
                if (resolveValues[i2] && jQuery2.isFunction(resolveValues[i2].promise)) {
                  resolveValues[i2].promise().done(updateFunc(i2, resolveContexts, resolveValues)).fail(deferred.reject).progress(updateFunc(i2, progressContexts, progressValues));
                } else {
                  --remaining;
                }
              }
            }
            if (!remaining) {
              deferred.resolveWith(resolveContexts, resolveValues);
            }
            return deferred.promise();
          }
        });
        var readyList;
        jQuery2.fn.ready = function(fn) {
          jQuery2.ready.promise().done(fn);
          return this;
        };
        jQuery2.extend({
          // Is the DOM ready to be used? Set to true once it occurs.
          isReady: false,
          // A counter to track how many items to wait for before
          // the ready event fires. See #6781
          readyWait: 1,
          // Hold (or release) the ready event
          holdReady: function(hold) {
            if (hold) {
              jQuery2.readyWait++;
            } else {
              jQuery2.ready(true);
            }
          },
          // Handle when the DOM is ready
          ready: function(wait) {
            if (wait === true ? --jQuery2.readyWait : jQuery2.isReady) {
              return;
            }
            if (!document2.body) {
              return setTimeout(jQuery2.ready);
            }
            jQuery2.isReady = true;
            if (wait !== true && --jQuery2.readyWait > 0) {
              return;
            }
            readyList.resolveWith(document2, [jQuery2]);
            if (jQuery2.fn.triggerHandler) {
              jQuery2(document2).triggerHandler("ready");
              jQuery2(document2).off("ready");
            }
          }
        });
        function detach() {
          if (document2.addEventListener) {
            document2.removeEventListener("DOMContentLoaded", completed, false);
            window2.removeEventListener("load", completed, false);
          } else {
            document2.detachEvent("onreadystatechange", completed);
            window2.detachEvent("onload", completed);
          }
        }
        function completed() {
          if (document2.addEventListener || event.type === "load" || document2.readyState === "complete") {
            detach();
            jQuery2.ready();
          }
        }
        jQuery2.ready.promise = function(obj) {
          if (!readyList) {
            readyList = jQuery2.Deferred();
            if (document2.readyState === "complete") {
              setTimeout(jQuery2.ready);
            } else if (document2.addEventListener) {
              document2.addEventListener("DOMContentLoaded", completed, false);
              window2.addEventListener("load", completed, false);
            } else {
              document2.attachEvent("onreadystatechange", completed);
              window2.attachEvent("onload", completed);
              var top = false;
              try {
                top = window2.frameElement == null && document2.documentElement;
              } catch (e) {
              }
              if (top && top.doScroll) {
                (function doScrollCheck() {
                  if (!jQuery2.isReady) {
                    try {
                      top.doScroll("left");
                    } catch (e) {
                      return setTimeout(doScrollCheck, 50);
                    }
                    detach();
                    jQuery2.ready();
                  }
                })();
              }
            }
          }
          return readyList.promise(obj);
        };
        var strundefined = "undefined";
        var i;
        for (i in jQuery2(support)) {
          break;
        }
        support.ownLast = i !== "0";
        support.inlineBlockNeedsLayout = false;
        jQuery2(function() {
          var val, div, body, container;
          body = document2.getElementsByTagName("body")[0];
          if (!body || !body.style) {
            return;
          }
          div = document2.createElement("div");
          container = document2.createElement("div");
          container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
          body.appendChild(container).appendChild(div);
          if (typeof div.style.zoom !== strundefined) {
            div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
            support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
            if (val) {
              body.style.zoom = 1;
            }
          }
          body.removeChild(container);
        });
        (function() {
          var div = document2.createElement("div");
          if (support.deleteExpando == null) {
            support.deleteExpando = true;
            try {
              delete div.test;
            } catch (e) {
              support.deleteExpando = false;
            }
          }
          div = null;
        })();
        jQuery2.acceptData = function(elem) {
          var noData = jQuery2.noData[(elem.nodeName + " ").toLowerCase()], nodeType = +elem.nodeType || 1;
          return nodeType !== 1 && nodeType !== 9 ? false : (
            // Nodes accept data unless otherwise specified; rejection can be conditional
            !noData || noData !== true && elem.getAttribute("classid") === noData
          );
        };
        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /([A-Z])/g;
        function dataAttr(elem, key, data) {
          if (data === void 0 && elem.nodeType === 1) {
            var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
              try {
                data = data === "true" ? true : data === "false" ? false : data === "null" ? null : (
                  // Only convert to a number if it doesn't change the string
                  +data + "" === data ? +data : rbrace.test(data) ? jQuery2.parseJSON(data) : data
                );
              } catch (e) {
              }
              jQuery2.data(elem, key, data);
            } else {
              data = void 0;
            }
          }
          return data;
        }
        function isEmptyDataObject(obj) {
          var name;
          for (name in obj) {
            if (name === "data" && jQuery2.isEmptyObject(obj[name])) {
              continue;
            }
            if (name !== "toJSON") {
              return false;
            }
          }
          return true;
        }
        function internalData(elem, name, data, pvt) {
          if (!jQuery2.acceptData(elem)) {
            return;
          }
          var ret, thisCache, internalKey = jQuery2.expando, isNode = elem.nodeType, cache = isNode ? jQuery2.cache : elem, id = isNode ? elem[internalKey] : elem[internalKey] && internalKey;
          if ((!id || !cache[id] || !pvt && !cache[id].data) && data === void 0 && typeof name === "string") {
            return;
          }
          if (!id) {
            if (isNode) {
              id = elem[internalKey] = deletedIds.pop() || jQuery2.guid++;
            } else {
              id = internalKey;
            }
          }
          if (!cache[id]) {
            cache[id] = isNode ? {} : { toJSON: jQuery2.noop };
          }
          if (typeof name === "object" || typeof name === "function") {
            if (pvt) {
              cache[id] = jQuery2.extend(cache[id], name);
            } else {
              cache[id].data = jQuery2.extend(cache[id].data, name);
            }
          }
          thisCache = cache[id];
          if (!pvt) {
            if (!thisCache.data) {
              thisCache.data = {};
            }
            thisCache = thisCache.data;
          }
          if (data !== void 0) {
            thisCache[jQuery2.camelCase(name)] = data;
          }
          if (typeof name === "string") {
            ret = thisCache[name];
            if (ret == null) {
              ret = thisCache[jQuery2.camelCase(name)];
            }
          } else {
            ret = thisCache;
          }
          return ret;
        }
        function internalRemoveData(elem, name, pvt) {
          if (!jQuery2.acceptData(elem)) {
            return;
          }
          var thisCache, i2, isNode = elem.nodeType, cache = isNode ? jQuery2.cache : elem, id = isNode ? elem[jQuery2.expando] : jQuery2.expando;
          if (!cache[id]) {
            return;
          }
          if (name) {
            thisCache = pvt ? cache[id] : cache[id].data;
            if (thisCache) {
              if (!jQuery2.isArray(name)) {
                if (name in thisCache) {
                  name = [name];
                } else {
                  name = jQuery2.camelCase(name);
                  if (name in thisCache) {
                    name = [name];
                  } else {
                    name = name.split(" ");
                  }
                }
              } else {
                name = name.concat(jQuery2.map(name, jQuery2.camelCase));
              }
              i2 = name.length;
              while (i2--) {
                delete thisCache[name[i2]];
              }
              if (pvt ? !isEmptyDataObject(thisCache) : !jQuery2.isEmptyObject(thisCache)) {
                return;
              }
            }
          }
          if (!pvt) {
            delete cache[id].data;
            if (!isEmptyDataObject(cache[id])) {
              return;
            }
          }
          if (isNode) {
            jQuery2.cleanData([elem], true);
          } else if (support.deleteExpando || cache != cache.window) {
            delete cache[id];
          } else {
            cache[id] = null;
          }
        }
        jQuery2.extend({
          cache: {},
          // The following elements (space-suffixed to avoid Object.prototype collisions)
          // throw uncatchable exceptions if you attempt to set expando properties
          noData: {
            "applet ": true,
            "embed ": true,
            // ...but Flash objects (which have this classid) *can* handle expandos
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
          },
          hasData: function(elem) {
            elem = elem.nodeType ? jQuery2.cache[elem[jQuery2.expando]] : elem[jQuery2.expando];
            return !!elem && !isEmptyDataObject(elem);
          },
          data: function(elem, name, data) {
            return internalData(elem, name, data);
          },
          removeData: function(elem, name) {
            return internalRemoveData(elem, name);
          },
          // For internal use only.
          _data: function(elem, name, data) {
            return internalData(elem, name, data, true);
          },
          _removeData: function(elem, name) {
            return internalRemoveData(elem, name, true);
          }
        });
        jQuery2.fn.extend({
          data: function(key, value) {
            var i2, name, data, elem = this[0], attrs = elem && elem.attributes;
            if (key === void 0) {
              if (this.length) {
                data = jQuery2.data(elem);
                if (elem.nodeType === 1 && !jQuery2._data(elem, "parsedAttrs")) {
                  i2 = attrs.length;
                  while (i2--) {
                    if (attrs[i2]) {
                      name = attrs[i2].name;
                      if (name.indexOf("data-") === 0) {
                        name = jQuery2.camelCase(name.slice(5));
                        dataAttr(elem, name, data[name]);
                      }
                    }
                  }
                  jQuery2._data(elem, "parsedAttrs", true);
                }
              }
              return data;
            }
            if (typeof key === "object") {
              return this.each(function() {
                jQuery2.data(this, key);
              });
            }
            return arguments.length > 1 ? (
              // Sets one value
              this.each(function() {
                jQuery2.data(this, key, value);
              })
            ) : (
              // Gets one value
              // Try to fetch any internally stored data first
              elem ? dataAttr(elem, key, jQuery2.data(elem, key)) : void 0
            );
          },
          removeData: function(key) {
            return this.each(function() {
              jQuery2.removeData(this, key);
            });
          }
        });
        jQuery2.extend({
          queue: function(elem, type, data) {
            var queue;
            if (elem) {
              type = (type || "fx") + "queue";
              queue = jQuery2._data(elem, type);
              if (data) {
                if (!queue || jQuery2.isArray(data)) {
                  queue = jQuery2._data(elem, type, jQuery2.makeArray(data));
                } else {
                  queue.push(data);
                }
              }
              return queue || [];
            }
          },
          dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery2.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery2._queueHooks(elem, type), next = function() {
              jQuery2.dequeue(elem, type);
            };
            if (fn === "inprogress") {
              fn = queue.shift();
              startLength--;
            }
            if (fn) {
              if (type === "fx") {
                queue.unshift("inprogress");
              }
              delete hooks.stop;
              fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) {
              hooks.empty.fire();
            }
          },
          // not intended for public consumption - generates a queueHooks object, or returns the current one
          _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return jQuery2._data(elem, key) || jQuery2._data(elem, key, {
              empty: jQuery2.Callbacks("once memory").add(function() {
                jQuery2._removeData(elem, type + "queue");
                jQuery2._removeData(elem, key);
              })
            });
          }
        });
        jQuery2.fn.extend({
          queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
              data = type;
              type = "fx";
              setter--;
            }
            if (arguments.length < setter) {
              return jQuery2.queue(this[0], type);
            }
            return data === void 0 ? this : this.each(function() {
              var queue = jQuery2.queue(this, type, data);
              jQuery2._queueHooks(this, type);
              if (type === "fx" && queue[0] !== "inprogress") {
                jQuery2.dequeue(this, type);
              }
            });
          },
          dequeue: function(type) {
            return this.each(function() {
              jQuery2.dequeue(this, type);
            });
          },
          clearQueue: function(type) {
            return this.queue(type || "fx", []);
          },
          // Get a promise resolved when queues of a certain type
          // are emptied (fx is the type by default)
          promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery2.Deferred(), elements = this, i2 = this.length, resolve = function() {
              if (!--count) {
                defer.resolveWith(elements, [elements]);
              }
            };
            if (typeof type !== "string") {
              obj = type;
              type = void 0;
            }
            type = type || "fx";
            while (i2--) {
              tmp = jQuery2._data(elements[i2], type + "queueHooks");
              if (tmp && tmp.empty) {
                count++;
                tmp.empty.add(resolve);
              }
            }
            resolve();
            return defer.promise(obj);
          }
        });
        var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
        var cssExpand = ["Top", "Right", "Bottom", "Left"];
        var isHidden = function(elem, el) {
          elem = el || elem;
          return jQuery2.css(elem, "display") === "none" || !jQuery2.contains(elem.ownerDocument, elem);
        };
        var access = jQuery2.access = function(elems, fn, key, value, chainable, emptyGet, raw) {
          var i2 = 0, length = elems.length, bulk = key == null;
          if (jQuery2.type(key) === "object") {
            chainable = true;
            for (i2 in key) {
              jQuery2.access(elems, fn, i2, key[i2], true, emptyGet, raw);
            }
          } else if (value !== void 0) {
            chainable = true;
            if (!jQuery2.isFunction(value)) {
              raw = true;
            }
            if (bulk) {
              if (raw) {
                fn.call(elems, value);
                fn = null;
              } else {
                bulk = fn;
                fn = function(elem, key2, value2) {
                  return bulk.call(jQuery2(elem), value2);
                };
              }
            }
            if (fn) {
              for (; i2 < length; i2++) {
                fn(elems[i2], key, raw ? value : value.call(elems[i2], i2, fn(elems[i2], key)));
              }
            }
          }
          return chainable ? elems : (
            // Gets
            bulk ? fn.call(elems) : length ? fn(elems[0], key) : emptyGet
          );
        };
        var rcheckableType = /^(?:checkbox|radio)$/i;
        (function() {
          var input = document2.createElement("input"), div = document2.createElement("div"), fragment = document2.createDocumentFragment();
          div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
          support.leadingWhitespace = div.firstChild.nodeType === 3;
          support.tbody = !div.getElementsByTagName("tbody").length;
          support.htmlSerialize = !!div.getElementsByTagName("link").length;
          support.html5Clone = document2.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>";
          input.type = "checkbox";
          input.checked = true;
          fragment.appendChild(input);
          support.appendChecked = input.checked;
          div.innerHTML = "<textarea>x</textarea>";
          support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
          fragment.appendChild(div);
          div.innerHTML = "<input type='radio' checked='checked' name='t'/>";
          support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
          support.noCloneEvent = true;
          if (div.attachEvent) {
            div.attachEvent("onclick", function() {
              support.noCloneEvent = false;
            });
            div.cloneNode(true).click();
          }
          if (support.deleteExpando == null) {
            support.deleteExpando = true;
            try {
              delete div.test;
            } catch (e) {
              support.deleteExpando = false;
            }
          }
        })();
        (function() {
          var i2, eventName, div = document2.createElement("div");
          for (i2 in { submit: true, change: true, focusin: true }) {
            eventName = "on" + i2;
            if (!(support[i2 + "Bubbles"] = eventName in window2)) {
              div.setAttribute(eventName, "t");
              support[i2 + "Bubbles"] = div.attributes[eventName].expando === false;
            }
          }
          div = null;
        })();
        var rformElems = /^(?:input|select|textarea)$/i, rkeyEvent = /^key/, rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/, rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
        function returnTrue() {
          return true;
        }
        function returnFalse() {
          return false;
        }
        function safeActiveElement() {
          try {
            return document2.activeElement;
          } catch (err) {
          }
        }
        jQuery2.event = {
          global: {},
          add: function(elem, types, handler, data, selector) {
            var tmp, events, t, handleObjIn, special, eventHandle, handleObj, handlers, type, namespaces, origType, elemData = jQuery2._data(elem);
            if (!elemData) {
              return;
            }
            if (handler.handler) {
              handleObjIn = handler;
              handler = handleObjIn.handler;
              selector = handleObjIn.selector;
            }
            if (!handler.guid) {
              handler.guid = jQuery2.guid++;
            }
            if (!(events = elemData.events)) {
              events = elemData.events = {};
            }
            if (!(eventHandle = elemData.handle)) {
              eventHandle = elemData.handle = function(e) {
                return typeof jQuery2 !== strundefined && (!e || jQuery2.event.triggered !== e.type) ? jQuery2.event.dispatch.apply(eventHandle.elem, arguments) : void 0;
              };
              eventHandle.elem = elem;
            }
            types = (types || "").match(rnotwhite) || [""];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || "").split(".").sort();
              if (!type) {
                continue;
              }
              special = jQuery2.event.special[type] || {};
              type = (selector ? special.delegateType : special.bindType) || type;
              special = jQuery2.event.special[type] || {};
              handleObj = jQuery2.extend({
                type,
                origType,
                data,
                handler,
                guid: handler.guid,
                selector,
                needsContext: selector && jQuery2.expr.match.needsContext.test(selector),
                namespace: namespaces.join(".")
              }, handleObjIn);
              if (!(handlers = events[type])) {
                handlers = events[type] = [];
                handlers.delegateCount = 0;
                if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                  if (elem.addEventListener) {
                    elem.addEventListener(type, eventHandle, false);
                  } else if (elem.attachEvent) {
                    elem.attachEvent("on" + type, eventHandle);
                  }
                }
              }
              if (special.add) {
                special.add.call(elem, handleObj);
                if (!handleObj.handler.guid) {
                  handleObj.handler.guid = handler.guid;
                }
              }
              if (selector) {
                handlers.splice(handlers.delegateCount++, 0, handleObj);
              } else {
                handlers.push(handleObj);
              }
              jQuery2.event.global[type] = true;
            }
            elem = null;
          },
          // Detach an event or set of events from an element
          remove: function(elem, types, handler, selector, mappedTypes) {
            var j, handleObj, tmp, origCount, t, events, special, handlers, type, namespaces, origType, elemData = jQuery2.hasData(elem) && jQuery2._data(elem);
            if (!elemData || !(events = elemData.events)) {
              return;
            }
            types = (types || "").match(rnotwhite) || [""];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || "").split(".").sort();
              if (!type) {
                for (type in events) {
                  jQuery2.event.remove(elem, type + types[t], handler, selector, true);
                }
                continue;
              }
              special = jQuery2.event.special[type] || {};
              type = (selector ? special.delegateType : special.bindType) || type;
              handlers = events[type] || [];
              tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
              origCount = j = handlers.length;
              while (j--) {
                handleObj = handlers[j];
                if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                  handlers.splice(j, 1);
                  if (handleObj.selector) {
                    handlers.delegateCount--;
                  }
                  if (special.remove) {
                    special.remove.call(elem, handleObj);
                  }
                }
              }
              if (origCount && !handlers.length) {
                if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
                  jQuery2.removeEvent(elem, type, elemData.handle);
                }
                delete events[type];
              }
            }
            if (jQuery2.isEmptyObject(events)) {
              delete elemData.handle;
              jQuery2._removeData(elem, "events");
            }
          },
          trigger: function(event2, data, elem, onlyHandlers) {
            var handle, ontype, cur, bubbleType, special, tmp, i2, eventPath = [elem || document2], type = hasOwn.call(event2, "type") ? event2.type : event2, namespaces = hasOwn.call(event2, "namespace") ? event2.namespace.split(".") : [];
            cur = tmp = elem = elem || document2;
            if (elem.nodeType === 3 || elem.nodeType === 8) {
              return;
            }
            if (rfocusMorph.test(type + jQuery2.event.triggered)) {
              return;
            }
            if (type.indexOf(".") >= 0) {
              namespaces = type.split(".");
              type = namespaces.shift();
              namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            event2 = event2[jQuery2.expando] ? event2 : new jQuery2.Event(type, typeof event2 === "object" && event2);
            event2.isTrigger = onlyHandlers ? 2 : 3;
            event2.namespace = namespaces.join(".");
            event2.namespace_re = event2.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            event2.result = void 0;
            if (!event2.target) {
              event2.target = elem;
            }
            data = data == null ? [event2] : jQuery2.makeArray(data, [event2]);
            special = jQuery2.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
              return;
            }
            if (!onlyHandlers && !special.noBubble && !jQuery2.isWindow(elem)) {
              bubbleType = special.delegateType || type;
              if (!rfocusMorph.test(bubbleType + type)) {
                cur = cur.parentNode;
              }
              for (; cur; cur = cur.parentNode) {
                eventPath.push(cur);
                tmp = cur;
              }
              if (tmp === (elem.ownerDocument || document2)) {
                eventPath.push(tmp.defaultView || tmp.parentWindow || window2);
              }
            }
            i2 = 0;
            while ((cur = eventPath[i2++]) && !event2.isPropagationStopped()) {
              event2.type = i2 > 1 ? bubbleType : special.bindType || type;
              handle = (jQuery2._data(cur, "events") || {})[event2.type] && jQuery2._data(cur, "handle");
              if (handle) {
                handle.apply(cur, data);
              }
              handle = ontype && cur[ontype];
              if (handle && handle.apply && jQuery2.acceptData(cur)) {
                event2.result = handle.apply(cur, data);
                if (event2.result === false) {
                  event2.preventDefault();
                }
              }
            }
            event2.type = type;
            if (!onlyHandlers && !event2.isDefaultPrevented()) {
              if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && jQuery2.acceptData(elem)) {
                if (ontype && elem[type] && !jQuery2.isWindow(elem)) {
                  tmp = elem[ontype];
                  if (tmp) {
                    elem[ontype] = null;
                  }
                  jQuery2.event.triggered = type;
                  try {
                    elem[type]();
                  } catch (e) {
                  }
                  jQuery2.event.triggered = void 0;
                  if (tmp) {
                    elem[ontype] = tmp;
                  }
                }
              }
            }
            return event2.result;
          },
          dispatch: function(event2) {
            event2 = jQuery2.event.fix(event2);
            var i2, ret, handleObj, matched, j, handlerQueue = [], args = slice.call(arguments), handlers = (jQuery2._data(this, "events") || {})[event2.type] || [], special = jQuery2.event.special[event2.type] || {};
            args[0] = event2;
            event2.delegateTarget = this;
            if (special.preDispatch && special.preDispatch.call(this, event2) === false) {
              return;
            }
            handlerQueue = jQuery2.event.handlers.call(this, event2, handlers);
            i2 = 0;
            while ((matched = handlerQueue[i2++]) && !event2.isPropagationStopped()) {
              event2.currentTarget = matched.elem;
              j = 0;
              while ((handleObj = matched.handlers[j++]) && !event2.isImmediatePropagationStopped()) {
                if (!event2.namespace_re || event2.namespace_re.test(handleObj.namespace)) {
                  event2.handleObj = handleObj;
                  event2.data = handleObj.data;
                  ret = ((jQuery2.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                  if (ret !== void 0) {
                    if ((event2.result = ret) === false) {
                      event2.preventDefault();
                      event2.stopPropagation();
                    }
                  }
                }
              }
            }
            if (special.postDispatch) {
              special.postDispatch.call(this, event2);
            }
            return event2.result;
          },
          handlers: function(event2, handlers) {
            var sel, handleObj, matches, i2, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event2.target;
            if (delegateCount && cur.nodeType && (!event2.button || event2.type !== "click")) {
              for (; cur != this; cur = cur.parentNode || this) {
                if (cur.nodeType === 1 && (cur.disabled !== true || event2.type !== "click")) {
                  matches = [];
                  for (i2 = 0; i2 < delegateCount; i2++) {
                    handleObj = handlers[i2];
                    sel = handleObj.selector + " ";
                    if (matches[sel] === void 0) {
                      matches[sel] = handleObj.needsContext ? jQuery2(sel, this).index(cur) >= 0 : jQuery2.find(sel, this, null, [cur]).length;
                    }
                    if (matches[sel]) {
                      matches.push(handleObj);
                    }
                  }
                  if (matches.length) {
                    handlerQueue.push({ elem: cur, handlers: matches });
                  }
                }
              }
            }
            if (delegateCount < handlers.length) {
              handlerQueue.push({ elem: this, handlers: handlers.slice(delegateCount) });
            }
            return handlerQueue;
          },
          fix: function(event2) {
            if (event2[jQuery2.expando]) {
              return event2;
            }
            var i2, prop, copy, type = event2.type, originalEvent = event2, fixHook = this.fixHooks[type];
            if (!fixHook) {
              this.fixHooks[type] = fixHook = rmouseEvent.test(type) ? this.mouseHooks : rkeyEvent.test(type) ? this.keyHooks : {};
            }
            copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;
            event2 = new jQuery2.Event(originalEvent);
            i2 = copy.length;
            while (i2--) {
              prop = copy[i2];
              event2[prop] = originalEvent[prop];
            }
            if (!event2.target) {
              event2.target = originalEvent.srcElement || document2;
            }
            if (event2.target.nodeType === 3) {
              event2.target = event2.target.parentNode;
            }
            event2.metaKey = !!event2.metaKey;
            return fixHook.filter ? fixHook.filter(event2, originalEvent) : event2;
          },
          // Includes some event props shared by KeyEvent and MouseEvent
          props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
          fixHooks: {},
          keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(event2, original) {
              if (event2.which == null) {
                event2.which = original.charCode != null ? original.charCode : original.keyCode;
              }
              return event2;
            }
          },
          mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(event2, original) {
              var body, eventDoc, doc, button = original.button, fromElement = original.fromElement;
              if (event2.pageX == null && original.clientX != null) {
                eventDoc = event2.target.ownerDocument || document2;
                doc = eventDoc.documentElement;
                body = eventDoc.body;
                event2.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                event2.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
              }
              if (!event2.relatedTarget && fromElement) {
                event2.relatedTarget = fromElement === event2.target ? original.toElement : fromElement;
              }
              if (!event2.which && button !== void 0) {
                event2.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
              }
              return event2;
            }
          },
          special: {
            load: {
              // Prevent triggered image.load events from bubbling to window.load
              noBubble: true
            },
            focus: {
              // Fire native event if possible so blur/focus sequence is correct
              trigger: function() {
                if (this !== safeActiveElement() && this.focus) {
                  try {
                    this.focus();
                    return false;
                  } catch (e) {
                  }
                }
              },
              delegateType: "focusin"
            },
            blur: {
              trigger: function() {
                if (this === safeActiveElement() && this.blur) {
                  this.blur();
                  return false;
                }
              },
              delegateType: "focusout"
            },
            click: {
              // For checkbox, fire native event so checked state will be right
              trigger: function() {
                if (jQuery2.nodeName(this, "input") && this.type === "checkbox" && this.click) {
                  this.click();
                  return false;
                }
              },
              // For cross-browser consistency, don't fire native .click() on links
              _default: function(event2) {
                return jQuery2.nodeName(event2.target, "a");
              }
            },
            beforeunload: {
              postDispatch: function(event2) {
                if (event2.result !== void 0 && event2.originalEvent) {
                  event2.originalEvent.returnValue = event2.result;
                }
              }
            }
          },
          simulate: function(type, elem, event2, bubble) {
            var e = jQuery2.extend(
              new jQuery2.Event(),
              event2,
              {
                type,
                isSimulated: true,
                originalEvent: {}
              }
            );
            if (bubble) {
              jQuery2.event.trigger(e, null, elem);
            } else {
              jQuery2.event.dispatch.call(elem, e);
            }
            if (e.isDefaultPrevented()) {
              event2.preventDefault();
            }
          }
        };
        jQuery2.removeEvent = document2.removeEventListener ? function(elem, type, handle) {
          if (elem.removeEventListener) {
            elem.removeEventListener(type, handle, false);
          }
        } : function(elem, type, handle) {
          var name = "on" + type;
          if (elem.detachEvent) {
            if (typeof elem[name] === strundefined) {
              elem[name] = null;
            }
            elem.detachEvent(name, handle);
          }
        };
        jQuery2.Event = function(src, props) {
          if (!(this instanceof jQuery2.Event)) {
            return new jQuery2.Event(src, props);
          }
          if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === void 0 && // Support: IE < 9, Android < 4.0
            src.returnValue === false ? returnTrue : returnFalse;
          } else {
            this.type = src;
          }
          if (props) {
            jQuery2.extend(this, props);
          }
          this.timeStamp = src && src.timeStamp || jQuery2.now();
          this[jQuery2.expando] = true;
        };
        jQuery2.Event.prototype = {
          isDefaultPrevented: returnFalse,
          isPropagationStopped: returnFalse,
          isImmediatePropagationStopped: returnFalse,
          preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (!e) {
              return;
            }
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
          },
          stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (!e) {
              return;
            }
            if (e.stopPropagation) {
              e.stopPropagation();
            }
            e.cancelBubble = true;
          },
          stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && e.stopImmediatePropagation) {
              e.stopImmediatePropagation();
            }
            this.stopPropagation();
          }
        };
        jQuery2.each({
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout"
        }, function(orig, fix) {
          jQuery2.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event2) {
              var ret, target = this, related = event2.relatedTarget, handleObj = event2.handleObj;
              if (!related || related !== target && !jQuery2.contains(target, related)) {
                event2.type = handleObj.origType;
                ret = handleObj.handler.apply(this, arguments);
                event2.type = fix;
              }
              return ret;
            }
          };
        });
        if (!support.submitBubbles) {
          jQuery2.event.special.submit = {
            setup: function() {
              if (jQuery2.nodeName(this, "form")) {
                return false;
              }
              jQuery2.event.add(this, "click._submit keypress._submit", function(e) {
                var elem = e.target, form = jQuery2.nodeName(elem, "input") || jQuery2.nodeName(elem, "button") ? elem.form : void 0;
                if (form && !jQuery2._data(form, "submitBubbles")) {
                  jQuery2.event.add(form, "submit._submit", function(event2) {
                    event2._submit_bubble = true;
                  });
                  jQuery2._data(form, "submitBubbles", true);
                }
              });
            },
            postDispatch: function(event2) {
              if (event2._submit_bubble) {
                delete event2._submit_bubble;
                if (this.parentNode && !event2.isTrigger) {
                  jQuery2.event.simulate("submit", this.parentNode, event2, true);
                }
              }
            },
            teardown: function() {
              if (jQuery2.nodeName(this, "form")) {
                return false;
              }
              jQuery2.event.remove(this, "._submit");
            }
          };
        }
        if (!support.changeBubbles) {
          jQuery2.event.special.change = {
            setup: function() {
              if (rformElems.test(this.nodeName)) {
                if (this.type === "checkbox" || this.type === "radio") {
                  jQuery2.event.add(this, "propertychange._change", function(event2) {
                    if (event2.originalEvent.propertyName === "checked") {
                      this._just_changed = true;
                    }
                  });
                  jQuery2.event.add(this, "click._change", function(event2) {
                    if (this._just_changed && !event2.isTrigger) {
                      this._just_changed = false;
                    }
                    jQuery2.event.simulate("change", this, event2, true);
                  });
                }
                return false;
              }
              jQuery2.event.add(this, "beforeactivate._change", function(e) {
                var elem = e.target;
                if (rformElems.test(elem.nodeName) && !jQuery2._data(elem, "changeBubbles")) {
                  jQuery2.event.add(elem, "change._change", function(event2) {
                    if (this.parentNode && !event2.isSimulated && !event2.isTrigger) {
                      jQuery2.event.simulate("change", this.parentNode, event2, true);
                    }
                  });
                  jQuery2._data(elem, "changeBubbles", true);
                }
              });
            },
            handle: function(event2) {
              var elem = event2.target;
              if (this !== elem || event2.isSimulated || event2.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") {
                return event2.handleObj.handler.apply(this, arguments);
              }
            },
            teardown: function() {
              jQuery2.event.remove(this, "._change");
              return !rformElems.test(this.nodeName);
            }
          };
        }
        if (!support.focusinBubbles) {
          jQuery2.each({ focus: "focusin", blur: "focusout" }, function(orig, fix) {
            var handler = function(event2) {
              jQuery2.event.simulate(fix, event2.target, jQuery2.event.fix(event2), true);
            };
            jQuery2.event.special[fix] = {
              setup: function() {
                var doc = this.ownerDocument || this, attaches = jQuery2._data(doc, fix);
                if (!attaches) {
                  doc.addEventListener(orig, handler, true);
                }
                jQuery2._data(doc, fix, (attaches || 0) + 1);
              },
              teardown: function() {
                var doc = this.ownerDocument || this, attaches = jQuery2._data(doc, fix) - 1;
                if (!attaches) {
                  doc.removeEventListener(orig, handler, true);
                  jQuery2._removeData(doc, fix);
                } else {
                  jQuery2._data(doc, fix, attaches);
                }
              }
            };
          });
        }
        jQuery2.fn.extend({
          on: function(types, selector, data, fn, one) {
            var type, origFn;
            if (typeof types === "object") {
              if (typeof selector !== "string") {
                data = data || selector;
                selector = void 0;
              }
              for (type in types) {
                this.on(type, selector, data, types[type], one);
              }
              return this;
            }
            if (data == null && fn == null) {
              fn = selector;
              data = selector = void 0;
            } else if (fn == null) {
              if (typeof selector === "string") {
                fn = data;
                data = void 0;
              } else {
                fn = data;
                data = selector;
                selector = void 0;
              }
            }
            if (fn === false) {
              fn = returnFalse;
            } else if (!fn) {
              return this;
            }
            if (one === 1) {
              origFn = fn;
              fn = function(event2) {
                jQuery2().off(event2);
                return origFn.apply(this, arguments);
              };
              fn.guid = origFn.guid || (origFn.guid = jQuery2.guid++);
            }
            return this.each(function() {
              jQuery2.event.add(this, types, fn, data, selector);
            });
          },
          one: function(types, selector, data, fn) {
            return this.on(types, selector, data, fn, 1);
          },
          off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
              handleObj = types.handleObj;
              jQuery2(types.delegateTarget).off(
                handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
                handleObj.selector,
                handleObj.handler
              );
              return this;
            }
            if (typeof types === "object") {
              for (type in types) {
                this.off(type, selector, types[type]);
              }
              return this;
            }
            if (selector === false || typeof selector === "function") {
              fn = selector;
              selector = void 0;
            }
            if (fn === false) {
              fn = returnFalse;
            }
            return this.each(function() {
              jQuery2.event.remove(this, types, fn, selector);
            });
          },
          trigger: function(type, data) {
            return this.each(function() {
              jQuery2.event.trigger(type, data, this);
            });
          },
          triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) {
              return jQuery2.event.trigger(type, data, elem, true);
            }
          }
        });
        function createSafeFragment(document3) {
          var list = nodeNames.split("|"), safeFrag = document3.createDocumentFragment();
          if (safeFrag.createElement) {
            while (list.length) {
              safeFrag.createElement(
                list.pop()
              );
            }
          }
          return safeFrag;
        }
        var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video", rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g, rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"), rleadingWhitespace = /^\s+/, rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi, rtagName = /<([\w:]+)/, rtbody = /<tbody/i, rhtml = /<|&#?\w+;/, rnoInnerhtml = /<(?:script|style|link)/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rscriptType = /^$|\/(?:java|ecma)script/i, rscriptTypeMasked = /^true\/(.*)/, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g, wrapMap = {
          option: [1, "<select multiple='multiple'>", "</select>"],
          legend: [1, "<fieldset>", "</fieldset>"],
          area: [1, "<map>", "</map>"],
          param: [1, "<object>", "</object>"],
          thead: [1, "<table>", "</table>"],
          tr: [2, "<table><tbody>", "</tbody></table>"],
          col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
          td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
          // IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
          // unless wrapped in a div with non-breaking characters in front of it.
          _default: support.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
        }, safeFragment = createSafeFragment(document2), fragmentDiv = safeFragment.appendChild(document2.createElement("div"));
        wrapMap.optgroup = wrapMap.option;
        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
        wrapMap.th = wrapMap.td;
        function getAll(context, tag) {
          var elems, elem, i2 = 0, found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName(tag || "*") : typeof context.querySelectorAll !== strundefined ? context.querySelectorAll(tag || "*") : void 0;
          if (!found) {
            for (found = [], elems = context.childNodes || context; (elem = elems[i2]) != null; i2++) {
              if (!tag || jQuery2.nodeName(elem, tag)) {
                found.push(elem);
              } else {
                jQuery2.merge(found, getAll(elem, tag));
              }
            }
          }
          return tag === void 0 || tag && jQuery2.nodeName(context, tag) ? jQuery2.merge([context], found) : found;
        }
        function fixDefaultChecked(elem) {
          if (rcheckableType.test(elem.type)) {
            elem.defaultChecked = elem.checked;
          }
        }
        function manipulationTarget(elem, content) {
          return jQuery2.nodeName(elem, "table") && jQuery2.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
        }
        function disableScript(elem) {
          elem.type = (jQuery2.find.attr(elem, "type") !== null) + "/" + elem.type;
          return elem;
        }
        function restoreScript(elem) {
          var match = rscriptTypeMasked.exec(elem.type);
          if (match) {
            elem.type = match[1];
          } else {
            elem.removeAttribute("type");
          }
          return elem;
        }
        function setGlobalEval(elems, refElements) {
          var elem, i2 = 0;
          for (; (elem = elems[i2]) != null; i2++) {
            jQuery2._data(elem, "globalEval", !refElements || jQuery2._data(refElements[i2], "globalEval"));
          }
        }
        function cloneCopyEvent(src, dest) {
          if (dest.nodeType !== 1 || !jQuery2.hasData(src)) {
            return;
          }
          var type, i2, l, oldData = jQuery2._data(src), curData = jQuery2._data(dest, oldData), events = oldData.events;
          if (events) {
            delete curData.handle;
            curData.events = {};
            for (type in events) {
              for (i2 = 0, l = events[type].length; i2 < l; i2++) {
                jQuery2.event.add(dest, type, events[type][i2]);
              }
            }
          }
          if (curData.data) {
            curData.data = jQuery2.extend({}, curData.data);
          }
        }
        function fixCloneNodeIssues(src, dest) {
          var nodeName, e, data;
          if (dest.nodeType !== 1) {
            return;
          }
          nodeName = dest.nodeName.toLowerCase();
          if (!support.noCloneEvent && dest[jQuery2.expando]) {
            data = jQuery2._data(dest);
            for (e in data.events) {
              jQuery2.removeEvent(dest, e, data.handle);
            }
            dest.removeAttribute(jQuery2.expando);
          }
          if (nodeName === "script" && dest.text !== src.text) {
            disableScript(dest).text = src.text;
            restoreScript(dest);
          } else if (nodeName === "object") {
            if (dest.parentNode) {
              dest.outerHTML = src.outerHTML;
            }
            if (support.html5Clone && (src.innerHTML && !jQuery2.trim(dest.innerHTML))) {
              dest.innerHTML = src.innerHTML;
            }
          } else if (nodeName === "input" && rcheckableType.test(src.type)) {
            dest.defaultChecked = dest.checked = src.checked;
            if (dest.value !== src.value) {
              dest.value = src.value;
            }
          } else if (nodeName === "option") {
            dest.defaultSelected = dest.selected = src.defaultSelected;
          } else if (nodeName === "input" || nodeName === "textarea") {
            dest.defaultValue = src.defaultValue;
          }
        }
        jQuery2.extend({
          clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var destElements, node, clone, i2, srcElements, inPage = jQuery2.contains(elem.ownerDocument, elem);
            if (support.html5Clone || jQuery2.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">")) {
              clone = elem.cloneNode(true);
            } else {
              fragmentDiv.innerHTML = elem.outerHTML;
              fragmentDiv.removeChild(clone = fragmentDiv.firstChild);
            }
            if ((!support.noCloneEvent || !support.noCloneChecked) && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery2.isXMLDoc(elem)) {
              destElements = getAll(clone);
              srcElements = getAll(elem);
              for (i2 = 0; (node = srcElements[i2]) != null; ++i2) {
                if (destElements[i2]) {
                  fixCloneNodeIssues(node, destElements[i2]);
                }
              }
            }
            if (dataAndEvents) {
              if (deepDataAndEvents) {
                srcElements = srcElements || getAll(elem);
                destElements = destElements || getAll(clone);
                for (i2 = 0; (node = srcElements[i2]) != null; i2++) {
                  cloneCopyEvent(node, destElements[i2]);
                }
              } else {
                cloneCopyEvent(elem, clone);
              }
            }
            destElements = getAll(clone, "script");
            if (destElements.length > 0) {
              setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            }
            destElements = srcElements = node = null;
            return clone;
          },
          buildFragment: function(elems, context, scripts, selection) {
            var j, elem, contains, tmp, tag, tbody, wrap, l = elems.length, safe = createSafeFragment(context), nodes = [], i2 = 0;
            for (; i2 < l; i2++) {
              elem = elems[i2];
              if (elem || elem === 0) {
                if (jQuery2.type(elem) === "object") {
                  jQuery2.merge(nodes, elem.nodeType ? [elem] : elem);
                } else if (!rhtml.test(elem)) {
                  nodes.push(context.createTextNode(elem));
                } else {
                  tmp = tmp || safe.appendChild(context.createElement("div"));
                  tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                  wrap = wrapMap[tag] || wrapMap._default;
                  tmp.innerHTML = wrap[1] + elem.replace(rxhtmlTag, "<$1></$2>") + wrap[2];
                  j = wrap[0];
                  while (j--) {
                    tmp = tmp.lastChild;
                  }
                  if (!support.leadingWhitespace && rleadingWhitespace.test(elem)) {
                    nodes.push(context.createTextNode(rleadingWhitespace.exec(elem)[0]));
                  }
                  if (!support.tbody) {
                    elem = tag === "table" && !rtbody.test(elem) ? tmp.firstChild : (
                      // String was a bare <thead> or <tfoot>
                      wrap[1] === "<table>" && !rtbody.test(elem) ? tmp : 0
                    );
                    j = elem && elem.childNodes.length;
                    while (j--) {
                      if (jQuery2.nodeName(tbody = elem.childNodes[j], "tbody") && !tbody.childNodes.length) {
                        elem.removeChild(tbody);
                      }
                    }
                  }
                  jQuery2.merge(nodes, tmp.childNodes);
                  tmp.textContent = "";
                  while (tmp.firstChild) {
                    tmp.removeChild(tmp.firstChild);
                  }
                  tmp = safe.lastChild;
                }
              }
            }
            if (tmp) {
              safe.removeChild(tmp);
            }
            if (!support.appendChecked) {
              jQuery2.grep(getAll(nodes, "input"), fixDefaultChecked);
            }
            i2 = 0;
            while (elem = nodes[i2++]) {
              if (selection && jQuery2.inArray(elem, selection) !== -1) {
                continue;
              }
              contains = jQuery2.contains(elem.ownerDocument, elem);
              tmp = getAll(safe.appendChild(elem), "script");
              if (contains) {
                setGlobalEval(tmp);
              }
              if (scripts) {
                j = 0;
                while (elem = tmp[j++]) {
                  if (rscriptType.test(elem.type || "")) {
                    scripts.push(elem);
                  }
                }
              }
            }
            tmp = null;
            return safe;
          },
          cleanData: function(elems, acceptData) {
            var elem, type, id, data, i2 = 0, internalKey = jQuery2.expando, cache = jQuery2.cache, deleteExpando = support.deleteExpando, special = jQuery2.event.special;
            for (; (elem = elems[i2]) != null; i2++) {
              if (acceptData || jQuery2.acceptData(elem)) {
                id = elem[internalKey];
                data = id && cache[id];
                if (data) {
                  if (data.events) {
                    for (type in data.events) {
                      if (special[type]) {
                        jQuery2.event.remove(elem, type);
                      } else {
                        jQuery2.removeEvent(elem, type, data.handle);
                      }
                    }
                  }
                  if (cache[id]) {
                    delete cache[id];
                    if (deleteExpando) {
                      delete elem[internalKey];
                    } else if (typeof elem.removeAttribute !== strundefined) {
                      elem.removeAttribute(internalKey);
                    } else {
                      elem[internalKey] = null;
                    }
                    deletedIds.push(id);
                  }
                }
              }
            }
          }
        });
        jQuery2.fn.extend({
          text: function(value) {
            return access(this, function(value2) {
              return value2 === void 0 ? jQuery2.text(this) : this.empty().append((this[0] && this[0].ownerDocument || document2).createTextNode(value2));
            }, null, value, arguments.length);
          },
          append: function() {
            return this.domManip(arguments, function(elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.appendChild(elem);
              }
            });
          },
          prepend: function() {
            return this.domManip(arguments, function(elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.insertBefore(elem, target.firstChild);
              }
            });
          },
          before: function() {
            return this.domManip(arguments, function(elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this);
              }
            });
          },
          after: function() {
            return this.domManip(arguments, function(elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this.nextSibling);
              }
            });
          },
          remove: function(selector, keepData) {
            var elem, elems = selector ? jQuery2.filter(selector, this) : this, i2 = 0;
            for (; (elem = elems[i2]) != null; i2++) {
              if (!keepData && elem.nodeType === 1) {
                jQuery2.cleanData(getAll(elem));
              }
              if (elem.parentNode) {
                if (keepData && jQuery2.contains(elem.ownerDocument, elem)) {
                  setGlobalEval(getAll(elem, "script"));
                }
                elem.parentNode.removeChild(elem);
              }
            }
            return this;
          },
          empty: function() {
            var elem, i2 = 0;
            for (; (elem = this[i2]) != null; i2++) {
              if (elem.nodeType === 1) {
                jQuery2.cleanData(getAll(elem, false));
              }
              while (elem.firstChild) {
                elem.removeChild(elem.firstChild);
              }
              if (elem.options && jQuery2.nodeName(elem, "select")) {
                elem.options.length = 0;
              }
            }
            return this;
          },
          clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
              return jQuery2.clone(this, dataAndEvents, deepDataAndEvents);
            });
          },
          html: function(value) {
            return access(this, function(value2) {
              var elem = this[0] || {}, i2 = 0, l = this.length;
              if (value2 === void 0) {
                return elem.nodeType === 1 ? elem.innerHTML.replace(rinlinejQuery, "") : void 0;
              }
              if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && (support.htmlSerialize || !rnoshimcache.test(value2)) && (support.leadingWhitespace || !rleadingWhitespace.test(value2)) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
                value2 = value2.replace(rxhtmlTag, "<$1></$2>");
                try {
                  for (; i2 < l; i2++) {
                    elem = this[i2] || {};
                    if (elem.nodeType === 1) {
                      jQuery2.cleanData(getAll(elem, false));
                      elem.innerHTML = value2;
                    }
                  }
                  elem = 0;
                } catch (e) {
                }
              }
              if (elem) {
                this.empty().append(value2);
              }
            }, null, value, arguments.length);
          },
          replaceWith: function() {
            var arg = arguments[0];
            this.domManip(arguments, function(elem) {
              arg = this.parentNode;
              jQuery2.cleanData(getAll(this));
              if (arg) {
                arg.replaceChild(elem, this);
              }
            });
            return arg && (arg.length || arg.nodeType) ? this : this.remove();
          },
          detach: function(selector) {
            return this.remove(selector, true);
          },
          domManip: function(args, callback) {
            args = concat.apply([], args);
            var first, node, hasScripts, scripts, doc, fragment, i2 = 0, l = this.length, set = this, iNoClone = l - 1, value = args[0], isFunction = jQuery2.isFunction(value);
            if (isFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
              return this.each(function(index) {
                var self2 = set.eq(index);
                if (isFunction) {
                  args[0] = value.call(this, index, self2.html());
                }
                self2.domManip(args, callback);
              });
            }
            if (l) {
              fragment = jQuery2.buildFragment(args, this[0].ownerDocument, false, this);
              first = fragment.firstChild;
              if (fragment.childNodes.length === 1) {
                fragment = first;
              }
              if (first) {
                scripts = jQuery2.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                for (; i2 < l; i2++) {
                  node = fragment;
                  if (i2 !== iNoClone) {
                    node = jQuery2.clone(node, true, true);
                    if (hasScripts) {
                      jQuery2.merge(scripts, getAll(node, "script"));
                    }
                  }
                  callback.call(this[i2], node, i2);
                }
                if (hasScripts) {
                  doc = scripts[scripts.length - 1].ownerDocument;
                  jQuery2.map(scripts, restoreScript);
                  for (i2 = 0; i2 < hasScripts; i2++) {
                    node = scripts[i2];
                    if (rscriptType.test(node.type || "") && !jQuery2._data(node, "globalEval") && jQuery2.contains(doc, node)) {
                      if (node.src) {
                        if (jQuery2._evalUrl) {
                          jQuery2._evalUrl(node.src);
                        }
                      } else {
                        jQuery2.globalEval((node.text || node.textContent || node.innerHTML || "").replace(rcleanScript, ""));
                      }
                    }
                  }
                }
                fragment = first = null;
              }
            }
            return this;
          }
        });
        jQuery2.each({
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith"
        }, function(name, original) {
          jQuery2.fn[name] = function(selector) {
            var elems, i2 = 0, ret = [], insert = jQuery2(selector), last = insert.length - 1;
            for (; i2 <= last; i2++) {
              elems = i2 === last ? this : this.clone(true);
              jQuery2(insert[i2])[original](elems);
              push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
          };
        });
        var iframe, elemdisplay = {};
        function actualDisplay(name, doc) {
          var style, elem = jQuery2(doc.createElement(name)).appendTo(doc.body), display = window2.getDefaultComputedStyle && (style = window2.getDefaultComputedStyle(elem[0])) ? (
            // Use of this method is a temporary fix (more like optmization) until something better comes along,
            // since it was removed from specification and supported only in FF
            style.display
          ) : jQuery2.css(elem[0], "display");
          elem.detach();
          return display;
        }
        function defaultDisplay(nodeName) {
          var doc = document2, display = elemdisplay[nodeName];
          if (!display) {
            display = actualDisplay(nodeName, doc);
            if (display === "none" || !display) {
              iframe = (iframe || jQuery2("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement);
              doc = (iframe[0].contentWindow || iframe[0].contentDocument).document;
              doc.write();
              doc.close();
              display = actualDisplay(nodeName, doc);
              iframe.detach();
            }
            elemdisplay[nodeName] = display;
          }
          return display;
        }
        (function() {
          var shrinkWrapBlocksVal;
          support.shrinkWrapBlocks = function() {
            if (shrinkWrapBlocksVal != null) {
              return shrinkWrapBlocksVal;
            }
            shrinkWrapBlocksVal = false;
            var div, body, container;
            body = document2.getElementsByTagName("body")[0];
            if (!body || !body.style) {
              return;
            }
            div = document2.createElement("div");
            container = document2.createElement("div");
            container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
            body.appendChild(container).appendChild(div);
            if (typeof div.style.zoom !== strundefined) {
              div.style.cssText = // Support: Firefox<29, Android 2.3
              // Vendor-prefix box-sizing
              "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1";
              div.appendChild(document2.createElement("div")).style.width = "5px";
              shrinkWrapBlocksVal = div.offsetWidth !== 3;
            }
            body.removeChild(container);
            return shrinkWrapBlocksVal;
          };
        })();
        var rmargin = /^margin/;
        var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
        var getStyles, curCSS, rposition = /^(top|right|bottom|left)$/;
        if (window2.getComputedStyle) {
          getStyles = function(elem) {
            if (elem.ownerDocument.defaultView.opener) {
              return elem.ownerDocument.defaultView.getComputedStyle(elem, null);
            }
            return window2.getComputedStyle(elem, null);
          };
          curCSS = function(elem, name, computed) {
            var width, minWidth, maxWidth, ret, style = elem.style;
            computed = computed || getStyles(elem);
            ret = computed ? computed.getPropertyValue(name) || computed[name] : void 0;
            if (computed) {
              if (ret === "" && !jQuery2.contains(elem.ownerDocument, elem)) {
                ret = jQuery2.style(elem, name);
              }
              if (rnumnonpx.test(ret) && rmargin.test(name)) {
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
              }
            }
            return ret === void 0 ? ret : ret + "";
          };
        } else if (document2.documentElement.currentStyle) {
          getStyles = function(elem) {
            return elem.currentStyle;
          };
          curCSS = function(elem, name, computed) {
            var left, rs, rsLeft, ret, style = elem.style;
            computed = computed || getStyles(elem);
            ret = computed ? computed[name] : void 0;
            if (ret == null && style && style[name]) {
              ret = style[name];
            }
            if (rnumnonpx.test(ret) && !rposition.test(name)) {
              left = style.left;
              rs = elem.runtimeStyle;
              rsLeft = rs && rs.left;
              if (rsLeft) {
                rs.left = elem.currentStyle.left;
              }
              style.left = name === "fontSize" ? "1em" : ret;
              ret = style.pixelLeft + "px";
              style.left = left;
              if (rsLeft) {
                rs.left = rsLeft;
              }
            }
            return ret === void 0 ? ret : ret + "" || "auto";
          };
        }
        function addGetHookIf(conditionFn, hookFn) {
          return {
            get: function() {
              var condition = conditionFn();
              if (condition == null) {
                return;
              }
              if (condition) {
                delete this.get;
                return;
              }
              return (this.get = hookFn).apply(this, arguments);
            }
          };
        }
        (function() {
          var div, style, a, pixelPositionVal, boxSizingReliableVal, reliableHiddenOffsetsVal, reliableMarginRightVal;
          div = document2.createElement("div");
          div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
          a = div.getElementsByTagName("a")[0];
          style = a && a.style;
          if (!style) {
            return;
          }
          style.cssText = "float:left;opacity:.5";
          support.opacity = style.opacity === "0.5";
          support.cssFloat = !!style.cssFloat;
          div.style.backgroundClip = "content-box";
          div.cloneNode(true).style.backgroundClip = "";
          support.clearCloneStyle = div.style.backgroundClip === "content-box";
          support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" || style.WebkitBoxSizing === "";
          jQuery2.extend(support, {
            reliableHiddenOffsets: function() {
              if (reliableHiddenOffsetsVal == null) {
                computeStyleTests();
              }
              return reliableHiddenOffsetsVal;
            },
            boxSizingReliable: function() {
              if (boxSizingReliableVal == null) {
                computeStyleTests();
              }
              return boxSizingReliableVal;
            },
            pixelPosition: function() {
              if (pixelPositionVal == null) {
                computeStyleTests();
              }
              return pixelPositionVal;
            },
            // Support: Android 2.3
            reliableMarginRight: function() {
              if (reliableMarginRightVal == null) {
                computeStyleTests();
              }
              return reliableMarginRightVal;
            }
          });
          function computeStyleTests() {
            var div2, body, container, contents;
            body = document2.getElementsByTagName("body")[0];
            if (!body || !body.style) {
              return;
            }
            div2 = document2.createElement("div");
            container = document2.createElement("div");
            container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
            body.appendChild(container).appendChild(div2);
            div2.style.cssText = // Support: Firefox<29, Android 2.3
            // Vendor-prefix box-sizing
            "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute";
            pixelPositionVal = boxSizingReliableVal = false;
            reliableMarginRightVal = true;
            if (window2.getComputedStyle) {
              pixelPositionVal = (window2.getComputedStyle(div2, null) || {}).top !== "1%";
              boxSizingReliableVal = (window2.getComputedStyle(div2, null) || { width: "4px" }).width === "4px";
              contents = div2.appendChild(document2.createElement("div"));
              contents.style.cssText = div2.style.cssText = // Support: Firefox<29, Android 2.3
              // Vendor-prefix box-sizing
              "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0";
              contents.style.marginRight = contents.style.width = "0";
              div2.style.width = "1px";
              reliableMarginRightVal = !parseFloat((window2.getComputedStyle(contents, null) || {}).marginRight);
              div2.removeChild(contents);
            }
            div2.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
            contents = div2.getElementsByTagName("td");
            contents[0].style.cssText = "margin:0;border:0;padding:0;display:none";
            reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
            if (reliableHiddenOffsetsVal) {
              contents[0].style.display = "";
              contents[1].style.display = "none";
              reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
            }
            body.removeChild(container);
          }
        })();
        jQuery2.swap = function(elem, options, callback, args) {
          var ret, name, old = {};
          for (name in options) {
            old[name] = elem.style[name];
            elem.style[name] = options[name];
          }
          ret = callback.apply(elem, args || []);
          for (name in options) {
            elem.style[name] = old[name];
          }
          return ret;
        };
        var ralpha = /alpha\([^)]*\)/i, ropacity = /opacity\s*=\s*([^)]*)/, rdisplayswap = /^(none|table(?!-c[ea]).+)/, rnumsplit = new RegExp("^(" + pnum + ")(.*)$", "i"), rrelNum = new RegExp("^([+-])=(" + pnum + ")", "i"), cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
          letterSpacing: "0",
          fontWeight: "400"
        }, cssPrefixes = ["Webkit", "O", "Moz", "ms"];
        function vendorPropName(style, name) {
          if (name in style) {
            return name;
          }
          var capName = name.charAt(0).toUpperCase() + name.slice(1), origName = name, i2 = cssPrefixes.length;
          while (i2--) {
            name = cssPrefixes[i2] + capName;
            if (name in style) {
              return name;
            }
          }
          return origName;
        }
        function showHide(elements, show) {
          var display, elem, hidden, values = [], index = 0, length = elements.length;
          for (; index < length; index++) {
            elem = elements[index];
            if (!elem.style) {
              continue;
            }
            values[index] = jQuery2._data(elem, "olddisplay");
            display = elem.style.display;
            if (show) {
              if (!values[index] && display === "none") {
                elem.style.display = "";
              }
              if (elem.style.display === "" && isHidden(elem)) {
                values[index] = jQuery2._data(elem, "olddisplay", defaultDisplay(elem.nodeName));
              }
            } else {
              hidden = isHidden(elem);
              if (display && display !== "none" || !hidden) {
                jQuery2._data(elem, "olddisplay", hidden ? display : jQuery2.css(elem, "display"));
              }
            }
          }
          for (index = 0; index < length; index++) {
            elem = elements[index];
            if (!elem.style) {
              continue;
            }
            if (!show || elem.style.display === "none" || elem.style.display === "") {
              elem.style.display = show ? values[index] || "" : "none";
            }
          }
          return elements;
        }
        function setPositiveNumber(elem, value, subtract) {
          var matches = rnumsplit.exec(value);
          return matches ? (
            // Guard against undefined "subtract", e.g., when used as in cssHooks
            Math.max(0, matches[1] - (subtract || 0)) + (matches[2] || "px")
          ) : value;
        }
        function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
          var i2 = extra === (isBorderBox ? "border" : "content") ? (
            // If we already have the right measurement, avoid augmentation
            4
          ) : (
            // Otherwise initialize for horizontal or vertical properties
            name === "width" ? 1 : 0
          ), val = 0;
          for (; i2 < 4; i2 += 2) {
            if (extra === "margin") {
              val += jQuery2.css(elem, extra + cssExpand[i2], true, styles);
            }
            if (isBorderBox) {
              if (extra === "content") {
                val -= jQuery2.css(elem, "padding" + cssExpand[i2], true, styles);
              }
              if (extra !== "margin") {
                val -= jQuery2.css(elem, "border" + cssExpand[i2] + "Width", true, styles);
              }
            } else {
              val += jQuery2.css(elem, "padding" + cssExpand[i2], true, styles);
              if (extra !== "padding") {
                val += jQuery2.css(elem, "border" + cssExpand[i2] + "Width", true, styles);
              }
            }
          }
          return val;
        }
        function getWidthOrHeight(elem, name, extra) {
          var valueIsBorderBox = true, val = name === "width" ? elem.offsetWidth : elem.offsetHeight, styles = getStyles(elem), isBorderBox = support.boxSizing && jQuery2.css(elem, "boxSizing", false, styles) === "border-box";
          if (val <= 0 || val == null) {
            val = curCSS(elem, name, styles);
            if (val < 0 || val == null) {
              val = elem.style[name];
            }
            if (rnumnonpx.test(val)) {
              return val;
            }
            valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]);
            val = parseFloat(val) || 0;
          }
          return val + augmentWidthOrHeight(
            elem,
            name,
            extra || (isBorderBox ? "border" : "content"),
            valueIsBorderBox,
            styles
          ) + "px";
        }
        jQuery2.extend({
          // Add in style property hooks for overriding the default
          // behavior of getting and setting a style property
          cssHooks: {
            opacity: {
              get: function(elem, computed) {
                if (computed) {
                  var ret = curCSS(elem, "opacity");
                  return ret === "" ? "1" : ret;
                }
              }
            }
          },
          // Don't automatically add "px" to these possibly-unitless properties
          cssNumber: {
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
          },
          // Add in properties whose names you wish to fix before
          // setting or getting the value
          cssProps: {
            // normalize float css property
            "float": support.cssFloat ? "cssFloat" : "styleFloat"
          },
          // Get and set the style property on a DOM Node
          style: function(elem, name, value, extra) {
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
              return;
            }
            var ret, type, hooks, origName = jQuery2.camelCase(name), style = elem.style;
            name = jQuery2.cssProps[origName] || (jQuery2.cssProps[origName] = vendorPropName(style, origName));
            hooks = jQuery2.cssHooks[name] || jQuery2.cssHooks[origName];
            if (value !== void 0) {
              type = typeof value;
              if (type === "string" && (ret = rrelNum.exec(value))) {
                value = (ret[1] + 1) * ret[2] + parseFloat(jQuery2.css(elem, name));
                type = "number";
              }
              if (value == null || value !== value) {
                return;
              }
              if (type === "number" && !jQuery2.cssNumber[origName]) {
                value += "px";
              }
              if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                style[name] = "inherit";
              }
              if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== void 0) {
                try {
                  style[name] = value;
                } catch (e) {
                }
              }
            } else {
              if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== void 0) {
                return ret;
              }
              return style[name];
            }
          },
          css: function(elem, name, extra, styles) {
            var num, val, hooks, origName = jQuery2.camelCase(name);
            name = jQuery2.cssProps[origName] || (jQuery2.cssProps[origName] = vendorPropName(elem.style, origName));
            hooks = jQuery2.cssHooks[name] || jQuery2.cssHooks[origName];
            if (hooks && "get" in hooks) {
              val = hooks.get(elem, true, extra);
            }
            if (val === void 0) {
              val = curCSS(elem, name, styles);
            }
            if (val === "normal" && name in cssNormalTransform) {
              val = cssNormalTransform[name];
            }
            if (extra === "" || extra) {
              num = parseFloat(val);
              return extra === true || jQuery2.isNumeric(num) ? num || 0 : val;
            }
            return val;
          }
        });
        jQuery2.each(["height", "width"], function(i2, name) {
          jQuery2.cssHooks[name] = {
            get: function(elem, computed, extra) {
              if (computed) {
                return rdisplayswap.test(jQuery2.css(elem, "display")) && elem.offsetWidth === 0 ? jQuery2.swap(elem, cssShow, function() {
                  return getWidthOrHeight(elem, name, extra);
                }) : getWidthOrHeight(elem, name, extra);
              }
            },
            set: function(elem, value, extra) {
              var styles = extra && getStyles(elem);
              return setPositiveNumber(
                elem,
                value,
                extra ? augmentWidthOrHeight(
                  elem,
                  name,
                  extra,
                  support.boxSizing && jQuery2.css(elem, "boxSizing", false, styles) === "border-box",
                  styles
                ) : 0
              );
            }
          };
        });
        if (!support.opacity) {
          jQuery2.cssHooks.opacity = {
            get: function(elem, computed) {
              return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? 0.01 * parseFloat(RegExp.$1) + "" : computed ? "1" : "";
            },
            set: function(elem, value) {
              var style = elem.style, currentStyle = elem.currentStyle, opacity = jQuery2.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "", filter = currentStyle && currentStyle.filter || style.filter || "";
              style.zoom = 1;
              if ((value >= 1 || value === "") && jQuery2.trim(filter.replace(ralpha, "")) === "" && style.removeAttribute) {
                style.removeAttribute("filter");
                if (value === "" || currentStyle && !currentStyle.filter) {
                  return;
                }
              }
              style.filter = ralpha.test(filter) ? filter.replace(ralpha, opacity) : filter + " " + opacity;
            }
          };
        }
        jQuery2.cssHooks.marginRight = addGetHookIf(
          support.reliableMarginRight,
          function(elem, computed) {
            if (computed) {
              return jQuery2.swap(
                elem,
                { "display": "inline-block" },
                curCSS,
                [elem, "marginRight"]
              );
            }
          }
        );
        jQuery2.each({
          margin: "",
          padding: "",
          border: "Width"
        }, function(prefix, suffix) {
          jQuery2.cssHooks[prefix + suffix] = {
            expand: function(value) {
              var i2 = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
              for (; i2 < 4; i2++) {
                expanded[prefix + cssExpand[i2] + suffix] = parts[i2] || parts[i2 - 2] || parts[0];
              }
              return expanded;
            }
          };
          if (!rmargin.test(prefix)) {
            jQuery2.cssHooks[prefix + suffix].set = setPositiveNumber;
          }
        });
        jQuery2.fn.extend({
          css: function(name, value) {
            return access(this, function(elem, name2, value2) {
              var styles, len, map = {}, i2 = 0;
              if (jQuery2.isArray(name2)) {
                styles = getStyles(elem);
                len = name2.length;
                for (; i2 < len; i2++) {
                  map[name2[i2]] = jQuery2.css(elem, name2[i2], false, styles);
                }
                return map;
              }
              return value2 !== void 0 ? jQuery2.style(elem, name2, value2) : jQuery2.css(elem, name2);
            }, name, value, arguments.length > 1);
          },
          show: function() {
            return showHide(this, true);
          },
          hide: function() {
            return showHide(this);
          },
          toggle: function(state) {
            if (typeof state === "boolean") {
              return state ? this.show() : this.hide();
            }
            return this.each(function() {
              if (isHidden(this)) {
                jQuery2(this).show();
              } else {
                jQuery2(this).hide();
              }
            });
          }
        });
        function Tween(elem, options, prop, end, easing) {
          return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery2.Tween = Tween;
        Tween.prototype = {
          constructor: Tween,
          init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || "swing";
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery2.cssNumber[prop] ? "" : "px");
          },
          cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
          },
          run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) {
              this.pos = eased = jQuery2.easing[this.easing](
                percent,
                this.options.duration * percent,
                0,
                1,
                this.options.duration
              );
            } else {
              this.pos = eased = percent;
            }
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) {
              this.options.step.call(this.elem, this.now, this);
            }
            if (hooks && hooks.set) {
              hooks.set(this);
            } else {
              Tween.propHooks._default.set(this);
            }
            return this;
          }
        };
        Tween.prototype.init.prototype = Tween.prototype;
        Tween.propHooks = {
          _default: {
            get: function(tween) {
              var result;
              if (tween.elem[tween.prop] != null && (!tween.elem.style || tween.elem.style[tween.prop] == null)) {
                return tween.elem[tween.prop];
              }
              result = jQuery2.css(tween.elem, tween.prop, "");
              return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
              if (jQuery2.fx.step[tween.prop]) {
                jQuery2.fx.step[tween.prop](tween);
              } else if (tween.elem.style && (tween.elem.style[jQuery2.cssProps[tween.prop]] != null || jQuery2.cssHooks[tween.prop])) {
                jQuery2.style(tween.elem, tween.prop, tween.now + tween.unit);
              } else {
                tween.elem[tween.prop] = tween.now;
              }
            }
          }
        };
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
          set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) {
              tween.elem[tween.prop] = tween.now;
            }
          }
        };
        jQuery2.easing = {
          linear: function(p) {
            return p;
          },
          swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
          }
        };
        jQuery2.fx = Tween.prototype.init;
        jQuery2.fx.step = {};
        var fxNow, timerId, rfxtypes = /^(?:toggle|show|hide)$/, rfxnum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i"), rrun = /queueHooks$/, animationPrefilters = [defaultPrefilter], tweeners = {
          "*": [function(prop, value) {
            var tween = this.createTween(prop, value), target = tween.cur(), parts = rfxnum.exec(value), unit = parts && parts[3] || (jQuery2.cssNumber[prop] ? "" : "px"), start = (jQuery2.cssNumber[prop] || unit !== "px" && +target) && rfxnum.exec(jQuery2.css(tween.elem, prop)), scale = 1, maxIterations = 20;
            if (start && start[3] !== unit) {
              unit = unit || start[3];
              parts = parts || [];
              start = +target || 1;
              do {
                scale = scale || ".5";
                start = start / scale;
                jQuery2.style(tween.elem, prop, start + unit);
              } while (scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations);
            }
            if (parts) {
              start = tween.start = +start || +target || 0;
              tween.unit = unit;
              tween.end = parts[1] ? start + (parts[1] + 1) * parts[2] : +parts[2];
            }
            return tween;
          }]
        };
        function createFxNow() {
          setTimeout(function() {
            fxNow = void 0;
          });
          return fxNow = jQuery2.now();
        }
        function genFx(type, includeWidth) {
          var which, attrs = { height: type }, i2 = 0;
          includeWidth = includeWidth ? 1 : 0;
          for (; i2 < 4; i2 += 2 - includeWidth) {
            which = cssExpand[i2];
            attrs["margin" + which] = attrs["padding" + which] = type;
          }
          if (includeWidth) {
            attrs.opacity = attrs.width = type;
          }
          return attrs;
        }
        function createTween(value, prop, animation) {
          var tween, collection = (tweeners[prop] || []).concat(tweeners["*"]), index = 0, length = collection.length;
          for (; index < length; index++) {
            if (tween = collection[index].call(animation, prop, value)) {
              return tween;
            }
          }
        }
        function defaultPrefilter(elem, props, opts) {
          var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHidden(elem), dataShow = jQuery2._data(elem, "fxshow");
          if (!opts.queue) {
            hooks = jQuery2._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
              hooks.unqueued = 0;
              oldfire = hooks.empty.fire;
              hooks.empty.fire = function() {
                if (!hooks.unqueued) {
                  oldfire();
                }
              };
            }
            hooks.unqueued++;
            anim.always(function() {
              anim.always(function() {
                hooks.unqueued--;
                if (!jQuery2.queue(elem, "fx").length) {
                  hooks.empty.fire();
                }
              });
            });
          }
          if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
            opts.overflow = [style.overflow, style.overflowX, style.overflowY];
            display = jQuery2.css(elem, "display");
            checkDisplay = display === "none" ? jQuery2._data(elem, "olddisplay") || defaultDisplay(elem.nodeName) : display;
            if (checkDisplay === "inline" && jQuery2.css(elem, "float") === "none") {
              if (!support.inlineBlockNeedsLayout || defaultDisplay(elem.nodeName) === "inline") {
                style.display = "inline-block";
              } else {
                style.zoom = 1;
              }
            }
          }
          if (opts.overflow) {
            style.overflow = "hidden";
            if (!support.shrinkWrapBlocks()) {
              anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
              });
            }
          }
          for (prop in props) {
            value = props[prop];
            if (rfxtypes.exec(value)) {
              delete props[prop];
              toggle = toggle || value === "toggle";
              if (value === (hidden ? "hide" : "show")) {
                if (value === "show" && dataShow && dataShow[prop] !== void 0) {
                  hidden = true;
                } else {
                  continue;
                }
              }
              orig[prop] = dataShow && dataShow[prop] || jQuery2.style(elem, prop);
            } else {
              display = void 0;
            }
          }
          if (!jQuery2.isEmptyObject(orig)) {
            if (dataShow) {
              if ("hidden" in dataShow) {
                hidden = dataShow.hidden;
              }
            } else {
              dataShow = jQuery2._data(elem, "fxshow", {});
            }
            if (toggle) {
              dataShow.hidden = !hidden;
            }
            if (hidden) {
              jQuery2(elem).show();
            } else {
              anim.done(function() {
                jQuery2(elem).hide();
              });
            }
            anim.done(function() {
              var prop2;
              jQuery2._removeData(elem, "fxshow");
              for (prop2 in orig) {
                jQuery2.style(elem, prop2, orig[prop2]);
              }
            });
            for (prop in orig) {
              tween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
              if (!(prop in dataShow)) {
                dataShow[prop] = tween.start;
                if (hidden) {
                  tween.end = tween.start;
                  tween.start = prop === "width" || prop === "height" ? 1 : 0;
                }
              }
            }
          } else if ((display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline") {
            style.display = display;
          }
        }
        function propFilter(props, specialEasing) {
          var index, name, easing, value, hooks;
          for (index in props) {
            name = jQuery2.camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (jQuery2.isArray(value)) {
              easing = value[1];
              value = props[index] = value[0];
            }
            if (index !== name) {
              props[name] = value;
              delete props[index];
            }
            hooks = jQuery2.cssHooks[name];
            if (hooks && "expand" in hooks) {
              value = hooks.expand(value);
              delete props[name];
              for (index in value) {
                if (!(index in props)) {
                  props[index] = value[index];
                  specialEasing[index] = easing;
                }
              }
            } else {
              specialEasing[name] = easing;
            }
          }
        }
        function Animation(elem, properties, options) {
          var result, stopped, index = 0, length = animationPrefilters.length, deferred = jQuery2.Deferred().always(function() {
            delete tick.elem;
          }), tick = function() {
            if (stopped) {
              return false;
            }
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp = remaining / animation.duration || 0, percent = 1 - temp, index2 = 0, length2 = animation.tweens.length;
            for (; index2 < length2; index2++) {
              animation.tweens[index2].run(percent);
            }
            deferred.notifyWith(elem, [animation, percent, remaining]);
            if (percent < 1 && length2) {
              return remaining;
            } else {
              deferred.resolveWith(elem, [animation]);
              return false;
            }
          }, animation = deferred.promise({
            elem,
            props: jQuery2.extend({}, properties),
            opts: jQuery2.extend(true, { specialEasing: {} }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
              var tween = jQuery2.Tween(
                elem,
                animation.opts,
                prop,
                end,
                animation.opts.specialEasing[prop] || animation.opts.easing
              );
              animation.tweens.push(tween);
              return tween;
            },
            stop: function(gotoEnd) {
              var index2 = 0, length2 = gotoEnd ? animation.tweens.length : 0;
              if (stopped) {
                return this;
              }
              stopped = true;
              for (; index2 < length2; index2++) {
                animation.tweens[index2].run(1);
              }
              if (gotoEnd) {
                deferred.resolveWith(elem, [animation, gotoEnd]);
              } else {
                deferred.rejectWith(elem, [animation, gotoEnd]);
              }
              return this;
            }
          }), props = animation.props;
          propFilter(props, animation.opts.specialEasing);
          for (; index < length; index++) {
            result = animationPrefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
              return result;
            }
          }
          jQuery2.map(props, createTween, animation);
          if (jQuery2.isFunction(animation.opts.start)) {
            animation.opts.start.call(elem, animation);
          }
          jQuery2.fx.timer(
            jQuery2.extend(tick, {
              elem,
              anim: animation,
              queue: animation.opts.queue
            })
          );
          return animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        }
        jQuery2.Animation = jQuery2.extend(Animation, {
          tweener: function(props, callback) {
            if (jQuery2.isFunction(props)) {
              callback = props;
              props = ["*"];
            } else {
              props = props.split(" ");
            }
            var prop, index = 0, length = props.length;
            for (; index < length; index++) {
              prop = props[index];
              tweeners[prop] = tweeners[prop] || [];
              tweeners[prop].unshift(callback);
            }
          },
          prefilter: function(callback, prepend) {
            if (prepend) {
              animationPrefilters.unshift(callback);
            } else {
              animationPrefilters.push(callback);
            }
          }
        });
        jQuery2.speed = function(speed, easing, fn) {
          var opt = speed && typeof speed === "object" ? jQuery2.extend({}, speed) : {
            complete: fn || !fn && easing || jQuery2.isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !jQuery2.isFunction(easing) && easing
          };
          opt.duration = jQuery2.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery2.fx.speeds ? jQuery2.fx.speeds[opt.duration] : jQuery2.fx.speeds._default;
          if (opt.queue == null || opt.queue === true) {
            opt.queue = "fx";
          }
          opt.old = opt.complete;
          opt.complete = function() {
            if (jQuery2.isFunction(opt.old)) {
              opt.old.call(this);
            }
            if (opt.queue) {
              jQuery2.dequeue(this, opt.queue);
            }
          };
          return opt;
        };
        jQuery2.fn.extend({
          fadeTo: function(speed, to, easing, callback) {
            return this.filter(isHidden).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
          },
          animate: function(prop, speed, easing, callback) {
            var empty = jQuery2.isEmptyObject(prop), optall = jQuery2.speed(speed, easing, callback), doAnimation = function() {
              var anim = Animation(this, jQuery2.extend({}, prop), optall);
              if (empty || jQuery2._data(this, "finish")) {
                anim.stop(true);
              }
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
          },
          stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
              var stop = hooks.stop;
              delete hooks.stop;
              stop(gotoEnd);
            };
            if (typeof type !== "string") {
              gotoEnd = clearQueue;
              clearQueue = type;
              type = void 0;
            }
            if (clearQueue && type !== false) {
              this.queue(type || "fx", []);
            }
            return this.each(function() {
              var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery2.timers, data = jQuery2._data(this);
              if (index) {
                if (data[index] && data[index].stop) {
                  stopQueue(data[index]);
                }
              } else {
                for (index in data) {
                  if (data[index] && data[index].stop && rrun.test(index)) {
                    stopQueue(data[index]);
                  }
                }
              }
              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                  timers[index].anim.stop(gotoEnd);
                  dequeue = false;
                  timers.splice(index, 1);
                }
              }
              if (dequeue || !gotoEnd) {
                jQuery2.dequeue(this, type);
              }
            });
          },
          finish: function(type) {
            if (type !== false) {
              type = type || "fx";
            }
            return this.each(function() {
              var index, data = jQuery2._data(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery2.timers, length = queue ? queue.length : 0;
              data.finish = true;
              jQuery2.queue(this, type, []);
              if (hooks && hooks.stop) {
                hooks.stop.call(this, true);
              }
              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && timers[index].queue === type) {
                  timers[index].anim.stop(true);
                  timers.splice(index, 1);
                }
              }
              for (index = 0; index < length; index++) {
                if (queue[index] && queue[index].finish) {
                  queue[index].finish.call(this);
                }
              }
              delete data.finish;
            });
          }
        });
        jQuery2.each(["toggle", "show", "hide"], function(i2, name) {
          var cssFn = jQuery2.fn[name];
          jQuery2.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
          };
        });
        jQuery2.each({
          slideDown: genFx("show"),
          slideUp: genFx("hide"),
          slideToggle: genFx("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" }
        }, function(name, props) {
          jQuery2.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
          };
        });
        jQuery2.timers = [];
        jQuery2.fx.tick = function() {
          var timer, timers = jQuery2.timers, i2 = 0;
          fxNow = jQuery2.now();
          for (; i2 < timers.length; i2++) {
            timer = timers[i2];
            if (!timer() && timers[i2] === timer) {
              timers.splice(i2--, 1);
            }
          }
          if (!timers.length) {
            jQuery2.fx.stop();
          }
          fxNow = void 0;
        };
        jQuery2.fx.timer = function(timer) {
          jQuery2.timers.push(timer);
          if (timer()) {
            jQuery2.fx.start();
          } else {
            jQuery2.timers.pop();
          }
        };
        jQuery2.fx.interval = 13;
        jQuery2.fx.start = function() {
          if (!timerId) {
            timerId = setInterval(jQuery2.fx.tick, jQuery2.fx.interval);
          }
        };
        jQuery2.fx.stop = function() {
          clearInterval(timerId);
          timerId = null;
        };
        jQuery2.fx.speeds = {
          slow: 600,
          fast: 200,
          // Default speed
          _default: 400
        };
        jQuery2.fn.delay = function(time, type) {
          time = jQuery2.fx ? jQuery2.fx.speeds[time] || time : time;
          type = type || "fx";
          return this.queue(type, function(next, hooks) {
            var timeout = setTimeout(next, time);
            hooks.stop = function() {
              clearTimeout(timeout);
            };
          });
        };
        (function() {
          var input, div, select, a, opt;
          div = document2.createElement("div");
          div.setAttribute("className", "t");
          div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
          a = div.getElementsByTagName("a")[0];
          select = document2.createElement("select");
          opt = select.appendChild(document2.createElement("option"));
          input = div.getElementsByTagName("input")[0];
          a.style.cssText = "top:1px";
          support.getSetAttribute = div.className !== "t";
          support.style = /top/.test(a.getAttribute("style"));
          support.hrefNormalized = a.getAttribute("href") === "/a";
          support.checkOn = !!input.value;
          support.optSelected = opt.selected;
          support.enctype = !!document2.createElement("form").enctype;
          select.disabled = true;
          support.optDisabled = !opt.disabled;
          input = document2.createElement("input");
          input.setAttribute("value", "");
          support.input = input.getAttribute("value") === "";
          input.value = "t";
          input.setAttribute("type", "radio");
          support.radioValue = input.value === "t";
        })();
        var rreturn = /\r/g;
        jQuery2.fn.extend({
          val: function(value) {
            var hooks, ret, isFunction, elem = this[0];
            if (!arguments.length) {
              if (elem) {
                hooks = jQuery2.valHooks[elem.type] || jQuery2.valHooks[elem.nodeName.toLowerCase()];
                if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== void 0) {
                  return ret;
                }
                ret = elem.value;
                return typeof ret === "string" ? (
                  // handle most common string cases
                  ret.replace(rreturn, "")
                ) : (
                  // handle cases where value is null/undef or number
                  ret == null ? "" : ret
                );
              }
              return;
            }
            isFunction = jQuery2.isFunction(value);
            return this.each(function(i2) {
              var val;
              if (this.nodeType !== 1) {
                return;
              }
              if (isFunction) {
                val = value.call(this, i2, jQuery2(this).val());
              } else {
                val = value;
              }
              if (val == null) {
                val = "";
              } else if (typeof val === "number") {
                val += "";
              } else if (jQuery2.isArray(val)) {
                val = jQuery2.map(val, function(value2) {
                  return value2 == null ? "" : value2 + "";
                });
              }
              hooks = jQuery2.valHooks[this.type] || jQuery2.valHooks[this.nodeName.toLowerCase()];
              if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === void 0) {
                this.value = val;
              }
            });
          }
        });
        jQuery2.extend({
          valHooks: {
            option: {
              get: function(elem) {
                var val = jQuery2.find.attr(elem, "value");
                return val != null ? val : (
                  // Support: IE10-11+
                  // option.text throws exceptions (#14686, #14858)
                  jQuery2.trim(jQuery2.text(elem))
                );
              }
            },
            select: {
              get: function(elem) {
                var value, option, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one" || index < 0, values = one ? null : [], max = one ? index + 1 : options.length, i2 = index < 0 ? max : one ? index : 0;
                for (; i2 < max; i2++) {
                  option = options[i2];
                  if ((option.selected || i2 === index) && // Don't return options that are disabled or in a disabled optgroup
                  (support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery2.nodeName(option.parentNode, "optgroup"))) {
                    value = jQuery2(option).val();
                    if (one) {
                      return value;
                    }
                    values.push(value);
                  }
                }
                return values;
              },
              set: function(elem, value) {
                var optionSet, option, options = elem.options, values = jQuery2.makeArray(value), i2 = options.length;
                while (i2--) {
                  option = options[i2];
                  if (jQuery2.inArray(jQuery2.valHooks.option.get(option), values) >= 0) {
                    try {
                      option.selected = optionSet = true;
                    } catch (_) {
                      option.scrollHeight;
                    }
                  } else {
                    option.selected = false;
                  }
                }
                if (!optionSet) {
                  elem.selectedIndex = -1;
                }
                return options;
              }
            }
          }
        });
        jQuery2.each(["radio", "checkbox"], function() {
          jQuery2.valHooks[this] = {
            set: function(elem, value) {
              if (jQuery2.isArray(value)) {
                return elem.checked = jQuery2.inArray(jQuery2(elem).val(), value) >= 0;
              }
            }
          };
          if (!support.checkOn) {
            jQuery2.valHooks[this].get = function(elem) {
              return elem.getAttribute("value") === null ? "on" : elem.value;
            };
          }
        });
        var nodeHook, boolHook, attrHandle = jQuery2.expr.attrHandle, ruseDefault = /^(?:checked|selected)$/i, getSetAttribute = support.getSetAttribute, getSetInput = support.input;
        jQuery2.fn.extend({
          attr: function(name, value) {
            return access(this, jQuery2.attr, name, value, arguments.length > 1);
          },
          removeAttr: function(name) {
            return this.each(function() {
              jQuery2.removeAttr(this, name);
            });
          }
        });
        jQuery2.extend({
          attr: function(elem, name, value) {
            var hooks, ret, nType = elem.nodeType;
            if (!elem || nType === 3 || nType === 8 || nType === 2) {
              return;
            }
            if (typeof elem.getAttribute === strundefined) {
              return jQuery2.prop(elem, name, value);
            }
            if (nType !== 1 || !jQuery2.isXMLDoc(elem)) {
              name = name.toLowerCase();
              hooks = jQuery2.attrHooks[name] || (jQuery2.expr.match.bool.test(name) ? boolHook : nodeHook);
            }
            if (value !== void 0) {
              if (value === null) {
                jQuery2.removeAttr(elem, name);
              } else if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
                return ret;
              } else {
                elem.setAttribute(name, value + "");
                return value;
              }
            } else if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret;
            } else {
              ret = jQuery2.find.attr(elem, name);
              return ret == null ? void 0 : ret;
            }
          },
          removeAttr: function(elem, value) {
            var name, propName, i2 = 0, attrNames = value && value.match(rnotwhite);
            if (attrNames && elem.nodeType === 1) {
              while (name = attrNames[i2++]) {
                propName = jQuery2.propFix[name] || name;
                if (jQuery2.expr.match.bool.test(name)) {
                  if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
                    elem[propName] = false;
                  } else {
                    elem[jQuery2.camelCase("default-" + name)] = elem[propName] = false;
                  }
                } else {
                  jQuery2.attr(elem, name, "");
                }
                elem.removeAttribute(getSetAttribute ? name : propName);
              }
            }
          },
          attrHooks: {
            type: {
              set: function(elem, value) {
                if (!support.radioValue && value === "radio" && jQuery2.nodeName(elem, "input")) {
                  var val = elem.value;
                  elem.setAttribute("type", value);
                  if (val) {
                    elem.value = val;
                  }
                  return value;
                }
              }
            }
          }
        });
        boolHook = {
          set: function(elem, value, name) {
            if (value === false) {
              jQuery2.removeAttr(elem, name);
            } else if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
              elem.setAttribute(!getSetAttribute && jQuery2.propFix[name] || name, name);
            } else {
              elem[jQuery2.camelCase("default-" + name)] = elem[name] = true;
            }
            return name;
          }
        };
        jQuery2.each(jQuery2.expr.match.bool.source.match(/\w+/g), function(i2, name) {
          var getter = attrHandle[name] || jQuery2.find.attr;
          attrHandle[name] = getSetInput && getSetAttribute || !ruseDefault.test(name) ? function(elem, name2, isXML) {
            var ret, handle;
            if (!isXML) {
              handle = attrHandle[name2];
              attrHandle[name2] = ret;
              ret = getter(elem, name2, isXML) != null ? name2.toLowerCase() : null;
              attrHandle[name2] = handle;
            }
            return ret;
          } : function(elem, name2, isXML) {
            if (!isXML) {
              return elem[jQuery2.camelCase("default-" + name2)] ? name2.toLowerCase() : null;
            }
          };
        });
        if (!getSetInput || !getSetAttribute) {
          jQuery2.attrHooks.value = {
            set: function(elem, value, name) {
              if (jQuery2.nodeName(elem, "input")) {
                elem.defaultValue = value;
              } else {
                return nodeHook && nodeHook.set(elem, value, name);
              }
            }
          };
        }
        if (!getSetAttribute) {
          nodeHook = {
            set: function(elem, value, name) {
              var ret = elem.getAttributeNode(name);
              if (!ret) {
                elem.setAttributeNode(
                  ret = elem.ownerDocument.createAttribute(name)
                );
              }
              ret.value = value += "";
              if (name === "value" || value === elem.getAttribute(name)) {
                return value;
              }
            }
          };
          attrHandle.id = attrHandle.name = attrHandle.coords = function(elem, name, isXML) {
            var ret;
            if (!isXML) {
              return (ret = elem.getAttributeNode(name)) && ret.value !== "" ? ret.value : null;
            }
          };
          jQuery2.valHooks.button = {
            get: function(elem, name) {
              var ret = elem.getAttributeNode(name);
              if (ret && ret.specified) {
                return ret.value;
              }
            },
            set: nodeHook.set
          };
          jQuery2.attrHooks.contenteditable = {
            set: function(elem, value, name) {
              nodeHook.set(elem, value === "" ? false : value, name);
            }
          };
          jQuery2.each(["width", "height"], function(i2, name) {
            jQuery2.attrHooks[name] = {
              set: function(elem, value) {
                if (value === "") {
                  elem.setAttribute(name, "auto");
                  return value;
                }
              }
            };
          });
        }
        if (!support.style) {
          jQuery2.attrHooks.style = {
            get: function(elem) {
              return elem.style.cssText || void 0;
            },
            set: function(elem, value) {
              return elem.style.cssText = value + "";
            }
          };
        }
        var rfocusable = /^(?:input|select|textarea|button|object)$/i, rclickable = /^(?:a|area)$/i;
        jQuery2.fn.extend({
          prop: function(name, value) {
            return access(this, jQuery2.prop, name, value, arguments.length > 1);
          },
          removeProp: function(name) {
            name = jQuery2.propFix[name] || name;
            return this.each(function() {
              try {
                this[name] = void 0;
                delete this[name];
              } catch (e) {
              }
            });
          }
        });
        jQuery2.extend({
          propFix: {
            "for": "htmlFor",
            "class": "className"
          },
          prop: function(elem, name, value) {
            var ret, hooks, notxml, nType = elem.nodeType;
            if (!elem || nType === 3 || nType === 8 || nType === 2) {
              return;
            }
            notxml = nType !== 1 || !jQuery2.isXMLDoc(elem);
            if (notxml) {
              name = jQuery2.propFix[name] || name;
              hooks = jQuery2.propHooks[name];
            }
            if (value !== void 0) {
              return hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0 ? ret : elem[name] = value;
            } else {
              return hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null ? ret : elem[name];
            }
          },
          propHooks: {
            tabIndex: {
              get: function(elem) {
                var tabindex = jQuery2.find.attr(elem, "tabindex");
                return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : -1;
              }
            }
          }
        });
        if (!support.hrefNormalized) {
          jQuery2.each(["href", "src"], function(i2, name) {
            jQuery2.propHooks[name] = {
              get: function(elem) {
                return elem.getAttribute(name, 4);
              }
            };
          });
        }
        if (!support.optSelected) {
          jQuery2.propHooks.selected = {
            get: function(elem) {
              var parent = elem.parentNode;
              if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
              }
              return null;
            }
          };
        }
        jQuery2.each([
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable"
        ], function() {
          jQuery2.propFix[this.toLowerCase()] = this;
        });
        if (!support.enctype) {
          jQuery2.propFix.enctype = "encoding";
        }
        var rclass = /[\t\r\n\f]/g;
        jQuery2.fn.extend({
          addClass: function(value) {
            var classes, elem, cur, clazz, j, finalValue, i2 = 0, len = this.length, proceed = typeof value === "string" && value;
            if (jQuery2.isFunction(value)) {
              return this.each(function(j2) {
                jQuery2(this).addClass(value.call(this, j2, this.className));
              });
            }
            if (proceed) {
              classes = (value || "").match(rnotwhite) || [];
              for (; i2 < len; i2++) {
                elem = this[i2];
                cur = elem.nodeType === 1 && (elem.className ? (" " + elem.className + " ").replace(rclass, " ") : " ");
                if (cur) {
                  j = 0;
                  while (clazz = classes[j++]) {
                    if (cur.indexOf(" " + clazz + " ") < 0) {
                      cur += clazz + " ";
                    }
                  }
                  finalValue = jQuery2.trim(cur);
                  if (elem.className !== finalValue) {
                    elem.className = finalValue;
                  }
                }
              }
            }
            return this;
          },
          removeClass: function(value) {
            var classes, elem, cur, clazz, j, finalValue, i2 = 0, len = this.length, proceed = arguments.length === 0 || typeof value === "string" && value;
            if (jQuery2.isFunction(value)) {
              return this.each(function(j2) {
                jQuery2(this).removeClass(value.call(this, j2, this.className));
              });
            }
            if (proceed) {
              classes = (value || "").match(rnotwhite) || [];
              for (; i2 < len; i2++) {
                elem = this[i2];
                cur = elem.nodeType === 1 && (elem.className ? (" " + elem.className + " ").replace(rclass, " ") : "");
                if (cur) {
                  j = 0;
                  while (clazz = classes[j++]) {
                    while (cur.indexOf(" " + clazz + " ") >= 0) {
                      cur = cur.replace(" " + clazz + " ", " ");
                    }
                  }
                  finalValue = value ? jQuery2.trim(cur) : "";
                  if (elem.className !== finalValue) {
                    elem.className = finalValue;
                  }
                }
              }
            }
            return this;
          },
          toggleClass: function(value, stateVal) {
            var type = typeof value;
            if (typeof stateVal === "boolean" && type === "string") {
              return stateVal ? this.addClass(value) : this.removeClass(value);
            }
            if (jQuery2.isFunction(value)) {
              return this.each(function(i2) {
                jQuery2(this).toggleClass(value.call(this, i2, this.className, stateVal), stateVal);
              });
            }
            return this.each(function() {
              if (type === "string") {
                var className, i2 = 0, self2 = jQuery2(this), classNames = value.match(rnotwhite) || [];
                while (className = classNames[i2++]) {
                  if (self2.hasClass(className)) {
                    self2.removeClass(className);
                  } else {
                    self2.addClass(className);
                  }
                }
              } else if (type === strundefined || type === "boolean") {
                if (this.className) {
                  jQuery2._data(this, "__className__", this.className);
                }
                this.className = this.className || value === false ? "" : jQuery2._data(this, "__className__") || "";
              }
            });
          },
          hasClass: function(selector) {
            var className = " " + selector + " ", i2 = 0, l = this.length;
            for (; i2 < l; i2++) {
              if (this[i2].nodeType === 1 && (" " + this[i2].className + " ").replace(rclass, " ").indexOf(className) >= 0) {
                return true;
              }
            }
            return false;
          }
        });
        jQuery2.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(i2, name) {
          jQuery2.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
          };
        });
        jQuery2.fn.extend({
          hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
          },
          bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
          },
          unbind: function(types, fn) {
            return this.off(types, null, fn);
          },
          delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
          },
          undelegate: function(selector, types, fn) {
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
          }
        });
        var nonce = jQuery2.now();
        var rquery = /\?/;
        var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
        jQuery2.parseJSON = function(data) {
          if (window2.JSON && window2.JSON.parse) {
            return window2.JSON.parse(data + "");
          }
          var requireNonComma, depth = null, str = jQuery2.trim(data + "");
          return str && !jQuery2.trim(str.replace(rvalidtokens, function(token, comma, open, close) {
            if (requireNonComma && comma) {
              depth = 0;
            }
            if (depth === 0) {
              return token;
            }
            requireNonComma = open || comma;
            depth += !close - !open;
            return "";
          })) ? Function("return " + str)() : jQuery2.error("Invalid JSON: " + data);
        };
        jQuery2.parseXML = function(data) {
          var xml, tmp;
          if (!data || typeof data !== "string") {
            return null;
          }
          try {
            if (window2.DOMParser) {
              tmp = new DOMParser();
              xml = tmp.parseFromString(data, "text/xml");
            } else {
              xml = new ActiveXObject("Microsoft.XMLDOM");
              xml.async = "false";
              xml.loadXML(data);
            }
          } catch (e) {
            xml = void 0;
          }
          if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) {
            jQuery2.error("Invalid XML: " + data);
          }
          return xml;
        };
        var ajaxLocParts, ajaxLocation, rhash = /#.*$/, rts = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/, prefilters = {}, transports = {}, allTypes = "*/".concat("*");
        try {
          ajaxLocation = location.href;
        } catch (e) {
          ajaxLocation = document2.createElement("a");
          ajaxLocation.href = "";
          ajaxLocation = ajaxLocation.href;
        }
        ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];
        function addToPrefiltersOrTransports(structure) {
          return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
              func = dataTypeExpression;
              dataTypeExpression = "*";
            }
            var dataType, i2 = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];
            if (jQuery2.isFunction(func)) {
              while (dataType = dataTypes[i2++]) {
                if (dataType.charAt(0) === "+") {
                  dataType = dataType.slice(1) || "*";
                  (structure[dataType] = structure[dataType] || []).unshift(func);
                } else {
                  (structure[dataType] = structure[dataType] || []).push(func);
                }
              }
            }
          };
        }
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
          var inspected = {}, seekingTransport = structure === transports;
          function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery2.each(structure[dataType] || [], function(_, prefilterOrFactory) {
              var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
              if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                options.dataTypes.unshift(dataTypeOrTransport);
                inspect(dataTypeOrTransport);
                return false;
              } else if (seekingTransport) {
                return !(selected = dataTypeOrTransport);
              }
            });
            return selected;
          }
          return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
        }
        function ajaxExtend(target, src) {
          var deep, key, flatOptions = jQuery2.ajaxSettings.flatOptions || {};
          for (key in src) {
            if (src[key] !== void 0) {
              (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
            }
          }
          if (deep) {
            jQuery2.extend(true, target, deep);
          }
          return target;
        }
        function ajaxHandleResponses(s, jqXHR, responses) {
          var firstDataType, ct, finalDataType, type, contents = s.contents, dataTypes = s.dataTypes;
          while (dataTypes[0] === "*") {
            dataTypes.shift();
            if (ct === void 0) {
              ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
            }
          }
          if (ct) {
            for (type in contents) {
              if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
              }
            }
          }
          if (dataTypes[0] in responses) {
            finalDataType = dataTypes[0];
          } else {
            for (type in responses) {
              if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                finalDataType = type;
                break;
              }
              if (!firstDataType) {
                firstDataType = type;
              }
            }
            finalDataType = finalDataType || firstDataType;
          }
          if (finalDataType) {
            if (finalDataType !== dataTypes[0]) {
              dataTypes.unshift(finalDataType);
            }
            return responses[finalDataType];
          }
        }
        function ajaxConvert(s, response, jqXHR, isSuccess) {
          var conv2, current, conv, tmp, prev, converters = {}, dataTypes = s.dataTypes.slice();
          if (dataTypes[1]) {
            for (conv in s.converters) {
              converters[conv.toLowerCase()] = s.converters[conv];
            }
          }
          current = dataTypes.shift();
          while (current) {
            if (s.responseFields[current]) {
              jqXHR[s.responseFields[current]] = response;
            }
            if (!prev && isSuccess && s.dataFilter) {
              response = s.dataFilter(response, s.dataType);
            }
            prev = current;
            current = dataTypes.shift();
            if (current) {
              if (current === "*") {
                current = prev;
              } else if (prev !== "*" && prev !== current) {
                conv = converters[prev + " " + current] || converters["* " + current];
                if (!conv) {
                  for (conv2 in converters) {
                    tmp = conv2.split(" ");
                    if (tmp[1] === current) {
                      conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                      if (conv) {
                        if (conv === true) {
                          conv = converters[conv2];
                        } else if (converters[conv2] !== true) {
                          current = tmp[0];
                          dataTypes.unshift(tmp[1]);
                        }
                        break;
                      }
                    }
                  }
                }
                if (conv !== true) {
                  if (conv && s["throws"]) {
                    response = conv(response);
                  } else {
                    try {
                      response = conv(response);
                    } catch (e) {
                      return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
                    }
                  }
                }
              }
            }
          }
          return { state: "success", data: response };
        }
        jQuery2.extend({
          // Counter for holding the number of active queries
          active: 0,
          // Last-Modified header cache for next request
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: ajaxLocation,
            type: "GET",
            isLocal: rlocalProtocol.test(ajaxLocParts[1]),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
            timeout: 0,
            data: null,
            dataType: null,
            username: null,
            password: null,
            cache: null,
            throws: false,
            traditional: false,
            headers: {},
            */
            accepts: {
              "*": allTypes,
              text: "text/plain",
              html: "text/html",
              xml: "application/xml, text/xml",
              json: "application/json, text/javascript"
            },
            contents: {
              xml: /xml/,
              html: /html/,
              json: /json/
            },
            responseFields: {
              xml: "responseXML",
              text: "responseText",
              json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
              // Convert anything to text
              "* text": String,
              // Text to html (true = no transformation)
              "text html": true,
              // Evaluate text as a json expression
              "text json": jQuery2.parseJSON,
              // Parse text as xml
              "text xml": jQuery2.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
              url: true,
              context: true
            }
          },
          // Creates a full fledged settings object into target
          // with both ajaxSettings and settings fields.
          // If target is omitted, writes into ajaxSettings.
          ajaxSetup: function(target, settings) {
            return settings ? (
              // Building a settings object
              ajaxExtend(ajaxExtend(target, jQuery2.ajaxSettings), settings)
            ) : (
              // Extending ajaxSettings
              ajaxExtend(jQuery2.ajaxSettings, target)
            );
          },
          ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
          ajaxTransport: addToPrefiltersOrTransports(transports),
          // Main method
          ajax: function(url, options) {
            if (typeof url === "object") {
              options = url;
              url = void 0;
            }
            options = options || {};
            var parts, i2, cacheURL, responseHeadersString, timeoutTimer, fireGlobals, transport, responseHeaders, s = jQuery2.ajaxSetup({}, options), callbackContext = s.context || s, globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery2(callbackContext) : jQuery2.event, deferred = jQuery2.Deferred(), completeDeferred = jQuery2.Callbacks("once memory"), statusCode = s.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, state = 0, strAbort = "canceled", jqXHR = {
              readyState: 0,
              // Builds headers hashtable if needed
              getResponseHeader: function(key) {
                var match;
                if (state === 2) {
                  if (!responseHeaders) {
                    responseHeaders = {};
                    while (match = rheaders.exec(responseHeadersString)) {
                      responseHeaders[match[1].toLowerCase()] = match[2];
                    }
                  }
                  match = responseHeaders[key.toLowerCase()];
                }
                return match == null ? null : match;
              },
              // Raw string
              getAllResponseHeaders: function() {
                return state === 2 ? responseHeadersString : null;
              },
              // Caches the header
              setRequestHeader: function(name, value) {
                var lname = name.toLowerCase();
                if (!state) {
                  name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
                  requestHeaders[name] = value;
                }
                return this;
              },
              // Overrides response content-type header
              overrideMimeType: function(type) {
                if (!state) {
                  s.mimeType = type;
                }
                return this;
              },
              // Status-dependent callbacks
              statusCode: function(map) {
                var code;
                if (map) {
                  if (state < 2) {
                    for (code in map) {
                      statusCode[code] = [statusCode[code], map[code]];
                    }
                  } else {
                    jqXHR.always(map[jqXHR.status]);
                  }
                }
                return this;
              },
              // Cancel the request
              abort: function(statusText) {
                var finalText = statusText || strAbort;
                if (transport) {
                  transport.abort(finalText);
                }
                done(0, finalText);
                return this;
              }
            };
            deferred.promise(jqXHR).complete = completeDeferred.add;
            jqXHR.success = jqXHR.done;
            jqXHR.error = jqXHR.fail;
            s.url = ((url || s.url || ajaxLocation) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//");
            s.type = options.method || options.type || s.method || s.type;
            s.dataTypes = jQuery2.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [""];
            if (s.crossDomain == null) {
              parts = rurl.exec(s.url.toLowerCase());
              s.crossDomain = !!(parts && (parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] || (parts[3] || (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? "80" : "443"))));
            }
            if (s.data && s.processData && typeof s.data !== "string") {
              s.data = jQuery2.param(s.data, s.traditional);
            }
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            if (state === 2) {
              return jqXHR;
            }
            fireGlobals = jQuery2.event && s.global;
            if (fireGlobals && jQuery2.active++ === 0) {
              jQuery2.event.trigger("ajaxStart");
            }
            s.type = s.type.toUpperCase();
            s.hasContent = !rnoContent.test(s.type);
            cacheURL = s.url;
            if (!s.hasContent) {
              if (s.data) {
                cacheURL = s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                delete s.data;
              }
              if (s.cache === false) {
                s.url = rts.test(cacheURL) ? (
                  // If there is already a '_' parameter, set its value
                  cacheURL.replace(rts, "$1_=" + nonce++)
                ) : (
                  // Otherwise add one to the end
                  cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++
                );
              }
            }
            if (s.ifModified) {
              if (jQuery2.lastModified[cacheURL]) {
                jqXHR.setRequestHeader("If-Modified-Since", jQuery2.lastModified[cacheURL]);
              }
              if (jQuery2.etag[cacheURL]) {
                jqXHR.setRequestHeader("If-None-Match", jQuery2.etag[cacheURL]);
              }
            }
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
              jqXHR.setRequestHeader("Content-Type", s.contentType);
            }
            jqXHR.setRequestHeader(
              "Accept",
              s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]
            );
            for (i2 in s.headers) {
              jqXHR.setRequestHeader(i2, s.headers[i2]);
            }
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
              return jqXHR.abort();
            }
            strAbort = "abort";
            for (i2 in { success: 1, error: 1, complete: 1 }) {
              jqXHR[i2](s[i2]);
            }
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            if (!transport) {
              done(-1, "No Transport");
            } else {
              jqXHR.readyState = 1;
              if (fireGlobals) {
                globalEventContext.trigger("ajaxSend", [jqXHR, s]);
              }
              if (s.async && s.timeout > 0) {
                timeoutTimer = setTimeout(function() {
                  jqXHR.abort("timeout");
                }, s.timeout);
              }
              try {
                state = 1;
                transport.send(requestHeaders, done);
              } catch (e) {
                if (state < 2) {
                  done(-1, e);
                } else {
                  throw e;
                }
              }
            }
            function done(status, nativeStatusText, responses, headers) {
              var isSuccess, success, error, response, modified, statusText = nativeStatusText;
              if (state === 2) {
                return;
              }
              state = 2;
              if (timeoutTimer) {
                clearTimeout(timeoutTimer);
              }
              transport = void 0;
              responseHeadersString = headers || "";
              jqXHR.readyState = status > 0 ? 4 : 0;
              isSuccess = status >= 200 && status < 300 || status === 304;
              if (responses) {
                response = ajaxHandleResponses(s, jqXHR, responses);
              }
              response = ajaxConvert(s, response, jqXHR, isSuccess);
              if (isSuccess) {
                if (s.ifModified) {
                  modified = jqXHR.getResponseHeader("Last-Modified");
                  if (modified) {
                    jQuery2.lastModified[cacheURL] = modified;
                  }
                  modified = jqXHR.getResponseHeader("etag");
                  if (modified) {
                    jQuery2.etag[cacheURL] = modified;
                  }
                }
                if (status === 204 || s.type === "HEAD") {
                  statusText = "nocontent";
                } else if (status === 304) {
                  statusText = "notmodified";
                } else {
                  statusText = response.state;
                  success = response.data;
                  error = response.error;
                  isSuccess = !error;
                }
              } else {
                error = statusText;
                if (status || !statusText) {
                  statusText = "error";
                  if (status < 0) {
                    status = 0;
                  }
                }
              }
              jqXHR.status = status;
              jqXHR.statusText = (nativeStatusText || statusText) + "";
              if (isSuccess) {
                deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
              } else {
                deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
              }
              jqXHR.statusCode(statusCode);
              statusCode = void 0;
              if (fireGlobals) {
                globalEventContext.trigger(
                  isSuccess ? "ajaxSuccess" : "ajaxError",
                  [jqXHR, s, isSuccess ? success : error]
                );
              }
              completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
              if (fireGlobals) {
                globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
                if (!--jQuery2.active) {
                  jQuery2.event.trigger("ajaxStop");
                }
              }
            }
            return jqXHR;
          },
          getJSON: function(url, data, callback) {
            return jQuery2.get(url, data, callback, "json");
          },
          getScript: function(url, callback) {
            return jQuery2.get(url, void 0, callback, "script");
          }
        });
        jQuery2.each(["get", "post"], function(i2, method) {
          jQuery2[method] = function(url, data, callback, type) {
            if (jQuery2.isFunction(data)) {
              type = type || callback;
              callback = data;
              data = void 0;
            }
            return jQuery2.ajax({
              url,
              type: method,
              dataType: type,
              data,
              success: callback
            });
          };
        });
        jQuery2._evalUrl = function(url) {
          return jQuery2.ajax({
            url,
            type: "GET",
            dataType: "script",
            async: false,
            global: false,
            "throws": true
          });
        };
        jQuery2.fn.extend({
          wrapAll: function(html) {
            if (jQuery2.isFunction(html)) {
              return this.each(function(i2) {
                jQuery2(this).wrapAll(html.call(this, i2));
              });
            }
            if (this[0]) {
              var wrap = jQuery2(html, this[0].ownerDocument).eq(0).clone(true);
              if (this[0].parentNode) {
                wrap.insertBefore(this[0]);
              }
              wrap.map(function() {
                var elem = this;
                while (elem.firstChild && elem.firstChild.nodeType === 1) {
                  elem = elem.firstChild;
                }
                return elem;
              }).append(this);
            }
            return this;
          },
          wrapInner: function(html) {
            if (jQuery2.isFunction(html)) {
              return this.each(function(i2) {
                jQuery2(this).wrapInner(html.call(this, i2));
              });
            }
            return this.each(function() {
              var self2 = jQuery2(this), contents = self2.contents();
              if (contents.length) {
                contents.wrapAll(html);
              } else {
                self2.append(html);
              }
            });
          },
          wrap: function(html) {
            var isFunction = jQuery2.isFunction(html);
            return this.each(function(i2) {
              jQuery2(this).wrapAll(isFunction ? html.call(this, i2) : html);
            });
          },
          unwrap: function() {
            return this.parent().each(function() {
              if (!jQuery2.nodeName(this, "body")) {
                jQuery2(this).replaceWith(this.childNodes);
              }
            }).end();
          }
        });
        jQuery2.expr.filters.hidden = function(elem) {
          return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 || !support.reliableHiddenOffsets() && (elem.style && elem.style.display || jQuery2.css(elem, "display")) === "none";
        };
        jQuery2.expr.filters.visible = function(elem) {
          return !jQuery2.expr.filters.hidden(elem);
        };
        var r20 = /%20/g, rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
        function buildParams(prefix, obj, traditional, add) {
          var name;
          if (jQuery2.isArray(obj)) {
            jQuery2.each(obj, function(i2, v) {
              if (traditional || rbracket.test(prefix)) {
                add(prefix, v);
              } else {
                buildParams(prefix + "[" + (typeof v === "object" ? i2 : "") + "]", v, traditional, add);
              }
            });
          } else if (!traditional && jQuery2.type(obj) === "object") {
            for (name in obj) {
              buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
            }
          } else {
            add(prefix, obj);
          }
        }
        jQuery2.param = function(a, traditional) {
          var prefix, s = [], add = function(key, value) {
            value = jQuery2.isFunction(value) ? value() : value == null ? "" : value;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
          };
          if (traditional === void 0) {
            traditional = jQuery2.ajaxSettings && jQuery2.ajaxSettings.traditional;
          }
          if (jQuery2.isArray(a) || a.jquery && !jQuery2.isPlainObject(a)) {
            jQuery2.each(a, function() {
              add(this.name, this.value);
            });
          } else {
            for (prefix in a) {
              buildParams(prefix, a[prefix], traditional, add);
            }
          }
          return s.join("&").replace(r20, "+");
        };
        jQuery2.fn.extend({
          serialize: function() {
            return jQuery2.param(this.serializeArray());
          },
          serializeArray: function() {
            return this.map(function() {
              var elements = jQuery2.prop(this, "elements");
              return elements ? jQuery2.makeArray(elements) : this;
            }).filter(function() {
              var type = this.type;
              return this.name && !jQuery2(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(i2, elem) {
              var val = jQuery2(this).val();
              return val == null ? null : jQuery2.isArray(val) ? jQuery2.map(val, function(val2) {
                return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
              }) : { name: elem.name, value: val.replace(rCRLF, "\r\n") };
            }).get();
          }
        });
        jQuery2.ajaxSettings.xhr = window2.ActiveXObject !== void 0 ? (
          // Support: IE6+
          function() {
            return !this.isLocal && // Support: IE7-8
            // oldIE XHR does not support non-RFC2616 methods (#13240)
            // See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
            // and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
            // Although this check for six methods instead of eight
            // since IE also does not support "trace" and "connect"
            /^(get|post|head|put|delete|options)$/i.test(this.type) && createStandardXHR() || createActiveXHR();
          }
        ) : (
          // For all other browsers, use the standard XMLHttpRequest object
          createStandardXHR
        );
        var xhrId = 0, xhrCallbacks = {}, xhrSupported = jQuery2.ajaxSettings.xhr();
        if (window2.attachEvent) {
          window2.attachEvent("onunload", function() {
            for (var key in xhrCallbacks) {
              xhrCallbacks[key](void 0, true);
            }
          });
        }
        support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
        xhrSupported = support.ajax = !!xhrSupported;
        if (xhrSupported) {
          jQuery2.ajaxTransport(function(options) {
            if (!options.crossDomain || support.cors) {
              var callback;
              return {
                send: function(headers, complete) {
                  var i2, xhr = options.xhr(), id = ++xhrId;
                  xhr.open(options.type, options.url, options.async, options.username, options.password);
                  if (options.xhrFields) {
                    for (i2 in options.xhrFields) {
                      xhr[i2] = options.xhrFields[i2];
                    }
                  }
                  if (options.mimeType && xhr.overrideMimeType) {
                    xhr.overrideMimeType(options.mimeType);
                  }
                  if (!options.crossDomain && !headers["X-Requested-With"]) {
                    headers["X-Requested-With"] = "XMLHttpRequest";
                  }
                  for (i2 in headers) {
                    if (headers[i2] !== void 0) {
                      xhr.setRequestHeader(i2, headers[i2] + "");
                    }
                  }
                  xhr.send(options.hasContent && options.data || null);
                  callback = function(_, isAbort) {
                    var status, statusText, responses;
                    if (callback && (isAbort || xhr.readyState === 4)) {
                      delete xhrCallbacks[id];
                      callback = void 0;
                      xhr.onreadystatechange = jQuery2.noop;
                      if (isAbort) {
                        if (xhr.readyState !== 4) {
                          xhr.abort();
                        }
                      } else {
                        responses = {};
                        status = xhr.status;
                        if (typeof xhr.responseText === "string") {
                          responses.text = xhr.responseText;
                        }
                        try {
                          statusText = xhr.statusText;
                        } catch (e) {
                          statusText = "";
                        }
                        if (!status && options.isLocal && !options.crossDomain) {
                          status = responses.text ? 200 : 404;
                        } else if (status === 1223) {
                          status = 204;
                        }
                      }
                    }
                    if (responses) {
                      complete(status, statusText, responses, xhr.getAllResponseHeaders());
                    }
                  };
                  if (!options.async) {
                    callback();
                  } else if (xhr.readyState === 4) {
                    setTimeout(callback);
                  } else {
                    xhr.onreadystatechange = xhrCallbacks[id] = callback;
                  }
                },
                abort: function() {
                  if (callback) {
                    callback(void 0, true);
                  }
                }
              };
            }
          });
        }
        function createStandardXHR() {
          try {
            return new window2.XMLHttpRequest();
          } catch (e) {
          }
        }
        function createActiveXHR() {
          try {
            return new window2.ActiveXObject("Microsoft.XMLHTTP");
          } catch (e) {
          }
        }
        jQuery2.ajaxSetup({
          accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
          },
          contents: {
            script: /(?:java|ecma)script/
          },
          converters: {
            "text script": function(text) {
              jQuery2.globalEval(text);
              return text;
            }
          }
        });
        jQuery2.ajaxPrefilter("script", function(s) {
          if (s.cache === void 0) {
            s.cache = false;
          }
          if (s.crossDomain) {
            s.type = "GET";
            s.global = false;
          }
        });
        jQuery2.ajaxTransport("script", function(s) {
          if (s.crossDomain) {
            var script, head = document2.head || jQuery2("head")[0] || document2.documentElement;
            return {
              send: function(_, callback) {
                script = document2.createElement("script");
                script.async = true;
                if (s.scriptCharset) {
                  script.charset = s.scriptCharset;
                }
                script.src = s.url;
                script.onload = script.onreadystatechange = function(_2, isAbort) {
                  if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                    script.onload = script.onreadystatechange = null;
                    if (script.parentNode) {
                      script.parentNode.removeChild(script);
                    }
                    script = null;
                    if (!isAbort) {
                      callback(200, "success");
                    }
                  }
                };
                head.insertBefore(script, head.firstChild);
              },
              abort: function() {
                if (script) {
                  script.onload(void 0, true);
                }
              }
            };
          }
        });
        var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
        jQuery2.ajaxSetup({
          jsonp: "callback",
          jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery2.expando + "_" + nonce++;
            this[callback] = true;
            return callback;
          }
        });
        jQuery2.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
          var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && !(s.contentType || "").indexOf("application/x-www-form-urlencoded") && rjsonp.test(s.data) && "data");
          if (jsonProp || s.dataTypes[0] === "jsonp") {
            callbackName = s.jsonpCallback = jQuery2.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            if (jsonProp) {
              s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            } else if (s.jsonp !== false) {
              s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            }
            s.converters["script json"] = function() {
              if (!responseContainer) {
                jQuery2.error(callbackName + " was not called");
              }
              return responseContainer[0];
            };
            s.dataTypes[0] = "json";
            overwritten = window2[callbackName];
            window2[callbackName] = function() {
              responseContainer = arguments;
            };
            jqXHR.always(function() {
              window2[callbackName] = overwritten;
              if (s[callbackName]) {
                s.jsonpCallback = originalSettings.jsonpCallback;
                oldCallbacks.push(callbackName);
              }
              if (responseContainer && jQuery2.isFunction(overwritten)) {
                overwritten(responseContainer[0]);
              }
              responseContainer = overwritten = void 0;
            });
            return "script";
          }
        });
        jQuery2.parseHTML = function(data, context, keepScripts) {
          if (!data || typeof data !== "string") {
            return null;
          }
          if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
          }
          context = context || document2;
          var parsed = rsingleTag.exec(data), scripts = !keepScripts && [];
          if (parsed) {
            return [context.createElement(parsed[1])];
          }
          parsed = jQuery2.buildFragment([data], context, scripts);
          if (scripts && scripts.length) {
            jQuery2(scripts).remove();
          }
          return jQuery2.merge([], parsed.childNodes);
        };
        var _load = jQuery2.fn.load;
        jQuery2.fn.load = function(url, params, callback) {
          if (typeof url !== "string" && _load) {
            return _load.apply(this, arguments);
          }
          var selector, response, type, self2 = this, off = url.indexOf(" ");
          if (off >= 0) {
            selector = jQuery2.trim(url.slice(off, url.length));
            url = url.slice(0, off);
          }
          if (jQuery2.isFunction(params)) {
            callback = params;
            params = void 0;
          } else if (params && typeof params === "object") {
            type = "POST";
          }
          if (self2.length > 0) {
            jQuery2.ajax({
              url,
              // if "type" variable is undefined, then "GET" method will be used
              type,
              dataType: "html",
              data: params
            }).done(function(responseText) {
              response = arguments;
              self2.html(selector ? (
                // If a selector was specified, locate the right elements in a dummy div
                // Exclude scripts to avoid IE 'Permission Denied' errors
                jQuery2("<div>").append(jQuery2.parseHTML(responseText)).find(selector)
              ) : (
                // Otherwise use the full result
                responseText
              ));
            }).complete(callback && function(jqXHR, status) {
              self2.each(callback, response || [jqXHR.responseText, status, jqXHR]);
            });
          }
          return this;
        };
        jQuery2.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(i2, type) {
          jQuery2.fn[type] = function(fn) {
            return this.on(type, fn);
          };
        });
        jQuery2.expr.filters.animated = function(elem) {
          return jQuery2.grep(jQuery2.timers, function(fn) {
            return elem === fn.elem;
          }).length;
        };
        var docElem = window2.document.documentElement;
        function getWindow(elem) {
          return jQuery2.isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
        }
        jQuery2.offset = {
          setOffset: function(elem, options, i2) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery2.css(elem, "position"), curElem = jQuery2(elem), props = {};
            if (position === "static") {
              elem.style.position = "relative";
            }
            curOffset = curElem.offset();
            curCSSTop = jQuery2.css(elem, "top");
            curCSSLeft = jQuery2.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && jQuery2.inArray("auto", [curCSSTop, curCSSLeft]) > -1;
            if (calculatePosition) {
              curPosition = curElem.position();
              curTop = curPosition.top;
              curLeft = curPosition.left;
            } else {
              curTop = parseFloat(curCSSTop) || 0;
              curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (jQuery2.isFunction(options)) {
              options = options.call(elem, i2, curOffset);
            }
            if (options.top != null) {
              props.top = options.top - curOffset.top + curTop;
            }
            if (options.left != null) {
              props.left = options.left - curOffset.left + curLeft;
            }
            if ("using" in options) {
              options.using.call(elem, props);
            } else {
              curElem.css(props);
            }
          }
        };
        jQuery2.fn.extend({
          offset: function(options) {
            if (arguments.length) {
              return options === void 0 ? this : this.each(function(i2) {
                jQuery2.offset.setOffset(this, options, i2);
              });
            }
            var docElem2, win, box = { top: 0, left: 0 }, elem = this[0], doc = elem && elem.ownerDocument;
            if (!doc) {
              return;
            }
            docElem2 = doc.documentElement;
            if (!jQuery2.contains(docElem2, elem)) {
              return box;
            }
            if (typeof elem.getBoundingClientRect !== strundefined) {
              box = elem.getBoundingClientRect();
            }
            win = getWindow(doc);
            return {
              top: box.top + (win.pageYOffset || docElem2.scrollTop) - (docElem2.clientTop || 0),
              left: box.left + (win.pageXOffset || docElem2.scrollLeft) - (docElem2.clientLeft || 0)
            };
          },
          position: function() {
            if (!this[0]) {
              return;
            }
            var offsetParent, offset, parentOffset = { top: 0, left: 0 }, elem = this[0];
            if (jQuery2.css(elem, "position") === "fixed") {
              offset = elem.getBoundingClientRect();
            } else {
              offsetParent = this.offsetParent();
              offset = this.offset();
              if (!jQuery2.nodeName(offsetParent[0], "html")) {
                parentOffset = offsetParent.offset();
              }
              parentOffset.top += jQuery2.css(offsetParent[0], "borderTopWidth", true);
              parentOffset.left += jQuery2.css(offsetParent[0], "borderLeftWidth", true);
            }
            return {
              top: offset.top - parentOffset.top - jQuery2.css(elem, "marginTop", true),
              left: offset.left - parentOffset.left - jQuery2.css(elem, "marginLeft", true)
            };
          },
          offsetParent: function() {
            return this.map(function() {
              var offsetParent = this.offsetParent || docElem;
              while (offsetParent && (!jQuery2.nodeName(offsetParent, "html") && jQuery2.css(offsetParent, "position") === "static")) {
                offsetParent = offsetParent.offsetParent;
              }
              return offsetParent || docElem;
            });
          }
        });
        jQuery2.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
          var top = /Y/.test(prop);
          jQuery2.fn[method] = function(val) {
            return access(this, function(elem, method2, val2) {
              var win = getWindow(elem);
              if (val2 === void 0) {
                return win ? prop in win ? win[prop] : win.document.documentElement[method2] : elem[method2];
              }
              if (win) {
                win.scrollTo(
                  !top ? val2 : jQuery2(win).scrollLeft(),
                  top ? val2 : jQuery2(win).scrollTop()
                );
              } else {
                elem[method2] = val2;
              }
            }, method, val, arguments.length, null);
          };
        });
        jQuery2.each(["top", "left"], function(i2, prop) {
          jQuery2.cssHooks[prop] = addGetHookIf(
            support.pixelPosition,
            function(elem, computed) {
              if (computed) {
                computed = curCSS(elem, prop);
                return rnumnonpx.test(computed) ? jQuery2(elem).position()[prop] + "px" : computed;
              }
            }
          );
        });
        jQuery2.each({ Height: "height", Width: "width" }, function(name, type) {
          jQuery2.each({ padding: "inner" + name, content: type, "": "outer" + name }, function(defaultExtra, funcName) {
            jQuery2.fn[funcName] = function(margin, value) {
              var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
              return access(this, function(elem, type2, value2) {
                var doc;
                if (jQuery2.isWindow(elem)) {
                  return elem.document.documentElement["client" + name];
                }
                if (elem.nodeType === 9) {
                  doc = elem.documentElement;
                  return Math.max(
                    elem.body["scroll" + name],
                    doc["scroll" + name],
                    elem.body["offset" + name],
                    doc["offset" + name],
                    doc["client" + name]
                  );
                }
                return value2 === void 0 ? (
                  // Get width or height on the element, requesting but not forcing parseFloat
                  jQuery2.css(elem, type2, extra)
                ) : (
                  // Set width or height on the element
                  jQuery2.style(elem, type2, value2, extra)
                );
              }, type, chainable ? margin : void 0, chainable, null);
            };
          });
        });
        jQuery2.fn.size = function() {
          return this.length;
        };
        jQuery2.fn.andSelf = jQuery2.fn.addBack;
        if (typeof define === "function" && define.amd) {
          define("jquery", [], function() {
            return jQuery2;
          });
        }
        var _jQuery = window2.jQuery, _$ = window2.$;
        jQuery2.noConflict = function(deep) {
          if (window2.$ === jQuery2) {
            window2.$ = _$;
          }
          if (deep && window2.jQuery === jQuery2) {
            window2.jQuery = _jQuery;
          }
          return jQuery2;
        };
        if (typeof noGlobal === strundefined) {
          window2.jQuery = window2.$ = jQuery2;
        }
        return jQuery2;
      });
    }
  });

  // node_modules/multiselect/js/jquery.multi-select.js
  var require_jquery_multi_select = __commonJS({
    "node_modules/multiselect/js/jquery.multi-select.js"() {
      !function($2) {
        "use strict";
        var MultiSelect = function(element, options) {
          this.options = options;
          this.$element = $2(element);
          this.$container = $2("<div/>", { "class": "ms-container" });
          this.$selectableContainer = $2("<div/>", { "class": "ms-selectable" });
          this.$selectionContainer = $2("<div/>", { "class": "ms-selection" });
          this.$selectableUl = $2("<ul/>", { "class": "ms-list", "tabindex": "-1" });
          this.$selectionUl = $2("<ul/>", { "class": "ms-list", "tabindex": "-1" });
          this.scrollTo = 0;
          this.elemsSelector = "li:visible:not(.ms-optgroup-label,.ms-optgroup-container,." + options.disabledClass + ")";
        };
        MultiSelect.prototype = {
          constructor: MultiSelect,
          init: function() {
            var that = this, ms = this.$element;
            if (ms.next(".ms-container").length === 0) {
              ms.css({ position: "absolute", left: "-9999px" });
              ms.attr("id", ms.attr("id") ? ms.attr("id") : Math.ceil(Math.random() * 1e3) + "multiselect");
              this.$container.attr("id", "ms-" + ms.attr("id"));
              this.$container.addClass(that.options.cssClass);
              ms.find("option").each(function() {
                that.generateLisFromOption(this);
              });
              this.$selectionUl.find(".ms-optgroup-label").hide();
              if (that.options.selectableHeader) {
                that.$selectableContainer.append(that.options.selectableHeader);
              }
              that.$selectableContainer.append(that.$selectableUl);
              if (that.options.selectableFooter) {
                that.$selectableContainer.append(that.options.selectableFooter);
              }
              if (that.options.selectionHeader) {
                that.$selectionContainer.append(that.options.selectionHeader);
              }
              that.$selectionContainer.append(that.$selectionUl);
              if (that.options.selectionFooter) {
                that.$selectionContainer.append(that.options.selectionFooter);
              }
              that.$container.append(that.$selectableContainer);
              that.$container.append(that.$selectionContainer);
              ms.after(that.$container);
              that.activeMouse(that.$selectableUl);
              that.activeKeyboard(that.$selectableUl);
              var action = that.options.dblClick ? "dblclick" : "click";
              that.$selectableUl.on(action, ".ms-elem-selectable", function() {
                that.select($2(this).data("ms-value"));
              });
              that.$selectionUl.on(action, ".ms-elem-selection", function() {
                that.deselect($2(this).data("ms-value"));
              });
              that.activeMouse(that.$selectionUl);
              that.activeKeyboard(that.$selectionUl);
              ms.on("focus", function() {
                that.$selectableUl.focus();
              });
            }
            var selectedValues = ms.find("option:selected").map(function() {
              return $2(this).val();
            }).get();
            that.select(selectedValues, "init");
            if (typeof that.options.afterInit === "function") {
              that.options.afterInit.call(this, this.$container);
            }
          },
          "generateLisFromOption": function(option, index, $container) {
            var that = this, ms = that.$element, attributes = "", $option = $2(option);
            for (var cpt = 0; cpt < option.attributes.length; cpt++) {
              var attr = option.attributes[cpt];
              if (attr.name !== "value" && attr.name !== "disabled") {
                attributes += attr.name + '="' + attr.value + '" ';
              }
            }
            var selectableLi = $2("<li " + attributes + "><span>" + that.escapeHTML($option.text()) + "</span></li>"), selectedLi = selectableLi.clone(), value = $option.val(), elementId = that.sanitize(value);
            selectableLi.data("ms-value", value).addClass("ms-elem-selectable").attr("id", elementId + "-selectable");
            selectedLi.data("ms-value", value).addClass("ms-elem-selection").attr("id", elementId + "-selection").hide();
            if ($option.attr("disabled") || ms.attr("disabled")) {
              selectedLi.addClass(that.options.disabledClass);
              selectableLi.addClass(that.options.disabledClass);
            }
            var $optgroup = $option.parent("optgroup");
            if ($optgroup.length > 0) {
              var optgroupLabel = $optgroup.attr("label"), optgroupId = that.sanitize(optgroupLabel), $selectableOptgroup = that.$selectableUl.find("#optgroup-selectable-" + optgroupId), $selectionOptgroup = that.$selectionUl.find("#optgroup-selection-" + optgroupId);
              if ($selectableOptgroup.length === 0) {
                var optgroupContainerTpl = '<li class="ms-optgroup-container"></li>', optgroupTpl = '<ul class="ms-optgroup"><li class="ms-optgroup-label"><span>' + optgroupLabel + "</span></li></ul>";
                $selectableOptgroup = $2(optgroupContainerTpl);
                $selectionOptgroup = $2(optgroupContainerTpl);
                $selectableOptgroup.attr("id", "optgroup-selectable-" + optgroupId);
                $selectionOptgroup.attr("id", "optgroup-selection-" + optgroupId);
                $selectableOptgroup.append($2(optgroupTpl));
                $selectionOptgroup.append($2(optgroupTpl));
                if (that.options.selectableOptgroup) {
                  $selectableOptgroup.find(".ms-optgroup-label").on("click", function() {
                    var values = $optgroup.children(":not(:selected, :disabled)").map(function() {
                      return $2(this).val();
                    }).get();
                    that.select(values);
                  });
                  $selectionOptgroup.find(".ms-optgroup-label").on("click", function() {
                    var values = $optgroup.children(":selected:not(:disabled)").map(function() {
                      return $2(this).val();
                    }).get();
                    that.deselect(values);
                  });
                }
                that.$selectableUl.append($selectableOptgroup);
                that.$selectionUl.append($selectionOptgroup);
              }
              index = index === void 0 ? $selectableOptgroup.find("ul").children().length : index + 1;
              selectableLi.insertAt(index, $selectableOptgroup.children());
              selectedLi.insertAt(index, $selectionOptgroup.children());
            } else {
              index = index === void 0 ? that.$selectableUl.children().length : index;
              selectableLi.insertAt(index, that.$selectableUl);
              selectedLi.insertAt(index, that.$selectionUl);
            }
          },
          "addOption": function(options) {
            var that = this;
            if (options.value !== void 0 && options.value !== null) {
              options = [options];
            }
            $2.each(options, function(index, option) {
              if (option.value !== void 0 && option.value !== null && that.$element.find("option[value='" + option.value + "']").length === 0) {
                var $option = $2('<option value="' + option.value + '">' + option.text + "</option>"), $container = option.nested === void 0 ? that.$element : $2("optgroup[label='" + option.nested + "']"), index = parseInt(typeof option.index === "undefined" ? $container.children().length : option.index);
                if (option.optionClass) {
                  $option.addClass(option.optionClass);
                }
                if (option.disabled) {
                  $option.prop("disabled", true);
                }
                $option.insertAt(index, $container);
                that.generateLisFromOption($option.get(0), index, option.nested);
              }
            });
          },
          "escapeHTML": function(text) {
            return $2("<div>").text(text).html();
          },
          "activeKeyboard": function($list) {
            var that = this;
            $list.on("focus", function() {
              $2(this).addClass("ms-focus");
            }).on("blur", function() {
              $2(this).removeClass("ms-focus");
            }).on("keydown", function(e) {
              switch (e.which) {
                case 40:
                case 38:
                  e.preventDefault();
                  e.stopPropagation();
                  that.moveHighlight($2(this), e.which === 38 ? -1 : 1);
                  return;
                case 37:
                case 39:
                  e.preventDefault();
                  e.stopPropagation();
                  that.switchList($list);
                  return;
                case 9:
                  if (that.$element.is("[tabindex]")) {
                    e.preventDefault();
                    var tabindex = parseInt(that.$element.attr("tabindex"), 10);
                    tabindex = e.shiftKey ? tabindex - 1 : tabindex + 1;
                    $2('[tabindex="' + tabindex + '"]').focus();
                    return;
                  } else {
                    if (e.shiftKey) {
                      that.$element.trigger("focus");
                    }
                  }
              }
              if ($2.inArray(e.which, that.options.keySelect) > -1) {
                e.preventDefault();
                e.stopPropagation();
                that.selectHighlighted($list);
                return;
              }
            });
          },
          "moveHighlight": function($list, direction) {
            var $elems = $list.find(this.elemsSelector), $currElem = $elems.filter(".ms-hover"), $nextElem = null, elemHeight = $elems.first().outerHeight(), containerHeight = $list.height(), containerSelector = "#" + this.$container.prop("id");
            $elems.removeClass("ms-hover");
            if (direction === 1) {
              $nextElem = $currElem.nextAll(this.elemsSelector).first();
              if ($nextElem.length === 0) {
                var $optgroupUl = $currElem.parent();
                if ($optgroupUl.hasClass("ms-optgroup")) {
                  var $optgroupLi = $optgroupUl.parent(), $nextOptgroupLi = $optgroupLi.next(":visible");
                  if ($nextOptgroupLi.length > 0) {
                    $nextElem = $nextOptgroupLi.find(this.elemsSelector).first();
                  } else {
                    $nextElem = $elems.first();
                  }
                } else {
                  $nextElem = $elems.first();
                }
              }
            } else if (direction === -1) {
              $nextElem = $currElem.prevAll(this.elemsSelector).first();
              if ($nextElem.length === 0) {
                var $optgroupUl = $currElem.parent();
                if ($optgroupUl.hasClass("ms-optgroup")) {
                  var $optgroupLi = $optgroupUl.parent(), $prevOptgroupLi = $optgroupLi.prev(":visible");
                  if ($prevOptgroupLi.length > 0) {
                    $nextElem = $prevOptgroupLi.find(this.elemsSelector).last();
                  } else {
                    $nextElem = $elems.last();
                  }
                } else {
                  $nextElem = $elems.last();
                }
              }
            }
            if ($nextElem.length > 0) {
              $nextElem.addClass("ms-hover");
              var scrollTo = $list.scrollTop() + $nextElem.position().top - containerHeight / 2 + elemHeight / 2;
              $list.scrollTop(scrollTo);
            }
          },
          "selectHighlighted": function($list) {
            var $elems = $list.find(this.elemsSelector), $highlightedElem = $elems.filter(".ms-hover").first();
            if ($highlightedElem.length > 0) {
              if ($list.parent().hasClass("ms-selectable")) {
                this.select($highlightedElem.data("ms-value"));
              } else {
                this.deselect($highlightedElem.data("ms-value"));
              }
              $elems.removeClass("ms-hover");
            }
          },
          "switchList": function($list) {
            $list.blur();
            this.$container.find(this.elemsSelector).removeClass("ms-hover");
            if ($list.parent().hasClass("ms-selectable")) {
              this.$selectionUl.focus();
            } else {
              this.$selectableUl.focus();
            }
          },
          "activeMouse": function($list) {
            var that = this;
            this.$container.on("mouseenter", that.elemsSelector, function() {
              $2(this).parents(".ms-container").find(that.elemsSelector).removeClass("ms-hover");
              $2(this).addClass("ms-hover");
            });
            this.$container.on("mouseleave", that.elemsSelector, function() {
              $2(this).parents(".ms-container").find(that.elemsSelector).removeClass("ms-hover");
            });
          },
          "refresh": function() {
            this.destroy();
            this.$element.multiSelect(this.options);
          },
          "destroy": function() {
            $2("#ms-" + this.$element.attr("id")).remove();
            this.$element.off("focus");
            this.$element.css("position", "").css("left", "");
            this.$element.removeData("multiselect");
          },
          "select": function(value, method) {
            if (typeof value === "string") {
              value = [value];
            }
            var that = this, ms = this.$element, msIds = $2.map(value, function(val) {
              return that.sanitize(val);
            }), selectables = this.$selectableUl.find("#" + msIds.join("-selectable, #") + "-selectable").filter(":not(." + that.options.disabledClass + ")"), selections = this.$selectionUl.find("#" + msIds.join("-selection, #") + "-selection").filter(":not(." + that.options.disabledClass + ")"), options = ms.find("option:not(:disabled)").filter(function() {
              return $2.inArray(this.value, value) > -1;
            });
            if (method === "init") {
              selectables = this.$selectableUl.find("#" + msIds.join("-selectable, #") + "-selectable"), selections = this.$selectionUl.find("#" + msIds.join("-selection, #") + "-selection");
            }
            if (selectables.length > 0) {
              selectables.addClass("ms-selected").hide();
              selections.addClass("ms-selected").show();
              options.attr("selected", "selected");
              that.$container.find(that.elemsSelector).removeClass("ms-hover");
              var selectableOptgroups = that.$selectableUl.children(".ms-optgroup-container");
              if (selectableOptgroups.length > 0) {
                selectableOptgroups.each(function() {
                  var selectablesLi = $2(this).find(".ms-elem-selectable");
                  if (selectablesLi.length === selectablesLi.filter(".ms-selected").length) {
                    $2(this).find(".ms-optgroup-label").hide();
                  }
                });
                var selectionOptgroups = that.$selectionUl.children(".ms-optgroup-container");
                selectionOptgroups.each(function() {
                  var selectionsLi = $2(this).find(".ms-elem-selection");
                  if (selectionsLi.filter(".ms-selected").length > 0) {
                    $2(this).find(".ms-optgroup-label").show();
                  }
                });
              } else {
                if (that.options.keepOrder && method !== "init") {
                  var selectionLiLast = that.$selectionUl.find(".ms-selected");
                  if (selectionLiLast.length > 1 && selectionLiLast.last().get(0) != selections.get(0)) {
                    selections.insertAfter(selectionLiLast.last());
                  }
                }
              }
              if (method !== "init") {
                ms.trigger("change");
                if (typeof that.options.afterSelect === "function") {
                  that.options.afterSelect.call(this, value);
                }
              }
            }
          },
          "deselect": function(value) {
            if (typeof value === "string") {
              value = [value];
            }
            var that = this, ms = this.$element, msIds = $2.map(value, function(val) {
              return that.sanitize(val);
            }), selectables = this.$selectableUl.find("#" + msIds.join("-selectable, #") + "-selectable"), selections = this.$selectionUl.find("#" + msIds.join("-selection, #") + "-selection").filter(".ms-selected").filter(":not(." + that.options.disabledClass + ")"), options = ms.find("option").filter(function() {
              return $2.inArray(this.value, value) > -1;
            });
            if (selections.length > 0) {
              selectables.removeClass("ms-selected").show();
              selections.removeClass("ms-selected").hide();
              options.removeAttr("selected");
              that.$container.find(that.elemsSelector).removeClass("ms-hover");
              var selectableOptgroups = that.$selectableUl.children(".ms-optgroup-container");
              if (selectableOptgroups.length > 0) {
                selectableOptgroups.each(function() {
                  var selectablesLi = $2(this).find(".ms-elem-selectable");
                  if (selectablesLi.filter(":not(.ms-selected)").length > 0) {
                    $2(this).find(".ms-optgroup-label").show();
                  }
                });
                var selectionOptgroups = that.$selectionUl.children(".ms-optgroup-container");
                selectionOptgroups.each(function() {
                  var selectionsLi = $2(this).find(".ms-elem-selection");
                  if (selectionsLi.filter(".ms-selected").length === 0) {
                    $2(this).find(".ms-optgroup-label").hide();
                  }
                });
              }
              ms.trigger("change");
              if (typeof that.options.afterDeselect === "function") {
                that.options.afterDeselect.call(this, value);
              }
            }
          },
          "select_all": function() {
            var ms = this.$element, values = ms.val();
            ms.find('option:not(":disabled")').attr("selected", "selected");
            this.$selectableUl.find(".ms-elem-selectable").filter(":not(." + this.options.disabledClass + ")").addClass("ms-selected").hide();
            this.$selectionUl.find(".ms-optgroup-label").show();
            this.$selectableUl.find(".ms-optgroup-label").hide();
            this.$selectionUl.find(".ms-elem-selection").filter(":not(." + this.options.disabledClass + ")").addClass("ms-selected").show();
            this.$selectionUl.focus();
            ms.trigger("change");
            if (typeof this.options.afterSelect === "function") {
              var selectedValues = $2.grep(ms.val(), function(item) {
                return $2.inArray(item, values) < 0;
              });
              this.options.afterSelect.call(this, selectedValues);
            }
          },
          "deselect_all": function() {
            var ms = this.$element, values = ms.val();
            ms.find("option").removeAttr("selected");
            this.$selectableUl.find(".ms-elem-selectable").removeClass("ms-selected").show();
            this.$selectionUl.find(".ms-optgroup-label").hide();
            this.$selectableUl.find(".ms-optgroup-label").show();
            this.$selectionUl.find(".ms-elem-selection").removeClass("ms-selected").hide();
            this.$selectableUl.focus();
            ms.trigger("change");
            if (typeof this.options.afterDeselect === "function") {
              this.options.afterDeselect.call(this, values);
            }
          },
          sanitize: function(value) {
            var hash = 0, i, character;
            if (value.length == 0)
              return hash;
            var ls = 0;
            for (i = 0, ls = value.length; i < ls; i++) {
              character = value.charCodeAt(i);
              hash = (hash << 5) - hash + character;
              hash |= 0;
            }
            return hash;
          }
        };
        $2.fn.multiSelect = function() {
          var option = arguments[0], args = arguments;
          return this.each(function() {
            var $this = $2(this), data = $this.data("multiselect"), options = $2.extend({}, $2.fn.multiSelect.defaults, $this.data(), typeof option === "object" && option);
            if (!data) {
              $this.data("multiselect", data = new MultiSelect(this, options));
            }
            if (typeof option === "string") {
              data[option](args[1]);
            } else {
              data.init();
            }
          });
        };
        $2.fn.multiSelect.defaults = {
          keySelect: [32],
          selectableOptgroup: false,
          disabledClass: "disabled",
          dblClick: false,
          keepOrder: false,
          cssClass: ""
        };
        $2.fn.multiSelect.Constructor = MultiSelect;
        $2.fn.insertAt = function(index, $parent) {
          return this.each(function() {
            if (index === 0) {
              $parent.prepend(this);
            } else {
              $parent.children().eq(index - 1).after(this);
            }
          });
        };
      }(window.jQuery);
    }
  });

  // node_modules/bootstrap-sass/assets/javascripts/bootstrap.js
  var require_bootstrap = __commonJS({
    "node_modules/bootstrap-sass/assets/javascripts/bootstrap.js"() {
      if (typeof jQuery === "undefined") {
        throw new Error("Bootstrap's JavaScript requires jQuery");
      }
      +function($2) {
        "use strict";
        var version = $2.fn.jquery.split(" ")[0].split(".");
        if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] > 3) {
          throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
        }
      }(jQuery);
      +function($2) {
        "use strict";
        function transitionEnd() {
          var el = document.createElement("bootstrap");
          var transEndEventNames = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
          };
          for (var name in transEndEventNames) {
            if (el.style[name] !== void 0) {
              return { end: transEndEventNames[name] };
            }
          }
          return false;
        }
        $2.fn.emulateTransitionEnd = function(duration) {
          var called = false;
          var $el = this;
          $2(this).one("bsTransitionEnd", function() {
            called = true;
          });
          var callback = function() {
            if (!called)
              $2($el).trigger($2.support.transition.end);
          };
          setTimeout(callback, duration);
          return this;
        };
        $2(function() {
          $2.support.transition = transitionEnd();
          if (!$2.support.transition)
            return;
          $2.event.special.bsTransitionEnd = {
            bindType: $2.support.transition.end,
            delegateType: $2.support.transition.end,
            handle: function(e) {
              if ($2(e.target).is(this))
                return e.handleObj.handler.apply(this, arguments);
            }
          };
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var dismiss = '[data-dismiss="alert"]';
        var Alert = function(el) {
          $2(el).on("click", dismiss, this.close);
        };
        Alert.VERSION = "3.4.1";
        Alert.TRANSITION_DURATION = 150;
        Alert.prototype.close = function(e) {
          var $this = $2(this);
          var selector = $this.attr("data-target");
          if (!selector) {
            selector = $this.attr("href");
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, "");
          }
          selector = selector === "#" ? [] : selector;
          var $parent = $2(document).find(selector);
          if (e)
            e.preventDefault();
          if (!$parent.length) {
            $parent = $this.closest(".alert");
          }
          $parent.trigger(e = $2.Event("close.bs.alert"));
          if (e.isDefaultPrevented())
            return;
          $parent.removeClass("in");
          function removeElement() {
            $parent.detach().trigger("closed.bs.alert").remove();
          }
          $2.support.transition && $parent.hasClass("fade") ? $parent.one("bsTransitionEnd", removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.alert");
            if (!data)
              $this.data("bs.alert", data = new Alert(this));
            if (typeof option == "string")
              data[option].call($this);
          });
        }
        var old = $2.fn.alert;
        $2.fn.alert = Plugin;
        $2.fn.alert.Constructor = Alert;
        $2.fn.alert.noConflict = function() {
          $2.fn.alert = old;
          return this;
        };
        $2(document).on("click.bs.alert.data-api", dismiss, Alert.prototype.close);
      }(jQuery);
      +function($2) {
        "use strict";
        var Button = function(element, options) {
          this.$element = $2(element);
          this.options = $2.extend({}, Button.DEFAULTS, options);
          this.isLoading = false;
        };
        Button.VERSION = "3.4.1";
        Button.DEFAULTS = {
          loadingText: "loading..."
        };
        Button.prototype.setState = function(state) {
          var d = "disabled";
          var $el = this.$element;
          var val = $el.is("input") ? "val" : "html";
          var data = $el.data();
          state += "Text";
          if (data.resetText == null)
            $el.data("resetText", $el[val]());
          setTimeout($2.proxy(function() {
            $el[val](data[state] == null ? this.options[state] : data[state]);
            if (state == "loadingText") {
              this.isLoading = true;
              $el.addClass(d).attr(d, d).prop(d, true);
            } else if (this.isLoading) {
              this.isLoading = false;
              $el.removeClass(d).removeAttr(d).prop(d, false);
            }
          }, this), 0);
        };
        Button.prototype.toggle = function() {
          var changed = true;
          var $parent = this.$element.closest('[data-toggle="buttons"]');
          if ($parent.length) {
            var $input = this.$element.find("input");
            if ($input.prop("type") == "radio") {
              if ($input.prop("checked"))
                changed = false;
              $parent.find(".active").removeClass("active");
              this.$element.addClass("active");
            } else if ($input.prop("type") == "checkbox") {
              if ($input.prop("checked") !== this.$element.hasClass("active"))
                changed = false;
              this.$element.toggleClass("active");
            }
            $input.prop("checked", this.$element.hasClass("active"));
            if (changed)
              $input.trigger("change");
          } else {
            this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
            this.$element.toggleClass("active");
          }
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.button");
            var options = typeof option == "object" && option;
            if (!data)
              $this.data("bs.button", data = new Button(this, options));
            if (option == "toggle")
              data.toggle();
            else if (option)
              data.setState(option);
          });
        }
        var old = $2.fn.button;
        $2.fn.button = Plugin;
        $2.fn.button.Constructor = Button;
        $2.fn.button.noConflict = function() {
          $2.fn.button = old;
          return this;
        };
        $2(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(e) {
          var $btn = $2(e.target).closest(".btn");
          Plugin.call($btn, "toggle");
          if (!$2(e.target).is('input[type="radio"], input[type="checkbox"]')) {
            e.preventDefault();
            if ($btn.is("input,button"))
              $btn.trigger("focus");
            else
              $btn.find("input:visible,button:visible").first().trigger("focus");
          }
        }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(e) {
          $2(e.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(e.type));
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var Carousel = function(element, options) {
          this.$element = $2(element);
          this.$indicators = this.$element.find(".carousel-indicators");
          this.options = options;
          this.paused = null;
          this.sliding = null;
          this.interval = null;
          this.$active = null;
          this.$items = null;
          this.options.keyboard && this.$element.on("keydown.bs.carousel", $2.proxy(this.keydown, this));
          this.options.pause == "hover" && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", $2.proxy(this.pause, this)).on("mouseleave.bs.carousel", $2.proxy(this.cycle, this));
        };
        Carousel.VERSION = "3.4.1";
        Carousel.TRANSITION_DURATION = 600;
        Carousel.DEFAULTS = {
          interval: 5e3,
          pause: "hover",
          wrap: true,
          keyboard: true
        };
        Carousel.prototype.keydown = function(e) {
          if (/input|textarea/i.test(e.target.tagName))
            return;
          switch (e.which) {
            case 37:
              this.prev();
              break;
            case 39:
              this.next();
              break;
            default:
              return;
          }
          e.preventDefault();
        };
        Carousel.prototype.cycle = function(e) {
          e || (this.paused = false);
          this.interval && clearInterval(this.interval);
          this.options.interval && !this.paused && (this.interval = setInterval($2.proxy(this.next, this), this.options.interval));
          return this;
        };
        Carousel.prototype.getItemIndex = function(item) {
          this.$items = item.parent().children(".item");
          return this.$items.index(item || this.$active);
        };
        Carousel.prototype.getItemForDirection = function(direction, active) {
          var activeIndex = this.getItemIndex(active);
          var willWrap = direction == "prev" && activeIndex === 0 || direction == "next" && activeIndex == this.$items.length - 1;
          if (willWrap && !this.options.wrap)
            return active;
          var delta = direction == "prev" ? -1 : 1;
          var itemIndex = (activeIndex + delta) % this.$items.length;
          return this.$items.eq(itemIndex);
        };
        Carousel.prototype.to = function(pos) {
          var that = this;
          var activeIndex = this.getItemIndex(this.$active = this.$element.find(".item.active"));
          if (pos > this.$items.length - 1 || pos < 0)
            return;
          if (this.sliding)
            return this.$element.one("slid.bs.carousel", function() {
              that.to(pos);
            });
          if (activeIndex == pos)
            return this.pause().cycle();
          return this.slide(pos > activeIndex ? "next" : "prev", this.$items.eq(pos));
        };
        Carousel.prototype.pause = function(e) {
          e || (this.paused = true);
          if (this.$element.find(".next, .prev").length && $2.support.transition) {
            this.$element.trigger($2.support.transition.end);
            this.cycle(true);
          }
          this.interval = clearInterval(this.interval);
          return this;
        };
        Carousel.prototype.next = function() {
          if (this.sliding)
            return;
          return this.slide("next");
        };
        Carousel.prototype.prev = function() {
          if (this.sliding)
            return;
          return this.slide("prev");
        };
        Carousel.prototype.slide = function(type, next) {
          var $active = this.$element.find(".item.active");
          var $next = next || this.getItemForDirection(type, $active);
          var isCycling = this.interval;
          var direction = type == "next" ? "left" : "right";
          var that = this;
          if ($next.hasClass("active"))
            return this.sliding = false;
          var relatedTarget = $next[0];
          var slideEvent = $2.Event("slide.bs.carousel", {
            relatedTarget,
            direction
          });
          this.$element.trigger(slideEvent);
          if (slideEvent.isDefaultPrevented())
            return;
          this.sliding = true;
          isCycling && this.pause();
          if (this.$indicators.length) {
            this.$indicators.find(".active").removeClass("active");
            var $nextIndicator = $2(this.$indicators.children()[this.getItemIndex($next)]);
            $nextIndicator && $nextIndicator.addClass("active");
          }
          var slidEvent = $2.Event("slid.bs.carousel", { relatedTarget, direction });
          if ($2.support.transition && this.$element.hasClass("slide")) {
            $next.addClass(type);
            if (typeof $next === "object" && $next.length) {
              $next[0].offsetWidth;
            }
            $active.addClass(direction);
            $next.addClass(direction);
            $active.one("bsTransitionEnd", function() {
              $next.removeClass([type, direction].join(" ")).addClass("active");
              $active.removeClass(["active", direction].join(" "));
              that.sliding = false;
              setTimeout(function() {
                that.$element.trigger(slidEvent);
              }, 0);
            }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
          } else {
            $active.removeClass("active");
            $next.addClass("active");
            this.sliding = false;
            this.$element.trigger(slidEvent);
          }
          isCycling && this.cycle();
          return this;
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.carousel");
            var options = $2.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == "object" && option);
            var action = typeof option == "string" ? option : options.slide;
            if (!data)
              $this.data("bs.carousel", data = new Carousel(this, options));
            if (typeof option == "number")
              data.to(option);
            else if (action)
              data[action]();
            else if (options.interval)
              data.pause().cycle();
          });
        }
        var old = $2.fn.carousel;
        $2.fn.carousel = Plugin;
        $2.fn.carousel.Constructor = Carousel;
        $2.fn.carousel.noConflict = function() {
          $2.fn.carousel = old;
          return this;
        };
        var clickHandler = function(e) {
          var $this = $2(this);
          var href = $this.attr("href");
          if (href) {
            href = href.replace(/.*(?=#[^\s]+$)/, "");
          }
          var target = $this.attr("data-target") || href;
          var $target = $2(document).find(target);
          if (!$target.hasClass("carousel"))
            return;
          var options = $2.extend({}, $target.data(), $this.data());
          var slideIndex = $this.attr("data-slide-to");
          if (slideIndex)
            options.interval = false;
          Plugin.call($target, options);
          if (slideIndex) {
            $target.data("bs.carousel").to(slideIndex);
          }
          e.preventDefault();
        };
        $2(document).on("click.bs.carousel.data-api", "[data-slide]", clickHandler).on("click.bs.carousel.data-api", "[data-slide-to]", clickHandler);
        $2(window).on("load", function() {
          $2('[data-ride="carousel"]').each(function() {
            var $carousel = $2(this);
            Plugin.call($carousel, $carousel.data());
          });
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var Collapse = function(element, options) {
          this.$element = $2(element);
          this.options = $2.extend({}, Collapse.DEFAULTS, options);
          this.$trigger = $2('[data-toggle="collapse"][href="#' + element.id + '"],[data-toggle="collapse"][data-target="#' + element.id + '"]');
          this.transitioning = null;
          if (this.options.parent) {
            this.$parent = this.getParent();
          } else {
            this.addAriaAndCollapsedClass(this.$element, this.$trigger);
          }
          if (this.options.toggle)
            this.toggle();
        };
        Collapse.VERSION = "3.4.1";
        Collapse.TRANSITION_DURATION = 350;
        Collapse.DEFAULTS = {
          toggle: true
        };
        Collapse.prototype.dimension = function() {
          var hasWidth = this.$element.hasClass("width");
          return hasWidth ? "width" : "height";
        };
        Collapse.prototype.show = function() {
          if (this.transitioning || this.$element.hasClass("in"))
            return;
          var activesData;
          var actives = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
          if (actives && actives.length) {
            activesData = actives.data("bs.collapse");
            if (activesData && activesData.transitioning)
              return;
          }
          var startEvent = $2.Event("show.bs.collapse");
          this.$element.trigger(startEvent);
          if (startEvent.isDefaultPrevented())
            return;
          if (actives && actives.length) {
            Plugin.call(actives, "hide");
            activesData || actives.data("bs.collapse", null);
          }
          var dimension = this.dimension();
          this.$element.removeClass("collapse").addClass("collapsing")[dimension](0).attr("aria-expanded", true);
          this.$trigger.removeClass("collapsed").attr("aria-expanded", true);
          this.transitioning = 1;
          var complete = function() {
            this.$element.removeClass("collapsing").addClass("collapse in")[dimension]("");
            this.transitioning = 0;
            this.$element.trigger("shown.bs.collapse");
          };
          if (!$2.support.transition)
            return complete.call(this);
          var scrollSize = $2.camelCase(["scroll", dimension].join("-"));
          this.$element.one("bsTransitionEnd", $2.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
        };
        Collapse.prototype.hide = function() {
          if (this.transitioning || !this.$element.hasClass("in"))
            return;
          var startEvent = $2.Event("hide.bs.collapse");
          this.$element.trigger(startEvent);
          if (startEvent.isDefaultPrevented())
            return;
          var dimension = this.dimension();
          this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
          this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", false);
          this.$trigger.addClass("collapsed").attr("aria-expanded", false);
          this.transitioning = 1;
          var complete = function() {
            this.transitioning = 0;
            this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
          };
          if (!$2.support.transition)
            return complete.call(this);
          this.$element[dimension](0).one("bsTransitionEnd", $2.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
        };
        Collapse.prototype.toggle = function() {
          this[this.$element.hasClass("in") ? "hide" : "show"]();
        };
        Collapse.prototype.getParent = function() {
          return $2(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($2.proxy(function(i, element) {
            var $element = $2(element);
            this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
          }, this)).end();
        };
        Collapse.prototype.addAriaAndCollapsedClass = function($element, $trigger) {
          var isOpen = $element.hasClass("in");
          $element.attr("aria-expanded", isOpen);
          $trigger.toggleClass("collapsed", !isOpen).attr("aria-expanded", isOpen);
        };
        function getTargetFromTrigger($trigger) {
          var href;
          var target = $trigger.attr("data-target") || (href = $trigger.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "");
          return $2(document).find(target);
        }
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.collapse");
            var options = $2.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == "object" && option);
            if (!data && options.toggle && /show|hide/.test(option))
              options.toggle = false;
            if (!data)
              $this.data("bs.collapse", data = new Collapse(this, options));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.collapse;
        $2.fn.collapse = Plugin;
        $2.fn.collapse.Constructor = Collapse;
        $2.fn.collapse.noConflict = function() {
          $2.fn.collapse = old;
          return this;
        };
        $2(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(e) {
          var $this = $2(this);
          if (!$this.attr("data-target"))
            e.preventDefault();
          var $target = getTargetFromTrigger($this);
          var data = $target.data("bs.collapse");
          var option = data ? "toggle" : $this.data();
          Plugin.call($target, option);
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var backdrop = ".dropdown-backdrop";
        var toggle = '[data-toggle="dropdown"]';
        var Dropdown = function(element) {
          $2(element).on("click.bs.dropdown", this.toggle);
        };
        Dropdown.VERSION = "3.4.1";
        function getParent($this) {
          var selector = $this.attr("data-target");
          if (!selector) {
            selector = $this.attr("href");
            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, "");
          }
          var $parent = selector !== "#" ? $2(document).find(selector) : null;
          return $parent && $parent.length ? $parent : $this.parent();
        }
        function clearMenus(e) {
          if (e && e.which === 3)
            return;
          $2(backdrop).remove();
          $2(toggle).each(function() {
            var $this = $2(this);
            var $parent = getParent($this);
            var relatedTarget = { relatedTarget: this };
            if (!$parent.hasClass("open"))
              return;
            if (e && e.type == "click" && /input|textarea/i.test(e.target.tagName) && $2.contains($parent[0], e.target))
              return;
            $parent.trigger(e = $2.Event("hide.bs.dropdown", relatedTarget));
            if (e.isDefaultPrevented())
              return;
            $this.attr("aria-expanded", "false");
            $parent.removeClass("open").trigger($2.Event("hidden.bs.dropdown", relatedTarget));
          });
        }
        Dropdown.prototype.toggle = function(e) {
          var $this = $2(this);
          if ($this.is(".disabled, :disabled"))
            return;
          var $parent = getParent($this);
          var isActive = $parent.hasClass("open");
          clearMenus();
          if (!isActive) {
            if ("ontouchstart" in document.documentElement && !$parent.closest(".navbar-nav").length) {
              $2(document.createElement("div")).addClass("dropdown-backdrop").insertAfter($2(this)).on("click", clearMenus);
            }
            var relatedTarget = { relatedTarget: this };
            $parent.trigger(e = $2.Event("show.bs.dropdown", relatedTarget));
            if (e.isDefaultPrevented())
              return;
            $this.trigger("focus").attr("aria-expanded", "true");
            $parent.toggleClass("open").trigger($2.Event("shown.bs.dropdown", relatedTarget));
          }
          return false;
        };
        Dropdown.prototype.keydown = function(e) {
          if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName))
            return;
          var $this = $2(this);
          e.preventDefault();
          e.stopPropagation();
          if ($this.is(".disabled, :disabled"))
            return;
          var $parent = getParent($this);
          var isActive = $parent.hasClass("open");
          if (!isActive && e.which != 27 || isActive && e.which == 27) {
            if (e.which == 27)
              $parent.find(toggle).trigger("focus");
            return $this.trigger("click");
          }
          var desc = " li:not(.disabled):visible a";
          var $items = $parent.find(".dropdown-menu" + desc);
          if (!$items.length)
            return;
          var index = $items.index(e.target);
          if (e.which == 38 && index > 0)
            index--;
          if (e.which == 40 && index < $items.length - 1)
            index++;
          if (!~index)
            index = 0;
          $items.eq(index).trigger("focus");
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.dropdown");
            if (!data)
              $this.data("bs.dropdown", data = new Dropdown(this));
            if (typeof option == "string")
              data[option].call($this);
          });
        }
        var old = $2.fn.dropdown;
        $2.fn.dropdown = Plugin;
        $2.fn.dropdown.Constructor = Dropdown;
        $2.fn.dropdown.noConflict = function() {
          $2.fn.dropdown = old;
          return this;
        };
        $2(document).on("click.bs.dropdown.data-api", clearMenus).on("click.bs.dropdown.data-api", ".dropdown form", function(e) {
          e.stopPropagation();
        }).on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle).on("keydown.bs.dropdown.data-api", toggle, Dropdown.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", Dropdown.prototype.keydown);
      }(jQuery);
      +function($2) {
        "use strict";
        var Modal = function(element, options) {
          this.options = options;
          this.$body = $2(document.body);
          this.$element = $2(element);
          this.$dialog = this.$element.find(".modal-dialog");
          this.$backdrop = null;
          this.isShown = null;
          this.originalBodyPad = null;
          this.scrollbarWidth = 0;
          this.ignoreBackdropClick = false;
          this.fixedContent = ".navbar-fixed-top, .navbar-fixed-bottom";
          if (this.options.remote) {
            this.$element.find(".modal-content").load(this.options.remote, $2.proxy(function() {
              this.$element.trigger("loaded.bs.modal");
            }, this));
          }
        };
        Modal.VERSION = "3.4.1";
        Modal.TRANSITION_DURATION = 300;
        Modal.BACKDROP_TRANSITION_DURATION = 150;
        Modal.DEFAULTS = {
          backdrop: true,
          keyboard: true,
          show: true
        };
        Modal.prototype.toggle = function(_relatedTarget) {
          return this.isShown ? this.hide() : this.show(_relatedTarget);
        };
        Modal.prototype.show = function(_relatedTarget) {
          var that = this;
          var e = $2.Event("show.bs.modal", { relatedTarget: _relatedTarget });
          this.$element.trigger(e);
          if (this.isShown || e.isDefaultPrevented())
            return;
          this.isShown = true;
          this.checkScrollbar();
          this.setScrollbar();
          this.$body.addClass("modal-open");
          this.escape();
          this.resize();
          this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', $2.proxy(this.hide, this));
          this.$dialog.on("mousedown.dismiss.bs.modal", function() {
            that.$element.one("mouseup.dismiss.bs.modal", function(e2) {
              if ($2(e2.target).is(that.$element))
                that.ignoreBackdropClick = true;
            });
          });
          this.backdrop(function() {
            var transition = $2.support.transition && that.$element.hasClass("fade");
            if (!that.$element.parent().length) {
              that.$element.appendTo(that.$body);
            }
            that.$element.show().scrollTop(0);
            that.adjustDialog();
            if (transition) {
              that.$element[0].offsetWidth;
            }
            that.$element.addClass("in");
            that.enforceFocus();
            var e2 = $2.Event("shown.bs.modal", { relatedTarget: _relatedTarget });
            transition ? that.$dialog.one("bsTransitionEnd", function() {
              that.$element.trigger("focus").trigger(e2);
            }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger("focus").trigger(e2);
          });
        };
        Modal.prototype.hide = function(e) {
          if (e)
            e.preventDefault();
          e = $2.Event("hide.bs.modal");
          this.$element.trigger(e);
          if (!this.isShown || e.isDefaultPrevented())
            return;
          this.isShown = false;
          this.escape();
          this.resize();
          $2(document).off("focusin.bs.modal");
          this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal");
          this.$dialog.off("mousedown.dismiss.bs.modal");
          $2.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", $2.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
        };
        Modal.prototype.enforceFocus = function() {
          $2(document).off("focusin.bs.modal").on("focusin.bs.modal", $2.proxy(function(e) {
            if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
              this.$element.trigger("focus");
            }
          }, this));
        };
        Modal.prototype.escape = function() {
          if (this.isShown && this.options.keyboard) {
            this.$element.on("keydown.dismiss.bs.modal", $2.proxy(function(e) {
              e.which == 27 && this.hide();
            }, this));
          } else if (!this.isShown) {
            this.$element.off("keydown.dismiss.bs.modal");
          }
        };
        Modal.prototype.resize = function() {
          if (this.isShown) {
            $2(window).on("resize.bs.modal", $2.proxy(this.handleUpdate, this));
          } else {
            $2(window).off("resize.bs.modal");
          }
        };
        Modal.prototype.hideModal = function() {
          var that = this;
          this.$element.hide();
          this.backdrop(function() {
            that.$body.removeClass("modal-open");
            that.resetAdjustments();
            that.resetScrollbar();
            that.$element.trigger("hidden.bs.modal");
          });
        };
        Modal.prototype.removeBackdrop = function() {
          this.$backdrop && this.$backdrop.remove();
          this.$backdrop = null;
        };
        Modal.prototype.backdrop = function(callback) {
          var that = this;
          var animate = this.$element.hasClass("fade") ? "fade" : "";
          if (this.isShown && this.options.backdrop) {
            var doAnimate = $2.support.transition && animate;
            this.$backdrop = $2(document.createElement("div")).addClass("modal-backdrop " + animate).appendTo(this.$body);
            this.$element.on("click.dismiss.bs.modal", $2.proxy(function(e) {
              if (this.ignoreBackdropClick) {
                this.ignoreBackdropClick = false;
                return;
              }
              if (e.target !== e.currentTarget)
                return;
              this.options.backdrop == "static" ? this.$element[0].focus() : this.hide();
            }, this));
            if (doAnimate)
              this.$backdrop[0].offsetWidth;
            this.$backdrop.addClass("in");
            if (!callback)
              return;
            doAnimate ? this.$backdrop.one("bsTransitionEnd", callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
          } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass("in");
            var callbackRemove = function() {
              that.removeBackdrop();
              callback && callback();
            };
            $2.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
          } else if (callback) {
            callback();
          }
        };
        Modal.prototype.handleUpdate = function() {
          this.adjustDialog();
        };
        Modal.prototype.adjustDialog = function() {
          var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
          this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : "",
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ""
          });
        };
        Modal.prototype.resetAdjustments = function() {
          this.$element.css({
            paddingLeft: "",
            paddingRight: ""
          });
        };
        Modal.prototype.checkScrollbar = function() {
          var fullWindowWidth = window.innerWidth;
          if (!fullWindowWidth) {
            var documentElementRect = document.documentElement.getBoundingClientRect();
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
          }
          this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
          this.scrollbarWidth = this.measureScrollbar();
        };
        Modal.prototype.setScrollbar = function() {
          var bodyPad = parseInt(this.$body.css("padding-right") || 0, 10);
          this.originalBodyPad = document.body.style.paddingRight || "";
          var scrollbarWidth = this.scrollbarWidth;
          if (this.bodyIsOverflowing) {
            this.$body.css("padding-right", bodyPad + scrollbarWidth);
            $2(this.fixedContent).each(function(index, element) {
              var actualPadding = element.style.paddingRight;
              var calculatedPadding = $2(element).css("padding-right");
              $2(element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + scrollbarWidth + "px");
            });
          }
        };
        Modal.prototype.resetScrollbar = function() {
          this.$body.css("padding-right", this.originalBodyPad);
          $2(this.fixedContent).each(function(index, element) {
            var padding = $2(element).data("padding-right");
            $2(element).removeData("padding-right");
            element.style.paddingRight = padding ? padding : "";
          });
        };
        Modal.prototype.measureScrollbar = function() {
          var scrollDiv = document.createElement("div");
          scrollDiv.className = "modal-scrollbar-measure";
          this.$body.append(scrollDiv);
          var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
          this.$body[0].removeChild(scrollDiv);
          return scrollbarWidth;
        };
        function Plugin(option, _relatedTarget) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.modal");
            var options = $2.extend({}, Modal.DEFAULTS, $this.data(), typeof option == "object" && option);
            if (!data)
              $this.data("bs.modal", data = new Modal(this, options));
            if (typeof option == "string")
              data[option](_relatedTarget);
            else if (options.show)
              data.show(_relatedTarget);
          });
        }
        var old = $2.fn.modal;
        $2.fn.modal = Plugin;
        $2.fn.modal.Constructor = Modal;
        $2.fn.modal.noConflict = function() {
          $2.fn.modal = old;
          return this;
        };
        $2(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e) {
          var $this = $2(this);
          var href = $this.attr("href");
          var target = $this.attr("data-target") || href && href.replace(/.*(?=#[^\s]+$)/, "");
          var $target = $2(document).find(target);
          var option = $target.data("bs.modal") ? "toggle" : $2.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
          if ($this.is("a"))
            e.preventDefault();
          $target.one("show.bs.modal", function(showEvent) {
            if (showEvent.isDefaultPrevented())
              return;
            $target.one("hidden.bs.modal", function() {
              $this.is(":visible") && $this.trigger("focus");
            });
          });
          Plugin.call($target, option, this);
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var DISALLOWED_ATTRIBUTES = ["sanitize", "whiteList", "sanitizeFn"];
        var uriAttrs = [
          "background",
          "cite",
          "href",
          "itemtype",
          "longdesc",
          "poster",
          "src",
          "xlink:href"
        ];
        var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
        var DefaultWhitelist = {
          // Global attributes allowed on any supplied element below.
          "*": ["class", "dir", "id", "lang", "role", ARIA_ATTRIBUTE_PATTERN],
          a: ["target", "href", "title", "rel"],
          area: [],
          b: [],
          br: [],
          col: [],
          code: [],
          div: [],
          em: [],
          hr: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          i: [],
          img: ["src", "alt", "title", "width", "height"],
          li: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: []
        };
        var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
        var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
        function allowedAttribute(attr, allowedAttributeList) {
          var attrName = attr.nodeName.toLowerCase();
          if ($2.inArray(attrName, allowedAttributeList) !== -1) {
            if ($2.inArray(attrName, uriAttrs) !== -1) {
              return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
            }
            return true;
          }
          var regExp = $2(allowedAttributeList).filter(function(index, value) {
            return value instanceof RegExp;
          });
          for (var i = 0, l = regExp.length; i < l; i++) {
            if (attrName.match(regExp[i])) {
              return true;
            }
          }
          return false;
        }
        function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
          if (unsafeHtml.length === 0) {
            return unsafeHtml;
          }
          if (sanitizeFn && typeof sanitizeFn === "function") {
            return sanitizeFn(unsafeHtml);
          }
          if (!document.implementation || !document.implementation.createHTMLDocument) {
            return unsafeHtml;
          }
          var createdDocument = document.implementation.createHTMLDocument("sanitization");
          createdDocument.body.innerHTML = unsafeHtml;
          var whitelistKeys = $2.map(whiteList, function(el2, i2) {
            return i2;
          });
          var elements = $2(createdDocument.body).find("*");
          for (var i = 0, len = elements.length; i < len; i++) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if ($2.inArray(elName, whitelistKeys) === -1) {
              el.parentNode.removeChild(el);
              continue;
            }
            var attributeList = $2.map(el.attributes, function(el2) {
              return el2;
            });
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            for (var j = 0, len2 = attributeList.length; j < len2; j++) {
              if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
                el.removeAttribute(attributeList[j].nodeName);
              }
            }
          }
          return createdDocument.body.innerHTML;
        }
        var Tooltip = function(element, options) {
          this.type = null;
          this.options = null;
          this.enabled = null;
          this.timeout = null;
          this.hoverState = null;
          this.$element = null;
          this.inState = null;
          this.init("tooltip", element, options);
        };
        Tooltip.VERSION = "3.4.1";
        Tooltip.TRANSITION_DURATION = 150;
        Tooltip.DEFAULTS = {
          animation: true,
          placement: "top",
          selector: false,
          template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
          trigger: "hover focus",
          title: "",
          delay: 0,
          html: false,
          container: false,
          viewport: {
            selector: "body",
            padding: 0
          },
          sanitize: true,
          sanitizeFn: null,
          whiteList: DefaultWhitelist
        };
        Tooltip.prototype.init = function(type, element, options) {
          this.enabled = true;
          this.type = type;
          this.$element = $2(element);
          this.options = this.getOptions(options);
          this.$viewport = this.options.viewport && $2(document).find($2.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
          this.inState = { click: false, hover: false, focus: false };
          if (this.$element[0] instanceof document.constructor && !this.options.selector) {
            throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
          }
          var triggers = this.options.trigger.split(" ");
          for (var i = triggers.length; i--; ) {
            var trigger = triggers[i];
            if (trigger == "click") {
              this.$element.on("click." + this.type, this.options.selector, $2.proxy(this.toggle, this));
            } else if (trigger != "manual") {
              var eventIn = trigger == "hover" ? "mouseenter" : "focusin";
              var eventOut = trigger == "hover" ? "mouseleave" : "focusout";
              this.$element.on(eventIn + "." + this.type, this.options.selector, $2.proxy(this.enter, this));
              this.$element.on(eventOut + "." + this.type, this.options.selector, $2.proxy(this.leave, this));
            }
          }
          this.options.selector ? this._options = $2.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle();
        };
        Tooltip.prototype.getDefaults = function() {
          return Tooltip.DEFAULTS;
        };
        Tooltip.prototype.getOptions = function(options) {
          var dataAttributes = this.$element.data();
          for (var dataAttr in dataAttributes) {
            if (dataAttributes.hasOwnProperty(dataAttr) && $2.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
              delete dataAttributes[dataAttr];
            }
          }
          options = $2.extend({}, this.getDefaults(), dataAttributes, options);
          if (options.delay && typeof options.delay == "number") {
            options.delay = {
              show: options.delay,
              hide: options.delay
            };
          }
          if (options.sanitize) {
            options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn);
          }
          return options;
        };
        Tooltip.prototype.getDelegateOptions = function() {
          var options = {};
          var defaults = this.getDefaults();
          this._options && $2.each(this._options, function(key, value) {
            if (defaults[key] != value)
              options[key] = value;
          });
          return options;
        };
        Tooltip.prototype.enter = function(obj) {
          var self2 = obj instanceof this.constructor ? obj : $2(obj.currentTarget).data("bs." + this.type);
          if (!self2) {
            self2 = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $2(obj.currentTarget).data("bs." + this.type, self2);
          }
          if (obj instanceof $2.Event) {
            self2.inState[obj.type == "focusin" ? "focus" : "hover"] = true;
          }
          if (self2.tip().hasClass("in") || self2.hoverState == "in") {
            self2.hoverState = "in";
            return;
          }
          clearTimeout(self2.timeout);
          self2.hoverState = "in";
          if (!self2.options.delay || !self2.options.delay.show)
            return self2.show();
          self2.timeout = setTimeout(function() {
            if (self2.hoverState == "in")
              self2.show();
          }, self2.options.delay.show);
        };
        Tooltip.prototype.isInStateTrue = function() {
          for (var key in this.inState) {
            if (this.inState[key])
              return true;
          }
          return false;
        };
        Tooltip.prototype.leave = function(obj) {
          var self2 = obj instanceof this.constructor ? obj : $2(obj.currentTarget).data("bs." + this.type);
          if (!self2) {
            self2 = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $2(obj.currentTarget).data("bs." + this.type, self2);
          }
          if (obj instanceof $2.Event) {
            self2.inState[obj.type == "focusout" ? "focus" : "hover"] = false;
          }
          if (self2.isInStateTrue())
            return;
          clearTimeout(self2.timeout);
          self2.hoverState = "out";
          if (!self2.options.delay || !self2.options.delay.hide)
            return self2.hide();
          self2.timeout = setTimeout(function() {
            if (self2.hoverState == "out")
              self2.hide();
          }, self2.options.delay.hide);
        };
        Tooltip.prototype.show = function() {
          var e = $2.Event("show.bs." + this.type);
          if (this.hasContent() && this.enabled) {
            this.$element.trigger(e);
            var inDom = $2.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (e.isDefaultPrevented() || !inDom)
              return;
            var that = this;
            var $tip = this.tip();
            var tipId = this.getUID(this.type);
            this.setContent();
            $tip.attr("id", tipId);
            this.$element.attr("aria-describedby", tipId);
            if (this.options.animation)
              $tip.addClass("fade");
            var placement = typeof this.options.placement == "function" ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
            var autoToken = /\s?auto?\s?/i;
            var autoPlace = autoToken.test(placement);
            if (autoPlace)
              placement = placement.replace(autoToken, "") || "top";
            $tip.detach().css({ top: 0, left: 0, display: "block" }).addClass(placement).data("bs." + this.type, this);
            this.options.container ? $tip.appendTo($2(document).find(this.options.container)) : $tip.insertAfter(this.$element);
            this.$element.trigger("inserted.bs." + this.type);
            var pos = this.getPosition();
            var actualWidth = $tip[0].offsetWidth;
            var actualHeight = $tip[0].offsetHeight;
            if (autoPlace) {
              var orgPlacement = placement;
              var viewportDim = this.getPosition(this.$viewport);
              placement = placement == "bottom" && pos.bottom + actualHeight > viewportDim.bottom ? "top" : placement == "top" && pos.top - actualHeight < viewportDim.top ? "bottom" : placement == "right" && pos.right + actualWidth > viewportDim.width ? "left" : placement == "left" && pos.left - actualWidth < viewportDim.left ? "right" : placement;
              $tip.removeClass(orgPlacement).addClass(placement);
            }
            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
            this.applyPlacement(calculatedOffset, placement);
            var complete = function() {
              var prevHoverState = that.hoverState;
              that.$element.trigger("shown.bs." + that.type);
              that.hoverState = null;
              if (prevHoverState == "out")
                that.leave(that);
            };
            $2.support.transition && this.$tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
          }
        };
        Tooltip.prototype.applyPlacement = function(offset, placement) {
          var $tip = this.tip();
          var width = $tip[0].offsetWidth;
          var height = $tip[0].offsetHeight;
          var marginTop = parseInt($tip.css("margin-top"), 10);
          var marginLeft = parseInt($tip.css("margin-left"), 10);
          if (isNaN(marginTop))
            marginTop = 0;
          if (isNaN(marginLeft))
            marginLeft = 0;
          offset.top += marginTop;
          offset.left += marginLeft;
          $2.offset.setOffset($tip[0], $2.extend({
            using: function(props) {
              $tip.css({
                top: Math.round(props.top),
                left: Math.round(props.left)
              });
            }
          }, offset), 0);
          $tip.addClass("in");
          var actualWidth = $tip[0].offsetWidth;
          var actualHeight = $tip[0].offsetHeight;
          if (placement == "top" && actualHeight != height) {
            offset.top = offset.top + height - actualHeight;
          }
          var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
          if (delta.left)
            offset.left += delta.left;
          else
            offset.top += delta.top;
          var isVertical = /top|bottom/.test(placement);
          var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
          var arrowOffsetPosition = isVertical ? "offsetWidth" : "offsetHeight";
          $tip.offset(offset);
          this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
        };
        Tooltip.prototype.replaceArrow = function(delta, dimension, isVertical) {
          this.arrow().css(isVertical ? "left" : "top", 50 * (1 - delta / dimension) + "%").css(isVertical ? "top" : "left", "");
        };
        Tooltip.prototype.setContent = function() {
          var $tip = this.tip();
          var title = this.getTitle();
          if (this.options.html) {
            if (this.options.sanitize) {
              title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn);
            }
            $tip.find(".tooltip-inner").html(title);
          } else {
            $tip.find(".tooltip-inner").text(title);
          }
          $tip.removeClass("fade in top bottom left right");
        };
        Tooltip.prototype.hide = function(callback) {
          var that = this;
          var $tip = $2(this.$tip);
          var e = $2.Event("hide.bs." + this.type);
          function complete() {
            if (that.hoverState != "in")
              $tip.detach();
            if (that.$element) {
              that.$element.removeAttr("aria-describedby").trigger("hidden.bs." + that.type);
            }
            callback && callback();
          }
          this.$element.trigger(e);
          if (e.isDefaultPrevented())
            return;
          $tip.removeClass("in");
          $2.support.transition && $tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
          this.hoverState = null;
          return this;
        };
        Tooltip.prototype.fixTitle = function() {
          var $e = this.$element;
          if ($e.attr("title") || typeof $e.attr("data-original-title") != "string") {
            $e.attr("data-original-title", $e.attr("title") || "").attr("title", "");
          }
        };
        Tooltip.prototype.hasContent = function() {
          return this.getTitle();
        };
        Tooltip.prototype.getPosition = function($element) {
          $element = $element || this.$element;
          var el = $element[0];
          var isBody = el.tagName == "BODY";
          var elRect = el.getBoundingClientRect();
          if (elRect.width == null) {
            elRect = $2.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
          }
          var isSvg = window.SVGElement && el instanceof window.SVGElement;
          var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
          var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
          var outerDims = isBody ? { width: $2(window).width(), height: $2(window).height() } : null;
          return $2.extend({}, elRect, scroll, outerDims, elOffset);
        };
        Tooltip.prototype.getCalculatedOffset = function(placement, pos, actualWidth, actualHeight) {
          return placement == "bottom" ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == "top" ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == "left" ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } : (
            /* placement == 'right' */
            { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
          );
        };
        Tooltip.prototype.getViewportAdjustedDelta = function(placement, pos, actualWidth, actualHeight) {
          var delta = { top: 0, left: 0 };
          if (!this.$viewport)
            return delta;
          var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
          var viewportDimensions = this.getPosition(this.$viewport);
          if (/right|left/.test(placement)) {
            var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) {
              delta.top = viewportDimensions.top - topEdgeOffset;
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
            }
          } else {
            var leftEdgeOffset = pos.left - viewportPadding;
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) {
              delta.left = viewportDimensions.left - leftEdgeOffset;
            } else if (rightEdgeOffset > viewportDimensions.right) {
              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
            }
          }
          return delta;
        };
        Tooltip.prototype.getTitle = function() {
          var title;
          var $e = this.$element;
          var o = this.options;
          title = $e.attr("data-original-title") || (typeof o.title == "function" ? o.title.call($e[0]) : o.title);
          return title;
        };
        Tooltip.prototype.getUID = function(prefix) {
          do
            prefix += ~~(Math.random() * 1e6);
          while (document.getElementById(prefix));
          return prefix;
        };
        Tooltip.prototype.tip = function() {
          if (!this.$tip) {
            this.$tip = $2(this.options.template);
            if (this.$tip.length != 1) {
              throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
            }
          }
          return this.$tip;
        };
        Tooltip.prototype.arrow = function() {
          return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
        };
        Tooltip.prototype.enable = function() {
          this.enabled = true;
        };
        Tooltip.prototype.disable = function() {
          this.enabled = false;
        };
        Tooltip.prototype.toggleEnabled = function() {
          this.enabled = !this.enabled;
        };
        Tooltip.prototype.toggle = function(e) {
          var self2 = this;
          if (e) {
            self2 = $2(e.currentTarget).data("bs." + this.type);
            if (!self2) {
              self2 = new this.constructor(e.currentTarget, this.getDelegateOptions());
              $2(e.currentTarget).data("bs." + this.type, self2);
            }
          }
          if (e) {
            self2.inState.click = !self2.inState.click;
            if (self2.isInStateTrue())
              self2.enter(self2);
            else
              self2.leave(self2);
          } else {
            self2.tip().hasClass("in") ? self2.leave(self2) : self2.enter(self2);
          }
        };
        Tooltip.prototype.destroy = function() {
          var that = this;
          clearTimeout(this.timeout);
          this.hide(function() {
            that.$element.off("." + that.type).removeData("bs." + that.type);
            if (that.$tip) {
              that.$tip.detach();
            }
            that.$tip = null;
            that.$arrow = null;
            that.$viewport = null;
            that.$element = null;
          });
        };
        Tooltip.prototype.sanitizeHtml = function(unsafeHtml) {
          return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn);
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.tooltip");
            var options = typeof option == "object" && option;
            if (!data && /destroy|hide/.test(option))
              return;
            if (!data)
              $this.data("bs.tooltip", data = new Tooltip(this, options));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.tooltip;
        $2.fn.tooltip = Plugin;
        $2.fn.tooltip.Constructor = Tooltip;
        $2.fn.tooltip.noConflict = function() {
          $2.fn.tooltip = old;
          return this;
        };
      }(jQuery);
      +function($2) {
        "use strict";
        var Popover = function(element, options) {
          this.init("popover", element, options);
        };
        if (!$2.fn.tooltip)
          throw new Error("Popover requires tooltip.js");
        Popover.VERSION = "3.4.1";
        Popover.DEFAULTS = $2.extend({}, $2.fn.tooltip.Constructor.DEFAULTS, {
          placement: "right",
          trigger: "click",
          content: "",
          template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
        });
        Popover.prototype = $2.extend({}, $2.fn.tooltip.Constructor.prototype);
        Popover.prototype.constructor = Popover;
        Popover.prototype.getDefaults = function() {
          return Popover.DEFAULTS;
        };
        Popover.prototype.setContent = function() {
          var $tip = this.tip();
          var title = this.getTitle();
          var content = this.getContent();
          if (this.options.html) {
            var typeContent = typeof content;
            if (this.options.sanitize) {
              title = this.sanitizeHtml(title);
              if (typeContent === "string") {
                content = this.sanitizeHtml(content);
              }
            }
            $tip.find(".popover-title").html(title);
            $tip.find(".popover-content").children().detach().end()[typeContent === "string" ? "html" : "append"](content);
          } else {
            $tip.find(".popover-title").text(title);
            $tip.find(".popover-content").children().detach().end().text(content);
          }
          $tip.removeClass("fade top bottom left right in");
          if (!$tip.find(".popover-title").html())
            $tip.find(".popover-title").hide();
        };
        Popover.prototype.hasContent = function() {
          return this.getTitle() || this.getContent();
        };
        Popover.prototype.getContent = function() {
          var $e = this.$element;
          var o = this.options;
          return $e.attr("data-content") || (typeof o.content == "function" ? o.content.call($e[0]) : o.content);
        };
        Popover.prototype.arrow = function() {
          return this.$arrow = this.$arrow || this.tip().find(".arrow");
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.popover");
            var options = typeof option == "object" && option;
            if (!data && /destroy|hide/.test(option))
              return;
            if (!data)
              $this.data("bs.popover", data = new Popover(this, options));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.popover;
        $2.fn.popover = Plugin;
        $2.fn.popover.Constructor = Popover;
        $2.fn.popover.noConflict = function() {
          $2.fn.popover = old;
          return this;
        };
      }(jQuery);
      +function($2) {
        "use strict";
        function ScrollSpy(element, options) {
          this.$body = $2(document.body);
          this.$scrollElement = $2(element).is(document.body) ? $2(window) : $2(element);
          this.options = $2.extend({}, ScrollSpy.DEFAULTS, options);
          this.selector = (this.options.target || "") + " .nav li > a";
          this.offsets = [];
          this.targets = [];
          this.activeTarget = null;
          this.scrollHeight = 0;
          this.$scrollElement.on("scroll.bs.scrollspy", $2.proxy(this.process, this));
          this.refresh();
          this.process();
        }
        ScrollSpy.VERSION = "3.4.1";
        ScrollSpy.DEFAULTS = {
          offset: 10
        };
        ScrollSpy.prototype.getScrollHeight = function() {
          return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
        };
        ScrollSpy.prototype.refresh = function() {
          var that = this;
          var offsetMethod = "offset";
          var offsetBase = 0;
          this.offsets = [];
          this.targets = [];
          this.scrollHeight = this.getScrollHeight();
          if (!$2.isWindow(this.$scrollElement[0])) {
            offsetMethod = "position";
            offsetBase = this.$scrollElement.scrollTop();
          }
          this.$body.find(this.selector).map(function() {
            var $el = $2(this);
            var href = $el.data("target") || $el.attr("href");
            var $href = /^#./.test(href) && $2(href);
            return $href && $href.length && $href.is(":visible") && [[$href[offsetMethod]().top + offsetBase, href]] || null;
          }).sort(function(a, b) {
            return a[0] - b[0];
          }).each(function() {
            that.offsets.push(this[0]);
            that.targets.push(this[1]);
          });
        };
        ScrollSpy.prototype.process = function() {
          var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
          var scrollHeight = this.getScrollHeight();
          var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
          var offsets = this.offsets;
          var targets = this.targets;
          var activeTarget = this.activeTarget;
          var i;
          if (this.scrollHeight != scrollHeight) {
            this.refresh();
          }
          if (scrollTop >= maxScroll) {
            return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
          }
          if (activeTarget && scrollTop < offsets[0]) {
            this.activeTarget = null;
            return this.clear();
          }
          for (i = offsets.length; i--; ) {
            activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === void 0 || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
          }
        };
        ScrollSpy.prototype.activate = function(target) {
          this.activeTarget = target;
          this.clear();
          var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
          var active = $2(selector).parents("li").addClass("active");
          if (active.parent(".dropdown-menu").length) {
            active = active.closest("li.dropdown").addClass("active");
          }
          active.trigger("activate.bs.scrollspy");
        };
        ScrollSpy.prototype.clear = function() {
          $2(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.scrollspy");
            var options = typeof option == "object" && option;
            if (!data)
              $this.data("bs.scrollspy", data = new ScrollSpy(this, options));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.scrollspy;
        $2.fn.scrollspy = Plugin;
        $2.fn.scrollspy.Constructor = ScrollSpy;
        $2.fn.scrollspy.noConflict = function() {
          $2.fn.scrollspy = old;
          return this;
        };
        $2(window).on("load.bs.scrollspy.data-api", function() {
          $2('[data-spy="scroll"]').each(function() {
            var $spy = $2(this);
            Plugin.call($spy, $spy.data());
          });
        });
      }(jQuery);
      +function($2) {
        "use strict";
        var Tab = function(element) {
          this.element = $2(element);
        };
        Tab.VERSION = "3.4.1";
        Tab.TRANSITION_DURATION = 150;
        Tab.prototype.show = function() {
          var $this = this.element;
          var $ul = $this.closest("ul:not(.dropdown-menu)");
          var selector = $this.data("target");
          if (!selector) {
            selector = $this.attr("href");
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, "");
          }
          if ($this.parent("li").hasClass("active"))
            return;
          var $previous = $ul.find(".active:last a");
          var hideEvent = $2.Event("hide.bs.tab", {
            relatedTarget: $this[0]
          });
          var showEvent = $2.Event("show.bs.tab", {
            relatedTarget: $previous[0]
          });
          $previous.trigger(hideEvent);
          $this.trigger(showEvent);
          if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented())
            return;
          var $target = $2(document).find(selector);
          this.activate($this.closest("li"), $ul);
          this.activate($target, $target.parent(), function() {
            $previous.trigger({
              type: "hidden.bs.tab",
              relatedTarget: $this[0]
            });
            $this.trigger({
              type: "shown.bs.tab",
              relatedTarget: $previous[0]
            });
          });
        };
        Tab.prototype.activate = function(element, container, callback) {
          var $active = container.find("> .active");
          var transition = callback && $2.support.transition && ($active.length && $active.hasClass("fade") || !!container.find("> .fade").length);
          function next() {
            $active.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", false);
            element.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", true);
            if (transition) {
              element[0].offsetWidth;
              element.addClass("in");
            } else {
              element.removeClass("fade");
            }
            if (element.parent(".dropdown-menu").length) {
              element.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", true);
            }
            callback && callback();
          }
          $active.length && transition ? $active.one("bsTransitionEnd", next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
          $active.removeClass("in");
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.tab");
            if (!data)
              $this.data("bs.tab", data = new Tab(this));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.tab;
        $2.fn.tab = Plugin;
        $2.fn.tab.Constructor = Tab;
        $2.fn.tab.noConflict = function() {
          $2.fn.tab = old;
          return this;
        };
        var clickHandler = function(e) {
          e.preventDefault();
          Plugin.call($2(this), "show");
        };
        $2(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', clickHandler).on("click.bs.tab.data-api", '[data-toggle="pill"]', clickHandler);
      }(jQuery);
      +function($2) {
        "use strict";
        var Affix = function(element, options) {
          this.options = $2.extend({}, Affix.DEFAULTS, options);
          var target = this.options.target === Affix.DEFAULTS.target ? $2(this.options.target) : $2(document).find(this.options.target);
          this.$target = target.on("scroll.bs.affix.data-api", $2.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", $2.proxy(this.checkPositionWithEventLoop, this));
          this.$element = $2(element);
          this.affixed = null;
          this.unpin = null;
          this.pinnedOffset = null;
          this.checkPosition();
        };
        Affix.VERSION = "3.4.1";
        Affix.RESET = "affix affix-top affix-bottom";
        Affix.DEFAULTS = {
          offset: 0,
          target: window
        };
        Affix.prototype.getState = function(scrollHeight, height, offsetTop, offsetBottom) {
          var scrollTop = this.$target.scrollTop();
          var position = this.$element.offset();
          var targetHeight = this.$target.height();
          if (offsetTop != null && this.affixed == "top")
            return scrollTop < offsetTop ? "top" : false;
          if (this.affixed == "bottom") {
            if (offsetTop != null)
              return scrollTop + this.unpin <= position.top ? false : "bottom";
            return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : "bottom";
          }
          var initializing = this.affixed == null;
          var colliderTop = initializing ? scrollTop : position.top;
          var colliderHeight = initializing ? targetHeight : height;
          if (offsetTop != null && scrollTop <= offsetTop)
            return "top";
          if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom)
            return "bottom";
          return false;
        };
        Affix.prototype.getPinnedOffset = function() {
          if (this.pinnedOffset)
            return this.pinnedOffset;
          this.$element.removeClass(Affix.RESET).addClass("affix");
          var scrollTop = this.$target.scrollTop();
          var position = this.$element.offset();
          return this.pinnedOffset = position.top - scrollTop;
        };
        Affix.prototype.checkPositionWithEventLoop = function() {
          setTimeout($2.proxy(this.checkPosition, this), 1);
        };
        Affix.prototype.checkPosition = function() {
          if (!this.$element.is(":visible"))
            return;
          var height = this.$element.height();
          var offset = this.options.offset;
          var offsetTop = offset.top;
          var offsetBottom = offset.bottom;
          var scrollHeight = Math.max($2(document).height(), $2(document.body).height());
          if (typeof offset != "object")
            offsetBottom = offsetTop = offset;
          if (typeof offsetTop == "function")
            offsetTop = offset.top(this.$element);
          if (typeof offsetBottom == "function")
            offsetBottom = offset.bottom(this.$element);
          var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
          if (this.affixed != affix) {
            if (this.unpin != null)
              this.$element.css("top", "");
            var affixType = "affix" + (affix ? "-" + affix : "");
            var e = $2.Event(affixType + ".bs.affix");
            this.$element.trigger(e);
            if (e.isDefaultPrevented())
              return;
            this.affixed = affix;
            this.unpin = affix == "bottom" ? this.getPinnedOffset() : null;
            this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace("affix", "affixed") + ".bs.affix");
          }
          if (affix == "bottom") {
            this.$element.offset({
              top: scrollHeight - height - offsetBottom
            });
          }
        };
        function Plugin(option) {
          return this.each(function() {
            var $this = $2(this);
            var data = $this.data("bs.affix");
            var options = typeof option == "object" && option;
            if (!data)
              $this.data("bs.affix", data = new Affix(this, options));
            if (typeof option == "string")
              data[option]();
          });
        }
        var old = $2.fn.affix;
        $2.fn.affix = Plugin;
        $2.fn.affix.Constructor = Affix;
        $2.fn.affix.noConflict = function() {
          $2.fn.affix = old;
          return this;
        };
        $2(window).on("load", function() {
          $2('[data-spy="affix"]').each(function() {
            var $spy = $2(this);
            var data = $spy.data();
            data.offset = data.offset || {};
            if (data.offsetBottom != null)
              data.offset.bottom = data.offsetBottom;
            if (data.offsetTop != null)
              data.offset.top = data.offsetTop;
            Plugin.call($spy, data);
          });
        });
      }(jQuery);
    }
  });

  // node_modules/parsleyjs/dist/parsley.js
  var require_parsley = __commonJS({
    "node_modules/parsleyjs/dist/parsley.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory(require_jquery()) : typeof define === "function" && define.amd ? define(["jquery"], factory) : (global2 = global2 || self, global2.parsley = factory(global2.jQuery));
      })(exports, function($2) {
        "use strict";
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function(obj2) {
              return typeof obj2;
            };
          } else {
            _typeof = function(obj2) {
              return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
          }
          return _typeof(obj);
        }
        function _extends() {
          _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };
          return _extends.apply(this, arguments);
        }
        function _slicedToArray(arr, i) {
          return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
        }
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
              arr2[i] = arr[i];
            return arr2;
          }
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr))
            return arr;
        }
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
            return Array.from(iter);
        }
        function _iterableToArrayLimit(arr, i) {
          if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
            return;
          }
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = void 0;
          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);
              if (i && _arr.length === i)
                break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null)
                _i["return"]();
            } finally {
              if (_d)
                throw _e;
            }
          }
          return _arr;
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        var globalID = 1;
        var pastWarnings = {};
        var Utils = {
          // Parsley DOM-API
          // returns object from dom attributes and values
          attr: function attr(element, namespace, obj) {
            var i;
            var attribute;
            var attributes;
            var regex = new RegExp("^" + namespace, "i");
            if ("undefined" === typeof obj)
              obj = {};
            else {
              for (i in obj) {
                if (obj.hasOwnProperty(i))
                  delete obj[i];
              }
            }
            if (!element)
              return obj;
            attributes = element.attributes;
            for (i = attributes.length; i--; ) {
              attribute = attributes[i];
              if (attribute && attribute.specified && regex.test(attribute.name)) {
                obj[this.camelize(attribute.name.slice(namespace.length))] = this.deserializeValue(attribute.value);
              }
            }
            return obj;
          },
          checkAttr: function checkAttr(element, namespace, _checkAttr) {
            return element.hasAttribute(namespace + _checkAttr);
          },
          setAttr: function setAttr(element, namespace, attr, value) {
            element.setAttribute(this.dasherize(namespace + attr), String(value));
          },
          getType: function getType(element) {
            return element.getAttribute("type") || "text";
          },
          generateID: function generateID() {
            return "" + globalID++;
          },
          /** Third party functions **/
          deserializeValue: function deserializeValue(value) {
            var num;
            try {
              return value ? value == "true" || (value == "false" ? false : value == "null" ? null : !isNaN(num = Number(value)) ? num : /^[\[\{]/.test(value) ? JSON.parse(value) : value) : value;
            } catch (e) {
              return value;
            }
          },
          // Zepto camelize function
          camelize: function camelize(str) {
            return str.replace(/-+(.)?/g, function(match, chr) {
              return chr ? chr.toUpperCase() : "";
            });
          },
          // Zepto dasherize function
          dasherize: function dasherize(str) {
            return str.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase();
          },
          warn: function warn() {
            var _window$console;
            if (window.console && "function" === typeof window.console.warn)
              (_window$console = window.console).warn.apply(_window$console, arguments);
          },
          warnOnce: function warnOnce(msg) {
            if (!pastWarnings[msg]) {
              pastWarnings[msg] = true;
              this.warn.apply(this, arguments);
            }
          },
          _resetWarnings: function _resetWarnings() {
            pastWarnings = {};
          },
          trimString: function trimString(string) {
            return string.replace(/^\s+|\s+$/g, "");
          },
          parse: {
            date: function date(string) {
              var parsed = string.match(/^(\d{4,})-(\d\d)-(\d\d)$/);
              if (!parsed)
                return null;
              var _parsed$map = parsed.map(function(x) {
                return parseInt(x, 10);
              }), _parsed$map2 = _slicedToArray(_parsed$map, 4), _ = _parsed$map2[0], year = _parsed$map2[1], month = _parsed$map2[2], day = _parsed$map2[3];
              var date2 = new Date(year, month - 1, day);
              if (date2.getFullYear() !== year || date2.getMonth() + 1 !== month || date2.getDate() !== day)
                return null;
              return date2;
            },
            string: function string(_string) {
              return _string;
            },
            integer: function integer(string) {
              if (isNaN(string))
                return null;
              return parseInt(string, 10);
            },
            number: function number(string) {
              if (isNaN(string))
                throw null;
              return parseFloat(string);
            },
            "boolean": function _boolean(string) {
              return !/^\s*false\s*$/i.test(string);
            },
            object: function object(string) {
              return Utils.deserializeValue(string);
            },
            regexp: function regexp(_regexp) {
              var flags = "";
              if (/^\/.*\/(?:[gimy]*)$/.test(_regexp)) {
                flags = _regexp.replace(/.*\/([gimy]*)$/, "$1");
                _regexp = _regexp.replace(new RegExp("^/(.*?)/" + flags + "$"), "$1");
              } else {
                _regexp = "^" + _regexp + "$";
              }
              return new RegExp(_regexp, flags);
            }
          },
          parseRequirement: function parseRequirement(requirementType, string) {
            var converter = this.parse[requirementType || "string"];
            if (!converter)
              throw 'Unknown requirement specification: "' + requirementType + '"';
            var converted = converter(string);
            if (converted === null)
              throw "Requirement is not a ".concat(requirementType, ': "').concat(string, '"');
            return converted;
          },
          namespaceEvents: function namespaceEvents(events, namespace) {
            events = this.trimString(events || "").split(/\s+/);
            if (!events[0])
              return "";
            return $2.map(events, function(evt) {
              return "".concat(evt, ".").concat(namespace);
            }).join(" ");
          },
          difference: function difference(array, remove) {
            var result = [];
            $2.each(array, function(_, elem) {
              if (remove.indexOf(elem) == -1)
                result.push(elem);
            });
            return result;
          },
          // Alter-ego to native Promise.all, but for jQuery
          all: function all(promises) {
            return $2.when.apply($2, _toConsumableArray(promises).concat([42, 42]));
          },
          // Object.create polyfill, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create#Polyfill
          objectCreate: Object.create || function() {
            var Object2 = function Object3() {
            };
            return function(prototype) {
              if (arguments.length > 1) {
                throw Error("Second argument not supported");
              }
              if (_typeof(prototype) != "object") {
                throw TypeError("Argument must be an object");
              }
              Object2.prototype = prototype;
              var result = new Object2();
              Object2.prototype = null;
              return result;
            };
          }(),
          _SubmitSelector: 'input[type="submit"], button:submit'
        };
        var Defaults = {
          // ### General
          // Default data-namespace for DOM API
          namespace: "data-parsley-",
          // Supported inputs by default
          inputs: "input, textarea, select",
          // Excluded inputs by default
          excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden]",
          // Stop validating field on highest priority failing constraint
          priorityEnabled: true,
          // ### Field only
          // identifier used to group together inputs (e.g. radio buttons...)
          multiple: null,
          // identifier (or array of identifiers) used to validate only a select group of inputs
          group: null,
          // ### UI
          // Enable\Disable error messages
          uiEnabled: true,
          // Key events threshold before validation
          validationThreshold: 3,
          // Focused field on form validation error. 'first'|'last'|'none'
          focus: "first",
          // event(s) that will trigger validation before first failure. eg: `input`...
          trigger: false,
          // event(s) that will trigger validation after first failure.
          triggerAfterFailure: "input",
          // Class that would be added on every failing validation Parsley field
          errorClass: "parsley-error",
          // Same for success validation
          successClass: "parsley-success",
          // Return the `$element` that will receive these above success or error classes
          // Could also be (and given directly from DOM) a valid selector like `'#div'`
          classHandler: function classHandler(Field2) {
          },
          // Return the `$element` where errors will be appended
          // Could also be (and given directly from DOM) a valid selector like `'#div'`
          errorsContainer: function errorsContainer(Field2) {
          },
          // ul elem that would receive errors' list
          errorsWrapper: '<ul class="parsley-errors-list"></ul>',
          // li elem that would receive error message
          errorTemplate: "<li></li>"
        };
        var Base = function Base2() {
          this.__id__ = Utils.generateID();
        };
        Base.prototype = {
          asyncSupport: true,
          // Deprecated
          _pipeAccordingToValidationResult: function _pipeAccordingToValidationResult() {
            var _this = this;
            var pipe = function pipe2() {
              var r = $2.Deferred();
              if (true !== _this.validationResult)
                r.reject();
              return r.resolve().promise();
            };
            return [pipe, pipe];
          },
          actualizeOptions: function actualizeOptions() {
            Utils.attr(this.element, this.options.namespace, this.domOptions);
            if (this.parent && this.parent.actualizeOptions)
              this.parent.actualizeOptions();
            return this;
          },
          _resetOptions: function _resetOptions(initOptions) {
            this.domOptions = Utils.objectCreate(this.parent.options);
            this.options = Utils.objectCreate(this.domOptions);
            for (var i in initOptions) {
              if (initOptions.hasOwnProperty(i))
                this.options[i] = initOptions[i];
            }
            this.actualizeOptions();
          },
          _listeners: null,
          // Register a callback for the given event name
          // Callback is called with context as the first argument and the `this`
          // The context is the current parsley instance, or window.Parsley if global
          // A return value of `false` will interrupt the calls
          on: function on(name, fn) {
            this._listeners = this._listeners || {};
            var queue = this._listeners[name] = this._listeners[name] || [];
            queue.push(fn);
            return this;
          },
          // Deprecated. Use `on` instead
          subscribe: function subscribe(name, fn) {
            $2.listenTo(this, name.toLowerCase(), fn);
          },
          // Unregister a callback (or all if none is given) for the given event name
          off: function off(name, fn) {
            var queue = this._listeners && this._listeners[name];
            if (queue) {
              if (!fn) {
                delete this._listeners[name];
              } else {
                for (var i = queue.length; i--; ) {
                  if (queue[i] === fn)
                    queue.splice(i, 1);
                }
              }
            }
            return this;
          },
          // Deprecated. Use `off`
          unsubscribe: function unsubscribe(name, fn) {
            $2.unsubscribeTo(this, name.toLowerCase());
          },
          // Trigger an event of the given name
          // A return value of `false` interrupts the callback chain
          // Returns false if execution was interrupted
          trigger: function trigger(name, target, extraArg) {
            target = target || this;
            var queue = this._listeners && this._listeners[name];
            var result;
            if (queue) {
              for (var i = queue.length; i--; ) {
                result = queue[i].call(target, target, extraArg);
                if (result === false)
                  return result;
              }
            }
            if (this.parent) {
              return this.parent.trigger(name, target, extraArg);
            }
            return true;
          },
          asyncIsValid: function asyncIsValid(group, force) {
            Utils.warnOnce("asyncIsValid is deprecated; please use whenValid instead");
            return this.whenValid({
              group,
              force
            });
          },
          _findRelated: function _findRelated() {
            return this.options.multiple ? $2(this.parent.element.querySelectorAll("[".concat(this.options.namespace, 'multiple="').concat(this.options.multiple, '"]'))) : this.$element;
          }
        };
        var convertArrayRequirement = function convertArrayRequirement2(string, length) {
          var m = string.match(/^\s*\[(.*)\]\s*$/);
          if (!m)
            throw 'Requirement is not an array: "' + string + '"';
          var values = m[1].split(",").map(Utils.trimString);
          if (values.length !== length)
            throw "Requirement has " + values.length + " values when " + length + " are needed";
          return values;
        };
        var convertExtraOptionRequirement = function convertExtraOptionRequirement2(requirementSpec, string, extraOptionReader) {
          var main = null;
          var extra = {};
          for (var key in requirementSpec) {
            if (key) {
              var value = extraOptionReader(key);
              if ("string" === typeof value)
                value = Utils.parseRequirement(requirementSpec[key], value);
              extra[key] = value;
            } else {
              main = Utils.parseRequirement(requirementSpec[key], string);
            }
          }
          return [main, extra];
        };
        var Validator = function Validator2(spec) {
          $2.extend(true, this, spec);
        };
        Validator.prototype = {
          // Returns `true` iff the given `value` is valid according the given requirements.
          validate: function validate(value, requirementFirstArg) {
            if (this.fn) {
              if (arguments.length > 3)
                requirementFirstArg = [].slice.call(arguments, 1, -1);
              return this.fn(value, requirementFirstArg);
            }
            if (Array.isArray(value)) {
              if (!this.validateMultiple)
                throw "Validator `" + this.name + "` does not handle multiple values";
              return this.validateMultiple.apply(this, arguments);
            } else {
              var instance = arguments[arguments.length - 1];
              if (this.validateDate && instance._isDateInput()) {
                arguments[0] = Utils.parse.date(arguments[0]);
                if (arguments[0] === null)
                  return false;
                return this.validateDate.apply(this, arguments);
              }
              if (this.validateNumber) {
                if (!value)
                  return true;
                if (isNaN(value))
                  return false;
                arguments[0] = parseFloat(arguments[0]);
                return this.validateNumber.apply(this, arguments);
              }
              if (this.validateString) {
                return this.validateString.apply(this, arguments);
              }
              throw "Validator `" + this.name + "` only handles multiple values";
            }
          },
          // Parses `requirements` into an array of arguments,
          // according to `this.requirementType`
          parseRequirements: function parseRequirements(requirements, extraOptionReader) {
            if ("string" !== typeof requirements) {
              return Array.isArray(requirements) ? requirements : [requirements];
            }
            var type = this.requirementType;
            if (Array.isArray(type)) {
              var values = convertArrayRequirement(requirements, type.length);
              for (var i = 0; i < values.length; i++) {
                values[i] = Utils.parseRequirement(type[i], values[i]);
              }
              return values;
            } else if ($2.isPlainObject(type)) {
              return convertExtraOptionRequirement(type, requirements, extraOptionReader);
            } else {
              return [Utils.parseRequirement(type, requirements)];
            }
          },
          // Defaults:
          requirementType: "string",
          priority: 2
        };
        var ValidatorRegistry = function ValidatorRegistry2(validators, catalog) {
          this.__class__ = "ValidatorRegistry";
          this.locale = "en";
          this.init(validators || {}, catalog || {});
        };
        var typeTesters = {
          email: /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))$/,
          // Follow https://www.w3.org/TR/html5/infrastructure.html#floating-point-numbers
          number: /^-?(\d*\.)?\d+(e[-+]?\d+)?$/i,
          integer: /^-?\d+$/,
          digits: /^\d+$/,
          alphanum: /^\w+$/i,
          date: {
            test: function test(value) {
              return Utils.parse.date(value) !== null;
            }
          },
          url: new RegExp("^(?:(?:https?|ftp)://)?(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-zA-Z\\u00a1-\\uffff]{2,})))(?::\\d{2,5})?(?:/\\S*)?$")
        };
        typeTesters.range = typeTesters.number;
        var decimalPlaces = function decimalPlaces2(num) {
          var match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
          if (!match) {
            return 0;
          }
          return Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
            (match[2] ? +match[2] : 0)
          );
        };
        var parseArguments = function parseArguments2(type, args) {
          return args.map(Utils.parse[type]);
        };
        var operatorToValidator = function operatorToValidator2(type, operator) {
          return function(value) {
            for (var _len = arguments.length, requirementsAndInput = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              requirementsAndInput[_key - 1] = arguments[_key];
            }
            requirementsAndInput.pop();
            return operator.apply(void 0, [value].concat(_toConsumableArray(parseArguments(type, requirementsAndInput))));
          };
        };
        var comparisonOperator = function comparisonOperator2(operator) {
          return {
            validateDate: operatorToValidator("date", operator),
            validateNumber: operatorToValidator("number", operator),
            requirementType: operator.length <= 2 ? "string" : ["string", "string"],
            // Support operators with a 1 or 2 requirement(s)
            priority: 30
          };
        };
        ValidatorRegistry.prototype = {
          init: function init(validators, catalog) {
            this.catalog = catalog;
            this.validators = _extends({}, this.validators);
            for (var name in validators) {
              this.addValidator(name, validators[name].fn, validators[name].priority);
            }
            window.Parsley.trigger("parsley:validator:init");
          },
          // Set new messages locale if we have dictionary loaded in ParsleyConfig.i18n
          setLocale: function setLocale(locale) {
            if ("undefined" === typeof this.catalog[locale])
              throw new Error(locale + " is not available in the catalog");
            this.locale = locale;
            return this;
          },
          // Add a new messages catalog for a given locale. Set locale for this catalog if set === `true`
          addCatalog: function addCatalog(locale, messages, set) {
            if ("object" === _typeof(messages))
              this.catalog[locale] = messages;
            if (true === set)
              return this.setLocale(locale);
            return this;
          },
          // Add a specific message for a given constraint in a given locale
          addMessage: function addMessage(locale, name, message) {
            if ("undefined" === typeof this.catalog[locale])
              this.catalog[locale] = {};
            this.catalog[locale][name] = message;
            return this;
          },
          // Add messages for a given locale
          addMessages: function addMessages(locale, nameMessageObject) {
            for (var name in nameMessageObject) {
              this.addMessage(locale, name, nameMessageObject[name]);
            }
            return this;
          },
          // Add a new validator
          //
          //    addValidator('custom', {
          //        requirementType: ['integer', 'integer'],
          //        validateString: function(value, from, to) {},
          //        priority: 22,
          //        messages: {
          //          en: "Hey, that's no good",
          //          fr: "Aye aye, pas bon du tout",
          //        }
          //    })
          //
          // Old API was addValidator(name, function, priority)
          //
          addValidator: function addValidator(name, arg1, arg2) {
            if (this.validators[name])
              Utils.warn('Validator "' + name + '" is already defined.');
            else if (Defaults.hasOwnProperty(name)) {
              Utils.warn('"' + name + '" is a restricted keyword and is not a valid validator name.');
              return;
            }
            return this._setValidator.apply(this, arguments);
          },
          hasValidator: function hasValidator(name) {
            return !!this.validators[name];
          },
          updateValidator: function updateValidator(name, arg1, arg2) {
            if (!this.validators[name]) {
              Utils.warn('Validator "' + name + '" is not already defined.');
              return this.addValidator.apply(this, arguments);
            }
            return this._setValidator.apply(this, arguments);
          },
          removeValidator: function removeValidator(name) {
            if (!this.validators[name])
              Utils.warn('Validator "' + name + '" is not defined.');
            delete this.validators[name];
            return this;
          },
          _setValidator: function _setValidator(name, validator, priority) {
            if ("object" !== _typeof(validator)) {
              validator = {
                fn: validator,
                priority
              };
            }
            if (!validator.validate) {
              validator = new Validator(validator);
            }
            this.validators[name] = validator;
            for (var locale in validator.messages || {}) {
              this.addMessage(locale, name, validator.messages[locale]);
            }
            return this;
          },
          getErrorMessage: function getErrorMessage(constraint) {
            var message;
            if ("type" === constraint.name) {
              var typeMessages = this.catalog[this.locale][constraint.name] || {};
              message = typeMessages[constraint.requirements];
            } else
              message = this.formatMessage(this.catalog[this.locale][constraint.name], constraint.requirements);
            return message || this.catalog[this.locale].defaultMessage || this.catalog.en.defaultMessage;
          },
          // Kind of light `sprintf()` implementation
          formatMessage: function formatMessage(string, parameters) {
            if ("object" === _typeof(parameters)) {
              for (var i in parameters) {
                string = this.formatMessage(string, parameters[i]);
              }
              return string;
            }
            return "string" === typeof string ? string.replace(/%s/i, parameters) : "";
          },
          // Here is the Parsley default validators list.
          // A validator is an object with the following key values:
          //  - priority: an integer
          //  - requirement: 'string' (default), 'integer', 'number', 'regexp' or an Array of these
          //  - validateString, validateMultiple, validateNumber: functions returning `true`, `false` or a promise
          // Alternatively, a validator can be a function that returns such an object
          //
          validators: {
            notblank: {
              validateString: function validateString(value) {
                return /\S/.test(value);
              },
              priority: 2
            },
            required: {
              validateMultiple: function validateMultiple(values) {
                return values.length > 0;
              },
              validateString: function validateString(value) {
                return /\S/.test(value);
              },
              priority: 512
            },
            type: {
              validateString: function validateString(value, type) {
                var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref$step = _ref.step, step = _ref$step === void 0 ? "any" : _ref$step, _ref$base = _ref.base, base = _ref$base === void 0 ? 0 : _ref$base;
                var tester = typeTesters[type];
                if (!tester) {
                  throw new Error("validator type `" + type + "` is not supported");
                }
                if (!value)
                  return true;
                if (!tester.test(value))
                  return false;
                if ("number" === type) {
                  if (!/^any$/i.test(step || "")) {
                    var nb = Number(value);
                    var decimals = Math.max(decimalPlaces(step), decimalPlaces(base));
                    if (decimalPlaces(nb) > decimals)
                      return false;
                    var toInt = function toInt2(f) {
                      return Math.round(f * Math.pow(10, decimals));
                    };
                    if ((toInt(nb) - toInt(base)) % toInt(step) != 0)
                      return false;
                  }
                }
                return true;
              },
              requirementType: {
                "": "string",
                step: "string",
                base: "number"
              },
              priority: 256
            },
            pattern: {
              validateString: function validateString(value, regexp) {
                if (!value)
                  return true;
                return regexp.test(value);
              },
              requirementType: "regexp",
              priority: 64
            },
            minlength: {
              validateString: function validateString(value, requirement) {
                if (!value)
                  return true;
                return value.length >= requirement;
              },
              requirementType: "integer",
              priority: 30
            },
            maxlength: {
              validateString: function validateString(value, requirement) {
                return value.length <= requirement;
              },
              requirementType: "integer",
              priority: 30
            },
            length: {
              validateString: function validateString(value, min, max) {
                if (!value)
                  return true;
                return value.length >= min && value.length <= max;
              },
              requirementType: ["integer", "integer"],
              priority: 30
            },
            mincheck: {
              validateMultiple: function validateMultiple(values, requirement) {
                return values.length >= requirement;
              },
              requirementType: "integer",
              priority: 30
            },
            maxcheck: {
              validateMultiple: function validateMultiple(values, requirement) {
                return values.length <= requirement;
              },
              requirementType: "integer",
              priority: 30
            },
            check: {
              validateMultiple: function validateMultiple(values, min, max) {
                return values.length >= min && values.length <= max;
              },
              requirementType: ["integer", "integer"],
              priority: 30
            },
            min: comparisonOperator(function(value, requirement) {
              return value >= requirement;
            }),
            max: comparisonOperator(function(value, requirement) {
              return value <= requirement;
            }),
            range: comparisonOperator(function(value, min, max) {
              return value >= min && value <= max;
            }),
            equalto: {
              validateString: function validateString(value, refOrValue) {
                if (!value)
                  return true;
                var $reference = $2(refOrValue);
                if ($reference.length)
                  return value === $reference.val();
                else
                  return value === refOrValue;
              },
              priority: 256
            },
            euvatin: {
              validateString: function validateString(value, refOrValue) {
                if (!value) {
                  return true;
                }
                var re = /^[A-Z][A-Z][A-Za-z0-9 -]{2,}$/;
                return re.test(value);
              },
              priority: 30
            }
          }
        };
        var UI = {};
        var diffResults = function diffResults2(newResult, oldResult, deep) {
          var added = [];
          var kept = [];
          for (var i = 0; i < newResult.length; i++) {
            var found = false;
            for (var j = 0; j < oldResult.length; j++) {
              if (newResult[i].assert.name === oldResult[j].assert.name) {
                found = true;
                break;
              }
            }
            if (found)
              kept.push(newResult[i]);
            else
              added.push(newResult[i]);
          }
          return {
            kept,
            added,
            removed: !deep ? diffResults2(oldResult, newResult, true).added : []
          };
        };
        UI.Form = {
          _actualizeTriggers: function _actualizeTriggers() {
            var _this = this;
            this.$element.on("submit.Parsley", function(evt) {
              _this.onSubmitValidate(evt);
            });
            this.$element.on("click.Parsley", Utils._SubmitSelector, function(evt) {
              _this.onSubmitButton(evt);
            });
            if (false === this.options.uiEnabled)
              return;
            this.element.setAttribute("novalidate", "");
          },
          focus: function focus() {
            this._focusedField = null;
            if (true === this.validationResult || "none" === this.options.focus)
              return null;
            for (var i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];
              if (true !== field.validationResult && field.validationResult.length > 0 && "undefined" === typeof field.options.noFocus) {
                this._focusedField = field.$element;
                if ("first" === this.options.focus)
                  break;
              }
            }
            if (null === this._focusedField)
              return null;
            return this._focusedField.focus();
          },
          _destroyUI: function _destroyUI() {
            this.$element.off(".Parsley");
          }
        };
        UI.Field = {
          _reflowUI: function _reflowUI() {
            this._buildUI();
            if (!this._ui)
              return;
            var diff = diffResults(this.validationResult, this._ui.lastValidationResult);
            this._ui.lastValidationResult = this.validationResult;
            this._manageStatusClass();
            this._manageErrorsMessages(diff);
            this._actualizeTriggers();
            if ((diff.kept.length || diff.added.length) && !this._failedOnce) {
              this._failedOnce = true;
              this._actualizeTriggers();
            }
          },
          // Returns an array of field's error message(s)
          getErrorsMessages: function getErrorsMessages() {
            if (true === this.validationResult)
              return [];
            var messages = [];
            for (var i = 0; i < this.validationResult.length; i++) {
              messages.push(this.validationResult[i].errorMessage || this._getErrorMessage(this.validationResult[i].assert));
            }
            return messages;
          },
          // It's a goal of Parsley that this method is no longer required [#1073]
          addError: function addError(name) {
            var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, message = _ref.message, assert = _ref.assert, _ref$updateClass = _ref.updateClass, updateClass = _ref$updateClass === void 0 ? true : _ref$updateClass;
            this._buildUI();
            this._addError(name, {
              message,
              assert
            });
            if (updateClass)
              this._errorClass();
          },
          // It's a goal of Parsley that this method is no longer required [#1073]
          updateError: function updateError(name) {
            var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, message = _ref2.message, assert = _ref2.assert, _ref2$updateClass = _ref2.updateClass, updateClass = _ref2$updateClass === void 0 ? true : _ref2$updateClass;
            this._buildUI();
            this._updateError(name, {
              message,
              assert
            });
            if (updateClass)
              this._errorClass();
          },
          // It's a goal of Parsley that this method is no longer required [#1073]
          removeError: function removeError(name) {
            var _ref3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref3$updateClass = _ref3.updateClass, updateClass = _ref3$updateClass === void 0 ? true : _ref3$updateClass;
            this._buildUI();
            this._removeError(name);
            if (updateClass)
              this._manageStatusClass();
          },
          _manageStatusClass: function _manageStatusClass() {
            if (this.hasConstraints() && this.needsValidation() && true === this.validationResult)
              this._successClass();
            else if (this.validationResult.length > 0)
              this._errorClass();
            else
              this._resetClass();
          },
          _manageErrorsMessages: function _manageErrorsMessages(diff) {
            if ("undefined" !== typeof this.options.errorsMessagesDisabled)
              return;
            if ("undefined" !== typeof this.options.errorMessage) {
              if (diff.added.length || diff.kept.length) {
                this._insertErrorWrapper();
                if (0 === this._ui.$errorsWrapper.find(".parsley-custom-error-message").length)
                  this._ui.$errorsWrapper.append($2(this.options.errorTemplate).addClass("parsley-custom-error-message"));
                this._ui.$errorClassHandler.attr("aria-describedby", this._ui.errorsWrapperId);
                return this._ui.$errorsWrapper.addClass("filled").attr("aria-hidden", "false").find(".parsley-custom-error-message").html(this.options.errorMessage);
              }
              this._ui.$errorClassHandler.removeAttr("aria-describedby");
              return this._ui.$errorsWrapper.removeClass("filled").attr("aria-hidden", "true").find(".parsley-custom-error-message").remove();
            }
            for (var i = 0; i < diff.removed.length; i++) {
              this._removeError(diff.removed[i].assert.name);
            }
            for (i = 0; i < diff.added.length; i++) {
              this._addError(diff.added[i].assert.name, {
                message: diff.added[i].errorMessage,
                assert: diff.added[i].assert
              });
            }
            for (i = 0; i < diff.kept.length; i++) {
              this._updateError(diff.kept[i].assert.name, {
                message: diff.kept[i].errorMessage,
                assert: diff.kept[i].assert
              });
            }
          },
          _addError: function _addError(name, _ref4) {
            var message = _ref4.message, assert = _ref4.assert;
            this._insertErrorWrapper();
            this._ui.$errorClassHandler.attr("aria-describedby", this._ui.errorsWrapperId);
            this._ui.$errorsWrapper.addClass("filled").attr("aria-hidden", "false").append($2(this.options.errorTemplate).addClass("parsley-" + name).html(message || this._getErrorMessage(assert)));
          },
          _updateError: function _updateError(name, _ref5) {
            var message = _ref5.message, assert = _ref5.assert;
            this._ui.$errorsWrapper.addClass("filled").find(".parsley-" + name).html(message || this._getErrorMessage(assert));
          },
          _removeError: function _removeError(name) {
            this._ui.$errorClassHandler.removeAttr("aria-describedby");
            this._ui.$errorsWrapper.removeClass("filled").attr("aria-hidden", "true").find(".parsley-" + name).remove();
          },
          _getErrorMessage: function _getErrorMessage(constraint) {
            var customConstraintErrorMessage = constraint.name + "Message";
            if ("undefined" !== typeof this.options[customConstraintErrorMessage])
              return window.Parsley.formatMessage(this.options[customConstraintErrorMessage], constraint.requirements);
            return window.Parsley.getErrorMessage(constraint);
          },
          _buildUI: function _buildUI() {
            if (this._ui || false === this.options.uiEnabled)
              return;
            var _ui = {};
            this.element.setAttribute(this.options.namespace + "id", this.__id__);
            _ui.$errorClassHandler = this._manageClassHandler();
            _ui.errorsWrapperId = "parsley-id-" + (this.options.multiple ? "multiple-" + this.options.multiple : this.__id__);
            _ui.$errorsWrapper = $2(this.options.errorsWrapper).attr("id", _ui.errorsWrapperId);
            _ui.lastValidationResult = [];
            _ui.validationInformationVisible = false;
            this._ui = _ui;
          },
          // Determine which element will have `parsley-error` and `parsley-success` classes
          _manageClassHandler: function _manageClassHandler() {
            if ("string" === typeof this.options.classHandler && $2(this.options.classHandler).length)
              return $2(this.options.classHandler);
            var $handlerFunction = this.options.classHandler;
            if ("string" === typeof this.options.classHandler && "function" === typeof window[this.options.classHandler])
              $handlerFunction = window[this.options.classHandler];
            if ("function" === typeof $handlerFunction) {
              var $handler = $handlerFunction.call(this, this);
              if ("undefined" !== typeof $handler && $handler.length)
                return $handler;
            } else if ("object" === _typeof($handlerFunction) && $handlerFunction instanceof jQuery && $handlerFunction.length) {
              return $handlerFunction;
            } else if ($handlerFunction) {
              Utils.warn("The class handler `" + $handlerFunction + "` does not exist in DOM nor as a global JS function");
            }
            return this._inputHolder();
          },
          _inputHolder: function _inputHolder() {
            if (!this.options.multiple || this.element.nodeName === "SELECT")
              return this.$element;
            return this.$element.parent();
          },
          _insertErrorWrapper: function _insertErrorWrapper() {
            var $errorsContainer = this.options.errorsContainer;
            if (0 !== this._ui.$errorsWrapper.parent().length)
              return this._ui.$errorsWrapper.parent();
            if ("string" === typeof $errorsContainer) {
              if ($2($errorsContainer).length)
                return $2($errorsContainer).append(this._ui.$errorsWrapper);
              else if ("function" === typeof window[$errorsContainer])
                $errorsContainer = window[$errorsContainer];
              else
                Utils.warn("The errors container `" + $errorsContainer + "` does not exist in DOM nor as a global JS function");
            }
            if ("function" === typeof $errorsContainer)
              $errorsContainer = $errorsContainer.call(this, this);
            if ("object" === _typeof($errorsContainer) && $errorsContainer.length)
              return $errorsContainer.append(this._ui.$errorsWrapper);
            return this._inputHolder().after(this._ui.$errorsWrapper);
          },
          _actualizeTriggers: function _actualizeTriggers() {
            var _this2 = this;
            var $toBind = this._findRelated();
            var trigger;
            $toBind.off(".Parsley");
            if (this._failedOnce)
              $toBind.on(Utils.namespaceEvents(this.options.triggerAfterFailure, "Parsley"), function() {
                _this2._validateIfNeeded();
              });
            else if (trigger = Utils.namespaceEvents(this.options.trigger, "Parsley")) {
              $toBind.on(trigger, function(event2) {
                _this2._validateIfNeeded(event2);
              });
            }
          },
          _validateIfNeeded: function _validateIfNeeded(event2) {
            var _this3 = this;
            if (event2 && /key|input/.test(event2.type)) {
              if (!(this._ui && this._ui.validationInformationVisible) && this.getValue().length <= this.options.validationThreshold)
                return;
            }
            if (this.options.debounce) {
              window.clearTimeout(this._debounced);
              this._debounced = window.setTimeout(function() {
                return _this3.validate();
              }, this.options.debounce);
            } else
              this.validate();
          },
          _resetUI: function _resetUI() {
            this._failedOnce = false;
            this._actualizeTriggers();
            if ("undefined" === typeof this._ui)
              return;
            this._ui.$errorsWrapper.removeClass("filled").children().remove();
            this._resetClass();
            this._ui.lastValidationResult = [];
            this._ui.validationInformationVisible = false;
          },
          _destroyUI: function _destroyUI() {
            this._resetUI();
            if ("undefined" !== typeof this._ui)
              this._ui.$errorsWrapper.remove();
            delete this._ui;
          },
          _successClass: function _successClass() {
            this._ui.validationInformationVisible = true;
            this._ui.$errorClassHandler.removeClass(this.options.errorClass).addClass(this.options.successClass);
          },
          _errorClass: function _errorClass() {
            this._ui.validationInformationVisible = true;
            this._ui.$errorClassHandler.removeClass(this.options.successClass).addClass(this.options.errorClass);
          },
          _resetClass: function _resetClass() {
            this._ui.$errorClassHandler.removeClass(this.options.successClass).removeClass(this.options.errorClass);
          }
        };
        var Form = function Form2(element, domOptions, options) {
          this.__class__ = "Form";
          this.element = element;
          this.$element = $2(element);
          this.domOptions = domOptions;
          this.options = options;
          this.parent = window.Parsley;
          this.fields = [];
          this.validationResult = null;
        };
        var statusMapping = {
          pending: null,
          resolved: true,
          rejected: false
        };
        Form.prototype = {
          onSubmitValidate: function onSubmitValidate(event2) {
            var _this = this;
            if (true === event2.parsley)
              return;
            var submitSource = this._submitSource || this.$element.find(Utils._SubmitSelector)[0];
            this._submitSource = null;
            this.$element.find(".parsley-synthetic-submit-button").prop("disabled", true);
            if (submitSource && null !== submitSource.getAttribute("formnovalidate"))
              return;
            window.Parsley._remoteCache = {};
            var promise = this.whenValidate({
              event: event2
            });
            if ("resolved" === promise.state() && false !== this._trigger("submit"))
              ;
            else {
              event2.stopImmediatePropagation();
              event2.preventDefault();
              if ("pending" === promise.state())
                promise.done(function() {
                  _this._submit(submitSource);
                });
            }
          },
          onSubmitButton: function onSubmitButton(event2) {
            this._submitSource = event2.currentTarget;
          },
          // internal
          // _submit submits the form, this time without going through the validations.
          // Care must be taken to "fake" the actual submit button being clicked.
          _submit: function _submit(submitSource) {
            if (false === this._trigger("submit"))
              return;
            if (submitSource) {
              var $synthetic = this.$element.find(".parsley-synthetic-submit-button").prop("disabled", false);
              if (0 === $synthetic.length)
                $synthetic = $2('<input class="parsley-synthetic-submit-button" type="hidden">').appendTo(this.$element);
              $synthetic.attr({
                name: submitSource.getAttribute("name"),
                value: submitSource.getAttribute("value")
              });
            }
            this.$element.trigger(_extends($2.Event("submit"), {
              parsley: true
            }));
          },
          // Performs validation on fields while triggering events.
          // @returns `true` if all validations succeeds, `false`
          // if a failure is immediately detected, or `null`
          // if dependant on a promise.
          // Consider using `whenValidate` instead.
          validate: function validate(options) {
            if (arguments.length >= 1 && !$2.isPlainObject(options)) {
              Utils.warnOnce("Calling validate on a parsley form without passing arguments as an object is deprecated.");
              var _arguments = Array.prototype.slice.call(arguments), group = _arguments[0], force = _arguments[1], event2 = _arguments[2];
              options = {
                group,
                force,
                event: event2
              };
            }
            return statusMapping[this.whenValidate(options).state()];
          },
          whenValidate: function whenValidate() {
            var _this2 = this, _Utils$all$done$fail$;
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, group = _ref.group, force = _ref.force, event2 = _ref.event;
            this.submitEvent = event2;
            if (event2) {
              this.submitEvent = _extends({}, event2, {
                preventDefault: function preventDefault() {
                  Utils.warnOnce("Using `this.submitEvent.preventDefault()` is deprecated; instead, call `this.validationResult = false`");
                  _this2.validationResult = false;
                }
              });
            }
            this.validationResult = true;
            this._trigger("validate");
            this._refreshFields();
            var promises = this._withoutReactualizingFormOptions(function() {
              return $2.map(_this2.fields, function(field) {
                return field.whenValidate({
                  force,
                  group
                });
              });
            });
            return (_Utils$all$done$fail$ = Utils.all(promises).done(function() {
              _this2._trigger("success");
            }).fail(function() {
              _this2.validationResult = false;
              _this2.focus();
              _this2._trigger("error");
            }).always(function() {
              _this2._trigger("validated");
            })).pipe.apply(_Utils$all$done$fail$, _toConsumableArray(this._pipeAccordingToValidationResult()));
          },
          // Iterate over refreshed fields, and stop on first failure.
          // Returns `true` if all fields are valid, `false` if a failure is detected
          // or `null` if the result depends on an unresolved promise.
          // Prefer using `whenValid` instead.
          isValid: function isValid(options) {
            if (arguments.length >= 1 && !$2.isPlainObject(options)) {
              Utils.warnOnce("Calling isValid on a parsley form without passing arguments as an object is deprecated.");
              var _arguments2 = Array.prototype.slice.call(arguments), group = _arguments2[0], force = _arguments2[1];
              options = {
                group,
                force
              };
            }
            return statusMapping[this.whenValid(options).state()];
          },
          // Iterate over refreshed fields and validate them.
          // Returns a promise.
          // A validation that immediately fails will interrupt the validations.
          whenValid: function whenValid() {
            var _this3 = this;
            var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, group = _ref2.group, force = _ref2.force;
            this._refreshFields();
            var promises = this._withoutReactualizingFormOptions(function() {
              return $2.map(_this3.fields, function(field) {
                return field.whenValid({
                  group,
                  force
                });
              });
            });
            return Utils.all(promises);
          },
          refresh: function refresh() {
            this._refreshFields();
            return this;
          },
          // Reset UI
          reset: function reset() {
            for (var i = 0; i < this.fields.length; i++) {
              this.fields[i].reset();
            }
            this._trigger("reset");
          },
          // Destroy Parsley instance (+ UI)
          destroy: function destroy() {
            this._destroyUI();
            for (var i = 0; i < this.fields.length; i++) {
              this.fields[i].destroy();
            }
            this.$element.removeData("Parsley");
            this._trigger("destroy");
          },
          _refreshFields: function _refreshFields() {
            return this.actualizeOptions()._bindFields();
          },
          _bindFields: function _bindFields() {
            var _this4 = this;
            var oldFields = this.fields;
            this.fields = [];
            this.fieldsMappedById = {};
            this._withoutReactualizingFormOptions(function() {
              _this4.$element.find(_this4.options.inputs).not(_this4.options.excluded).not("[".concat(_this4.options.namespace, "excluded=true]")).each(function(_, element) {
                var fieldInstance = new window.Parsley.Factory(element, {}, _this4);
                if ("Field" === fieldInstance.__class__ || "FieldMultiple" === fieldInstance.__class__) {
                  var uniqueId = fieldInstance.__class__ + "-" + fieldInstance.__id__;
                  if ("undefined" === typeof _this4.fieldsMappedById[uniqueId]) {
                    _this4.fieldsMappedById[uniqueId] = fieldInstance;
                    _this4.fields.push(fieldInstance);
                  }
                }
              });
              $2.each(Utils.difference(oldFields, _this4.fields), function(_, field) {
                field.reset();
              });
            });
            return this;
          },
          // Internal only.
          // Looping on a form's fields to do validation or similar
          // will trigger reactualizing options on all of them, which
          // in turn will reactualize the form's options.
          // To avoid calling actualizeOptions so many times on the form
          // for nothing, _withoutReactualizingFormOptions temporarily disables
          // the method actualizeOptions on this form while `fn` is called.
          _withoutReactualizingFormOptions: function _withoutReactualizingFormOptions(fn) {
            var oldActualizeOptions = this.actualizeOptions;
            this.actualizeOptions = function() {
              return this;
            };
            var result = fn();
            this.actualizeOptions = oldActualizeOptions;
            return result;
          },
          // Internal only.
          // Shortcut to trigger an event
          // Returns true iff event is not interrupted and default not prevented.
          _trigger: function _trigger(eventName2) {
            return this.trigger("form:" + eventName2);
          }
        };
        var Constraint = function Constraint2(parsleyField, name, requirements, priority, isDomConstraint) {
          var validatorSpec = window.Parsley._validatorRegistry.validators[name];
          var validator = new Validator(validatorSpec);
          priority = priority || parsleyField.options[name + "Priority"] || validator.priority;
          isDomConstraint = true === isDomConstraint;
          _extends(this, {
            validator,
            name,
            requirements,
            priority,
            isDomConstraint
          });
          this._parseRequirements(parsleyField.options);
        };
        var capitalize = function capitalize2(str) {
          var cap = str[0].toUpperCase();
          return cap + str.slice(1);
        };
        Constraint.prototype = {
          validate: function validate(value, instance) {
            var _this$validator;
            return (_this$validator = this.validator).validate.apply(_this$validator, [value].concat(_toConsumableArray(this.requirementList), [instance]));
          },
          _parseRequirements: function _parseRequirements(options) {
            var _this = this;
            this.requirementList = this.validator.parseRequirements(this.requirements, function(key) {
              return options[_this.name + capitalize(key)];
            });
          }
        };
        var Field = function Field2(field, domOptions, options, parsleyFormInstance) {
          this.__class__ = "Field";
          this.element = field;
          this.$element = $2(field);
          if ("undefined" !== typeof parsleyFormInstance) {
            this.parent = parsleyFormInstance;
          }
          this.options = options;
          this.domOptions = domOptions;
          this.constraints = [];
          this.constraintsByName = {};
          this.validationResult = true;
          this._bindConstraints();
        };
        var statusMapping$1 = {
          pending: null,
          resolved: true,
          rejected: false
        };
        Field.prototype = {
          // # Public API
          // Validate field and trigger some events for mainly `UI`
          // @returns `true`, an array of the validators that failed, or
          // `null` if validation is not finished. Prefer using whenValidate
          validate: function validate(options) {
            if (arguments.length >= 1 && !$2.isPlainObject(options)) {
              Utils.warnOnce("Calling validate on a parsley field without passing arguments as an object is deprecated.");
              options = {
                options
              };
            }
            var promise = this.whenValidate(options);
            if (!promise)
              return true;
            switch (promise.state()) {
              case "pending":
                return null;
              case "resolved":
                return true;
              case "rejected":
                return this.validationResult;
            }
          },
          // Validate field and trigger some events for mainly `UI`
          // @returns a promise that succeeds only when all validations do
          // or `undefined` if field is not in the given `group`.
          whenValidate: function whenValidate() {
            var _this$whenValid$alway, _this = this;
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, force = _ref.force, group = _ref.group;
            this.refresh();
            if (group && !this._isInGroup(group))
              return;
            this.value = this.getValue();
            this._trigger("validate");
            return (_this$whenValid$alway = this.whenValid({
              force,
              value: this.value,
              _refreshed: true
            }).always(function() {
              _this._reflowUI();
            }).done(function() {
              _this._trigger("success");
            }).fail(function() {
              _this._trigger("error");
            }).always(function() {
              _this._trigger("validated");
            })).pipe.apply(_this$whenValid$alway, _toConsumableArray(this._pipeAccordingToValidationResult()));
          },
          hasConstraints: function hasConstraints() {
            return 0 !== this.constraints.length;
          },
          // An empty optional field does not need validation
          needsValidation: function needsValidation(value) {
            if ("undefined" === typeof value)
              value = this.getValue();
            if (!value.length && !this._isRequired() && "undefined" === typeof this.options.validateIfEmpty)
              return false;
            return true;
          },
          _isInGroup: function _isInGroup(group) {
            if (Array.isArray(this.options.group))
              return -1 !== $2.inArray(group, this.options.group);
            return this.options.group === group;
          },
          // Just validate field. Do not trigger any event.
          // Returns `true` iff all constraints pass, `false` if there are failures,
          // or `null` if the result can not be determined yet (depends on a promise)
          // See also `whenValid`.
          isValid: function isValid(options) {
            if (arguments.length >= 1 && !$2.isPlainObject(options)) {
              Utils.warnOnce("Calling isValid on a parsley field without passing arguments as an object is deprecated.");
              var _arguments = Array.prototype.slice.call(arguments), force = _arguments[0], value = _arguments[1];
              options = {
                force,
                value
              };
            }
            var promise = this.whenValid(options);
            if (!promise)
              return true;
            return statusMapping$1[promise.state()];
          },
          // Just validate field. Do not trigger any event.
          // @returns a promise that succeeds only when all validations do
          // or `undefined` if the field is not in the given `group`.
          // The argument `force` will force validation of empty fields.
          // If a `value` is given, it will be validated instead of the value of the input.
          whenValid: function whenValid() {
            var _this2 = this;
            var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$force = _ref2.force, force = _ref2$force === void 0 ? false : _ref2$force, value = _ref2.value, group = _ref2.group, _refreshed = _ref2._refreshed;
            if (!_refreshed)
              this.refresh();
            if (group && !this._isInGroup(group))
              return;
            this.validationResult = true;
            if (!this.hasConstraints())
              return $2.when();
            if ("undefined" === typeof value || null === value)
              value = this.getValue();
            if (!this.needsValidation(value) && true !== force)
              return $2.when();
            var groupedConstraints = this._getGroupedConstraints();
            var promises = [];
            $2.each(groupedConstraints, function(_, constraints) {
              var promise = Utils.all($2.map(constraints, function(constraint) {
                return _this2._validateConstraint(value, constraint);
              }));
              promises.push(promise);
              if (promise.state() === "rejected")
                return false;
            });
            return Utils.all(promises);
          },
          // @returns a promise
          _validateConstraint: function _validateConstraint(value, constraint) {
            var _this3 = this;
            var result = constraint.validate(value, this);
            if (false === result)
              result = $2.Deferred().reject();
            return Utils.all([result]).fail(function(errorMessage) {
              if (!(_this3.validationResult instanceof Array))
                _this3.validationResult = [];
              _this3.validationResult.push({
                assert: constraint,
                errorMessage: "string" === typeof errorMessage && errorMessage
              });
            });
          },
          // @returns Parsley field computed value that could be overrided or configured in DOM
          getValue: function getValue() {
            var value;
            if ("function" === typeof this.options.value)
              value = this.options.value(this);
            else if ("undefined" !== typeof this.options.value)
              value = this.options.value;
            else
              value = this.$element.val();
            if ("undefined" === typeof value || null === value)
              return "";
            return this._handleWhitespace(value);
          },
          // Reset UI
          reset: function reset() {
            this._resetUI();
            return this._trigger("reset");
          },
          // Destroy Parsley instance (+ UI)
          destroy: function destroy() {
            this._destroyUI();
            this.$element.removeData("Parsley");
            this.$element.removeData("FieldMultiple");
            this._trigger("destroy");
          },
          // Actualize options and rebind constraints
          refresh: function refresh() {
            this._refreshConstraints();
            return this;
          },
          _refreshConstraints: function _refreshConstraints() {
            return this.actualizeOptions()._bindConstraints();
          },
          refreshConstraints: function refreshConstraints() {
            Utils.warnOnce("Parsley's refreshConstraints is deprecated. Please use refresh");
            return this.refresh();
          },
          /**
          * Add a new constraint to a field
          *
          * @param {String}   name
          * @param {Mixed}    requirements      optional
          * @param {Number}   priority          optional
          * @param {Boolean}  isDomConstraint   optional
          */
          addConstraint: function addConstraint(name, requirements, priority, isDomConstraint) {
            if (window.Parsley._validatorRegistry.validators[name]) {
              var constraint = new Constraint(this, name, requirements, priority, isDomConstraint);
              if ("undefined" !== this.constraintsByName[constraint.name])
                this.removeConstraint(constraint.name);
              this.constraints.push(constraint);
              this.constraintsByName[constraint.name] = constraint;
            }
            return this;
          },
          // Remove a constraint
          removeConstraint: function removeConstraint(name) {
            for (var i = 0; i < this.constraints.length; i++) {
              if (name === this.constraints[i].name) {
                this.constraints.splice(i, 1);
                break;
              }
            }
            delete this.constraintsByName[name];
            return this;
          },
          // Update a constraint (Remove + re-add)
          updateConstraint: function updateConstraint(name, parameters, priority) {
            return this.removeConstraint(name).addConstraint(name, parameters, priority);
          },
          // # Internals
          // Internal only.
          // Bind constraints from config + options + DOM
          _bindConstraints: function _bindConstraints() {
            var constraints = [];
            var constraintsByName = {};
            for (var i = 0; i < this.constraints.length; i++) {
              if (false === this.constraints[i].isDomConstraint) {
                constraints.push(this.constraints[i]);
                constraintsByName[this.constraints[i].name] = this.constraints[i];
              }
            }
            this.constraints = constraints;
            this.constraintsByName = constraintsByName;
            for (var name in this.options) {
              this.addConstraint(name, this.options[name], void 0, true);
            }
            return this._bindHtml5Constraints();
          },
          // Internal only.
          // Bind specific HTML5 constraints to be HTML5 compliant
          _bindHtml5Constraints: function _bindHtml5Constraints() {
            if (null !== this.element.getAttribute("required"))
              this.addConstraint("required", true, void 0, true);
            if (null !== this.element.getAttribute("pattern"))
              this.addConstraint("pattern", this.element.getAttribute("pattern"), void 0, true);
            var min = this.element.getAttribute("min");
            var max = this.element.getAttribute("max");
            if (null !== min && null !== max)
              this.addConstraint("range", [min, max], void 0, true);
            else if (null !== min)
              this.addConstraint("min", min, void 0, true);
            else if (null !== max)
              this.addConstraint("max", max, void 0, true);
            if (null !== this.element.getAttribute("minlength") && null !== this.element.getAttribute("maxlength"))
              this.addConstraint("length", [this.element.getAttribute("minlength"), this.element.getAttribute("maxlength")], void 0, true);
            else if (null !== this.element.getAttribute("minlength"))
              this.addConstraint("minlength", this.element.getAttribute("minlength"), void 0, true);
            else if (null !== this.element.getAttribute("maxlength"))
              this.addConstraint("maxlength", this.element.getAttribute("maxlength"), void 0, true);
            var type = Utils.getType(this.element);
            if ("number" === type) {
              return this.addConstraint("type", ["number", {
                step: this.element.getAttribute("step") || "1",
                base: min || this.element.getAttribute("value")
              }], void 0, true);
            } else if (/^(email|url|range|date)$/i.test(type)) {
              return this.addConstraint("type", type, void 0, true);
            }
            return this;
          },
          // Internal only.
          // Field is required if have required constraint without `false` value
          _isRequired: function _isRequired() {
            if ("undefined" === typeof this.constraintsByName.required)
              return false;
            return false !== this.constraintsByName.required.requirements;
          },
          // Internal only.
          // Shortcut to trigger an event
          _trigger: function _trigger(eventName2) {
            return this.trigger("field:" + eventName2);
          },
          // Internal only
          // Handles whitespace in a value
          // Use `data-parsley-whitespace="squish"` to auto squish input value
          // Use `data-parsley-whitespace="trim"` to auto trim input value
          _handleWhitespace: function _handleWhitespace(value) {
            if (true === this.options.trimValue)
              Utils.warnOnce('data-parsley-trim-value="true" is deprecated, please use data-parsley-whitespace="trim"');
            if ("squish" === this.options.whitespace)
              value = value.replace(/\s{2,}/g, " ");
            if ("trim" === this.options.whitespace || "squish" === this.options.whitespace || true === this.options.trimValue)
              value = Utils.trimString(value);
            return value;
          },
          _isDateInput: function _isDateInput() {
            var c = this.constraintsByName.type;
            return c && c.requirements === "date";
          },
          // Internal only.
          // Returns the constraints, grouped by descending priority.
          // The result is thus an array of arrays of constraints.
          _getGroupedConstraints: function _getGroupedConstraints() {
            if (false === this.options.priorityEnabled)
              return [this.constraints];
            var groupedConstraints = [];
            var index = {};
            for (var i = 0; i < this.constraints.length; i++) {
              var p = this.constraints[i].priority;
              if (!index[p])
                groupedConstraints.push(index[p] = []);
              index[p].push(this.constraints[i]);
            }
            groupedConstraints.sort(function(a, b) {
              return b[0].priority - a[0].priority;
            });
            return groupedConstraints;
          }
        };
        var Multiple = function Multiple2() {
          this.__class__ = "FieldMultiple";
        };
        Multiple.prototype = {
          // Add new `$element` sibling for multiple field
          addElement: function addElement($element) {
            this.$elements.push($element);
            return this;
          },
          // See `Field._refreshConstraints()`
          _refreshConstraints: function _refreshConstraints() {
            var fieldConstraints;
            this.constraints = [];
            if (this.element.nodeName === "SELECT") {
              this.actualizeOptions()._bindConstraints();
              return this;
            }
            for (var i = 0; i < this.$elements.length; i++) {
              if (!$2("html").has(this.$elements[i]).length) {
                this.$elements.splice(i, 1);
                continue;
              }
              fieldConstraints = this.$elements[i].data("FieldMultiple")._refreshConstraints().constraints;
              for (var j = 0; j < fieldConstraints.length; j++) {
                this.addConstraint(fieldConstraints[j].name, fieldConstraints[j].requirements, fieldConstraints[j].priority, fieldConstraints[j].isDomConstraint);
              }
            }
            return this;
          },
          // See `Field.getValue()`
          getValue: function getValue() {
            if ("function" === typeof this.options.value)
              return this.options.value(this);
            else if ("undefined" !== typeof this.options.value)
              return this.options.value;
            if (this.element.nodeName === "INPUT") {
              var type = Utils.getType(this.element);
              if (type === "radio")
                return this._findRelated().filter(":checked").val() || "";
              if (type === "checkbox") {
                var values = [];
                this._findRelated().filter(":checked").each(function() {
                  values.push($2(this).val());
                });
                return values;
              }
            }
            if (this.element.nodeName === "SELECT" && null === this.$element.val())
              return [];
            return this.$element.val();
          },
          _init: function _init() {
            this.$elements = [this.$element];
            return this;
          }
        };
        var Factory = function Factory2(element, options, parsleyFormInstance) {
          this.element = element;
          this.$element = $2(element);
          var savedparsleyFormInstance = this.$element.data("Parsley");
          if (savedparsleyFormInstance) {
            if ("undefined" !== typeof parsleyFormInstance && savedparsleyFormInstance.parent === window.Parsley) {
              savedparsleyFormInstance.parent = parsleyFormInstance;
              savedparsleyFormInstance._resetOptions(savedparsleyFormInstance.options);
            }
            if ("object" === _typeof(options)) {
              _extends(savedparsleyFormInstance.options, options);
            }
            return savedparsleyFormInstance;
          }
          if (!this.$element.length)
            throw new Error("You must bind Parsley on an existing element.");
          if ("undefined" !== typeof parsleyFormInstance && "Form" !== parsleyFormInstance.__class__)
            throw new Error("Parent instance must be a Form instance");
          this.parent = parsleyFormInstance || window.Parsley;
          return this.init(options);
        };
        Factory.prototype = {
          init: function init(options) {
            this.__class__ = "Parsley";
            this.__version__ = "2.9.2";
            this.__id__ = Utils.generateID();
            this._resetOptions(options);
            if (this.element.nodeName === "FORM" || Utils.checkAttr(this.element, this.options.namespace, "validate") && !this.$element.is(this.options.inputs))
              return this.bind("parsleyForm");
            return this.isMultiple() ? this.handleMultiple() : this.bind("parsleyField");
          },
          isMultiple: function isMultiple() {
            var type = Utils.getType(this.element);
            return type === "radio" || type === "checkbox" || this.element.nodeName === "SELECT" && null !== this.element.getAttribute("multiple");
          },
          // Multiples fields are a real nightmare :(
          // Maybe some refactoring would be appreciated here...
          handleMultiple: function handleMultiple() {
            var _this = this;
            var name;
            var parsleyMultipleInstance;
            this.options.multiple = this.options.multiple || (name = this.element.getAttribute("name")) || this.element.getAttribute("id");
            if (this.element.nodeName === "SELECT" && null !== this.element.getAttribute("multiple")) {
              this.options.multiple = this.options.multiple || this.__id__;
              return this.bind("parsleyFieldMultiple");
            } else if (!this.options.multiple) {
              Utils.warn("To be bound by Parsley, a radio, a checkbox and a multiple select input must have either a name or a multiple option.", this.$element);
              return this;
            }
            this.options.multiple = this.options.multiple.replace(/(:|\.|\[|\]|\{|\}|\$)/g, "");
            if (name) {
              $2('input[name="' + name + '"]').each(function(i2, input) {
                var type = Utils.getType(input);
                if (type === "radio" || type === "checkbox")
                  input.setAttribute(_this.options.namespace + "multiple", _this.options.multiple);
              });
            }
            var $previouslyRelated = this._findRelated();
            for (var i = 0; i < $previouslyRelated.length; i++) {
              parsleyMultipleInstance = $2($previouslyRelated.get(i)).data("Parsley");
              if ("undefined" !== typeof parsleyMultipleInstance) {
                if (!this.$element.data("FieldMultiple")) {
                  parsleyMultipleInstance.addElement(this.$element);
                }
                break;
              }
            }
            this.bind("parsleyField", true);
            return parsleyMultipleInstance || this.bind("parsleyFieldMultiple");
          },
          // Return proper `Form`, `Field` or `FieldMultiple`
          bind: function bind(type, doNotStore) {
            var parsleyInstance;
            switch (type) {
              case "parsleyForm":
                parsleyInstance = $2.extend(new Form(this.element, this.domOptions, this.options), new Base(), window.ParsleyExtend)._bindFields();
                break;
              case "parsleyField":
                parsleyInstance = $2.extend(new Field(this.element, this.domOptions, this.options, this.parent), new Base(), window.ParsleyExtend);
                break;
              case "parsleyFieldMultiple":
                parsleyInstance = $2.extend(new Field(this.element, this.domOptions, this.options, this.parent), new Multiple(), new Base(), window.ParsleyExtend)._init();
                break;
              default:
                throw new Error(type + "is not a supported Parsley type");
            }
            if (this.options.multiple)
              Utils.setAttr(this.element, this.options.namespace, "multiple", this.options.multiple);
            if ("undefined" !== typeof doNotStore) {
              this.$element.data("FieldMultiple", parsleyInstance);
              return parsleyInstance;
            }
            this.$element.data("Parsley", parsleyInstance);
            parsleyInstance._actualizeTriggers();
            parsleyInstance._trigger("init");
            return parsleyInstance;
          }
        };
        var vernums = $2.fn.jquery.split(".");
        if (parseInt(vernums[0]) <= 1 && parseInt(vernums[1]) < 8) {
          throw "The loaded version of jQuery is too old. Please upgrade to 1.8.x or better.";
        }
        if (!vernums.forEach) {
          Utils.warn("Parsley requires ES5 to run properly. Please include https://github.com/es-shims/es5-shim");
        }
        var Parsley = _extends(new Base(), {
          element: document,
          $element: $2(document),
          actualizeOptions: null,
          _resetOptions: null,
          Factory,
          version: "2.9.2"
        });
        _extends(Field.prototype, UI.Field, Base.prototype);
        _extends(Form.prototype, UI.Form, Base.prototype);
        _extends(Factory.prototype, Base.prototype);
        $2.fn.parsley = $2.fn.psly = function(options) {
          if (this.length > 1) {
            var instances = [];
            this.each(function() {
              instances.push($2(this).parsley(options));
            });
            return instances;
          }
          if (this.length == 0) {
            return;
          }
          return new Factory(this[0], options);
        };
        if ("undefined" === typeof window.ParsleyExtend)
          window.ParsleyExtend = {};
        Parsley.options = _extends(Utils.objectCreate(Defaults), window.ParsleyConfig);
        window.ParsleyConfig = Parsley.options;
        window.Parsley = window.psly = Parsley;
        Parsley.Utils = Utils;
        window.ParsleyUtils = {};
        $2.each(Utils, function(key, value) {
          if ("function" === typeof value) {
            window.ParsleyUtils[key] = function() {
              Utils.warnOnce("Accessing `window.ParsleyUtils` is deprecated. Use `window.Parsley.Utils` instead.");
              return Utils[key].apply(Utils, arguments);
            };
          }
        });
        var registry = window.Parsley._validatorRegistry = new ValidatorRegistry(window.ParsleyConfig.validators, window.ParsleyConfig.i18n);
        window.ParsleyValidator = {};
        $2.each("setLocale addCatalog addMessage addMessages getErrorMessage formatMessage addValidator updateValidator removeValidator hasValidator".split(" "), function(i, method) {
          window.Parsley[method] = function() {
            return registry[method].apply(registry, arguments);
          };
          window.ParsleyValidator[method] = function() {
            var _window$Parsley;
            Utils.warnOnce("Accessing the method '".concat(method, "' through Validator is deprecated. Simply call 'window.Parsley.").concat(method, "(...)'"));
            return (_window$Parsley = window.Parsley)[method].apply(_window$Parsley, arguments);
          };
        });
        window.Parsley.UI = UI;
        window.ParsleyUI = {
          removeError: function removeError(instance, name, doNotUpdateClass) {
            var updateClass = true !== doNotUpdateClass;
            Utils.warnOnce("Accessing UI is deprecated. Call 'removeError' on the instance directly. Please comment in issue 1073 as to your need to call this method.");
            return instance.removeError(name, {
              updateClass
            });
          },
          getErrorsMessages: function getErrorsMessages(instance) {
            Utils.warnOnce("Accessing UI is deprecated. Call 'getErrorsMessages' on the instance directly.");
            return instance.getErrorsMessages();
          }
        };
        $2.each("addError updateError".split(" "), function(i, method) {
          window.ParsleyUI[method] = function(instance, name, message, assert, doNotUpdateClass) {
            var updateClass = true !== doNotUpdateClass;
            Utils.warnOnce("Accessing UI is deprecated. Call '".concat(method, "' on the instance directly. Please comment in issue 1073 as to your need to call this method."));
            return instance[method](name, {
              message,
              assert,
              updateClass
            });
          };
        });
        if (false !== window.ParsleyConfig.autoBind) {
          $2(function() {
            if ($2("[data-parsley-validate]").length)
              $2("[data-parsley-validate]").parsley();
          });
        }
        var o = $2({});
        var deprecated = function deprecated2() {
          Utils.warnOnce("Parsley's pubsub module is deprecated; use the 'on' and 'off' methods on parsley instances or window.Parsley");
        };
        function adapt(fn, context) {
          if (!fn.parsleyAdaptedCallback) {
            fn.parsleyAdaptedCallback = function() {
              var args = Array.prototype.slice.call(arguments, 0);
              args.unshift(this);
              fn.apply(context || o, args);
            };
          }
          return fn.parsleyAdaptedCallback;
        }
        var eventPrefix = "parsley:";
        function eventName(name) {
          if (name.lastIndexOf(eventPrefix, 0) === 0)
            return name.substr(eventPrefix.length);
          return name;
        }
        $2.listen = function(name, callback) {
          var context;
          deprecated();
          if ("object" === _typeof(arguments[1]) && "function" === typeof arguments[2]) {
            context = arguments[1];
            callback = arguments[2];
          }
          if ("function" !== typeof callback)
            throw new Error("Wrong parameters");
          window.Parsley.on(eventName(name), adapt(callback, context));
        };
        $2.listenTo = function(instance, name, fn) {
          deprecated();
          if (!(instance instanceof Field) && !(instance instanceof Form))
            throw new Error("Must give Parsley instance");
          if ("string" !== typeof name || "function" !== typeof fn)
            throw new Error("Wrong parameters");
          instance.on(eventName(name), adapt(fn));
        };
        $2.unsubscribe = function(name, fn) {
          deprecated();
          if ("string" !== typeof name || "function" !== typeof fn)
            throw new Error("Wrong arguments");
          window.Parsley.off(eventName(name), fn.parsleyAdaptedCallback);
        };
        $2.unsubscribeTo = function(instance, name) {
          deprecated();
          if (!(instance instanceof Field) && !(instance instanceof Form))
            throw new Error("Must give Parsley instance");
          instance.off(eventName(name));
        };
        $2.unsubscribeAll = function(name) {
          deprecated();
          window.Parsley.off(eventName(name));
          $2("form,input,textarea,select").each(function() {
            var instance = $2(this).data("Parsley");
            if (instance) {
              instance.off(eventName(name));
            }
          });
        };
        $2.emit = function(name, instance) {
          var _instance;
          deprecated();
          var instanceGiven = instance instanceof Field || instance instanceof Form;
          var args = Array.prototype.slice.call(arguments, instanceGiven ? 2 : 1);
          args.unshift(eventName(name));
          if (!instanceGiven) {
            instance = window.Parsley;
          }
          (_instance = instance).trigger.apply(_instance, _toConsumableArray(args));
        };
        $2.extend(true, Parsley, {
          asyncValidators: {
            "default": {
              fn: function fn(xhr) {
                return xhr.status >= 200 && xhr.status < 300;
              },
              url: false
            },
            reverse: {
              fn: function fn(xhr) {
                return xhr.status < 200 || xhr.status >= 300;
              },
              url: false
            }
          },
          addAsyncValidator: function addAsyncValidator(name, fn, url, options) {
            Parsley.asyncValidators[name] = {
              fn,
              url: url || false,
              options: options || {}
            };
            return this;
          }
        });
        Parsley.addValidator("remote", {
          requirementType: {
            "": "string",
            "validator": "string",
            "reverse": "boolean",
            "options": "object"
          },
          validateString: function validateString(value, url, options, instance) {
            var data = {};
            var ajaxOptions;
            var csr;
            var validator = options.validator || (true === options.reverse ? "reverse" : "default");
            if ("undefined" === typeof Parsley.asyncValidators[validator])
              throw new Error("Calling an undefined async validator: `" + validator + "`");
            url = Parsley.asyncValidators[validator].url || url;
            if (url.indexOf("{value}") > -1) {
              url = url.replace("{value}", encodeURIComponent(value));
            } else {
              data[instance.element.getAttribute("name") || instance.element.getAttribute("id")] = value;
            }
            var remoteOptions = $2.extend(true, options.options || {}, Parsley.asyncValidators[validator].options);
            ajaxOptions = $2.extend(true, {}, {
              url,
              data,
              type: "GET"
            }, remoteOptions);
            instance.trigger("field:ajaxoptions", instance, ajaxOptions);
            csr = $2.param(ajaxOptions);
            if ("undefined" === typeof Parsley._remoteCache)
              Parsley._remoteCache = {};
            var xhr = Parsley._remoteCache[csr] = Parsley._remoteCache[csr] || $2.ajax(ajaxOptions);
            var handleXhr = function handleXhr2() {
              var result = Parsley.asyncValidators[validator].fn.call(instance, xhr, url, options);
              if (!result)
                result = $2.Deferred().reject();
              return $2.when(result);
            };
            return xhr.then(handleXhr, handleXhr);
          },
          priority: -1
        });
        Parsley.on("form:submit", function() {
          Parsley._remoteCache = {};
        });
        Base.prototype.addAsyncValidator = function() {
          Utils.warnOnce("Accessing the method `addAsyncValidator` through an instance is deprecated. Simply call `Parsley.addAsyncValidator(...)`");
          return Parsley.addAsyncValidator.apply(Parsley, arguments);
        };
        Parsley.addMessages("en", {
          defaultMessage: "This value seems to be invalid.",
          type: {
            email: "This value should be a valid email.",
            url: "This value should be a valid url.",
            number: "This value should be a valid number.",
            integer: "This value should be a valid integer.",
            digits: "This value should be digits.",
            alphanum: "This value should be alphanumeric."
          },
          notblank: "This value should not be blank.",
          required: "This value is required.",
          pattern: "This value seems to be invalid.",
          min: "This value should be greater than or equal to %s.",
          max: "This value should be lower than or equal to %s.",
          range: "This value should be between %s and %s.",
          minlength: "This value is too short. It should have %s characters or more.",
          maxlength: "This value is too long. It should have %s characters or fewer.",
          length: "This value length is invalid. It should be between %s and %s characters long.",
          mincheck: "You must select at least %s choices.",
          maxcheck: "You must select %s choices or fewer.",
          check: "You must select between %s and %s choices.",
          equalto: "This value should be the same.",
          euvatin: "It's not a valid VAT Identification Number."
        });
        Parsley.setLocale("en");
        function InputEvent() {
          var _this = this;
          var globals = window || global;
          _extends(this, {
            // For browsers that do not support isTrusted, assumes event is native.
            isNativeEvent: function isNativeEvent(evt) {
              return evt.originalEvent && evt.originalEvent.isTrusted !== false;
            },
            fakeInputEvent: function fakeInputEvent(evt) {
              if (_this.isNativeEvent(evt)) {
                $2(evt.target).trigger("input");
              }
            },
            misbehaves: function misbehaves(evt) {
              if (_this.isNativeEvent(evt)) {
                _this.behavesOk(evt);
                $2(document).on("change.inputevent", evt.data.selector, _this.fakeInputEvent);
                _this.fakeInputEvent(evt);
              }
            },
            behavesOk: function behavesOk(evt) {
              if (_this.isNativeEvent(evt)) {
                $2(document).off("input.inputevent", evt.data.selector, _this.behavesOk).off("change.inputevent", evt.data.selector, _this.misbehaves);
              }
            },
            // Bind the testing handlers
            install: function install() {
              if (globals.inputEventPatched) {
                return;
              }
              globals.inputEventPatched = "0.0.3";
              for (var _i = 0, _arr = ["select", 'input[type="checkbox"]', 'input[type="radio"]', 'input[type="file"]']; _i < _arr.length; _i++) {
                var selector = _arr[_i];
                $2(document).on("input.inputevent", selector, {
                  selector
                }, _this.behavesOk).on("change.inputevent", selector, {
                  selector
                }, _this.misbehaves);
              }
            },
            uninstall: function uninstall() {
              delete globals.inputEventPatched;
              $2(document).off(".inputevent");
            }
          });
        }
        var inputevent = new InputEvent();
        inputevent.install();
        return Parsley;
      });
    }
  });

  // node_modules/jstree/dist/jstree.js
  var require_jstree = __commonJS({
    "node_modules/jstree/dist/jstree.js"(exports, module) {
      (function(factory) {
        "use strict";
        if (typeof define === "function" && define.amd) {
          define(["jquery"], factory);
        } else if (typeof module !== "undefined" && module.exports) {
          module.exports = factory(require_jquery());
        } else {
          factory(jQuery);
        }
      })(function($2, undefined2) {
        "use strict";
        if ($2.jstree) {
          return;
        }
        var instance_counter = 0, ccp_node = false, ccp_mode = false, ccp_inst = false, themes_loaded = [], src = $2("script:last").attr("src"), document2 = window.document;
        var setImmediate = window.setImmediate;
        var Promise2 = window.Promise;
        if (!setImmediate && Promise2) {
          setImmediate = function(cb, arg) {
            Promise2.resolve(arg).then(cb);
          };
        }
        $2.jstree = {
          /**
           * specifies the jstree version in use
           * @name $.jstree.version
           */
          version: "3.3.10",
          /**
           * holds all the default options used when creating new instances
           * @name $.jstree.defaults
           */
          defaults: {
            /**
             * configure which plugins will be active on an instance. Should be an array of strings, where each element is a plugin name. The default is `[]`
             * @name $.jstree.defaults.plugins
             */
            plugins: []
          },
          /**
           * stores all loaded jstree plugins (used internally)
           * @name $.jstree.plugins
           */
          plugins: {},
          path: src && src.indexOf("/") !== -1 ? src.replace(/\/[^\/]+$/, "") : "",
          idregex: /[\\:&!^|()\[\]<>@*'+~#";.,=\- \/${}%?`]/g,
          root: "#"
        };
        $2.jstree.create = function(el, options) {
          var tmp = new $2.jstree.core(++instance_counter), opt = options;
          options = $2.extend(true, {}, $2.jstree.defaults, options);
          if (opt && opt.plugins) {
            options.plugins = opt.plugins;
          }
          $2.each(options.plugins, function(i, k) {
            if (i !== "core") {
              tmp = tmp.plugin(k, options[k]);
            }
          });
          $2(el).data("jstree", tmp);
          tmp.init(el, options);
          return tmp;
        };
        $2.jstree.destroy = function() {
          $2(".jstree:jstree").jstree("destroy");
          $2(document2).off(".jstree");
        };
        $2.jstree.core = function(id) {
          this._id = id;
          this._cnt = 0;
          this._wrk = null;
          this._data = {
            core: {
              themes: {
                name: false,
                dots: false,
                icons: false,
                ellipsis: false
              },
              selected: [],
              last_error: {},
              working: false,
              worker_queue: [],
              focused: null
            }
          };
        };
        $2.jstree.reference = function(needle) {
          var tmp = null, obj = null;
          if (needle && needle.id && (!needle.tagName || !needle.nodeType)) {
            needle = needle.id;
          }
          if (!obj || !obj.length) {
            try {
              obj = $2(needle);
            } catch (ignore) {
            }
          }
          if (!obj || !obj.length) {
            try {
              obj = $2("#" + needle.replace($2.jstree.idregex, "\\$&"));
            } catch (ignore) {
            }
          }
          if (obj && obj.length && (obj = obj.closest(".jstree")).length && (obj = obj.data("jstree"))) {
            tmp = obj;
          } else {
            $2(".jstree").each(function() {
              var inst = $2(this).data("jstree");
              if (inst && inst._model.data[needle]) {
                tmp = inst;
                return false;
              }
            });
          }
          return tmp;
        };
        $2.fn.jstree = function(arg) {
          var is_method = typeof arg === "string", args = Array.prototype.slice.call(arguments, 1), result = null;
          if (arg === true && !this.length) {
            return false;
          }
          this.each(function() {
            var instance = $2.jstree.reference(this), method = is_method && instance ? instance[arg] : null;
            result = is_method && method ? method.apply(instance, args) : null;
            if (!instance && !is_method && (arg === undefined2 || $2.isPlainObject(arg))) {
              $2.jstree.create(this, arg);
            }
            if (instance && !is_method || arg === true) {
              result = instance || false;
            }
            if (result !== null && result !== undefined2) {
              return false;
            }
          });
          return result !== null && result !== undefined2 ? result : this;
        };
        $2.expr.pseudos.jstree = $2.expr.createPseudo(function(search) {
          return function(a) {
            return $2(a).hasClass("jstree") && $2(a).data("jstree") !== undefined2;
          };
        });
        $2.jstree.defaults.core = {
          /**
           * data configuration
           *
           * If left as `false` the HTML inside the jstree container element is used to populate the tree (that should be an unordered list with list items).
           *
           * You can also pass in a HTML string or a JSON array here.
           *
           * It is possible to pass in a standard jQuery-like AJAX config and jstree will automatically determine if the response is JSON or HTML and use that to populate the tree.
           * In addition to the standard jQuery ajax options here you can suppy functions for `data` and `url`, the functions will be run in the current instance's scope and a param will be passed indicating which node is being loaded, the return value of those functions will be used.
           *
           * The last option is to specify a function, that function will receive the node being loaded as argument and a second param which is a function which should be called with the result.
           *
           * __Examples__
           *
           *	// AJAX
           *	$('#tree').jstree({
           *		'core' : {
           *			'data' : {
           *				'url' : '/get/children/',
           *				'data' : function (node) {
           *					return { 'id' : node.id };
           *				}
           *			}
           *		});
           *
           *	// direct data
           *	$('#tree').jstree({
           *		'core' : {
           *			'data' : [
           *				'Simple root node',
           *				{
           *					'id' : 'node_2',
           *					'text' : 'Root node with options',
           *					'state' : { 'opened' : true, 'selected' : true },
           *					'children' : [ { 'text' : 'Child 1' }, 'Child 2']
           *				}
           *			]
           *		}
           *	});
           *
           *	// function
           *	$('#tree').jstree({
           *		'core' : {
           *			'data' : function (obj, callback) {
           *				callback.call(this, ['Root 1', 'Root 2']);
           *			}
           *		});
           *
           * @name $.jstree.defaults.core.data
           */
          data: false,
          /**
           * configure the various strings used throughout the tree
           *
           * You can use an object where the key is the string you need to replace and the value is your replacement.
           * Another option is to specify a function which will be called with an argument of the needed string and should return the replacement.
           * If left as `false` no replacement is made.
           *
           * __Examples__
           *
           *	$('#tree').jstree({
           *		'core' : {
           *			'strings' : {
           *				'Loading ...' : 'Please wait ...'
           *			}
           *		}
           *	});
           *
           * @name $.jstree.defaults.core.strings
           */
          strings: false,
          /**
           * determines what happens when a user tries to modify the structure of the tree
           * If left as `false` all operations like create, rename, delete, move or copy are prevented.
           * You can set this to `true` to allow all interactions or use a function to have better control.
           *
           * __Examples__
           *
           *	$('#tree').jstree({
           *		'core' : {
           *			'check_callback' : function (operation, node, node_parent, node_position, more) {
           *				// operation can be 'create_node', 'rename_node', 'delete_node', 'move_node', 'copy_node' or 'edit'
           *				// in case of 'rename_node' node_position is filled with the new node name
           *				return operation === 'rename_node' ? true : false;
           *			}
           *		}
           *	});
           *
           * @name $.jstree.defaults.core.check_callback
           */
          check_callback: false,
          /**
           * a callback called with a single object parameter in the instance's scope when something goes wrong (operation prevented, ajax failed, etc)
           * @name $.jstree.defaults.core.error
           */
          error: $2.noop,
          /**
           * the open / close animation duration in milliseconds - set this to `false` to disable the animation (default is `200`)
           * @name $.jstree.defaults.core.animation
           */
          animation: 200,
          /**
           * a boolean indicating if multiple nodes can be selected
           * @name $.jstree.defaults.core.multiple
           */
          multiple: true,
          /**
           * theme configuration object
           * @name $.jstree.defaults.core.themes
           */
          themes: {
            /**
             * the name of the theme to use (if left as `false` the default theme is used)
             * @name $.jstree.defaults.core.themes.name
             */
            name: false,
            /**
             * the URL of the theme's CSS file, leave this as `false` if you have manually included the theme CSS (recommended). You can set this to `true` too which will try to autoload the theme.
             * @name $.jstree.defaults.core.themes.url
             */
            url: false,
            /**
             * the location of all jstree themes - only used if `url` is set to `true`
             * @name $.jstree.defaults.core.themes.dir
             */
            dir: false,
            /**
             * a boolean indicating if connecting dots are shown
             * @name $.jstree.defaults.core.themes.dots
             */
            dots: true,
            /**
             * a boolean indicating if node icons are shown
             * @name $.jstree.defaults.core.themes.icons
             */
            icons: true,
            /**
             * a boolean indicating if node ellipsis should be shown - this only works with a fixed with on the container
             * @name $.jstree.defaults.core.themes.ellipsis
             */
            ellipsis: false,
            /**
             * a boolean indicating if the tree background is striped
             * @name $.jstree.defaults.core.themes.stripes
             */
            stripes: false,
            /**
             * a string (or boolean `false`) specifying the theme variant to use (if the theme supports variants)
             * @name $.jstree.defaults.core.themes.variant
             */
            variant: false,
            /**
             * a boolean specifying if a reponsive version of the theme should kick in on smaller screens (if the theme supports it). Defaults to `false`.
             * @name $.jstree.defaults.core.themes.responsive
             */
            responsive: false
          },
          /**
           * if left as `true` all parents of all selected nodes will be opened once the tree loads (so that all selected nodes are visible to the user)
           * @name $.jstree.defaults.core.expand_selected_onload
           */
          expand_selected_onload: true,
          /**
           * if left as `true` web workers will be used to parse incoming JSON data where possible, so that the UI will not be blocked by large requests. Workers are however about 30% slower. Defaults to `true`
           * @name $.jstree.defaults.core.worker
           */
          worker: true,
          /**
           * Force node text to plain text (and escape HTML). Defaults to `false`
           * @name $.jstree.defaults.core.force_text
           */
          force_text: false,
          /**
           * Should the node be toggled if the text is double clicked. Defaults to `true`
           * @name $.jstree.defaults.core.dblclick_toggle
           */
          dblclick_toggle: true,
          /**
           * Should the loaded nodes be part of the state. Defaults to `false`
           * @name $.jstree.defaults.core.loaded_state
           */
          loaded_state: false,
          /**
           * Should the last active node be focused when the tree container is blurred and the focused again. This helps working with screen readers. Defaults to `true`
           * @name $.jstree.defaults.core.restore_focus
           */
          restore_focus: true,
          /**
           * Default keyboard shortcuts (an object where each key is the button name or combo - like 'enter', 'ctrl-space', 'p', etc and the value is the function to execute in the instance's scope)
           * @name $.jstree.defaults.core.keyboard
           */
          keyboard: {
            "ctrl-space": function(e) {
              e.type = "click";
              $2(e.currentTarget).trigger(e);
            },
            "enter": function(e) {
              e.type = "click";
              $2(e.currentTarget).trigger(e);
            },
            "left": function(e) {
              e.preventDefault();
              if (this.is_open(e.currentTarget)) {
                this.close_node(e.currentTarget);
              } else {
                var o = this.get_parent(e.currentTarget);
                if (o && o.id !== $2.jstree.root) {
                  this.get_node(o, true).children(".jstree-anchor").focus();
                }
              }
            },
            "up": function(e) {
              e.preventDefault();
              var o = this.get_prev_dom(e.currentTarget);
              if (o && o.length) {
                o.children(".jstree-anchor").focus();
              }
            },
            "right": function(e) {
              e.preventDefault();
              if (this.is_closed(e.currentTarget)) {
                this.open_node(e.currentTarget, function(o2) {
                  this.get_node(o2, true).children(".jstree-anchor").focus();
                });
              } else if (this.is_open(e.currentTarget)) {
                var o = this.get_node(e.currentTarget, true).children(".jstree-children")[0];
                if (o) {
                  $2(this._firstChild(o)).children(".jstree-anchor").focus();
                }
              }
            },
            "down": function(e) {
              e.preventDefault();
              var o = this.get_next_dom(e.currentTarget);
              if (o && o.length) {
                o.children(".jstree-anchor").focus();
              }
            },
            "*": function(e) {
              this.open_all();
            },
            "home": function(e) {
              e.preventDefault();
              var o = this._firstChild(this.get_container_ul()[0]);
              if (o) {
                $2(o).children(".jstree-anchor").filter(":visible").focus();
              }
            },
            "end": function(e) {
              e.preventDefault();
              this.element.find(".jstree-anchor").filter(":visible").last().focus();
            },
            "f2": function(e) {
              e.preventDefault();
              this.edit(e.currentTarget);
            }
          }
        };
        $2.jstree.core.prototype = {
          /**
           * used to decorate an instance with a plugin. Used internally.
           * @private
           * @name plugin(deco [, opts])
           * @param  {String} deco the plugin to decorate with
           * @param  {Object} opts options for the plugin
           * @return {jsTree}
           */
          plugin: function(deco, opts) {
            var Child = $2.jstree.plugins[deco];
            if (Child) {
              this._data[deco] = {};
              Child.prototype = this;
              return new Child(opts, this);
            }
            return this;
          },
          /**
           * initialize the instance. Used internally.
           * @private
           * @name init(el, optons)
           * @param {DOMElement|jQuery|String} el the element we are transforming
           * @param {Object} options options for this instance
           * @trigger init.jstree, loading.jstree, loaded.jstree, ready.jstree, changed.jstree
           */
          init: function(el, options) {
            this._model = {
              data: {},
              changed: [],
              force_full_redraw: false,
              redraw_timeout: false,
              default_state: {
                loaded: true,
                opened: false,
                selected: false,
                disabled: false
              }
            };
            this._model.data[$2.jstree.root] = {
              id: $2.jstree.root,
              parent: null,
              parents: [],
              children: [],
              children_d: [],
              state: { loaded: false }
            };
            this.element = $2(el).addClass("jstree jstree-" + this._id);
            this.settings = options;
            this._data.core.ready = false;
            this._data.core.loaded = false;
            this._data.core.rtl = this.element.css("direction") === "rtl";
            this.element[this._data.core.rtl ? "addClass" : "removeClass"]("jstree-rtl");
            this.element.attr("role", "tree");
            if (this.settings.core.multiple) {
              this.element.attr("aria-multiselectable", true);
            }
            if (!this.element.attr("tabindex")) {
              this.element.attr("tabindex", "0");
            }
            this.bind();
            this.trigger("init");
            this._data.core.original_container_html = this.element.find(" > ul > li").clone(true);
            this._data.core.original_container_html.find("li").addBack().contents().filter(function() {
              return this.nodeType === 3 && (!this.nodeValue || /^\s+$/.test(this.nodeValue));
            }).remove();
            this.element.html("<ul class='jstree-container-ul jstree-children' role='group'><li id='j" + this._id + "_loading' class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='presentation'><i class='jstree-icon jstree-ocl'></i><a class='jstree-anchor' role='treeitem' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>");
            this.element.attr("aria-activedescendant", "j" + this._id + "_loading");
            this._data.core.li_height = this.get_container_ul().children("li").first().outerHeight() || 24;
            this._data.core.node = this._create_prototype_node();
            this.trigger("loading");
            this.load_node($2.jstree.root);
          },
          /**
           * destroy an instance
           * @name destroy()
           * @param  {Boolean} keep_html if not set to `true` the container will be emptied, otherwise the current DOM elements will be kept intact
           */
          destroy: function(keep_html) {
            this.trigger("destroy");
            if (this._wrk) {
              try {
                window.URL.revokeObjectURL(this._wrk);
                this._wrk = null;
              } catch (ignore) {
              }
            }
            if (!keep_html) {
              this.element.empty();
            }
            this.teardown();
          },
          /**
           * Create a prototype node
           * @name _create_prototype_node()
           * @return {DOMElement}
           */
          _create_prototype_node: function() {
            var _node = document2.createElement("LI"), _temp1, _temp2;
            _node.setAttribute("role", "presentation");
            _temp1 = document2.createElement("I");
            _temp1.className = "jstree-icon jstree-ocl";
            _temp1.setAttribute("role", "presentation");
            _node.appendChild(_temp1);
            _temp1 = document2.createElement("A");
            _temp1.className = "jstree-anchor";
            _temp1.setAttribute("href", "#");
            _temp1.setAttribute("tabindex", "-1");
            _temp1.setAttribute("role", "treeitem");
            _temp2 = document2.createElement("I");
            _temp2.className = "jstree-icon jstree-themeicon";
            _temp2.setAttribute("role", "presentation");
            _temp1.appendChild(_temp2);
            _node.appendChild(_temp1);
            _temp1 = _temp2 = null;
            return _node;
          },
          _kbevent_to_func: function(e) {
            var keys = {
              8: "Backspace",
              9: "Tab",
              13: "Enter",
              19: "Pause",
              27: "Esc",
              32: "Space",
              33: "PageUp",
              34: "PageDown",
              35: "End",
              36: "Home",
              37: "Left",
              38: "Up",
              39: "Right",
              40: "Down",
              44: "Print",
              45: "Insert",
              46: "Delete",
              96: "Numpad0",
              97: "Numpad1",
              98: "Numpad2",
              99: "Numpad3",
              100: "Numpad4",
              101: "Numpad5",
              102: "Numpad6",
              103: "Numpad7",
              104: "Numpad8",
              105: "Numpad9",
              "-13": "NumpadEnter",
              112: "F1",
              113: "F2",
              114: "F3",
              115: "F4",
              116: "F5",
              117: "F6",
              118: "F7",
              119: "F8",
              120: "F9",
              121: "F10",
              122: "F11",
              123: "F12",
              144: "Numlock",
              145: "Scrolllock",
              16: "Shift",
              17: "Ctrl",
              18: "Alt",
              48: "0",
              49: "1",
              50: "2",
              51: "3",
              52: "4",
              53: "5",
              54: "6",
              55: "7",
              56: "8",
              57: "9",
              59: ";",
              61: "=",
              65: "a",
              66: "b",
              67: "c",
              68: "d",
              69: "e",
              70: "f",
              71: "g",
              72: "h",
              73: "i",
              74: "j",
              75: "k",
              76: "l",
              77: "m",
              78: "n",
              79: "o",
              80: "p",
              81: "q",
              82: "r",
              83: "s",
              84: "t",
              85: "u",
              86: "v",
              87: "w",
              88: "x",
              89: "y",
              90: "z",
              107: "+",
              109: "-",
              110: ".",
              186: ";",
              187: "=",
              188: ",",
              189: "-",
              190: ".",
              191: "/",
              192: "`",
              219: "[",
              220: "\\",
              221: "]",
              222: "'",
              111: "/",
              106: "*",
              173: "-"
            };
            var parts = [];
            if (e.ctrlKey) {
              parts.push("ctrl");
            }
            if (e.altKey) {
              parts.push("alt");
            }
            if (e.shiftKey) {
              parts.push("shift");
            }
            parts.push(keys[e.which] || e.which);
            parts = parts.sort().join("-").toLowerCase();
            if (parts === "shift-shift" || parts === "ctrl-ctrl" || parts === "alt-alt") {
              return null;
            }
            var kb = this.settings.core.keyboard, i, tmp;
            for (i in kb) {
              if (kb.hasOwnProperty(i)) {
                tmp = i;
                if (tmp !== "-" && tmp !== "+") {
                  tmp = tmp.replace("--", "-MINUS").replace("+-", "-MINUS").replace("++", "-PLUS").replace("-+", "-PLUS");
                  tmp = tmp.split(/-|\+/).sort().join("-").replace("MINUS", "-").replace("PLUS", "+").toLowerCase();
                }
                if (tmp === parts) {
                  return kb[i];
                }
              }
            }
            return null;
          },
          /**
           * part of the destroying of an instance. Used internally.
           * @private
           * @name teardown()
           */
          teardown: function() {
            this.unbind();
            this.element.removeClass("jstree").removeData("jstree").find("[class^='jstree']").addBack().attr("class", function() {
              return this.className.replace(/jstree[^ ]*|$/ig, "");
            });
            this.element = null;
          },
          /**
           * bind all events. Used internally.
           * @private
           * @name bind()
           */
          bind: function() {
            var word = "", tout = null, was_click = 0;
            this.element.on("dblclick.jstree", function(e) {
              if (e.target.tagName && e.target.tagName.toLowerCase() === "input") {
                return true;
              }
              if (document2.selection && document2.selection.empty) {
                document2.selection.empty();
              } else {
                if (window.getSelection) {
                  var sel = window.getSelection();
                  try {
                    sel.removeAllRanges();
                    sel.collapse();
                  } catch (ignore) {
                  }
                }
              }
            }).on("mousedown.jstree", $2.proxy(function(e) {
              if (e.target === this.element[0]) {
                e.preventDefault();
                was_click = +/* @__PURE__ */ new Date();
              }
            }, this)).on("mousedown.jstree", ".jstree-ocl", function(e) {
              e.preventDefault();
            }).on("click.jstree", ".jstree-ocl", $2.proxy(function(e) {
              this.toggle_node(e.target);
            }, this)).on("dblclick.jstree", ".jstree-anchor", $2.proxy(function(e) {
              if (e.target.tagName && e.target.tagName.toLowerCase() === "input") {
                return true;
              }
              if (this.settings.core.dblclick_toggle) {
                this.toggle_node(e.target);
              }
            }, this)).on("click.jstree", ".jstree-anchor", $2.proxy(function(e) {
              e.preventDefault();
              if (e.currentTarget !== document2.activeElement) {
                $2(e.currentTarget).focus();
              }
              this.activate_node(e.currentTarget, e);
            }, this)).on("keydown.jstree", ".jstree-anchor", $2.proxy(function(e) {
              if (e.target.tagName && e.target.tagName.toLowerCase() === "input") {
                return true;
              }
              if (this._data.core.rtl) {
                if (e.which === 37) {
                  e.which = 39;
                } else if (e.which === 39) {
                  e.which = 37;
                }
              }
              var f = this._kbevent_to_func(e);
              if (f) {
                var r = f.call(this, e);
                if (r === false || r === true) {
                  return r;
                }
              }
            }, this)).on("load_node.jstree", $2.proxy(function(e, data) {
              if (data.status) {
                if (data.node.id === $2.jstree.root && !this._data.core.loaded) {
                  this._data.core.loaded = true;
                  if (this._firstChild(this.get_container_ul()[0])) {
                    this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id);
                  }
                  this.trigger("loaded");
                }
                if (!this._data.core.ready) {
                  setTimeout($2.proxy(function() {
                    if (this.element && !this.get_container_ul().find(".jstree-loading").length) {
                      this._data.core.ready = true;
                      if (this._data.core.selected.length) {
                        if (this.settings.core.expand_selected_onload) {
                          var tmp = [], i, j;
                          for (i = 0, j = this._data.core.selected.length; i < j; i++) {
                            tmp = tmp.concat(this._model.data[this._data.core.selected[i]].parents);
                          }
                          tmp = $2.vakata.array_unique(tmp);
                          for (i = 0, j = tmp.length; i < j; i++) {
                            this.open_node(tmp[i], false, 0);
                          }
                        }
                        this.trigger("changed", { "action": "ready", "selected": this._data.core.selected });
                      }
                      this.trigger("ready");
                    }
                  }, this), 0);
                }
              }
            }, this)).on("keypress.jstree", $2.proxy(function(e) {
              if (e.target.tagName && e.target.tagName.toLowerCase() === "input") {
                return true;
              }
              if (tout) {
                clearTimeout(tout);
              }
              tout = setTimeout(function() {
                word = "";
              }, 500);
              var chr = String.fromCharCode(e.which).toLowerCase(), col = this.element.find(".jstree-anchor").filter(":visible"), ind = col.index(document2.activeElement) || 0, end = false;
              word += chr;
              if (word.length > 1) {
                col.slice(ind).each($2.proxy(function(i, v) {
                  if ($2(v).text().toLowerCase().indexOf(word) === 0) {
                    $2(v).focus();
                    end = true;
                    return false;
                  }
                }, this));
                if (end) {
                  return;
                }
                col.slice(0, ind).each($2.proxy(function(i, v) {
                  if ($2(v).text().toLowerCase().indexOf(word) === 0) {
                    $2(v).focus();
                    end = true;
                    return false;
                  }
                }, this));
                if (end) {
                  return;
                }
              }
              if (new RegExp("^" + chr.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + "+$").test(word)) {
                col.slice(ind + 1).each($2.proxy(function(i, v) {
                  if ($2(v).text().toLowerCase().charAt(0) === chr) {
                    $2(v).focus();
                    end = true;
                    return false;
                  }
                }, this));
                if (end) {
                  return;
                }
                col.slice(0, ind + 1).each($2.proxy(function(i, v) {
                  if ($2(v).text().toLowerCase().charAt(0) === chr) {
                    $2(v).focus();
                    end = true;
                    return false;
                  }
                }, this));
                if (end) {
                  return;
                }
              }
            }, this)).on("init.jstree", $2.proxy(function() {
              var s = this.settings.core.themes;
              this._data.core.themes.dots = s.dots;
              this._data.core.themes.stripes = s.stripes;
              this._data.core.themes.icons = s.icons;
              this._data.core.themes.ellipsis = s.ellipsis;
              this.set_theme(s.name || "default", s.url);
              this.set_theme_variant(s.variant);
            }, this)).on("loading.jstree", $2.proxy(function() {
              this[this._data.core.themes.dots ? "show_dots" : "hide_dots"]();
              this[this._data.core.themes.icons ? "show_icons" : "hide_icons"]();
              this[this._data.core.themes.stripes ? "show_stripes" : "hide_stripes"]();
              this[this._data.core.themes.ellipsis ? "show_ellipsis" : "hide_ellipsis"]();
            }, this)).on("blur.jstree", ".jstree-anchor", $2.proxy(function(e) {
              this._data.core.focused = null;
              $2(e.currentTarget).filter(".jstree-hovered").trigger("mouseleave");
              this.element.attr("tabindex", "0");
            }, this)).on("focus.jstree", ".jstree-anchor", $2.proxy(function(e) {
              var tmp = this.get_node(e.currentTarget);
              if (tmp && tmp.id) {
                this._data.core.focused = tmp.id;
              }
              this.element.find(".jstree-hovered").not(e.currentTarget).trigger("mouseleave");
              $2(e.currentTarget).trigger("mouseenter");
              this.element.attr("tabindex", "-1");
            }, this)).on("focus.jstree", $2.proxy(function() {
              if (+/* @__PURE__ */ new Date() - was_click > 500 && !this._data.core.focused && this.settings.core.restore_focus) {
                was_click = 0;
                var act = this.get_node(this.element.attr("aria-activedescendant"), true);
                if (act) {
                  act.find("> .jstree-anchor").focus();
                }
              }
            }, this)).on("mouseenter.jstree", ".jstree-anchor", $2.proxy(function(e) {
              this.hover_node(e.currentTarget);
            }, this)).on("mouseleave.jstree", ".jstree-anchor", $2.proxy(function(e) {
              this.dehover_node(e.currentTarget);
            }, this));
          },
          /**
           * part of the destroying of an instance. Used internally.
           * @private
           * @name unbind()
           */
          unbind: function() {
            this.element.off(".jstree");
            $2(document2).off(".jstree-" + this._id);
          },
          /**
           * trigger an event. Used internally.
           * @private
           * @name trigger(ev [, data])
           * @param  {String} ev the name of the event to trigger
           * @param  {Object} data additional data to pass with the event
           */
          trigger: function(ev, data) {
            if (!data) {
              data = {};
            }
            data.instance = this;
            this.element.triggerHandler(ev.replace(".jstree", "") + ".jstree", data);
          },
          /**
           * returns the jQuery extended instance container
           * @name get_container()
           * @return {jQuery}
           */
          get_container: function() {
            return this.element;
          },
          /**
           * returns the jQuery extended main UL node inside the instance container. Used internally.
           * @private
           * @name get_container_ul()
           * @return {jQuery}
           */
          get_container_ul: function() {
            return this.element.children(".jstree-children").first();
          },
          /**
           * gets string replacements (localization). Used internally.
           * @private
           * @name get_string(key)
           * @param  {String} key
           * @return {String}
           */
          get_string: function(key) {
            var a = this.settings.core.strings;
            if ($2.isFunction(a)) {
              return a.call(this, key);
            }
            if (a && a[key]) {
              return a[key];
            }
            return key;
          },
          /**
           * gets the first child of a DOM node. Used internally.
           * @private
           * @name _firstChild(dom)
           * @param  {DOMElement} dom
           * @return {DOMElement}
           */
          _firstChild: function(dom) {
            dom = dom ? dom.firstChild : null;
            while (dom !== null && dom.nodeType !== 1) {
              dom = dom.nextSibling;
            }
            return dom;
          },
          /**
           * gets the next sibling of a DOM node. Used internally.
           * @private
           * @name _nextSibling(dom)
           * @param  {DOMElement} dom
           * @return {DOMElement}
           */
          _nextSibling: function(dom) {
            dom = dom ? dom.nextSibling : null;
            while (dom !== null && dom.nodeType !== 1) {
              dom = dom.nextSibling;
            }
            return dom;
          },
          /**
           * gets the previous sibling of a DOM node. Used internally.
           * @private
           * @name _previousSibling(dom)
           * @param  {DOMElement} dom
           * @return {DOMElement}
           */
          _previousSibling: function(dom) {
            dom = dom ? dom.previousSibling : null;
            while (dom !== null && dom.nodeType !== 1) {
              dom = dom.previousSibling;
            }
            return dom;
          },
          /**
           * get the JSON representation of a node (or the actual jQuery extended DOM node) by using any input (child DOM element, ID string, selector, etc)
           * @name get_node(obj [, as_dom])
           * @param  {mixed} obj
           * @param  {Boolean} as_dom
           * @return {Object|jQuery}
           */
          get_node: function(obj, as_dom) {
            if (obj && obj.id) {
              obj = obj.id;
            }
            if (obj instanceof $2 && obj.length && obj[0].id) {
              obj = obj[0].id;
            }
            var dom;
            try {
              if (this._model.data[obj]) {
                obj = this._model.data[obj];
              } else if (typeof obj === "string" && this._model.data[obj.replace(/^#/, "")]) {
                obj = this._model.data[obj.replace(/^#/, "")];
              } else if (typeof obj === "string" && (dom = $2("#" + obj.replace($2.jstree.idregex, "\\$&"), this.element)).length && this._model.data[dom.closest(".jstree-node").attr("id")]) {
                obj = this._model.data[dom.closest(".jstree-node").attr("id")];
              } else if ((dom = this.element.find(obj)).length && this._model.data[dom.closest(".jstree-node").attr("id")]) {
                obj = this._model.data[dom.closest(".jstree-node").attr("id")];
              } else if ((dom = this.element.find(obj)).length && dom.hasClass("jstree")) {
                obj = this._model.data[$2.jstree.root];
              } else {
                return false;
              }
              if (as_dom) {
                obj = obj.id === $2.jstree.root ? this.element : $2("#" + obj.id.replace($2.jstree.idregex, "\\$&"), this.element);
              }
              return obj;
            } catch (ex) {
              return false;
            }
          },
          /**
           * get the path to a node, either consisting of node texts, or of node IDs, optionally glued together (otherwise an array)
           * @name get_path(obj [, glue, ids])
           * @param  {mixed} obj the node
           * @param  {String} glue if you want the path as a string - pass the glue here (for example '/'), if a falsy value is supplied here, an array is returned
           * @param  {Boolean} ids if set to true build the path using ID, otherwise node text is used
           * @return {mixed}
           */
          get_path: function(obj, glue, ids) {
            obj = obj.parents ? obj : this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root || !obj.parents) {
              return false;
            }
            var i, j, p = [];
            p.push(ids ? obj.id : obj.text);
            for (i = 0, j = obj.parents.length; i < j; i++) {
              p.push(ids ? obj.parents[i] : this.get_text(obj.parents[i]));
            }
            p = p.reverse().slice(1);
            return glue ? p.join(glue) : p;
          },
          /**
           * get the next visible node that is below the `obj` node. If `strict` is set to `true` only sibling nodes are returned.
           * @name get_next_dom(obj [, strict])
           * @param  {mixed} obj
           * @param  {Boolean} strict
           * @return {jQuery}
           */
          get_next_dom: function(obj, strict) {
            var tmp;
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) {
              tmp = this._firstChild(this.get_container_ul()[0]);
              while (tmp && tmp.offsetHeight === 0) {
                tmp = this._nextSibling(tmp);
              }
              return tmp ? $2(tmp) : false;
            }
            if (!obj || !obj.length) {
              return false;
            }
            if (strict) {
              tmp = obj[0];
              do {
                tmp = this._nextSibling(tmp);
              } while (tmp && tmp.offsetHeight === 0);
              return tmp ? $2(tmp) : false;
            }
            if (obj.hasClass("jstree-open")) {
              tmp = this._firstChild(obj.children(".jstree-children")[0]);
              while (tmp && tmp.offsetHeight === 0) {
                tmp = this._nextSibling(tmp);
              }
              if (tmp !== null) {
                return $2(tmp);
              }
            }
            tmp = obj[0];
            do {
              tmp = this._nextSibling(tmp);
            } while (tmp && tmp.offsetHeight === 0);
            if (tmp !== null) {
              return $2(tmp);
            }
            return obj.parentsUntil(".jstree", ".jstree-node").nextAll(".jstree-node:visible").first();
          },
          /**
           * get the previous visible node that is above the `obj` node. If `strict` is set to `true` only sibling nodes are returned.
           * @name get_prev_dom(obj [, strict])
           * @param  {mixed} obj
           * @param  {Boolean} strict
           * @return {jQuery}
           */
          get_prev_dom: function(obj, strict) {
            var tmp;
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) {
              tmp = this.get_container_ul()[0].lastChild;
              while (tmp && tmp.offsetHeight === 0) {
                tmp = this._previousSibling(tmp);
              }
              return tmp ? $2(tmp) : false;
            }
            if (!obj || !obj.length) {
              return false;
            }
            if (strict) {
              tmp = obj[0];
              do {
                tmp = this._previousSibling(tmp);
              } while (tmp && tmp.offsetHeight === 0);
              return tmp ? $2(tmp) : false;
            }
            tmp = obj[0];
            do {
              tmp = this._previousSibling(tmp);
            } while (tmp && tmp.offsetHeight === 0);
            if (tmp !== null) {
              obj = $2(tmp);
              while (obj.hasClass("jstree-open")) {
                obj = obj.children(".jstree-children").first().children(".jstree-node:visible:last");
              }
              return obj;
            }
            tmp = obj[0].parentNode.parentNode;
            return tmp && tmp.className && tmp.className.indexOf("jstree-node") !== -1 ? $2(tmp) : false;
          },
          /**
           * get the parent ID of a node
           * @name get_parent(obj)
           * @param  {mixed} obj
           * @return {String}
           */
          get_parent: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            return obj.parent;
          },
          /**
           * get a jQuery collection of all the children of a node (node must be rendered), returns false on error
           * @name get_children_dom(obj)
           * @param  {mixed} obj
           * @return {jQuery}
           */
          get_children_dom: function(obj) {
            obj = this.get_node(obj, true);
            if (obj[0] === this.element[0]) {
              return this.get_container_ul().children(".jstree-node");
            }
            if (!obj || !obj.length) {
              return false;
            }
            return obj.children(".jstree-children").children(".jstree-node");
          },
          /**
           * checks if a node has children
           * @name is_parent(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_parent: function(obj) {
            obj = this.get_node(obj);
            return obj && (obj.state.loaded === false || obj.children.length > 0);
          },
          /**
           * checks if a node is loaded (its children are available)
           * @name is_loaded(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_loaded: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state.loaded;
          },
          /**
           * check if a node is currently loading (fetching children)
           * @name is_loading(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_loading: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state && obj.state.loading;
          },
          /**
           * check if a node is opened
           * @name is_open(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_open: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state.opened;
          },
          /**
           * check if a node is in a closed state
           * @name is_closed(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_closed: function(obj) {
            obj = this.get_node(obj);
            return obj && this.is_parent(obj) && !obj.state.opened;
          },
          /**
           * check if a node has no children
           * @name is_leaf(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_leaf: function(obj) {
            return !this.is_parent(obj);
          },
          /**
           * loads a node (fetches its children using the `core.data` setting). Multiple nodes can be passed to by using an array.
           * @name load_node(obj [, callback])
           * @param  {mixed} obj
           * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives two arguments - the node and a boolean status
           * @return {Boolean}
           * @trigger load_node.jstree
           */
          load_node: function(obj, callback) {
            var k, l, i, j, c;
            if ($2.isArray(obj)) {
              this._load_nodes(obj.slice(), callback);
              return true;
            }
            obj = this.get_node(obj);
            if (!obj) {
              if (callback) {
                callback.call(this, obj, false);
              }
              return false;
            }
            if (obj.state.loaded) {
              obj.state.loaded = false;
              for (i = 0, j = obj.parents.length; i < j; i++) {
                this._model.data[obj.parents[i]].children_d = $2.vakata.array_filter(this._model.data[obj.parents[i]].children_d, function(v) {
                  return $2.inArray(v, obj.children_d) === -1;
                });
              }
              for (k = 0, l = obj.children_d.length; k < l; k++) {
                if (this._model.data[obj.children_d[k]].state.selected) {
                  c = true;
                }
                delete this._model.data[obj.children_d[k]];
              }
              if (c) {
                this._data.core.selected = $2.vakata.array_filter(this._data.core.selected, function(v) {
                  return $2.inArray(v, obj.children_d) === -1;
                });
              }
              obj.children = [];
              obj.children_d = [];
              if (c) {
                this.trigger("changed", { "action": "load_node", "node": obj, "selected": this._data.core.selected });
              }
            }
            obj.state.failed = false;
            obj.state.loading = true;
            this.get_node(obj, true).addClass("jstree-loading").attr("aria-busy", true);
            this._load_node(obj, $2.proxy(function(status) {
              obj = this._model.data[obj.id];
              obj.state.loading = false;
              obj.state.loaded = status;
              obj.state.failed = !obj.state.loaded;
              var dom = this.get_node(obj, true), i2 = 0, j2 = 0, m = this._model.data, has_children = false;
              for (i2 = 0, j2 = obj.children.length; i2 < j2; i2++) {
                if (m[obj.children[i2]] && !m[obj.children[i2]].state.hidden) {
                  has_children = true;
                  break;
                }
              }
              if (obj.state.loaded && dom && dom.length) {
                dom.removeClass("jstree-closed jstree-open jstree-leaf");
                if (!has_children) {
                  dom.addClass("jstree-leaf");
                } else {
                  if (obj.id !== "#") {
                    dom.addClass(obj.state.opened ? "jstree-open" : "jstree-closed");
                  }
                }
              }
              dom.removeClass("jstree-loading").attr("aria-busy", false);
              this.trigger("load_node", { "node": obj, "status": status });
              if (callback) {
                callback.call(this, obj, status);
              }
            }, this));
            return true;
          },
          /**
           * load an array of nodes (will also load unavailable nodes as soon as they appear in the structure). Used internally.
           * @private
           * @name _load_nodes(nodes [, callback])
           * @param  {array} nodes
           * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives one argument - the array passed to _load_nodes
           */
          _load_nodes: function(nodes, callback, is_callback, force_reload) {
            var r = true, c = function() {
              this._load_nodes(nodes, callback, true);
            }, m = this._model.data, i, j, tmp = [];
            for (i = 0, j = nodes.length; i < j; i++) {
              if (m[nodes[i]] && (!m[nodes[i]].state.loaded && !m[nodes[i]].state.failed || !is_callback && force_reload)) {
                if (!this.is_loading(nodes[i])) {
                  this.load_node(nodes[i], c);
                }
                r = false;
              }
            }
            if (r) {
              for (i = 0, j = nodes.length; i < j; i++) {
                if (m[nodes[i]] && m[nodes[i]].state.loaded) {
                  tmp.push(nodes[i]);
                }
              }
              if (callback && !callback.done) {
                callback.call(this, tmp);
                callback.done = true;
              }
            }
          },
          /**
           * loads all unloaded nodes
           * @name load_all([obj, callback])
           * @param {mixed} obj the node to load recursively, omit to load all nodes in the tree
           * @param {function} callback a function to be executed once loading all the nodes is complete,
           * @trigger load_all.jstree
           */
          load_all: function(obj, callback) {
            if (!obj) {
              obj = $2.jstree.root;
            }
            obj = this.get_node(obj);
            if (!obj) {
              return false;
            }
            var to_load = [], m = this._model.data, c = m[obj.id].children_d, i, j;
            if (obj.state && !obj.state.loaded) {
              to_load.push(obj.id);
            }
            for (i = 0, j = c.length; i < j; i++) {
              if (m[c[i]] && m[c[i]].state && !m[c[i]].state.loaded) {
                to_load.push(c[i]);
              }
            }
            if (to_load.length) {
              this._load_nodes(to_load, function() {
                this.load_all(obj, callback);
              });
            } else {
              if (callback) {
                callback.call(this, obj);
              }
              this.trigger("load_all", { "node": obj });
            }
          },
          /**
           * handles the actual loading of a node. Used only internally.
           * @private
           * @name _load_node(obj [, callback])
           * @param  {mixed} obj
           * @param  {function} callback a function to be executed once loading is complete, the function is executed in the instance's scope and receives one argument - a boolean status
           * @return {Boolean}
           */
          _load_node: function(obj, callback) {
            var s = this.settings.core.data, t;
            var notTextOrCommentNode = function notTextOrCommentNode2() {
              return this.nodeType !== 3 && this.nodeType !== 8;
            };
            if (!s) {
              if (obj.id === $2.jstree.root) {
                return this._append_html_data(obj, this._data.core.original_container_html.clone(true), function(status) {
                  callback.call(this, status);
                });
              } else {
                return callback.call(this, false);
              }
            }
            if ($2.isFunction(s)) {
              return s.call(this, obj, $2.proxy(function(d) {
                if (d === false) {
                  callback.call(this, false);
                } else {
                  this[typeof d === "string" ? "_append_html_data" : "_append_json_data"](obj, typeof d === "string" ? $2($2.parseHTML(d)).filter(notTextOrCommentNode) : d, function(status) {
                    callback.call(this, status);
                  });
                }
              }, this));
            }
            if (typeof s === "object") {
              if (s.url) {
                s = $2.extend(true, {}, s);
                if ($2.isFunction(s.url)) {
                  s.url = s.url.call(this, obj);
                }
                if ($2.isFunction(s.data)) {
                  s.data = s.data.call(this, obj);
                }
                return $2.ajax(s).done($2.proxy(function(d, t2, x) {
                  var type = x.getResponseHeader("Content-Type");
                  if (type && type.indexOf("json") !== -1 || typeof d === "object") {
                    return this._append_json_data(obj, d, function(status) {
                      callback.call(this, status);
                    });
                  }
                  if (type && type.indexOf("html") !== -1 || typeof d === "string") {
                    return this._append_html_data(obj, $2($2.parseHTML(d)).filter(notTextOrCommentNode), function(status) {
                      callback.call(this, status);
                    });
                  }
                  this._data.core.last_error = { "error": "ajax", "plugin": "core", "id": "core_04", "reason": "Could not load node", "data": JSON.stringify({ "id": obj.id, "xhr": x }) };
                  this.settings.core.error.call(this, this._data.core.last_error);
                  return callback.call(this, false);
                }, this)).fail($2.proxy(function(f) {
                  this._data.core.last_error = { "error": "ajax", "plugin": "core", "id": "core_04", "reason": "Could not load node", "data": JSON.stringify({ "id": obj.id, "xhr": f }) };
                  callback.call(this, false);
                  this.settings.core.error.call(this, this._data.core.last_error);
                }, this));
              }
              if ($2.isArray(s)) {
                t = $2.extend(true, [], s);
              } else if ($2.isPlainObject(s)) {
                t = $2.extend(true, {}, s);
              } else {
                t = s;
              }
              if (obj.id === $2.jstree.root) {
                return this._append_json_data(obj, t, function(status) {
                  callback.call(this, status);
                });
              } else {
                this._data.core.last_error = { "error": "nodata", "plugin": "core", "id": "core_05", "reason": "Could not load node", "data": JSON.stringify({ "id": obj.id }) };
                this.settings.core.error.call(this, this._data.core.last_error);
                return callback.call(this, false);
              }
            }
            if (typeof s === "string") {
              if (obj.id === $2.jstree.root) {
                return this._append_html_data(obj, $2($2.parseHTML(s)).filter(notTextOrCommentNode), function(status) {
                  callback.call(this, status);
                });
              } else {
                this._data.core.last_error = { "error": "nodata", "plugin": "core", "id": "core_06", "reason": "Could not load node", "data": JSON.stringify({ "id": obj.id }) };
                this.settings.core.error.call(this, this._data.core.last_error);
                return callback.call(this, false);
              }
            }
            return callback.call(this, false);
          },
          /**
           * adds a node to the list of nodes to redraw. Used only internally.
           * @private
           * @name _node_changed(obj [, callback])
           * @param  {mixed} obj
           */
          _node_changed: function(obj) {
            obj = this.get_node(obj);
            if (obj && $2.inArray(obj.id, this._model.changed) === -1) {
              this._model.changed.push(obj.id);
            }
          },
          /**
           * appends HTML content to the tree. Used internally.
           * @private
           * @name _append_html_data(obj, data)
           * @param  {mixed} obj the node to append to
           * @param  {String} data the HTML string to parse and append
           * @trigger model.jstree, changed.jstree
           */
          _append_html_data: function(dom, data, cb) {
            dom = this.get_node(dom);
            dom.children = [];
            dom.children_d = [];
            var dat = data.is("ul") ? data.children() : data, par = dom.id, chd = [], dpc = [], m = this._model.data, p = m[par], s = this._data.core.selected.length, tmp, i, j;
            dat.each($2.proxy(function(i2, v) {
              tmp = this._parse_model_from_html($2(v), par, p.parents.concat());
              if (tmp) {
                chd.push(tmp);
                dpc.push(tmp);
                if (m[tmp].children_d.length) {
                  dpc = dpc.concat(m[tmp].children_d);
                }
              }
            }, this));
            p.children = chd;
            p.children_d = dpc;
            for (i = 0, j = p.parents.length; i < j; i++) {
              m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
            }
            this.trigger("model", { "nodes": dpc, "parent": par });
            if (par !== $2.jstree.root) {
              this._node_changed(par);
              this.redraw();
            } else {
              this.get_container_ul().children(".jstree-initial-node").remove();
              this.redraw(true);
            }
            if (this._data.core.selected.length !== s) {
              this.trigger("changed", { "action": "model", "selected": this._data.core.selected });
            }
            cb.call(this, true);
          },
          /**
           * appends JSON content to the tree. Used internally.
           * @private
           * @name _append_json_data(obj, data)
           * @param  {mixed} obj the node to append to
           * @param  {String} data the JSON object to parse and append
           * @param  {Boolean} force_processing internal param - do not set
           * @trigger model.jstree, changed.jstree
           */
          _append_json_data: function(dom, data, cb, force_processing) {
            if (this.element === null) {
              return;
            }
            dom = this.get_node(dom);
            dom.children = [];
            dom.children_d = [];
            if (data.d) {
              data = data.d;
              if (typeof data === "string") {
                data = JSON.parse(data);
              }
            }
            if (!$2.isArray(data)) {
              data = [data];
            }
            var w = null, args = {
              "df": this._model.default_state,
              "dat": data,
              "par": dom.id,
              "m": this._model.data,
              "t_id": this._id,
              "t_cnt": this._cnt,
              "sel": this._data.core.selected
            }, inst = this, func = function(data2, undefined3) {
              if (data2.data) {
                data2 = data2.data;
              }
              var dat = data2.dat, par = data2.par, chd = [], dpc = [], add = [], df = data2.df, t_id = data2.t_id, t_cnt = data2.t_cnt, m = data2.m, p = m[par], sel = data2.sel, tmp, i, j, rslt2, parse_flat = function(d, p2, ps) {
                if (!ps) {
                  ps = [];
                } else {
                  ps = ps.concat();
                }
                if (p2) {
                  ps.unshift(p2);
                }
                var tid = d.id.toString(), i2, j2, c, e, tmp2 = {
                  id: tid,
                  text: d.text || "",
                  icon: d.icon !== undefined3 ? d.icon : true,
                  parent: p2,
                  parents: ps,
                  children: d.children || [],
                  children_d: d.children_d || [],
                  data: d.data,
                  state: {},
                  li_attr: { id: false },
                  a_attr: { href: "#" },
                  original: false
                };
                for (i2 in df) {
                  if (df.hasOwnProperty(i2)) {
                    tmp2.state[i2] = df[i2];
                  }
                }
                if (d && d.data && d.data.jstree && d.data.jstree.icon) {
                  tmp2.icon = d.data.jstree.icon;
                }
                if (tmp2.icon === undefined3 || tmp2.icon === null || tmp2.icon === "") {
                  tmp2.icon = true;
                }
                if (d && d.data) {
                  tmp2.data = d.data;
                  if (d.data.jstree) {
                    for (i2 in d.data.jstree) {
                      if (d.data.jstree.hasOwnProperty(i2)) {
                        tmp2.state[i2] = d.data.jstree[i2];
                      }
                    }
                  }
                }
                if (d && typeof d.state === "object") {
                  for (i2 in d.state) {
                    if (d.state.hasOwnProperty(i2)) {
                      tmp2.state[i2] = d.state[i2];
                    }
                  }
                }
                if (d && typeof d.li_attr === "object") {
                  for (i2 in d.li_attr) {
                    if (d.li_attr.hasOwnProperty(i2)) {
                      tmp2.li_attr[i2] = d.li_attr[i2];
                    }
                  }
                }
                if (!tmp2.li_attr.id) {
                  tmp2.li_attr.id = tid;
                }
                if (d && typeof d.a_attr === "object") {
                  for (i2 in d.a_attr) {
                    if (d.a_attr.hasOwnProperty(i2)) {
                      tmp2.a_attr[i2] = d.a_attr[i2];
                    }
                  }
                }
                if (d && d.children && d.children === true) {
                  tmp2.state.loaded = false;
                  tmp2.children = [];
                  tmp2.children_d = [];
                }
                m[tmp2.id] = tmp2;
                for (i2 = 0, j2 = tmp2.children.length; i2 < j2; i2++) {
                  c = parse_flat(m[tmp2.children[i2]], tmp2.id, ps);
                  e = m[c];
                  tmp2.children_d.push(c);
                  if (e.children_d.length) {
                    tmp2.children_d = tmp2.children_d.concat(e.children_d);
                  }
                }
                delete d.data;
                delete d.children;
                m[tmp2.id].original = d;
                if (tmp2.state.selected) {
                  add.push(tmp2.id);
                }
                return tmp2.id;
              }, parse_nest = function(d, p2, ps) {
                if (!ps) {
                  ps = [];
                } else {
                  ps = ps.concat();
                }
                if (p2) {
                  ps.unshift(p2);
                }
                var tid = false, i2, j2, c, e, tmp2;
                do {
                  tid = "j" + t_id + "_" + ++t_cnt;
                } while (m[tid]);
                tmp2 = {
                  id: false,
                  text: typeof d === "string" ? d : "",
                  icon: typeof d === "object" && d.icon !== undefined3 ? d.icon : true,
                  parent: p2,
                  parents: ps,
                  children: [],
                  children_d: [],
                  data: null,
                  state: {},
                  li_attr: { id: false },
                  a_attr: { href: "#" },
                  original: false
                };
                for (i2 in df) {
                  if (df.hasOwnProperty(i2)) {
                    tmp2.state[i2] = df[i2];
                  }
                }
                if (d && d.id) {
                  tmp2.id = d.id.toString();
                }
                if (d && d.text) {
                  tmp2.text = d.text;
                }
                if (d && d.data && d.data.jstree && d.data.jstree.icon) {
                  tmp2.icon = d.data.jstree.icon;
                }
                if (tmp2.icon === undefined3 || tmp2.icon === null || tmp2.icon === "") {
                  tmp2.icon = true;
                }
                if (d && d.data) {
                  tmp2.data = d.data;
                  if (d.data.jstree) {
                    for (i2 in d.data.jstree) {
                      if (d.data.jstree.hasOwnProperty(i2)) {
                        tmp2.state[i2] = d.data.jstree[i2];
                      }
                    }
                  }
                }
                if (d && typeof d.state === "object") {
                  for (i2 in d.state) {
                    if (d.state.hasOwnProperty(i2)) {
                      tmp2.state[i2] = d.state[i2];
                    }
                  }
                }
                if (d && typeof d.li_attr === "object") {
                  for (i2 in d.li_attr) {
                    if (d.li_attr.hasOwnProperty(i2)) {
                      tmp2.li_attr[i2] = d.li_attr[i2];
                    }
                  }
                }
                if (tmp2.li_attr.id && !tmp2.id) {
                  tmp2.id = tmp2.li_attr.id.toString();
                }
                if (!tmp2.id) {
                  tmp2.id = tid;
                }
                if (!tmp2.li_attr.id) {
                  tmp2.li_attr.id = tmp2.id;
                }
                if (d && typeof d.a_attr === "object") {
                  for (i2 in d.a_attr) {
                    if (d.a_attr.hasOwnProperty(i2)) {
                      tmp2.a_attr[i2] = d.a_attr[i2];
                    }
                  }
                }
                if (d && d.children && d.children.length) {
                  for (i2 = 0, j2 = d.children.length; i2 < j2; i2++) {
                    c = parse_nest(d.children[i2], tmp2.id, ps);
                    e = m[c];
                    tmp2.children.push(c);
                    if (e.children_d.length) {
                      tmp2.children_d = tmp2.children_d.concat(e.children_d);
                    }
                  }
                  tmp2.children_d = tmp2.children_d.concat(tmp2.children);
                }
                if (d && d.children && d.children === true) {
                  tmp2.state.loaded = false;
                  tmp2.children = [];
                  tmp2.children_d = [];
                }
                delete d.data;
                delete d.children;
                tmp2.original = d;
                m[tmp2.id] = tmp2;
                if (tmp2.state.selected) {
                  add.push(tmp2.id);
                }
                return tmp2.id;
              };
              if (dat.length && dat[0].id !== undefined3 && dat[0].parent !== undefined3) {
                for (i = 0, j = dat.length; i < j; i++) {
                  if (!dat[i].children) {
                    dat[i].children = [];
                  }
                  if (!dat[i].state) {
                    dat[i].state = {};
                  }
                  m[dat[i].id.toString()] = dat[i];
                }
                for (i = 0, j = dat.length; i < j; i++) {
                  if (!m[dat[i].parent.toString()]) {
                    if (typeof inst !== "undefined") {
                      inst._data.core.last_error = { "error": "parse", "plugin": "core", "id": "core_07", "reason": "Node with invalid parent", "data": JSON.stringify({ "id": dat[i].id.toString(), "parent": dat[i].parent.toString() }) };
                      inst.settings.core.error.call(inst, inst._data.core.last_error);
                    }
                    continue;
                  }
                  m[dat[i].parent.toString()].children.push(dat[i].id.toString());
                  p.children_d.push(dat[i].id.toString());
                }
                for (i = 0, j = p.children.length; i < j; i++) {
                  tmp = parse_flat(m[p.children[i]], par, p.parents.concat());
                  dpc.push(tmp);
                  if (m[tmp].children_d.length) {
                    dpc = dpc.concat(m[tmp].children_d);
                  }
                }
                for (i = 0, j = p.parents.length; i < j; i++) {
                  m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
                }
                rslt2 = {
                  "cnt": t_cnt,
                  "mod": m,
                  "sel": sel,
                  "par": par,
                  "dpc": dpc,
                  "add": add
                };
              } else {
                for (i = 0, j = dat.length; i < j; i++) {
                  tmp = parse_nest(dat[i], par, p.parents.concat());
                  if (tmp) {
                    chd.push(tmp);
                    dpc.push(tmp);
                    if (m[tmp].children_d.length) {
                      dpc = dpc.concat(m[tmp].children_d);
                    }
                  }
                }
                p.children = chd;
                p.children_d = dpc;
                for (i = 0, j = p.parents.length; i < j; i++) {
                  m[p.parents[i]].children_d = m[p.parents[i]].children_d.concat(dpc);
                }
                rslt2 = {
                  "cnt": t_cnt,
                  "mod": m,
                  "sel": sel,
                  "par": par,
                  "dpc": dpc,
                  "add": add
                };
              }
              if (typeof window === "undefined" || typeof window.document === "undefined") {
                postMessage(rslt2);
              } else {
                return rslt2;
              }
            }, rslt = function(rslt2, worker) {
              if (this.element === null) {
                return;
              }
              this._cnt = rslt2.cnt;
              var i, m = this._model.data;
              for (i in m) {
                if (m.hasOwnProperty(i) && m[i].state && m[i].state.loading && rslt2.mod[i]) {
                  rslt2.mod[i].state.loading = true;
                }
              }
              this._model.data = rslt2.mod;
              if (worker) {
                var j, a = rslt2.add, r = rslt2.sel, s = this._data.core.selected.slice();
                m = this._model.data;
                if (r.length !== s.length || $2.vakata.array_unique(r.concat(s)).length !== r.length) {
                  for (i = 0, j = r.length; i < j; i++) {
                    if ($2.inArray(r[i], a) === -1 && $2.inArray(r[i], s) === -1) {
                      m[r[i]].state.selected = false;
                    }
                  }
                  for (i = 0, j = s.length; i < j; i++) {
                    if ($2.inArray(s[i], r) === -1) {
                      m[s[i]].state.selected = true;
                    }
                  }
                }
              }
              if (rslt2.add.length) {
                this._data.core.selected = this._data.core.selected.concat(rslt2.add);
              }
              this.trigger("model", { "nodes": rslt2.dpc, "parent": rslt2.par });
              if (rslt2.par !== $2.jstree.root) {
                this._node_changed(rslt2.par);
                this.redraw();
              } else {
                this.redraw(true);
              }
              if (rslt2.add.length) {
                this.trigger("changed", { "action": "model", "selected": this._data.core.selected });
              }
              if (!worker && setImmediate) {
                setImmediate(function() {
                  cb.call(inst, true);
                });
              } else {
                cb.call(inst, true);
              }
            };
            if (this.settings.core.worker && window.Blob && window.URL && window.Worker) {
              try {
                if (this._wrk === null) {
                  this._wrk = window.URL.createObjectURL(
                    new window.Blob(
                      ["self.onmessage = " + func.toString()],
                      { type: "text/javascript" }
                    )
                  );
                }
                if (!this._data.core.working || force_processing) {
                  this._data.core.working = true;
                  w = new window.Worker(this._wrk);
                  w.onmessage = $2.proxy(function(e) {
                    rslt.call(this, e.data, true);
                    try {
                      w.terminate();
                      w = null;
                    } catch (ignore) {
                    }
                    if (this._data.core.worker_queue.length) {
                      this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                    } else {
                      this._data.core.working = false;
                    }
                  }, this);
                  if (!args.par) {
                    if (this._data.core.worker_queue.length) {
                      this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                    } else {
                      this._data.core.working = false;
                    }
                  } else {
                    w.postMessage(args);
                  }
                } else {
                  this._data.core.worker_queue.push([dom, data, cb, true]);
                }
              } catch (e) {
                rslt.call(this, func(args), false);
                if (this._data.core.worker_queue.length) {
                  this._append_json_data.apply(this, this._data.core.worker_queue.shift());
                } else {
                  this._data.core.working = false;
                }
              }
            } else {
              rslt.call(this, func(args), false);
            }
          },
          /**
           * parses a node from a jQuery object and appends them to the in memory tree model. Used internally.
           * @private
           * @name _parse_model_from_html(d [, p, ps])
           * @param  {jQuery} d the jQuery object to parse
           * @param  {String} p the parent ID
           * @param  {Array} ps list of all parents
           * @return {String} the ID of the object added to the model
           */
          _parse_model_from_html: function(d, p, ps) {
            if (!ps) {
              ps = [];
            } else {
              ps = [].concat(ps);
            }
            if (p) {
              ps.unshift(p);
            }
            var c, e, m = this._model.data, data = {
              id: false,
              text: false,
              icon: true,
              parent: p,
              parents: ps,
              children: [],
              children_d: [],
              data: null,
              state: {},
              li_attr: { id: false },
              a_attr: { href: "#" },
              original: false
            }, i, tmp, tid;
            for (i in this._model.default_state) {
              if (this._model.default_state.hasOwnProperty(i)) {
                data.state[i] = this._model.default_state[i];
              }
            }
            tmp = $2.vakata.attributes(d, true);
            $2.each(tmp, function(i2, v) {
              v = $2.trim(v);
              if (!v.length) {
                return true;
              }
              data.li_attr[i2] = v;
              if (i2 === "id") {
                data.id = v.toString();
              }
            });
            tmp = d.children("a").first();
            if (tmp.length) {
              tmp = $2.vakata.attributes(tmp, true);
              $2.each(tmp, function(i2, v) {
                v = $2.trim(v);
                if (v.length) {
                  data.a_attr[i2] = v;
                }
              });
            }
            tmp = d.children("a").first().length ? d.children("a").first().clone() : d.clone();
            tmp.children("ins, i, ul").remove();
            tmp = tmp.html();
            tmp = $2("<div></div>").html(tmp);
            data.text = this.settings.core.force_text ? tmp.text() : tmp.html();
            tmp = d.data();
            data.data = tmp ? $2.extend(true, {}, tmp) : null;
            data.state.opened = d.hasClass("jstree-open");
            data.state.selected = d.children("a").hasClass("jstree-clicked");
            data.state.disabled = d.children("a").hasClass("jstree-disabled");
            if (data.data && data.data.jstree) {
              for (i in data.data.jstree) {
                if (data.data.jstree.hasOwnProperty(i)) {
                  data.state[i] = data.data.jstree[i];
                }
              }
            }
            tmp = d.children("a").children(".jstree-themeicon");
            if (tmp.length) {
              data.icon = tmp.hasClass("jstree-themeicon-hidden") ? false : tmp.attr("rel");
            }
            if (data.state.icon !== undefined2) {
              data.icon = data.state.icon;
            }
            if (data.icon === undefined2 || data.icon === null || data.icon === "") {
              data.icon = true;
            }
            tmp = d.children("ul").children("li");
            do {
              tid = "j" + this._id + "_" + ++this._cnt;
            } while (m[tid]);
            data.id = data.li_attr.id ? data.li_attr.id.toString() : tid;
            if (tmp.length) {
              tmp.each($2.proxy(function(i2, v) {
                c = this._parse_model_from_html($2(v), data.id, ps);
                e = this._model.data[c];
                data.children.push(c);
                if (e.children_d.length) {
                  data.children_d = data.children_d.concat(e.children_d);
                }
              }, this));
              data.children_d = data.children_d.concat(data.children);
            } else {
              if (d.hasClass("jstree-closed")) {
                data.state.loaded = false;
              }
            }
            if (data.li_attr["class"]) {
              data.li_attr["class"] = data.li_attr["class"].replace("jstree-closed", "").replace("jstree-open", "");
            }
            if (data.a_attr["class"]) {
              data.a_attr["class"] = data.a_attr["class"].replace("jstree-clicked", "").replace("jstree-disabled", "");
            }
            m[data.id] = data;
            if (data.state.selected) {
              this._data.core.selected.push(data.id);
            }
            return data.id;
          },
          /**
           * parses a node from a JSON object (used when dealing with flat data, which has no nesting of children, but has id and parent properties) and appends it to the in memory tree model. Used internally.
           * @private
           * @name _parse_model_from_flat_json(d [, p, ps])
           * @param  {Object} d the JSON object to parse
           * @param  {String} p the parent ID
           * @param  {Array} ps list of all parents
           * @return {String} the ID of the object added to the model
           */
          _parse_model_from_flat_json: function(d, p, ps) {
            if (!ps) {
              ps = [];
            } else {
              ps = ps.concat();
            }
            if (p) {
              ps.unshift(p);
            }
            var tid = d.id.toString(), m = this._model.data, df = this._model.default_state, i, j, c, e, tmp = {
              id: tid,
              text: d.text || "",
              icon: d.icon !== undefined2 ? d.icon : true,
              parent: p,
              parents: ps,
              children: d.children || [],
              children_d: d.children_d || [],
              data: d.data,
              state: {},
              li_attr: { id: false },
              a_attr: { href: "#" },
              original: false
            };
            for (i in df) {
              if (df.hasOwnProperty(i)) {
                tmp.state[i] = df[i];
              }
            }
            if (d && d.data && d.data.jstree && d.data.jstree.icon) {
              tmp.icon = d.data.jstree.icon;
            }
            if (tmp.icon === undefined2 || tmp.icon === null || tmp.icon === "") {
              tmp.icon = true;
            }
            if (d && d.data) {
              tmp.data = d.data;
              if (d.data.jstree) {
                for (i in d.data.jstree) {
                  if (d.data.jstree.hasOwnProperty(i)) {
                    tmp.state[i] = d.data.jstree[i];
                  }
                }
              }
            }
            if (d && typeof d.state === "object") {
              for (i in d.state) {
                if (d.state.hasOwnProperty(i)) {
                  tmp.state[i] = d.state[i];
                }
              }
            }
            if (d && typeof d.li_attr === "object") {
              for (i in d.li_attr) {
                if (d.li_attr.hasOwnProperty(i)) {
                  tmp.li_attr[i] = d.li_attr[i];
                }
              }
            }
            if (!tmp.li_attr.id) {
              tmp.li_attr.id = tid;
            }
            if (d && typeof d.a_attr === "object") {
              for (i in d.a_attr) {
                if (d.a_attr.hasOwnProperty(i)) {
                  tmp.a_attr[i] = d.a_attr[i];
                }
              }
            }
            if (d && d.children && d.children === true) {
              tmp.state.loaded = false;
              tmp.children = [];
              tmp.children_d = [];
            }
            m[tmp.id] = tmp;
            for (i = 0, j = tmp.children.length; i < j; i++) {
              c = this._parse_model_from_flat_json(m[tmp.children[i]], tmp.id, ps);
              e = m[c];
              tmp.children_d.push(c);
              if (e.children_d.length) {
                tmp.children_d = tmp.children_d.concat(e.children_d);
              }
            }
            delete d.data;
            delete d.children;
            m[tmp.id].original = d;
            if (tmp.state.selected) {
              this._data.core.selected.push(tmp.id);
            }
            return tmp.id;
          },
          /**
           * parses a node from a JSON object and appends it to the in memory tree model. Used internally.
           * @private
           * @name _parse_model_from_json(d [, p, ps])
           * @param  {Object} d the JSON object to parse
           * @param  {String} p the parent ID
           * @param  {Array} ps list of all parents
           * @return {String} the ID of the object added to the model
           */
          _parse_model_from_json: function(d, p, ps) {
            if (!ps) {
              ps = [];
            } else {
              ps = ps.concat();
            }
            if (p) {
              ps.unshift(p);
            }
            var tid = false, i, j, c, e, m = this._model.data, df = this._model.default_state, tmp;
            do {
              tid = "j" + this._id + "_" + ++this._cnt;
            } while (m[tid]);
            tmp = {
              id: false,
              text: typeof d === "string" ? d : "",
              icon: typeof d === "object" && d.icon !== undefined2 ? d.icon : true,
              parent: p,
              parents: ps,
              children: [],
              children_d: [],
              data: null,
              state: {},
              li_attr: { id: false },
              a_attr: { href: "#" },
              original: false
            };
            for (i in df) {
              if (df.hasOwnProperty(i)) {
                tmp.state[i] = df[i];
              }
            }
            if (d && d.id) {
              tmp.id = d.id.toString();
            }
            if (d && d.text) {
              tmp.text = d.text;
            }
            if (d && d.data && d.data.jstree && d.data.jstree.icon) {
              tmp.icon = d.data.jstree.icon;
            }
            if (tmp.icon === undefined2 || tmp.icon === null || tmp.icon === "") {
              tmp.icon = true;
            }
            if (d && d.data) {
              tmp.data = d.data;
              if (d.data.jstree) {
                for (i in d.data.jstree) {
                  if (d.data.jstree.hasOwnProperty(i)) {
                    tmp.state[i] = d.data.jstree[i];
                  }
                }
              }
            }
            if (d && typeof d.state === "object") {
              for (i in d.state) {
                if (d.state.hasOwnProperty(i)) {
                  tmp.state[i] = d.state[i];
                }
              }
            }
            if (d && typeof d.li_attr === "object") {
              for (i in d.li_attr) {
                if (d.li_attr.hasOwnProperty(i)) {
                  tmp.li_attr[i] = d.li_attr[i];
                }
              }
            }
            if (tmp.li_attr.id && !tmp.id) {
              tmp.id = tmp.li_attr.id.toString();
            }
            if (!tmp.id) {
              tmp.id = tid;
            }
            if (!tmp.li_attr.id) {
              tmp.li_attr.id = tmp.id;
            }
            if (d && typeof d.a_attr === "object") {
              for (i in d.a_attr) {
                if (d.a_attr.hasOwnProperty(i)) {
                  tmp.a_attr[i] = d.a_attr[i];
                }
              }
            }
            if (d && d.children && d.children.length) {
              for (i = 0, j = d.children.length; i < j; i++) {
                c = this._parse_model_from_json(d.children[i], tmp.id, ps);
                e = m[c];
                tmp.children.push(c);
                if (e.children_d.length) {
                  tmp.children_d = tmp.children_d.concat(e.children_d);
                }
              }
              tmp.children_d = tmp.children.concat(tmp.children_d);
            }
            if (d && d.children && d.children === true) {
              tmp.state.loaded = false;
              tmp.children = [];
              tmp.children_d = [];
            }
            delete d.data;
            delete d.children;
            tmp.original = d;
            m[tmp.id] = tmp;
            if (tmp.state.selected) {
              this._data.core.selected.push(tmp.id);
            }
            return tmp.id;
          },
          /**
           * redraws all nodes that need to be redrawn. Used internally.
           * @private
           * @name _redraw()
           * @trigger redraw.jstree
           */
          _redraw: function() {
            var nodes = this._model.force_full_redraw ? this._model.data[$2.jstree.root].children.concat([]) : this._model.changed.concat([]), f = document2.createElement("UL"), tmp, i, j, fe = this._data.core.focused;
            for (i = 0, j = nodes.length; i < j; i++) {
              tmp = this.redraw_node(nodes[i], true, this._model.force_full_redraw);
              if (tmp && this._model.force_full_redraw) {
                f.appendChild(tmp);
              }
            }
            if (this._model.force_full_redraw) {
              f.className = this.get_container_ul()[0].className;
              f.setAttribute("role", "group");
              this.element.empty().append(f);
            }
            if (fe !== null && this.settings.core.restore_focus) {
              tmp = this.get_node(fe, true);
              if (tmp && tmp.length && tmp.children(".jstree-anchor")[0] !== document2.activeElement) {
                tmp.children(".jstree-anchor").focus();
              } else {
                this._data.core.focused = null;
              }
            }
            this._model.force_full_redraw = false;
            this._model.changed = [];
            this.trigger("redraw", { "nodes": nodes });
          },
          /**
           * redraws all nodes that need to be redrawn or optionally - the whole tree
           * @name redraw([full])
           * @param {Boolean} full if set to `true` all nodes are redrawn.
           */
          redraw: function(full) {
            if (full) {
              this._model.force_full_redraw = true;
            }
            this._redraw();
          },
          /**
           * redraws a single node's children. Used internally.
           * @private
           * @name draw_children(node)
           * @param {mixed} node the node whose children will be redrawn
           */
          draw_children: function(node) {
            var obj = this.get_node(node), i = false, j = false, k = false, d = document2;
            if (!obj) {
              return false;
            }
            if (obj.id === $2.jstree.root) {
              return this.redraw(true);
            }
            node = this.get_node(node, true);
            if (!node || !node.length) {
              return false;
            }
            node.children(".jstree-children").remove();
            node = node[0];
            if (obj.children.length && obj.state.loaded) {
              k = d.createElement("UL");
              k.setAttribute("role", "group");
              k.className = "jstree-children";
              for (i = 0, j = obj.children.length; i < j; i++) {
                k.appendChild(this.redraw_node(obj.children[i], true, true));
              }
              node.appendChild(k);
            }
          },
          /**
           * redraws a single node. Used internally.
           * @private
           * @name redraw_node(node, deep, is_callback, force_render)
           * @param {mixed} node the node to redraw
           * @param {Boolean} deep should child nodes be redrawn too
           * @param {Boolean} is_callback is this a recursion call
           * @param {Boolean} force_render should children of closed parents be drawn anyway
           */
          redraw_node: function(node, deep, is_callback, force_render) {
            var obj = this.get_node(node), par = false, ind = false, old = false, i = false, j = false, k = false, c = "", d = document2, m = this._model.data, f = false, s = false, tmp = null, t = 0, l = 0, has_children = false, last_sibling = false;
            if (!obj) {
              return false;
            }
            if (obj.id === $2.jstree.root) {
              return this.redraw(true);
            }
            deep = deep || obj.children.length === 0;
            node = !document2.querySelector ? document2.getElementById(obj.id) : this.element[0].querySelector("#" + ("0123456789".indexOf(obj.id[0]) !== -1 ? "\\3" + obj.id[0] + " " + obj.id.substr(1).replace($2.jstree.idregex, "\\$&") : obj.id.replace($2.jstree.idregex, "\\$&")));
            if (!node) {
              deep = true;
              if (!is_callback) {
                par = obj.parent !== $2.jstree.root ? $2("#" + obj.parent.replace($2.jstree.idregex, "\\$&"), this.element)[0] : null;
                if (par !== null && (!par || !m[obj.parent].state.opened)) {
                  return false;
                }
                ind = $2.inArray(obj.id, par === null ? m[$2.jstree.root].children : m[obj.parent].children);
              }
            } else {
              node = $2(node);
              if (!is_callback) {
                par = node.parent().parent()[0];
                if (par === this.element[0]) {
                  par = null;
                }
                ind = node.index();
              }
              if (!deep && obj.children.length && !node.children(".jstree-children").length) {
                deep = true;
              }
              if (!deep) {
                old = node.children(".jstree-children")[0];
              }
              f = node.children(".jstree-anchor")[0] === document2.activeElement;
              node.remove();
            }
            node = this._data.core.node.cloneNode(true);
            c = "jstree-node ";
            for (i in obj.li_attr) {
              if (obj.li_attr.hasOwnProperty(i)) {
                if (i === "id") {
                  continue;
                }
                if (i !== "class") {
                  node.setAttribute(i, obj.li_attr[i]);
                } else {
                  c += obj.li_attr[i];
                }
              }
            }
            if (!obj.a_attr.id) {
              obj.a_attr.id = obj.id + "_anchor";
            }
            node.setAttribute("aria-selected", !!obj.state.selected);
            node.childNodes[1].setAttribute("aria-selected", !!obj.state.selected);
            node.setAttribute("aria-level", obj.parents.length);
            node.childNodes[1].setAttribute("aria-level", obj.parents.length);
            node.setAttribute("aria-labelledby", obj.a_attr.id);
            if (obj.state.disabled) {
              node.setAttribute("aria-disabled", true);
              node.childNodes[1].setAttribute("aria-disabled", true);
            }
            for (i = 0, j = obj.children.length; i < j; i++) {
              if (!m[obj.children[i]].state.hidden) {
                has_children = true;
                break;
              }
            }
            if (obj.parent !== null && m[obj.parent] && !obj.state.hidden) {
              i = $2.inArray(obj.id, m[obj.parent].children);
              last_sibling = obj.id;
              if (i !== -1) {
                i++;
                for (j = m[obj.parent].children.length; i < j; i++) {
                  if (!m[m[obj.parent].children[i]].state.hidden) {
                    last_sibling = m[obj.parent].children[i];
                  }
                  if (last_sibling !== obj.id) {
                    break;
                  }
                }
              }
            }
            if (obj.state.hidden) {
              c += " jstree-hidden";
            }
            if (obj.state.loading) {
              c += " jstree-loading";
            }
            if (obj.state.loaded && !has_children) {
              c += " jstree-leaf";
            } else {
              c += obj.state.opened && obj.state.loaded ? " jstree-open" : " jstree-closed";
              node.setAttribute("aria-expanded", obj.state.opened && obj.state.loaded);
              node.childNodes[1].setAttribute("aria-expanded", obj.state.opened && obj.state.loaded);
            }
            if (last_sibling === obj.id) {
              c += " jstree-last";
            }
            node.id = obj.id;
            node.className = c;
            c = (obj.state.selected ? " jstree-clicked" : "") + (obj.state.disabled ? " jstree-disabled" : "");
            for (j in obj.a_attr) {
              if (obj.a_attr.hasOwnProperty(j)) {
                if (j === "href" && obj.a_attr[j] === "#") {
                  continue;
                }
                if (j !== "class") {
                  node.childNodes[1].setAttribute(j, obj.a_attr[j]);
                } else {
                  c += " " + obj.a_attr[j];
                }
              }
            }
            if (c.length) {
              node.childNodes[1].className = "jstree-anchor " + c;
            }
            if (obj.icon && obj.icon !== true || obj.icon === false) {
              if (obj.icon === false) {
                node.childNodes[1].childNodes[0].className += " jstree-themeicon-hidden";
              } else if (obj.icon.indexOf("/") === -1 && obj.icon.indexOf(".") === -1) {
                node.childNodes[1].childNodes[0].className += " " + obj.icon + " jstree-themeicon-custom";
              } else {
                node.childNodes[1].childNodes[0].style.backgroundImage = 'url("' + obj.icon + '")';
                node.childNodes[1].childNodes[0].style.backgroundPosition = "center center";
                node.childNodes[1].childNodes[0].style.backgroundSize = "auto";
                node.childNodes[1].childNodes[0].className += " jstree-themeicon-custom";
              }
            }
            if (this.settings.core.force_text) {
              node.childNodes[1].appendChild(d.createTextNode(obj.text));
            } else {
              node.childNodes[1].innerHTML += obj.text;
            }
            if (deep && obj.children.length && (obj.state.opened || force_render) && obj.state.loaded) {
              k = d.createElement("UL");
              k.setAttribute("role", "group");
              k.className = "jstree-children";
              for (i = 0, j = obj.children.length; i < j; i++) {
                k.appendChild(this.redraw_node(obj.children[i], deep, true));
              }
              node.appendChild(k);
            }
            if (old) {
              node.appendChild(old);
            }
            if (!is_callback) {
              if (!par) {
                par = this.element[0];
              }
              for (i = 0, j = par.childNodes.length; i < j; i++) {
                if (par.childNodes[i] && par.childNodes[i].className && par.childNodes[i].className.indexOf("jstree-children") !== -1) {
                  tmp = par.childNodes[i];
                  break;
                }
              }
              if (!tmp) {
                tmp = d.createElement("UL");
                tmp.setAttribute("role", "group");
                tmp.className = "jstree-children";
                par.appendChild(tmp);
              }
              par = tmp;
              if (ind < par.childNodes.length) {
                par.insertBefore(node, par.childNodes[ind]);
              } else {
                par.appendChild(node);
              }
              if (f) {
                t = this.element[0].scrollTop;
                l = this.element[0].scrollLeft;
                node.childNodes[1].focus();
                this.element[0].scrollTop = t;
                this.element[0].scrollLeft = l;
              }
            }
            if (obj.state.opened && !obj.state.loaded) {
              obj.state.opened = false;
              setTimeout($2.proxy(function() {
                this.open_node(obj.id, false, 0);
              }, this), 0);
            }
            return node;
          },
          /**
           * opens a node, revealing its children. If the node is not loaded it will be loaded and opened once ready.
           * @name open_node(obj [, callback, animation])
           * @param {mixed} obj the node to open
           * @param {Function} callback a function to execute once the node is opened
           * @param {Number} animation the animation duration in milliseconds when opening the node (overrides the `core.animation` setting). Use `false` for no animation.
           * @trigger open_node.jstree, after_open.jstree, before_open.jstree
           */
          open_node: function(obj, callback, animation) {
            var t1, t2, d, t;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.open_node(obj[t1], callback, animation);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            animation = animation === undefined2 ? this.settings.core.animation : animation;
            if (!this.is_closed(obj)) {
              if (callback) {
                callback.call(this, obj, false);
              }
              return false;
            }
            if (!this.is_loaded(obj)) {
              if (this.is_loading(obj)) {
                return setTimeout($2.proxy(function() {
                  this.open_node(obj, callback, animation);
                }, this), 500);
              }
              this.load_node(obj, function(o, ok) {
                return ok ? this.open_node(o, callback, animation) : callback ? callback.call(this, o, false) : false;
              });
            } else {
              d = this.get_node(obj, true);
              t = this;
              if (d.length) {
                if (animation && d.children(".jstree-children").length) {
                  d.children(".jstree-children").stop(true, true);
                }
                if (obj.children.length && !this._firstChild(d.children(".jstree-children")[0])) {
                  this.draw_children(obj);
                }
                if (!animation) {
                  this.trigger("before_open", { "node": obj });
                  d[0].className = d[0].className.replace("jstree-closed", "jstree-open");
                  d[0].setAttribute("aria-expanded", true);
                  d[0].childNodes[1].setAttribute("aria-expanded", true);
                } else {
                  this.trigger("before_open", { "node": obj });
                  d.children(".jstree-children").css("display", "none").end().removeClass("jstree-closed").addClass("jstree-open").attr("aria-expanded", true).children(".jstree-anchor").attr("aria-expanded", true).end().children(".jstree-children").stop(true, true).slideDown(animation, function() {
                    this.style.display = "";
                    if (t.element) {
                      t.trigger("after_open", { "node": obj });
                    }
                  });
                }
              }
              obj.state.opened = true;
              if (callback) {
                callback.call(this, obj, true);
              }
              if (!d.length) {
                this.trigger("before_open", { "node": obj });
              }
              this.trigger("open_node", { "node": obj });
              if (!animation || !d.length) {
                this.trigger("after_open", { "node": obj });
              }
              return true;
            }
          },
          /**
           * opens every parent of a node (node should be loaded)
           * @name _open_to(obj)
           * @param {mixed} obj the node to reveal
           * @private
           */
          _open_to: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            var i, j, p = obj.parents;
            for (i = 0, j = p.length; i < j; i += 1) {
              if (i !== $2.jstree.root) {
                this.open_node(p[i], false, 0);
              }
            }
            return $2("#" + obj.id.replace($2.jstree.idregex, "\\$&"), this.element);
          },
          /**
           * closes a node, hiding its children
           * @name close_node(obj [, animation])
           * @param {mixed} obj the node to close
           * @param {Number} animation the animation duration in milliseconds when closing the node (overrides the `core.animation` setting). Use `false` for no animation.
           * @trigger close_node.jstree, after_close.jstree
           */
          close_node: function(obj, animation) {
            var t1, t2, t, d;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.close_node(obj[t1], animation);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            if (this.is_closed(obj)) {
              return false;
            }
            animation = animation === undefined2 ? this.settings.core.animation : animation;
            t = this;
            d = this.get_node(obj, true);
            obj.state.opened = false;
            this.trigger("close_node", { "node": obj });
            if (!d.length) {
              this.trigger("after_close", { "node": obj });
            } else {
              if (!animation) {
                d[0].className = d[0].className.replace("jstree-open", "jstree-closed");
                d.children(".jstree-anchor").attr("aria-expanded", false);
                d.attr("aria-expanded", false).children(".jstree-children").remove();
                this.trigger("after_close", { "node": obj });
              } else {
                d.children(".jstree-children").attr("style", "display:block !important").end().removeClass("jstree-open").addClass("jstree-closed").attr("aria-expanded", false).children(".jstree-anchor").attr("aria-expanded", false).end().children(".jstree-children").stop(true, true).slideUp(animation, function() {
                  this.style.display = "";
                  d.children(".jstree-children").remove();
                  if (t.element) {
                    t.trigger("after_close", { "node": obj });
                  }
                });
              }
            }
          },
          /**
           * toggles a node - closing it if it is open, opening it if it is closed
           * @name toggle_node(obj)
           * @param {mixed} obj the node to toggle
           */
          toggle_node: function(obj) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.toggle_node(obj[t1]);
              }
              return true;
            }
            if (this.is_closed(obj)) {
              return this.open_node(obj);
            }
            if (this.is_open(obj)) {
              return this.close_node(obj);
            }
          },
          /**
           * opens all nodes within a node (or the tree), revealing their children. If the node is not loaded it will be loaded and opened once ready.
           * @name open_all([obj, animation, original_obj])
           * @param {mixed} obj the node to open recursively, omit to open all nodes in the tree
           * @param {Number} animation the animation duration in milliseconds when opening the nodes, the default is no animation
           * @param {jQuery} reference to the node that started the process (internal use)
           * @trigger open_all.jstree
           */
          open_all: function(obj, animation, original_obj) {
            if (!obj) {
              obj = $2.jstree.root;
            }
            obj = this.get_node(obj);
            if (!obj) {
              return false;
            }
            var dom = obj.id === $2.jstree.root ? this.get_container_ul() : this.get_node(obj, true), i, j, _this;
            if (!dom.length) {
              for (i = 0, j = obj.children_d.length; i < j; i++) {
                if (this.is_closed(this._model.data[obj.children_d[i]])) {
                  this._model.data[obj.children_d[i]].state.opened = true;
                }
              }
              return this.trigger("open_all", { "node": obj });
            }
            original_obj = original_obj || dom;
            _this = this;
            dom = this.is_closed(obj) ? dom.find(".jstree-closed").addBack() : dom.find(".jstree-closed");
            dom.each(function() {
              _this.open_node(
                this,
                function(node, status) {
                  if (status && this.is_parent(node)) {
                    this.open_all(node, animation, original_obj);
                  }
                },
                animation || 0
              );
            });
            if (original_obj.find(".jstree-closed").length === 0) {
              this.trigger("open_all", { "node": this.get_node(original_obj) });
            }
          },
          /**
           * closes all nodes within a node (or the tree), revealing their children
           * @name close_all([obj, animation])
           * @param {mixed} obj the node to close recursively, omit to close all nodes in the tree
           * @param {Number} animation the animation duration in milliseconds when closing the nodes, the default is no animation
           * @trigger close_all.jstree
           */
          close_all: function(obj, animation) {
            if (!obj) {
              obj = $2.jstree.root;
            }
            obj = this.get_node(obj);
            if (!obj) {
              return false;
            }
            var dom = obj.id === $2.jstree.root ? this.get_container_ul() : this.get_node(obj, true), _this = this, i, j;
            if (dom.length) {
              dom = this.is_open(obj) ? dom.find(".jstree-open").addBack() : dom.find(".jstree-open");
              $2(dom.get().reverse()).each(function() {
                _this.close_node(this, animation || 0);
              });
            }
            for (i = 0, j = obj.children_d.length; i < j; i++) {
              this._model.data[obj.children_d[i]].state.opened = false;
            }
            this.trigger("close_all", { "node": obj });
          },
          /**
           * checks if a node is disabled (not selectable)
           * @name is_disabled(obj)
           * @param  {mixed} obj
           * @return {Boolean}
           */
          is_disabled: function(obj) {
            obj = this.get_node(obj);
            return obj && obj.state && obj.state.disabled;
          },
          /**
           * enables a node - so that it can be selected
           * @name enable_node(obj)
           * @param {mixed} obj the node to enable
           * @trigger enable_node.jstree
           */
          enable_node: function(obj) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.enable_node(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            obj.state.disabled = false;
            this.get_node(obj, true).children(".jstree-anchor").removeClass("jstree-disabled").attr("aria-disabled", false);
            this.trigger("enable_node", { "node": obj });
          },
          /**
           * disables a node - so that it can not be selected
           * @name disable_node(obj)
           * @param {mixed} obj the node to disable
           * @trigger disable_node.jstree
           */
          disable_node: function(obj) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.disable_node(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            obj.state.disabled = true;
            this.get_node(obj, true).children(".jstree-anchor").addClass("jstree-disabled").attr("aria-disabled", true);
            this.trigger("disable_node", { "node": obj });
          },
          /**
           * determines if a node is hidden
           * @name is_hidden(obj)
           * @param {mixed} obj the node
           */
          is_hidden: function(obj) {
            obj = this.get_node(obj);
            return obj.state.hidden === true;
          },
          /**
           * hides a node - it is still in the structure but will not be visible
           * @name hide_node(obj)
           * @param {mixed} obj the node to hide
           * @param {Boolean} skip_redraw internal parameter controlling if redraw is called
           * @trigger hide_node.jstree
           */
          hide_node: function(obj, skip_redraw) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.hide_node(obj[t1], true);
              }
              if (!skip_redraw) {
                this.redraw();
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            if (!obj.state.hidden) {
              obj.state.hidden = true;
              this._node_changed(obj.parent);
              if (!skip_redraw) {
                this.redraw();
              }
              this.trigger("hide_node", { "node": obj });
            }
          },
          /**
           * shows a node
           * @name show_node(obj)
           * @param {mixed} obj the node to show
           * @param {Boolean} skip_redraw internal parameter controlling if redraw is called
           * @trigger show_node.jstree
           */
          show_node: function(obj, skip_redraw) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.show_node(obj[t1], true);
              }
              if (!skip_redraw) {
                this.redraw();
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            if (obj.state.hidden) {
              obj.state.hidden = false;
              this._node_changed(obj.parent);
              if (!skip_redraw) {
                this.redraw();
              }
              this.trigger("show_node", { "node": obj });
            }
          },
          /**
           * hides all nodes
           * @name hide_all()
           * @trigger hide_all.jstree
           */
          hide_all: function(skip_redraw) {
            var i, m = this._model.data, ids = [];
            for (i in m) {
              if (m.hasOwnProperty(i) && i !== $2.jstree.root && !m[i].state.hidden) {
                m[i].state.hidden = true;
                ids.push(i);
              }
            }
            this._model.force_full_redraw = true;
            if (!skip_redraw) {
              this.redraw();
            }
            this.trigger("hide_all", { "nodes": ids });
            return ids;
          },
          /**
           * shows all nodes
           * @name show_all()
           * @trigger show_all.jstree
           */
          show_all: function(skip_redraw) {
            var i, m = this._model.data, ids = [];
            for (i in m) {
              if (m.hasOwnProperty(i) && i !== $2.jstree.root && m[i].state.hidden) {
                m[i].state.hidden = false;
                ids.push(i);
              }
            }
            this._model.force_full_redraw = true;
            if (!skip_redraw) {
              this.redraw();
            }
            this.trigger("show_all", { "nodes": ids });
            return ids;
          },
          /**
           * called when a node is selected by the user. Used internally.
           * @private
           * @name activate_node(obj, e)
           * @param {mixed} obj the node
           * @param {Object} e the related event
           * @trigger activate_node.jstree, changed.jstree
           */
          activate_node: function(obj, e) {
            if (this.is_disabled(obj)) {
              return false;
            }
            if (!e || typeof e !== "object") {
              e = {};
            }
            this._data.core.last_clicked = this._data.core.last_clicked && this._data.core.last_clicked.id !== undefined2 ? this.get_node(this._data.core.last_clicked.id) : null;
            if (this._data.core.last_clicked && !this._data.core.last_clicked.state.selected) {
              this._data.core.last_clicked = null;
            }
            if (!this._data.core.last_clicked && this._data.core.selected.length) {
              this._data.core.last_clicked = this.get_node(this._data.core.selected[this._data.core.selected.length - 1]);
            }
            if (!this.settings.core.multiple || !e.metaKey && !e.ctrlKey && !e.shiftKey || e.shiftKey && (!this._data.core.last_clicked || !this.get_parent(obj) || this.get_parent(obj) !== this._data.core.last_clicked.parent)) {
              if (!this.settings.core.multiple && (e.metaKey || e.ctrlKey || e.shiftKey) && this.is_selected(obj)) {
                this.deselect_node(obj, false, e);
              } else {
                this.deselect_all(true);
                this.select_node(obj, false, false, e);
                this._data.core.last_clicked = this.get_node(obj);
              }
            } else {
              if (e.shiftKey) {
                var o = this.get_node(obj).id, l = this._data.core.last_clicked.id, p = this.get_node(this._data.core.last_clicked.parent).children, c = false, i, j;
                for (i = 0, j = p.length; i < j; i += 1) {
                  if (p[i] === o) {
                    c = !c;
                  }
                  if (p[i] === l) {
                    c = !c;
                  }
                  if (!this.is_disabled(p[i]) && (c || p[i] === o || p[i] === l)) {
                    if (!this.is_hidden(p[i])) {
                      this.select_node(p[i], true, false, e);
                    }
                  } else {
                    this.deselect_node(p[i], true, e);
                  }
                }
                this.trigger("changed", { "action": "select_node", "node": this.get_node(obj), "selected": this._data.core.selected, "event": e });
              } else {
                if (!this.is_selected(obj)) {
                  this.select_node(obj, false, false, e);
                } else {
                  this.deselect_node(obj, false, e);
                }
              }
            }
            this.trigger("activate_node", { "node": this.get_node(obj), "event": e });
          },
          /**
           * applies the hover state on a node, called when a node is hovered by the user. Used internally.
           * @private
           * @name hover_node(obj)
           * @param {mixed} obj
           * @trigger hover_node.jstree
           */
          hover_node: function(obj) {
            obj = this.get_node(obj, true);
            if (!obj || !obj.length || obj.children(".jstree-hovered").length) {
              return false;
            }
            var o = this.element.find(".jstree-hovered"), t = this.element;
            if (o && o.length) {
              this.dehover_node(o);
            }
            obj.children(".jstree-anchor").addClass("jstree-hovered");
            this.trigger("hover_node", { "node": this.get_node(obj) });
            setTimeout(function() {
              t.attr("aria-activedescendant", obj[0].id);
            }, 0);
          },
          /**
           * removes the hover state from a nodecalled when a node is no longer hovered by the user. Used internally.
           * @private
           * @name dehover_node(obj)
           * @param {mixed} obj
           * @trigger dehover_node.jstree
           */
          dehover_node: function(obj) {
            obj = this.get_node(obj, true);
            if (!obj || !obj.length || !obj.children(".jstree-hovered").length) {
              return false;
            }
            obj.children(".jstree-anchor").removeClass("jstree-hovered");
            this.trigger("dehover_node", { "node": this.get_node(obj) });
          },
          /**
           * select a node
           * @name select_node(obj [, supress_event, prevent_open])
           * @param {mixed} obj an array can be used to select multiple nodes
           * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
           * @param {Boolean} prevent_open if set to `true` parents of the selected node won't be opened
           * @trigger select_node.jstree, changed.jstree
           */
          select_node: function(obj, supress_event, prevent_open, e) {
            var dom, t1, t2, th;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.select_node(obj[t1], supress_event, prevent_open, e);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (!obj.state.selected) {
              obj.state.selected = true;
              this._data.core.selected.push(obj.id);
              if (!prevent_open) {
                dom = this._open_to(obj);
              }
              if (dom && dom.length) {
                dom.attr("aria-selected", true).children(".jstree-anchor").addClass("jstree-clicked").attr("aria-selected", true);
              }
              this.trigger("select_node", { "node": obj, "selected": this._data.core.selected, "event": e });
              if (!supress_event) {
                this.trigger("changed", { "action": "select_node", "node": obj, "selected": this._data.core.selected, "event": e });
              }
            }
          },
          /**
           * deselect a node
           * @name deselect_node(obj [, supress_event])
           * @param {mixed} obj an array can be used to deselect multiple nodes
           * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
           * @trigger deselect_node.jstree, changed.jstree
           */
          deselect_node: function(obj, supress_event, e) {
            var t1, t2, dom;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.deselect_node(obj[t1], supress_event, e);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (obj.state.selected) {
              obj.state.selected = false;
              this._data.core.selected = $2.vakata.array_remove_item(this._data.core.selected, obj.id);
              if (dom.length) {
                dom.attr("aria-selected", false).children(".jstree-anchor").removeClass("jstree-clicked").attr("aria-selected", false);
              }
              this.trigger("deselect_node", { "node": obj, "selected": this._data.core.selected, "event": e });
              if (!supress_event) {
                this.trigger("changed", { "action": "deselect_node", "node": obj, "selected": this._data.core.selected, "event": e });
              }
            }
          },
          /**
           * select all nodes in the tree
           * @name select_all([supress_event])
           * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
           * @trigger select_all.jstree, changed.jstree
           */
          select_all: function(supress_event) {
            var tmp = this._data.core.selected.concat([]), i, j;
            this._data.core.selected = this._model.data[$2.jstree.root].children_d.concat();
            for (i = 0, j = this._data.core.selected.length; i < j; i++) {
              if (this._model.data[this._data.core.selected[i]]) {
                this._model.data[this._data.core.selected[i]].state.selected = true;
              }
            }
            this.redraw(true);
            this.trigger("select_all", { "selected": this._data.core.selected });
            if (!supress_event) {
              this.trigger("changed", { "action": "select_all", "selected": this._data.core.selected, "old_selection": tmp });
            }
          },
          /**
           * deselect all selected nodes
           * @name deselect_all([supress_event])
           * @param {Boolean} supress_event if set to `true` the `changed.jstree` event won't be triggered
           * @trigger deselect_all.jstree, changed.jstree
           */
          deselect_all: function(supress_event) {
            var tmp = this._data.core.selected.concat([]), i, j;
            for (i = 0, j = this._data.core.selected.length; i < j; i++) {
              if (this._model.data[this._data.core.selected[i]]) {
                this._model.data[this._data.core.selected[i]].state.selected = false;
              }
            }
            this._data.core.selected = [];
            this.element.find(".jstree-clicked").removeClass("jstree-clicked").attr("aria-selected", false).parent().attr("aria-selected", false);
            this.trigger("deselect_all", { "selected": this._data.core.selected, "node": tmp });
            if (!supress_event) {
              this.trigger("changed", { "action": "deselect_all", "selected": this._data.core.selected, "old_selection": tmp });
            }
          },
          /**
           * checks if a node is selected
           * @name is_selected(obj)
           * @param  {mixed}  obj
           * @return {Boolean}
           */
          is_selected: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            return obj.state.selected;
          },
          /**
           * get an array of all selected nodes
           * @name get_selected([full])
           * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
           * @return {Array}
           */
          get_selected: function(full) {
            return full ? $2.map(this._data.core.selected, $2.proxy(function(i) {
              return this.get_node(i);
            }, this)) : this._data.core.selected.slice();
          },
          /**
           * get an array of all top level selected nodes (ignoring children of selected nodes)
           * @name get_top_selected([full])
           * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
           * @return {Array}
           */
          get_top_selected: function(full) {
            var tmp = this.get_selected(true), obj = {}, i, j, k, l;
            for (i = 0, j = tmp.length; i < j; i++) {
              obj[tmp[i].id] = tmp[i];
            }
            for (i = 0, j = tmp.length; i < j; i++) {
              for (k = 0, l = tmp[i].children_d.length; k < l; k++) {
                if (obj[tmp[i].children_d[k]]) {
                  delete obj[tmp[i].children_d[k]];
                }
              }
            }
            tmp = [];
            for (i in obj) {
              if (obj.hasOwnProperty(i)) {
                tmp.push(i);
              }
            }
            return full ? $2.map(tmp, $2.proxy(function(i2) {
              return this.get_node(i2);
            }, this)) : tmp;
          },
          /**
           * get an array of all bottom level selected nodes (ignoring selected parents)
           * @name get_bottom_selected([full])
           * @param  {mixed}  full if set to `true` the returned array will consist of the full node objects, otherwise - only IDs will be returned
           * @return {Array}
           */
          get_bottom_selected: function(full) {
            var tmp = this.get_selected(true), obj = [], i, j;
            for (i = 0, j = tmp.length; i < j; i++) {
              if (!tmp[i].children.length) {
                obj.push(tmp[i].id);
              }
            }
            return full ? $2.map(obj, $2.proxy(function(i2) {
              return this.get_node(i2);
            }, this)) : obj;
          },
          /**
           * gets the current state of the tree so that it can be restored later with `set_state(state)`. Used internally.
           * @name get_state()
           * @private
           * @return {Object}
           */
          get_state: function() {
            var state = {
              "core": {
                "open": [],
                "loaded": [],
                "scroll": {
                  "left": this.element.scrollLeft(),
                  "top": this.element.scrollTop()
                },
                /*!
                'themes' : {
                	'name' : this.get_theme(),
                	'icons' : this._data.core.themes.icons,
                	'dots' : this._data.core.themes.dots
                },
                */
                "selected": []
              }
            }, i;
            for (i in this._model.data) {
              if (this._model.data.hasOwnProperty(i)) {
                if (i !== $2.jstree.root) {
                  if (this._model.data[i].state.loaded && this.settings.core.loaded_state) {
                    state.core.loaded.push(i);
                  }
                  if (this._model.data[i].state.opened) {
                    state.core.open.push(i);
                  }
                  if (this._model.data[i].state.selected) {
                    state.core.selected.push(i);
                  }
                }
              }
            }
            return state;
          },
          /**
           * sets the state of the tree. Used internally.
           * @name set_state(state [, callback])
           * @private
           * @param {Object} state the state to restore. Keep in mind this object is passed by reference and jstree will modify it.
           * @param {Function} callback an optional function to execute once the state is restored.
           * @trigger set_state.jstree
           */
          set_state: function(state, callback) {
            if (state) {
              if (state.core && state.core.selected && state.core.initial_selection === undefined2) {
                state.core.initial_selection = this._data.core.selected.concat([]).sort().join(",");
              }
              if (state.core) {
                var res, n, t, _this, i;
                if (state.core.loaded) {
                  if (!this.settings.core.loaded_state || !$2.isArray(state.core.loaded) || !state.core.loaded.length) {
                    delete state.core.loaded;
                    this.set_state(state, callback);
                  } else {
                    this._load_nodes(state.core.loaded, function(nodes) {
                      delete state.core.loaded;
                      this.set_state(state, callback);
                    });
                  }
                  return false;
                }
                if (state.core.open) {
                  if (!$2.isArray(state.core.open) || !state.core.open.length) {
                    delete state.core.open;
                    this.set_state(state, callback);
                  } else {
                    this._load_nodes(state.core.open, function(nodes) {
                      this.open_node(nodes, false, 0);
                      delete state.core.open;
                      this.set_state(state, callback);
                    });
                  }
                  return false;
                }
                if (state.core.scroll) {
                  if (state.core.scroll && state.core.scroll.left !== undefined2) {
                    this.element.scrollLeft(state.core.scroll.left);
                  }
                  if (state.core.scroll && state.core.scroll.top !== undefined2) {
                    this.element.scrollTop(state.core.scroll.top);
                  }
                  delete state.core.scroll;
                  this.set_state(state, callback);
                  return false;
                }
                if (state.core.selected) {
                  _this = this;
                  if (state.core.initial_selection === undefined2 || state.core.initial_selection === this._data.core.selected.concat([]).sort().join(",")) {
                    this.deselect_all();
                    $2.each(state.core.selected, function(i2, v) {
                      _this.select_node(v, false, true);
                    });
                  }
                  delete state.core.initial_selection;
                  delete state.core.selected;
                  this.set_state(state, callback);
                  return false;
                }
                for (i in state) {
                  if (state.hasOwnProperty(i) && i !== "core" && $2.inArray(i, this.settings.plugins) === -1) {
                    delete state[i];
                  }
                }
                if ($2.isEmptyObject(state.core)) {
                  delete state.core;
                  this.set_state(state, callback);
                  return false;
                }
              }
              if ($2.isEmptyObject(state)) {
                state = null;
                if (callback) {
                  callback.call(this);
                }
                this.trigger("set_state");
                return false;
              }
              return true;
            }
            return false;
          },
          /**
           * refreshes the tree - all nodes are reloaded with calls to `load_node`.
           * @name refresh()
           * @param {Boolean} skip_loading an option to skip showing the loading indicator
           * @param {Mixed} forget_state if set to `true` state will not be reapplied, if set to a function (receiving the current state as argument) the result of that function will be used as state
           * @trigger refresh.jstree
           */
          refresh: function(skip_loading, forget_state) {
            this._data.core.state = forget_state === true ? {} : this.get_state();
            if (forget_state && $2.isFunction(forget_state)) {
              this._data.core.state = forget_state.call(this, this._data.core.state);
            }
            this._cnt = 0;
            this._model.data = {};
            this._model.data[$2.jstree.root] = {
              id: $2.jstree.root,
              parent: null,
              parents: [],
              children: [],
              children_d: [],
              state: { loaded: false }
            };
            this._data.core.selected = [];
            this._data.core.last_clicked = null;
            this._data.core.focused = null;
            var c = this.get_container_ul()[0].className;
            if (!skip_loading) {
              this.element.html("<ul class='" + c + "' role='group'><li class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='presentation' id='j" + this._id + "_loading'><i class='jstree-icon jstree-ocl'></i><a class='jstree-anchor' role='treeitem' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>");
              this.element.attr("aria-activedescendant", "j" + this._id + "_loading");
            }
            this.load_node($2.jstree.root, function(o, s) {
              if (s) {
                this.get_container_ul()[0].className = c;
                if (this._firstChild(this.get_container_ul()[0])) {
                  this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id);
                }
                this.set_state($2.extend(true, {}, this._data.core.state), function() {
                  this.trigger("refresh");
                });
              }
              this._data.core.state = null;
            });
          },
          /**
           * refreshes a node in the tree (reload its children) all opened nodes inside that node are reloaded with calls to `load_node`.
           * @name refresh_node(obj)
           * @param  {mixed} obj the node
           * @trigger refresh_node.jstree
           */
          refresh_node: function(obj) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            var opened = [], to_load = [], s = this._data.core.selected.concat([]);
            to_load.push(obj.id);
            if (obj.state.opened === true) {
              opened.push(obj.id);
            }
            this.get_node(obj, true).find(".jstree-open").each(function() {
              to_load.push(this.id);
              opened.push(this.id);
            });
            this._load_nodes(to_load, $2.proxy(function(nodes) {
              this.open_node(opened, false, 0);
              this.select_node(s);
              this.trigger("refresh_node", { "node": obj, "nodes": nodes });
            }, this), false, true);
          },
          /**
           * set (change) the ID of a node
           * @name set_id(obj, id)
           * @param  {mixed} obj the node
           * @param  {String} id the new ID
           * @return {Boolean}
           * @trigger set_id.jstree
           */
          set_id: function(obj, id) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            var i, j, m = this._model.data, old = obj.id;
            id = id.toString();
            m[obj.parent].children[$2.inArray(obj.id, m[obj.parent].children)] = id;
            for (i = 0, j = obj.parents.length; i < j; i++) {
              m[obj.parents[i]].children_d[$2.inArray(obj.id, m[obj.parents[i]].children_d)] = id;
            }
            for (i = 0, j = obj.children.length; i < j; i++) {
              m[obj.children[i]].parent = id;
            }
            for (i = 0, j = obj.children_d.length; i < j; i++) {
              m[obj.children_d[i]].parents[$2.inArray(obj.id, m[obj.children_d[i]].parents)] = id;
            }
            i = $2.inArray(obj.id, this._data.core.selected);
            if (i !== -1) {
              this._data.core.selected[i] = id;
            }
            i = this.get_node(obj.id, true);
            if (i) {
              i.attr("id", id);
              if (this.element.attr("aria-activedescendant") === obj.id) {
                this.element.attr("aria-activedescendant", id);
              }
            }
            delete m[obj.id];
            obj.id = id;
            obj.li_attr.id = id;
            m[id] = obj;
            this.trigger("set_id", { "node": obj, "new": obj.id, "old": old });
            return true;
          },
          /**
           * get the text value of a node
           * @name get_text(obj)
           * @param  {mixed} obj the node
           * @return {String}
           */
          get_text: function(obj) {
            obj = this.get_node(obj);
            return !obj || obj.id === $2.jstree.root ? false : obj.text;
          },
          /**
           * set the text value of a node. Used internally, please use `rename_node(obj, val)`.
           * @private
           * @name set_text(obj, val)
           * @param  {mixed} obj the node, you can pass an array to set the text on multiple nodes
           * @param  {String} val the new text value
           * @return {Boolean}
           * @trigger set_text.jstree
           */
          set_text: function(obj, val) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.set_text(obj[t1], val);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            obj.text = val;
            if (this.get_node(obj, true).length) {
              this.redraw_node(obj.id);
            }
            this.trigger("set_text", { "obj": obj, "text": val });
            return true;
          },
          /**
           * gets a JSON representation of a node (or the whole tree)
           * @name get_json([obj, options])
           * @param  {mixed} obj
           * @param  {Object} options
           * @param  {Boolean} options.no_state do not return state information
           * @param  {Boolean} options.no_id do not return ID
           * @param  {Boolean} options.no_children do not include children
           * @param  {Boolean} options.no_data do not include node data
           * @param  {Boolean} options.no_li_attr do not include LI attributes
           * @param  {Boolean} options.no_a_attr do not include A attributes
           * @param  {Boolean} options.flat return flat JSON instead of nested
           * @return {Object}
           */
          get_json: function(obj, options, flat) {
            obj = this.get_node(obj || $2.jstree.root);
            if (!obj) {
              return false;
            }
            if (options && options.flat && !flat) {
              flat = [];
            }
            var tmp = {
              "id": obj.id,
              "text": obj.text,
              "icon": this.get_icon(obj),
              "li_attr": $2.extend(true, {}, obj.li_attr),
              "a_attr": $2.extend(true, {}, obj.a_attr),
              "state": {},
              "data": options && options.no_data ? false : $2.extend(true, $2.isArray(obj.data) ? [] : {}, obj.data)
              //( this.get_node(obj, true).length ? this.get_node(obj, true).data() : obj.data ),
            }, i, j;
            if (options && options.flat) {
              tmp.parent = obj.parent;
            } else {
              tmp.children = [];
            }
            if (!options || !options.no_state) {
              for (i in obj.state) {
                if (obj.state.hasOwnProperty(i)) {
                  tmp.state[i] = obj.state[i];
                }
              }
            } else {
              delete tmp.state;
            }
            if (options && options.no_li_attr) {
              delete tmp.li_attr;
            }
            if (options && options.no_a_attr) {
              delete tmp.a_attr;
            }
            if (options && options.no_id) {
              delete tmp.id;
              if (tmp.li_attr && tmp.li_attr.id) {
                delete tmp.li_attr.id;
              }
              if (tmp.a_attr && tmp.a_attr.id) {
                delete tmp.a_attr.id;
              }
            }
            if (options && options.flat && obj.id !== $2.jstree.root) {
              flat.push(tmp);
            }
            if (!options || !options.no_children) {
              for (i = 0, j = obj.children.length; i < j; i++) {
                if (options && options.flat) {
                  this.get_json(obj.children[i], options, flat);
                } else {
                  tmp.children.push(this.get_json(obj.children[i], options));
                }
              }
            }
            return options && options.flat ? flat : obj.id === $2.jstree.root ? tmp.children : tmp;
          },
          /**
           * create a new node (do not confuse with load_node)
           * @name create_node([par, node, pos, callback, is_loaded])
           * @param  {mixed}   par       the parent node (to create a root node use either "#" (string) or `null`)
           * @param  {mixed}   node      the data for the new node (a valid JSON object, or a simple string with the name)
           * @param  {mixed}   pos       the index at which to insert the node, "first" and "last" are also supported, default is "last"
           * @param  {Function} callback a function to be called once the node is created
           * @param  {Boolean} is_loaded internal argument indicating if the parent node was succesfully loaded
           * @return {String}            the ID of the newly create node
           * @trigger model.jstree, create_node.jstree
           */
          create_node: function(par, node, pos, callback, is_loaded) {
            if (par === null) {
              par = $2.jstree.root;
            }
            par = this.get_node(par);
            if (!par) {
              return false;
            }
            pos = pos === undefined2 ? "last" : pos;
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) {
              return this.load_node(par, function() {
                this.create_node(par, node, pos, callback, true);
              });
            }
            if (!node) {
              node = { "text": this.get_string("New node") };
            }
            if (typeof node === "string") {
              node = { "text": node };
            } else {
              node = $2.extend(true, {}, node);
            }
            if (node.text === undefined2) {
              node.text = this.get_string("New node");
            }
            var tmp, dpc, i, j;
            if (par.id === $2.jstree.root) {
              if (pos === "before") {
                pos = "first";
              }
              if (pos === "after") {
                pos = "last";
              }
            }
            switch (pos) {
              case "before":
                tmp = this.get_node(par.parent);
                pos = $2.inArray(par.id, tmp.children);
                par = tmp;
                break;
              case "after":
                tmp = this.get_node(par.parent);
                pos = $2.inArray(par.id, tmp.children) + 1;
                par = tmp;
                break;
              case "inside":
              case "first":
                pos = 0;
                break;
              case "last":
                pos = par.children.length;
                break;
              default:
                if (!pos) {
                  pos = 0;
                }
                break;
            }
            if (pos > par.children.length) {
              pos = par.children.length;
            }
            if (!node.id) {
              node.id = true;
            }
            if (!this.check("create_node", node, par, pos)) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            if (node.id === true) {
              delete node.id;
            }
            node = this._parse_model_from_json(node, par.id, par.parents.concat());
            if (!node) {
              return false;
            }
            tmp = this.get_node(node);
            dpc = [];
            dpc.push(node);
            dpc = dpc.concat(tmp.children_d);
            this.trigger("model", { "nodes": dpc, "parent": par.id });
            par.children_d = par.children_d.concat(dpc);
            for (i = 0, j = par.parents.length; i < j; i++) {
              this._model.data[par.parents[i]].children_d = this._model.data[par.parents[i]].children_d.concat(dpc);
            }
            node = tmp;
            tmp = [];
            for (i = 0, j = par.children.length; i < j; i++) {
              tmp[i >= pos ? i + 1 : i] = par.children[i];
            }
            tmp[pos] = node.id;
            par.children = tmp;
            this.redraw_node(par, true);
            this.trigger("create_node", { "node": this.get_node(node), "parent": par.id, "position": pos });
            if (callback) {
              callback.call(this, this.get_node(node));
            }
            return node.id;
          },
          /**
           * set the text value of a node
           * @name rename_node(obj, val)
           * @param  {mixed} obj the node, you can pass an array to rename multiple nodes to the same name
           * @param  {String} val the new text value
           * @return {Boolean}
           * @trigger rename_node.jstree
           */
          rename_node: function(obj, val) {
            var t1, t2, old;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.rename_node(obj[t1], val);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            old = obj.text;
            if (!this.check("rename_node", obj, this.get_parent(obj), val)) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            this.set_text(obj, val);
            this.trigger("rename_node", { "node": obj, "text": val, "old": old });
            return true;
          },
          /**
           * remove a node
           * @name delete_node(obj)
           * @param  {mixed} obj the node, you can pass an array to delete multiple nodes
           * @return {Boolean}
           * @trigger delete_node.jstree, changed.jstree
           */
          delete_node: function(obj) {
            var t1, t2, par, pos, tmp, i, j, k, l, c, top, lft;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.delete_node(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            par = this.get_node(obj.parent);
            pos = $2.inArray(obj.id, par.children);
            c = false;
            if (!this.check("delete_node", obj, par, pos)) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            if (pos !== -1) {
              par.children = $2.vakata.array_remove(par.children, pos);
            }
            tmp = obj.children_d.concat([]);
            tmp.push(obj.id);
            for (i = 0, j = obj.parents.length; i < j; i++) {
              this._model.data[obj.parents[i]].children_d = $2.vakata.array_filter(this._model.data[obj.parents[i]].children_d, function(v) {
                return $2.inArray(v, tmp) === -1;
              });
            }
            for (k = 0, l = tmp.length; k < l; k++) {
              if (this._model.data[tmp[k]].state.selected) {
                c = true;
                break;
              }
            }
            if (c) {
              this._data.core.selected = $2.vakata.array_filter(this._data.core.selected, function(v) {
                return $2.inArray(v, tmp) === -1;
              });
            }
            this.trigger("delete_node", { "node": obj, "parent": par.id });
            if (c) {
              this.trigger("changed", { "action": "delete_node", "node": obj, "selected": this._data.core.selected, "parent": par.id });
            }
            for (k = 0, l = tmp.length; k < l; k++) {
              delete this._model.data[tmp[k]];
            }
            if ($2.inArray(this._data.core.focused, tmp) !== -1) {
              this._data.core.focused = null;
              top = this.element[0].scrollTop;
              lft = this.element[0].scrollLeft;
              if (par.id === $2.jstree.root) {
                if (this._model.data[$2.jstree.root].children[0]) {
                  this.get_node(this._model.data[$2.jstree.root].children[0], true).children(".jstree-anchor").focus();
                }
              } else {
                this.get_node(par, true).children(".jstree-anchor").focus();
              }
              this.element[0].scrollTop = top;
              this.element[0].scrollLeft = lft;
            }
            this.redraw_node(par, true);
            return true;
          },
          /**
           * check if an operation is premitted on the tree. Used internally.
           * @private
           * @name check(chk, obj, par, pos)
           * @param  {String} chk the operation to check, can be "create_node", "rename_node", "delete_node", "copy_node" or "move_node"
           * @param  {mixed} obj the node
           * @param  {mixed} par the parent
           * @param  {mixed} pos the position to insert at, or if "rename_node" - the new name
           * @param  {mixed} more some various additional information, for example if a "move_node" operations is triggered by DND this will be the hovered node
           * @return {Boolean}
           */
          check: function(chk, obj, par, pos, more) {
            obj = obj && obj.id ? obj : this.get_node(obj);
            par = par && par.id ? par : this.get_node(par);
            var tmp = chk.match(/^move_node|copy_node|create_node$/i) ? par : obj, chc = this.settings.core.check_callback;
            if (chk === "move_node" || chk === "copy_node") {
              if ((!more || !more.is_multi) && (chk === "move_node" && $2.inArray(obj.id, par.children) === pos)) {
                this._data.core.last_error = { "error": "check", "plugin": "core", "id": "core_08", "reason": "Moving node to its current position", "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                return false;
              }
              if ((!more || !more.is_multi) && (obj.id === par.id || chk === "move_node" && $2.inArray(obj.id, par.children) === pos || $2.inArray(par.id, obj.children_d) !== -1)) {
                this._data.core.last_error = { "error": "check", "plugin": "core", "id": "core_01", "reason": "Moving parent inside child", "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                return false;
              }
            }
            if (tmp && tmp.data) {
              tmp = tmp.data;
            }
            if (tmp && tmp.functions && (tmp.functions[chk] === false || tmp.functions[chk] === true)) {
              if (tmp.functions[chk] === false) {
                this._data.core.last_error = { "error": "check", "plugin": "core", "id": "core_02", "reason": "Node data prevents function: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
              }
              return tmp.functions[chk];
            }
            if (chc === false || $2.isFunction(chc) && chc.call(this, chk, obj, par, pos, more) === false || chc && chc[chk] === false) {
              this._data.core.last_error = { "error": "check", "plugin": "core", "id": "core_03", "reason": "User config for core.check_callback prevents function: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
              return false;
            }
            return true;
          },
          /**
           * get the last error
           * @name last_error()
           * @return {Object}
           */
          last_error: function() {
            return this._data.core.last_error;
          },
          /**
           * move a node to a new parent
           * @name move_node(obj, par [, pos, callback, is_loaded])
           * @param  {mixed} obj the node to move, pass an array to move multiple nodes
           * @param  {mixed} par the new parent
           * @param  {mixed} pos the position to insert at (besides integer values, "first" and "last" are supported, as well as "before" and "after"), defaults to integer `0`
           * @param  {function} callback a function to call once the move is completed, receives 3 arguments - the node, the new parent and the position
           * @param  {Boolean} is_loaded internal parameter indicating if the parent node has been loaded
           * @param  {Boolean} skip_redraw internal parameter indicating if the tree should be redrawn
           * @param  {Boolean} instance internal parameter indicating if the node comes from another instance
           * @trigger move_node.jstree
           */
          move_node: function(obj, par, pos, callback, is_loaded, skip_redraw, origin) {
            var t1, t2, old_par, old_pos, new_par, old_ins, is_multi, dpc, tmp, i, j, k, l, p;
            par = this.get_node(par);
            pos = pos === undefined2 ? 0 : pos;
            if (!par) {
              return false;
            }
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) {
              return this.load_node(par, function() {
                this.move_node(obj, par, pos, callback, true, false, origin);
              });
            }
            if ($2.isArray(obj)) {
              if (obj.length === 1) {
                obj = obj[0];
              } else {
                for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                  if (tmp = this.move_node(obj[t1], par, pos, callback, is_loaded, false, origin)) {
                    par = tmp;
                    pos = "after";
                  }
                }
                this.redraw();
                return true;
              }
            }
            obj = obj && obj.id ? obj : this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            old_par = (obj.parent || $2.jstree.root).toString();
            new_par = !pos.toString().match(/^(before|after)$/) || par.id === $2.jstree.root ? par : this.get_node(par.parent);
            old_ins = origin ? origin : this._model.data[obj.id] ? this : $2.jstree.reference(obj.id);
            is_multi = !old_ins || !old_ins._id || this._id !== old_ins._id;
            old_pos = old_ins && old_ins._id && old_par && old_ins._model.data[old_par] && old_ins._model.data[old_par].children ? $2.inArray(obj.id, old_ins._model.data[old_par].children) : -1;
            if (old_ins && old_ins._id) {
              obj = old_ins._model.data[obj.id];
            }
            if (is_multi) {
              if (tmp = this.copy_node(obj, par, pos, callback, is_loaded, false, origin)) {
                if (old_ins) {
                  old_ins.delete_node(obj);
                }
                return tmp;
              }
              return false;
            }
            if (par.id === $2.jstree.root) {
              if (pos === "before") {
                pos = "first";
              }
              if (pos === "after") {
                pos = "last";
              }
            }
            switch (pos) {
              case "before":
                pos = $2.inArray(par.id, new_par.children);
                break;
              case "after":
                pos = $2.inArray(par.id, new_par.children) + 1;
                break;
              case "inside":
              case "first":
                pos = 0;
                break;
              case "last":
                pos = new_par.children.length;
                break;
              default:
                if (!pos) {
                  pos = 0;
                }
                break;
            }
            if (pos > new_par.children.length) {
              pos = new_par.children.length;
            }
            if (!this.check("move_node", obj, new_par, pos, { "core": true, "origin": origin, "is_multi": old_ins && old_ins._id && old_ins._id !== this._id, "is_foreign": !old_ins || !old_ins._id })) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            if (obj.parent === new_par.id) {
              dpc = new_par.children.concat();
              tmp = $2.inArray(obj.id, dpc);
              if (tmp !== -1) {
                dpc = $2.vakata.array_remove(dpc, tmp);
                if (pos > tmp) {
                  pos--;
                }
              }
              tmp = [];
              for (i = 0, j = dpc.length; i < j; i++) {
                tmp[i >= pos ? i + 1 : i] = dpc[i];
              }
              tmp[pos] = obj.id;
              new_par.children = tmp;
              this._node_changed(new_par.id);
              this.redraw(new_par.id === $2.jstree.root);
            } else {
              tmp = obj.children_d.concat();
              tmp.push(obj.id);
              for (i = 0, j = obj.parents.length; i < j; i++) {
                dpc = [];
                p = old_ins._model.data[obj.parents[i]].children_d;
                for (k = 0, l = p.length; k < l; k++) {
                  if ($2.inArray(p[k], tmp) === -1) {
                    dpc.push(p[k]);
                  }
                }
                old_ins._model.data[obj.parents[i]].children_d = dpc;
              }
              old_ins._model.data[old_par].children = $2.vakata.array_remove_item(old_ins._model.data[old_par].children, obj.id);
              for (i = 0, j = new_par.parents.length; i < j; i++) {
                this._model.data[new_par.parents[i]].children_d = this._model.data[new_par.parents[i]].children_d.concat(tmp);
              }
              dpc = [];
              for (i = 0, j = new_par.children.length; i < j; i++) {
                dpc[i >= pos ? i + 1 : i] = new_par.children[i];
              }
              dpc[pos] = obj.id;
              new_par.children = dpc;
              new_par.children_d.push(obj.id);
              new_par.children_d = new_par.children_d.concat(obj.children_d);
              obj.parent = new_par.id;
              tmp = new_par.parents.concat();
              tmp.unshift(new_par.id);
              p = obj.parents.length;
              obj.parents = tmp;
              tmp = tmp.concat();
              for (i = 0, j = obj.children_d.length; i < j; i++) {
                this._model.data[obj.children_d[i]].parents = this._model.data[obj.children_d[i]].parents.slice(0, p * -1);
                Array.prototype.push.apply(this._model.data[obj.children_d[i]].parents, tmp);
              }
              if (old_par === $2.jstree.root || new_par.id === $2.jstree.root) {
                this._model.force_full_redraw = true;
              }
              if (!this._model.force_full_redraw) {
                this._node_changed(old_par);
                this._node_changed(new_par.id);
              }
              if (!skip_redraw) {
                this.redraw();
              }
            }
            if (callback) {
              callback.call(this, obj, new_par, pos);
            }
            this.trigger("move_node", { "node": obj, "parent": new_par.id, "position": pos, "old_parent": old_par, "old_position": old_pos, "is_multi": old_ins && old_ins._id && old_ins._id !== this._id, "is_foreign": !old_ins || !old_ins._id, "old_instance": old_ins, "new_instance": this });
            return obj.id;
          },
          /**
           * copy a node to a new parent
           * @name copy_node(obj, par [, pos, callback, is_loaded])
           * @param  {mixed} obj the node to copy, pass an array to copy multiple nodes
           * @param  {mixed} par the new parent
           * @param  {mixed} pos the position to insert at (besides integer values, "first" and "last" are supported, as well as "before" and "after"), defaults to integer `0`
           * @param  {function} callback a function to call once the move is completed, receives 3 arguments - the node, the new parent and the position
           * @param  {Boolean} is_loaded internal parameter indicating if the parent node has been loaded
           * @param  {Boolean} skip_redraw internal parameter indicating if the tree should be redrawn
           * @param  {Boolean} instance internal parameter indicating if the node comes from another instance
           * @trigger model.jstree copy_node.jstree
           */
          copy_node: function(obj, par, pos, callback, is_loaded, skip_redraw, origin) {
            var t1, t2, dpc, tmp, i, j, node, old_par, new_par, old_ins, is_multi;
            par = this.get_node(par);
            pos = pos === undefined2 ? 0 : pos;
            if (!par) {
              return false;
            }
            if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) {
              return this.load_node(par, function() {
                this.copy_node(obj, par, pos, callback, true, false, origin);
              });
            }
            if ($2.isArray(obj)) {
              if (obj.length === 1) {
                obj = obj[0];
              } else {
                for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                  if (tmp = this.copy_node(obj[t1], par, pos, callback, is_loaded, true, origin)) {
                    par = tmp;
                    pos = "after";
                  }
                }
                this.redraw();
                return true;
              }
            }
            obj = obj && obj.id ? obj : this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            old_par = (obj.parent || $2.jstree.root).toString();
            new_par = !pos.toString().match(/^(before|after)$/) || par.id === $2.jstree.root ? par : this.get_node(par.parent);
            old_ins = origin ? origin : this._model.data[obj.id] ? this : $2.jstree.reference(obj.id);
            is_multi = !old_ins || !old_ins._id || this._id !== old_ins._id;
            if (old_ins && old_ins._id) {
              obj = old_ins._model.data[obj.id];
            }
            if (par.id === $2.jstree.root) {
              if (pos === "before") {
                pos = "first";
              }
              if (pos === "after") {
                pos = "last";
              }
            }
            switch (pos) {
              case "before":
                pos = $2.inArray(par.id, new_par.children);
                break;
              case "after":
                pos = $2.inArray(par.id, new_par.children) + 1;
                break;
              case "inside":
              case "first":
                pos = 0;
                break;
              case "last":
                pos = new_par.children.length;
                break;
              default:
                if (!pos) {
                  pos = 0;
                }
                break;
            }
            if (pos > new_par.children.length) {
              pos = new_par.children.length;
            }
            if (!this.check("copy_node", obj, new_par, pos, { "core": true, "origin": origin, "is_multi": old_ins && old_ins._id && old_ins._id !== this._id, "is_foreign": !old_ins || !old_ins._id })) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            node = old_ins ? old_ins.get_json(obj, { no_id: true, no_data: true, no_state: true }) : obj;
            if (!node) {
              return false;
            }
            if (node.id === true) {
              delete node.id;
            }
            node = this._parse_model_from_json(node, new_par.id, new_par.parents.concat());
            if (!node) {
              return false;
            }
            tmp = this.get_node(node);
            if (obj && obj.state && obj.state.loaded === false) {
              tmp.state.loaded = false;
            }
            dpc = [];
            dpc.push(node);
            dpc = dpc.concat(tmp.children_d);
            this.trigger("model", { "nodes": dpc, "parent": new_par.id });
            for (i = 0, j = new_par.parents.length; i < j; i++) {
              this._model.data[new_par.parents[i]].children_d = this._model.data[new_par.parents[i]].children_d.concat(dpc);
            }
            dpc = [];
            for (i = 0, j = new_par.children.length; i < j; i++) {
              dpc[i >= pos ? i + 1 : i] = new_par.children[i];
            }
            dpc[pos] = tmp.id;
            new_par.children = dpc;
            new_par.children_d.push(tmp.id);
            new_par.children_d = new_par.children_d.concat(tmp.children_d);
            if (new_par.id === $2.jstree.root) {
              this._model.force_full_redraw = true;
            }
            if (!this._model.force_full_redraw) {
              this._node_changed(new_par.id);
            }
            if (!skip_redraw) {
              this.redraw(new_par.id === $2.jstree.root);
            }
            if (callback) {
              callback.call(this, tmp, new_par, pos);
            }
            this.trigger("copy_node", { "node": tmp, "original": obj, "parent": new_par.id, "position": pos, "old_parent": old_par, "old_position": old_ins && old_ins._id && old_par && old_ins._model.data[old_par] && old_ins._model.data[old_par].children ? $2.inArray(obj.id, old_ins._model.data[old_par].children) : -1, "is_multi": old_ins && old_ins._id && old_ins._id !== this._id, "is_foreign": !old_ins || !old_ins._id, "old_instance": old_ins, "new_instance": this });
            return tmp.id;
          },
          /**
           * cut a node (a later call to `paste(obj)` would move the node)
           * @name cut(obj)
           * @param  {mixed} obj multiple objects can be passed using an array
           * @trigger cut.jstree
           */
          cut: function(obj) {
            if (!obj) {
              obj = this._data.core.selected.concat();
            }
            if (!$2.isArray(obj)) {
              obj = [obj];
            }
            if (!obj.length) {
              return false;
            }
            var tmp = [], o, t1, t2;
            for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
              o = this.get_node(obj[t1]);
              if (o && o.id && o.id !== $2.jstree.root) {
                tmp.push(o);
              }
            }
            if (!tmp.length) {
              return false;
            }
            ccp_node = tmp;
            ccp_inst = this;
            ccp_mode = "move_node";
            this.trigger("cut", { "node": obj });
          },
          /**
           * copy a node (a later call to `paste(obj)` would copy the node)
           * @name copy(obj)
           * @param  {mixed} obj multiple objects can be passed using an array
           * @trigger copy.jstree
           */
          copy: function(obj) {
            if (!obj) {
              obj = this._data.core.selected.concat();
            }
            if (!$2.isArray(obj)) {
              obj = [obj];
            }
            if (!obj.length) {
              return false;
            }
            var tmp = [], o, t1, t2;
            for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
              o = this.get_node(obj[t1]);
              if (o && o.id && o.id !== $2.jstree.root) {
                tmp.push(o);
              }
            }
            if (!tmp.length) {
              return false;
            }
            ccp_node = tmp;
            ccp_inst = this;
            ccp_mode = "copy_node";
            this.trigger("copy", { "node": obj });
          },
          /**
           * get the current buffer (any nodes that are waiting for a paste operation)
           * @name get_buffer()
           * @return {Object} an object consisting of `mode` ("copy_node" or "move_node"), `node` (an array of objects) and `inst` (the instance)
           */
          get_buffer: function() {
            return { "mode": ccp_mode, "node": ccp_node, "inst": ccp_inst };
          },
          /**
           * check if there is something in the buffer to paste
           * @name can_paste()
           * @return {Boolean}
           */
          can_paste: function() {
            return ccp_mode !== false && ccp_node !== false;
          },
          /**
           * copy or move the previously cut or copied nodes to a new parent
           * @name paste(obj [, pos])
           * @param  {mixed} obj the new parent
           * @param  {mixed} pos the position to insert at (besides integer, "first" and "last" are supported), defaults to integer `0`
           * @trigger paste.jstree
           */
          paste: function(obj, pos) {
            obj = this.get_node(obj);
            if (!obj || !ccp_mode || !ccp_mode.match(/^(copy_node|move_node)$/) || !ccp_node) {
              return false;
            }
            if (this[ccp_mode](ccp_node, obj, pos, false, false, false, ccp_inst)) {
              this.trigger("paste", { "parent": obj.id, "node": ccp_node, "mode": ccp_mode });
            }
            ccp_node = false;
            ccp_mode = false;
            ccp_inst = false;
          },
          /**
           * clear the buffer of previously copied or cut nodes
           * @name clear_buffer()
           * @trigger clear_buffer.jstree
           */
          clear_buffer: function() {
            ccp_node = false;
            ccp_mode = false;
            ccp_inst = false;
            this.trigger("clear_buffer");
          },
          /**
           * put a node in edit mode (input field to rename the node)
           * @name edit(obj [, default_text, callback])
           * @param  {mixed} obj
           * @param  {String} default_text the text to populate the input with (if omitted or set to a non-string value the node's text value is used)
           * @param  {Function} callback a function to be called once the text box is blurred, it is called in the instance's scope and receives the node, a status parameter (true if the rename is successful, false otherwise) and a boolean indicating if the user cancelled the edit. You can access the node's title using .text
           */
          edit: function(obj, default_text, callback) {
            var rtl, w, a, s, t, h1, h2, fn, tmp, cancel = false;
            obj = this.get_node(obj);
            if (!obj) {
              return false;
            }
            if (!this.check("edit", obj, this.get_parent(obj))) {
              this.settings.core.error.call(this, this._data.core.last_error);
              return false;
            }
            tmp = obj;
            default_text = typeof default_text === "string" ? default_text : obj.text;
            this.set_text(obj, "");
            obj = this._open_to(obj);
            tmp.text = default_text;
            rtl = this._data.core.rtl;
            w = this.element.width();
            this._data.core.focused = tmp.id;
            a = obj.children(".jstree-anchor").focus();
            s = $2("<span></span>");
            t = default_text;
            h1 = $2("<div></div>", { css: { "position": "absolute", "top": "-200px", "left": rtl ? "0px" : "-1000px", "visibility": "hidden" } }).appendTo(document2.body);
            h2 = $2("<input />", {
              "value": t,
              "class": "jstree-rename-input",
              // "size" : t.length,
              "css": {
                "padding": "0",
                "border": "1px solid silver",
                "box-sizing": "border-box",
                "display": "inline-block",
                "height": this._data.core.li_height + "px",
                "lineHeight": this._data.core.li_height + "px",
                "width": "150px"
                // will be set a bit further down
              },
              "blur": $2.proxy(function(e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var i = s.children(".jstree-rename-input"), v = i.val(), f = this.settings.core.force_text, nv;
                if (v === "") {
                  v = t;
                }
                h1.remove();
                s.replaceWith(a);
                s.remove();
                t = f ? t : $2("<div></div>").append($2.parseHTML(t)).html();
                obj = this.get_node(obj);
                this.set_text(obj, t);
                nv = !!this.rename_node(obj, f ? $2("<div></div>").text(v).text() : $2("<div></div>").append($2.parseHTML(v)).html());
                if (!nv) {
                  this.set_text(obj, t);
                }
                this._data.core.focused = tmp.id;
                setTimeout($2.proxy(function() {
                  var node = this.get_node(tmp.id, true);
                  if (node.length) {
                    this._data.core.focused = tmp.id;
                    node.children(".jstree-anchor").focus();
                  }
                }, this), 0);
                if (callback) {
                  callback.call(this, tmp, nv, cancel);
                }
                h2 = null;
              }, this),
              "keydown": function(e) {
                var key = e.which;
                if (key === 27) {
                  cancel = true;
                  this.value = t;
                }
                if (key === 27 || key === 13 || key === 37 || key === 38 || key === 39 || key === 40 || key === 32) {
                  e.stopImmediatePropagation();
                }
                if (key === 27 || key === 13) {
                  e.preventDefault();
                  this.blur();
                }
              },
              "click": function(e) {
                e.stopImmediatePropagation();
              },
              "mousedown": function(e) {
                e.stopImmediatePropagation();
              },
              "keyup": function(e) {
                h2.width(Math.min(h1.text("pW" + this.value).width(), w));
              },
              "keypress": function(e) {
                if (e.which === 13) {
                  return false;
                }
              }
            });
            fn = {
              fontFamily: a.css("fontFamily") || "",
              fontSize: a.css("fontSize") || "",
              fontWeight: a.css("fontWeight") || "",
              fontStyle: a.css("fontStyle") || "",
              fontStretch: a.css("fontStretch") || "",
              fontVariant: a.css("fontVariant") || "",
              letterSpacing: a.css("letterSpacing") || "",
              wordSpacing: a.css("wordSpacing") || ""
            };
            s.attr("class", a.attr("class")).append(a.contents().clone()).append(h2);
            a.replaceWith(s);
            h1.css(fn);
            h2.css(fn).width(Math.min(h1.text("pW" + h2[0].value).width(), w))[0].select();
            $2(document2).one("mousedown.jstree touchstart.jstree dnd_start.vakata", function(e) {
              if (h2 && e.target !== h2) {
                $2(h2).blur();
              }
            });
          },
          /**
           * changes the theme
           * @name set_theme(theme_name [, theme_url])
           * @param {String} theme_name the name of the new theme to apply
           * @param {mixed} theme_url  the location of the CSS file for this theme. Omit or set to `false` if you manually included the file. Set to `true` to autoload from the `core.themes.dir` directory.
           * @trigger set_theme.jstree
           */
          set_theme: function(theme_name, theme_url) {
            if (!theme_name) {
              return false;
            }
            if (theme_url === true) {
              var dir = this.settings.core.themes.dir;
              if (!dir) {
                dir = $2.jstree.path + "/themes";
              }
              theme_url = dir + "/" + theme_name + "/style.css";
            }
            if (theme_url && $2.inArray(theme_url, themes_loaded) === -1) {
              $2("head").append('<link rel="stylesheet" href="' + theme_url + '" type="text/css" />');
              themes_loaded.push(theme_url);
            }
            if (this._data.core.themes.name) {
              this.element.removeClass("jstree-" + this._data.core.themes.name);
            }
            this._data.core.themes.name = theme_name;
            this.element.addClass("jstree-" + theme_name);
            this.element[this.settings.core.themes.responsive ? "addClass" : "removeClass"]("jstree-" + theme_name + "-responsive");
            this.trigger("set_theme", { "theme": theme_name });
          },
          /**
           * gets the name of the currently applied theme name
           * @name get_theme()
           * @return {String}
           */
          get_theme: function() {
            return this._data.core.themes.name;
          },
          /**
           * changes the theme variant (if the theme has variants)
           * @name set_theme_variant(variant_name)
           * @param {String|Boolean} variant_name the variant to apply (if `false` is used the current variant is removed)
           */
          set_theme_variant: function(variant_name) {
            if (this._data.core.themes.variant) {
              this.element.removeClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant);
            }
            this._data.core.themes.variant = variant_name;
            if (variant_name) {
              this.element.addClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant);
            }
          },
          /**
           * gets the name of the currently applied theme variant
           * @name get_theme()
           * @return {String}
           */
          get_theme_variant: function() {
            return this._data.core.themes.variant;
          },
          /**
           * shows a striped background on the container (if the theme supports it)
           * @name show_stripes()
           */
          show_stripes: function() {
            this._data.core.themes.stripes = true;
            this.get_container_ul().addClass("jstree-striped");
            this.trigger("show_stripes");
          },
          /**
           * hides the striped background on the container
           * @name hide_stripes()
           */
          hide_stripes: function() {
            this._data.core.themes.stripes = false;
            this.get_container_ul().removeClass("jstree-striped");
            this.trigger("hide_stripes");
          },
          /**
           * toggles the striped background on the container
           * @name toggle_stripes()
           */
          toggle_stripes: function() {
            if (this._data.core.themes.stripes) {
              this.hide_stripes();
            } else {
              this.show_stripes();
            }
          },
          /**
           * shows the connecting dots (if the theme supports it)
           * @name show_dots()
           */
          show_dots: function() {
            this._data.core.themes.dots = true;
            this.get_container_ul().removeClass("jstree-no-dots");
            this.trigger("show_dots");
          },
          /**
           * hides the connecting dots
           * @name hide_dots()
           */
          hide_dots: function() {
            this._data.core.themes.dots = false;
            this.get_container_ul().addClass("jstree-no-dots");
            this.trigger("hide_dots");
          },
          /**
           * toggles the connecting dots
           * @name toggle_dots()
           */
          toggle_dots: function() {
            if (this._data.core.themes.dots) {
              this.hide_dots();
            } else {
              this.show_dots();
            }
          },
          /**
           * show the node icons
           * @name show_icons()
           */
          show_icons: function() {
            this._data.core.themes.icons = true;
            this.get_container_ul().removeClass("jstree-no-icons");
            this.trigger("show_icons");
          },
          /**
           * hide the node icons
           * @name hide_icons()
           */
          hide_icons: function() {
            this._data.core.themes.icons = false;
            this.get_container_ul().addClass("jstree-no-icons");
            this.trigger("hide_icons");
          },
          /**
           * toggle the node icons
           * @name toggle_icons()
           */
          toggle_icons: function() {
            if (this._data.core.themes.icons) {
              this.hide_icons();
            } else {
              this.show_icons();
            }
          },
          /**
           * show the node ellipsis
           * @name show_icons()
           */
          show_ellipsis: function() {
            this._data.core.themes.ellipsis = true;
            this.get_container_ul().addClass("jstree-ellipsis");
            this.trigger("show_ellipsis");
          },
          /**
           * hide the node ellipsis
           * @name hide_ellipsis()
           */
          hide_ellipsis: function() {
            this._data.core.themes.ellipsis = false;
            this.get_container_ul().removeClass("jstree-ellipsis");
            this.trigger("hide_ellipsis");
          },
          /**
           * toggle the node ellipsis
           * @name toggle_icons()
           */
          toggle_ellipsis: function() {
            if (this._data.core.themes.ellipsis) {
              this.hide_ellipsis();
            } else {
              this.show_ellipsis();
            }
          },
          /**
           * set the node icon for a node
           * @name set_icon(obj, icon)
           * @param {mixed} obj
           * @param {String} icon the new icon - can be a path to an icon or a className, if using an image that is in the current directory use a `./` prefix, otherwise it will be detected as a class
           */
          set_icon: function(obj, icon) {
            var t1, t2, dom, old;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.set_icon(obj[t1], icon);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            old = obj.icon;
            obj.icon = icon === true || icon === null || icon === undefined2 || icon === "" ? true : icon;
            dom = this.get_node(obj, true).children(".jstree-anchor").children(".jstree-themeicon");
            if (icon === false) {
              dom.removeClass("jstree-themeicon-custom " + old).css("background", "").removeAttr("rel");
              this.hide_icon(obj);
            } else if (icon === true || icon === null || icon === undefined2 || icon === "") {
              dom.removeClass("jstree-themeicon-custom " + old).css("background", "").removeAttr("rel");
              if (old === false) {
                this.show_icon(obj);
              }
            } else if (icon.indexOf("/") === -1 && icon.indexOf(".") === -1) {
              dom.removeClass(old).css("background", "");
              dom.addClass(icon + " jstree-themeicon-custom").attr("rel", icon);
              if (old === false) {
                this.show_icon(obj);
              }
            } else {
              dom.removeClass(old).css("background", "");
              dom.addClass("jstree-themeicon-custom").css("background", "url('" + icon + "') center center no-repeat").attr("rel", icon);
              if (old === false) {
                this.show_icon(obj);
              }
            }
            return true;
          },
          /**
           * get the node icon for a node
           * @name get_icon(obj)
           * @param {mixed} obj
           * @return {String}
           */
          get_icon: function(obj) {
            obj = this.get_node(obj);
            return !obj || obj.id === $2.jstree.root ? false : obj.icon;
          },
          /**
           * hide the icon on an individual node
           * @name hide_icon(obj)
           * @param {mixed} obj
           */
          hide_icon: function(obj) {
            var t1, t2;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.hide_icon(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj === $2.jstree.root) {
              return false;
            }
            obj.icon = false;
            this.get_node(obj, true).children(".jstree-anchor").children(".jstree-themeicon").addClass("jstree-themeicon-hidden");
            return true;
          },
          /**
           * show the icon on an individual node
           * @name show_icon(obj)
           * @param {mixed} obj
           */
          show_icon: function(obj) {
            var t1, t2, dom;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.show_icon(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            obj.icon = dom.length ? dom.children(".jstree-anchor").children(".jstree-themeicon").attr("rel") : true;
            if (!obj.icon) {
              obj.icon = true;
            }
            dom.children(".jstree-anchor").children(".jstree-themeicon").removeClass("jstree-themeicon-hidden");
            return true;
          }
        };
        $2.vakata = {};
        $2.vakata.attributes = function(node, with_values) {
          node = $2(node)[0];
          var attr = with_values ? {} : [];
          if (node && node.attributes) {
            $2.each(node.attributes, function(i, v) {
              if ($2.inArray(v.name.toLowerCase(), ["style", "contenteditable", "hasfocus", "tabindex"]) !== -1) {
                return;
              }
              if (v.value !== null && $2.trim(v.value) !== "") {
                if (with_values) {
                  attr[v.name] = v.value;
                } else {
                  attr.push(v.name);
                }
              }
            });
          }
          return attr;
        };
        $2.vakata.array_unique = function(array) {
          var a = [], i, j, l, o = {};
          for (i = 0, l = array.length; i < l; i++) {
            if (o[array[i]] === undefined2) {
              a.push(array[i]);
              o[array[i]] = true;
            }
          }
          return a;
        };
        $2.vakata.array_remove = function(array, from) {
          array.splice(from, 1);
          return array;
        };
        $2.vakata.array_remove_item = function(array, item) {
          var tmp = $2.inArray(item, array);
          return tmp !== -1 ? $2.vakata.array_remove(array, tmp) : array;
        };
        $2.vakata.array_filter = function(c, a, b, d, e) {
          if (c.filter) {
            return c.filter(a, b);
          }
          d = [];
          for (e in c) {
            if (~~e + "" === e + "" && e >= 0 && a.call(b, c[e], +e, c)) {
              d.push(c[e]);
            }
          }
          return d;
        };
        $2.jstree.plugins.changed = function(options, parent) {
          var last = [];
          this.trigger = function(ev, data) {
            var i, j;
            if (!data) {
              data = {};
            }
            if (ev.replace(".jstree", "") === "changed") {
              data.changed = { selected: [], deselected: [] };
              var tmp = {};
              for (i = 0, j = last.length; i < j; i++) {
                tmp[last[i]] = 1;
              }
              for (i = 0, j = data.selected.length; i < j; i++) {
                if (!tmp[data.selected[i]]) {
                  data.changed.selected.push(data.selected[i]);
                } else {
                  tmp[data.selected[i]] = 2;
                }
              }
              for (i = 0, j = last.length; i < j; i++) {
                if (tmp[last[i]] === 1) {
                  data.changed.deselected.push(last[i]);
                }
              }
              last = data.selected.slice();
            }
            parent.trigger.call(this, ev, data);
          };
          this.refresh = function(skip_loading, forget_state) {
            last = [];
            return parent.refresh.apply(this, arguments);
          };
        };
        var _i = document2.createElement("I");
        _i.className = "jstree-icon jstree-checkbox";
        _i.setAttribute("role", "presentation");
        $2.jstree.defaults.checkbox = {
          /**
           * a boolean indicating if checkboxes should be visible (can be changed at a later time using `show_checkboxes()` and `hide_checkboxes`). Defaults to `true`.
           * @name $.jstree.defaults.checkbox.visible
           * @plugin checkbox
           */
          visible: true,
          /**
           * a boolean indicating if checkboxes should cascade down and have an undetermined state. Defaults to `true`.
           * @name $.jstree.defaults.checkbox.three_state
           * @plugin checkbox
           */
          three_state: true,
          /**
           * a boolean indicating if clicking anywhere on the node should act as clicking on the checkbox. Defaults to `true`.
           * @name $.jstree.defaults.checkbox.whole_node
           * @plugin checkbox
           */
          whole_node: true,
          /**
           * a boolean indicating if the selected style of a node should be kept, or removed. Defaults to `true`.
           * @name $.jstree.defaults.checkbox.keep_selected_style
           * @plugin checkbox
           */
          keep_selected_style: true,
          /**
           * This setting controls how cascading and undetermined nodes are applied.
           * If 'up' is in the string - cascading up is enabled, if 'down' is in the string - cascading down is enabled, if 'undetermined' is in the string - undetermined nodes will be used.
           * If `three_state` is set to `true` this setting is automatically set to 'up+down+undetermined'. Defaults to ''.
           * @name $.jstree.defaults.checkbox.cascade
           * @plugin checkbox
           */
          cascade: "",
          /**
           * This setting controls if checkbox are bound to the general tree selection or to an internal array maintained by the checkbox plugin. Defaults to `true`, only set to `false` if you know exactly what you are doing.
           * @name $.jstree.defaults.checkbox.tie_selection
           * @plugin checkbox
           */
          tie_selection: true,
          /**
           * This setting controls if cascading down affects disabled checkboxes
           * @name $.jstree.defaults.checkbox.cascade_to_disabled
           * @plugin checkbox
           */
          cascade_to_disabled: true,
          /**
           * This setting controls if cascading down affects hidden checkboxes
           * @name $.jstree.defaults.checkbox.cascade_to_hidden
           * @plugin checkbox
           */
          cascade_to_hidden: true
        };
        $2.jstree.plugins.checkbox = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            this._data.checkbox.uto = false;
            this._data.checkbox.selected = [];
            if (this.settings.checkbox.three_state) {
              this.settings.checkbox.cascade = "up+down+undetermined";
            }
            this.element.on("init.jstree", $2.proxy(function() {
              this._data.checkbox.visible = this.settings.checkbox.visible;
              if (!this.settings.checkbox.keep_selected_style) {
                this.element.addClass("jstree-checkbox-no-clicked");
              }
              if (this.settings.checkbox.tie_selection) {
                this.element.addClass("jstree-checkbox-selection");
              }
            }, this)).on("loading.jstree", $2.proxy(function() {
              this[this._data.checkbox.visible ? "show_checkboxes" : "hide_checkboxes"]();
            }, this));
            if (this.settings.checkbox.cascade.indexOf("undetermined") !== -1) {
              this.element.on("changed.jstree uncheck_node.jstree check_node.jstree uncheck_all.jstree check_all.jstree move_node.jstree copy_node.jstree redraw.jstree open_node.jstree", $2.proxy(function() {
                if (this._data.checkbox.uto) {
                  clearTimeout(this._data.checkbox.uto);
                }
                this._data.checkbox.uto = setTimeout($2.proxy(this._undetermined, this), 50);
              }, this));
            }
            if (!this.settings.checkbox.tie_selection) {
              this.element.on("model.jstree", $2.proxy(function(e, data) {
                var m = this._model.data, p = m[data.parent], dpc = data.nodes, i, j;
                for (i = 0, j = dpc.length; i < j; i++) {
                  m[dpc[i]].state.checked = m[dpc[i]].state.checked || m[dpc[i]].original && m[dpc[i]].original.state && m[dpc[i]].original.state.checked;
                  if (m[dpc[i]].state.checked) {
                    this._data.checkbox.selected.push(dpc[i]);
                  }
                }
              }, this));
            }
            if (this.settings.checkbox.cascade.indexOf("up") !== -1 || this.settings.checkbox.cascade.indexOf("down") !== -1) {
              this.element.on("model.jstree", $2.proxy(function(e, data) {
                var m = this._model.data, p = m[data.parent], dpc = data.nodes, chd = [], c, i, j, k, l, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection;
                if (s.indexOf("down") !== -1) {
                  if (p.state[t ? "selected" : "checked"]) {
                    for (i = 0, j = dpc.length; i < j; i++) {
                      m[dpc[i]].state[t ? "selected" : "checked"] = true;
                    }
                    this._data[t ? "core" : "checkbox"].selected = this._data[t ? "core" : "checkbox"].selected.concat(dpc);
                  } else {
                    for (i = 0, j = dpc.length; i < j; i++) {
                      if (m[dpc[i]].state[t ? "selected" : "checked"]) {
                        for (k = 0, l = m[dpc[i]].children_d.length; k < l; k++) {
                          m[m[dpc[i]].children_d[k]].state[t ? "selected" : "checked"] = true;
                        }
                        this._data[t ? "core" : "checkbox"].selected = this._data[t ? "core" : "checkbox"].selected.concat(m[dpc[i]].children_d);
                      }
                    }
                  }
                }
                if (s.indexOf("up") !== -1) {
                  for (i = 0, j = p.children_d.length; i < j; i++) {
                    if (!m[p.children_d[i]].children.length) {
                      chd.push(m[p.children_d[i]].parent);
                    }
                  }
                  chd = $2.vakata.array_unique(chd);
                  for (k = 0, l = chd.length; k < l; k++) {
                    p = m[chd[k]];
                    while (p && p.id !== $2.jstree.root) {
                      c = 0;
                      for (i = 0, j = p.children.length; i < j; i++) {
                        c += m[p.children[i]].state[t ? "selected" : "checked"];
                      }
                      if (c === j) {
                        p.state[t ? "selected" : "checked"] = true;
                        this._data[t ? "core" : "checkbox"].selected.push(p.id);
                        tmp = this.get_node(p, true);
                        if (tmp && tmp.length) {
                          tmp.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
                        }
                      } else {
                        break;
                      }
                      p = this.get_node(p.parent);
                    }
                  }
                }
                this._data[t ? "core" : "checkbox"].selected = $2.vakata.array_unique(this._data[t ? "core" : "checkbox"].selected);
              }, this)).on(this.settings.checkbox.tie_selection ? "select_node.jstree" : "check_node.jstree", $2.proxy(function(e, data) {
                var self2 = this, obj = data.node, m = this._model.data, par = this.get_node(obj.parent), i, j, c, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection, sel = {}, cur = this._data[t ? "core" : "checkbox"].selected;
                for (i = 0, j = cur.length; i < j; i++) {
                  sel[cur[i]] = true;
                }
                if (s.indexOf("down") !== -1) {
                  var selectedIds = this._cascade_new_checked_state(obj.id, true);
                  var temp = obj.children_d.concat(obj.id);
                  for (i = 0, j = temp.length; i < j; i++) {
                    if (selectedIds.indexOf(temp[i]) > -1) {
                      sel[temp[i]] = true;
                    } else {
                      delete sel[temp[i]];
                    }
                  }
                }
                if (s.indexOf("up") !== -1) {
                  while (par && par.id !== $2.jstree.root) {
                    c = 0;
                    for (i = 0, j = par.children.length; i < j; i++) {
                      c += m[par.children[i]].state[t ? "selected" : "checked"];
                    }
                    if (c === j) {
                      par.state[t ? "selected" : "checked"] = true;
                      sel[par.id] = true;
                      tmp = this.get_node(par, true);
                      if (tmp && tmp.length) {
                        tmp.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
                      }
                    } else {
                      break;
                    }
                    par = this.get_node(par.parent);
                  }
                }
                cur = [];
                for (i in sel) {
                  if (sel.hasOwnProperty(i)) {
                    cur.push(i);
                  }
                }
                this._data[t ? "core" : "checkbox"].selected = cur;
              }, this)).on(this.settings.checkbox.tie_selection ? "deselect_all.jstree" : "uncheck_all.jstree", $2.proxy(function(e, data) {
                var obj = this.get_node($2.jstree.root), m = this._model.data, i, j, tmp;
                for (i = 0, j = obj.children_d.length; i < j; i++) {
                  tmp = m[obj.children_d[i]];
                  if (tmp && tmp.original && tmp.original.state && tmp.original.state.undetermined) {
                    tmp.original.state.undetermined = false;
                  }
                }
              }, this)).on(this.settings.checkbox.tie_selection ? "deselect_node.jstree" : "uncheck_node.jstree", $2.proxy(function(e, data) {
                var self2 = this, obj = data.node, dom = this.get_node(obj, true), i, j, tmp, s = this.settings.checkbox.cascade, t = this.settings.checkbox.tie_selection, cur = this._data[t ? "core" : "checkbox"].selected, sel = {}, stillSelectedIds = [], allIds = obj.children_d.concat(obj.id);
                if (s.indexOf("down") !== -1) {
                  var selectedIds = this._cascade_new_checked_state(obj.id, false);
                  cur = $2.vakata.array_filter(cur, function(id) {
                    return allIds.indexOf(id) === -1 || selectedIds.indexOf(id) > -1;
                  });
                }
                if (s.indexOf("up") !== -1 && cur.indexOf(obj.id) === -1) {
                  for (i = 0, j = obj.parents.length; i < j; i++) {
                    tmp = this._model.data[obj.parents[i]];
                    tmp.state[t ? "selected" : "checked"] = false;
                    if (tmp && tmp.original && tmp.original.state && tmp.original.state.undetermined) {
                      tmp.original.state.undetermined = false;
                    }
                    tmp = this.get_node(obj.parents[i], true);
                    if (tmp && tmp.length) {
                      tmp.attr("aria-selected", false).children(".jstree-anchor").removeClass(t ? "jstree-clicked" : "jstree-checked");
                    }
                  }
                  cur = $2.vakata.array_filter(cur, function(id) {
                    return obj.parents.indexOf(id) === -1;
                  });
                }
                this._data[t ? "core" : "checkbox"].selected = cur;
              }, this));
            }
            if (this.settings.checkbox.cascade.indexOf("up") !== -1) {
              this.element.on("delete_node.jstree", $2.proxy(function(e, data) {
                var p = this.get_node(data.parent), m = this._model.data, i, j, c, tmp, t = this.settings.checkbox.tie_selection;
                while (p && p.id !== $2.jstree.root && !p.state[t ? "selected" : "checked"]) {
                  c = 0;
                  for (i = 0, j = p.children.length; i < j; i++) {
                    c += m[p.children[i]].state[t ? "selected" : "checked"];
                  }
                  if (j > 0 && c === j) {
                    p.state[t ? "selected" : "checked"] = true;
                    this._data[t ? "core" : "checkbox"].selected.push(p.id);
                    tmp = this.get_node(p, true);
                    if (tmp && tmp.length) {
                      tmp.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
                    }
                  } else {
                    break;
                  }
                  p = this.get_node(p.parent);
                }
              }, this)).on("move_node.jstree", $2.proxy(function(e, data) {
                var is_multi = data.is_multi, old_par = data.old_parent, new_par = this.get_node(data.parent), m = this._model.data, p, c, i, j, tmp, t = this.settings.checkbox.tie_selection;
                if (!is_multi) {
                  p = this.get_node(old_par);
                  while (p && p.id !== $2.jstree.root && !p.state[t ? "selected" : "checked"]) {
                    c = 0;
                    for (i = 0, j = p.children.length; i < j; i++) {
                      c += m[p.children[i]].state[t ? "selected" : "checked"];
                    }
                    if (j > 0 && c === j) {
                      p.state[t ? "selected" : "checked"] = true;
                      this._data[t ? "core" : "checkbox"].selected.push(p.id);
                      tmp = this.get_node(p, true);
                      if (tmp && tmp.length) {
                        tmp.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
                      }
                    } else {
                      break;
                    }
                    p = this.get_node(p.parent);
                  }
                }
                p = new_par;
                while (p && p.id !== $2.jstree.root) {
                  c = 0;
                  for (i = 0, j = p.children.length; i < j; i++) {
                    c += m[p.children[i]].state[t ? "selected" : "checked"];
                  }
                  if (c === j) {
                    if (!p.state[t ? "selected" : "checked"]) {
                      p.state[t ? "selected" : "checked"] = true;
                      this._data[t ? "core" : "checkbox"].selected.push(p.id);
                      tmp = this.get_node(p, true);
                      if (tmp && tmp.length) {
                        tmp.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
                      }
                    }
                  } else {
                    if (p.state[t ? "selected" : "checked"]) {
                      p.state[t ? "selected" : "checked"] = false;
                      this._data[t ? "core" : "checkbox"].selected = $2.vakata.array_remove_item(this._data[t ? "core" : "checkbox"].selected, p.id);
                      tmp = this.get_node(p, true);
                      if (tmp && tmp.length) {
                        tmp.attr("aria-selected", false).children(".jstree-anchor").removeClass(t ? "jstree-clicked" : "jstree-checked");
                      }
                    } else {
                      break;
                    }
                  }
                  p = this.get_node(p.parent);
                }
              }, this));
            }
          };
          this.get_undetermined = function(full) {
            if (this.settings.checkbox.cascade.indexOf("undetermined") === -1) {
              return [];
            }
            var i, j, k, l, o = {}, m = this._model.data, t = this.settings.checkbox.tie_selection, s = this._data[t ? "core" : "checkbox"].selected, p = [], tt = this, r = [];
            for (i = 0, j = s.length; i < j; i++) {
              if (m[s[i]] && m[s[i]].parents) {
                for (k = 0, l = m[s[i]].parents.length; k < l; k++) {
                  if (o[m[s[i]].parents[k]] !== undefined2) {
                    break;
                  }
                  if (m[s[i]].parents[k] !== $2.jstree.root) {
                    o[m[s[i]].parents[k]] = true;
                    p.push(m[s[i]].parents[k]);
                  }
                }
              }
            }
            this.element.find(".jstree-closed").not(":has(.jstree-children)").each(function() {
              var tmp = tt.get_node(this), tmp2;
              if (!tmp) {
                return;
              }
              if (!tmp.state.loaded) {
                if (tmp.original && tmp.original.state && tmp.original.state.undetermined && tmp.original.state.undetermined === true) {
                  if (o[tmp.id] === undefined2 && tmp.id !== $2.jstree.root) {
                    o[tmp.id] = true;
                    p.push(tmp.id);
                  }
                  for (k = 0, l = tmp.parents.length; k < l; k++) {
                    if (o[tmp.parents[k]] === undefined2 && tmp.parents[k] !== $2.jstree.root) {
                      o[tmp.parents[k]] = true;
                      p.push(tmp.parents[k]);
                    }
                  }
                }
              } else {
                for (i = 0, j = tmp.children_d.length; i < j; i++) {
                  tmp2 = m[tmp.children_d[i]];
                  if (!tmp2.state.loaded && tmp2.original && tmp2.original.state && tmp2.original.state.undetermined && tmp2.original.state.undetermined === true) {
                    if (o[tmp2.id] === undefined2 && tmp2.id !== $2.jstree.root) {
                      o[tmp2.id] = true;
                      p.push(tmp2.id);
                    }
                    for (k = 0, l = tmp2.parents.length; k < l; k++) {
                      if (o[tmp2.parents[k]] === undefined2 && tmp2.parents[k] !== $2.jstree.root) {
                        o[tmp2.parents[k]] = true;
                        p.push(tmp2.parents[k]);
                      }
                    }
                  }
                }
              }
            });
            for (i = 0, j = p.length; i < j; i++) {
              if (!m[p[i]].state[t ? "selected" : "checked"]) {
                r.push(full ? m[p[i]] : p[i]);
              }
            }
            return r;
          };
          this._undetermined = function() {
            if (this.element === null) {
              return;
            }
            var p = this.get_undetermined(false), i, j, s;
            this.element.find(".jstree-undetermined").removeClass("jstree-undetermined");
            for (i = 0, j = p.length; i < j; i++) {
              s = this.get_node(p[i], true);
              if (s && s.length) {
                s.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-undetermined");
              }
            }
          };
          this.redraw_node = function(obj, deep, is_callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
              var i, j, tmp = null, icon = null;
              for (i = 0, j = obj.childNodes.length; i < j; i++) {
                if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                  tmp = obj.childNodes[i];
                  break;
                }
              }
              if (tmp) {
                if (!this.settings.checkbox.tie_selection && this._model.data[obj.id].state.checked) {
                  tmp.className += " jstree-checked";
                }
                icon = _i.cloneNode(false);
                if (this._model.data[obj.id].state.checkbox_disabled) {
                  icon.className += " jstree-checkbox-disabled";
                }
                tmp.insertBefore(icon, tmp.childNodes[0]);
              }
            }
            if (!is_callback && this.settings.checkbox.cascade.indexOf("undetermined") !== -1) {
              if (this._data.checkbox.uto) {
                clearTimeout(this._data.checkbox.uto);
              }
              this._data.checkbox.uto = setTimeout($2.proxy(this._undetermined, this), 50);
            }
            return obj;
          };
          this.show_checkboxes = function() {
            this._data.core.themes.checkboxes = true;
            this.get_container_ul().removeClass("jstree-no-checkboxes");
          };
          this.hide_checkboxes = function() {
            this._data.core.themes.checkboxes = false;
            this.get_container_ul().addClass("jstree-no-checkboxes");
          };
          this.toggle_checkboxes = function() {
            if (this._data.core.themes.checkboxes) {
              this.hide_checkboxes();
            } else {
              this.show_checkboxes();
            }
          };
          this.is_undetermined = function(obj) {
            obj = this.get_node(obj);
            var s = this.settings.checkbox.cascade, i, j, t = this.settings.checkbox.tie_selection, d = this._data[t ? "core" : "checkbox"].selected, m = this._model.data;
            if (!obj || obj.state[t ? "selected" : "checked"] === true || s.indexOf("undetermined") === -1 || s.indexOf("down") === -1 && s.indexOf("up") === -1) {
              return false;
            }
            if (!obj.state.loaded && obj.original.state.undetermined === true) {
              return true;
            }
            for (i = 0, j = obj.children_d.length; i < j; i++) {
              if ($2.inArray(obj.children_d[i], d) !== -1 || !m[obj.children_d[i]].state.loaded && m[obj.children_d[i]].original.state.undetermined) {
                return true;
              }
            }
            return false;
          };
          this.disable_checkbox = function(obj) {
            var t1, t2, dom;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.disable_checkbox(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (!obj.state.checkbox_disabled) {
              obj.state.checkbox_disabled = true;
              if (dom && dom.length) {
                dom.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-checkbox-disabled");
              }
              this.trigger("disable_checkbox", { "node": obj });
            }
          };
          this.enable_checkbox = function(obj) {
            var t1, t2, dom;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.enable_checkbox(obj[t1]);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (obj.state.checkbox_disabled) {
              obj.state.checkbox_disabled = false;
              if (dom && dom.length) {
                dom.children(".jstree-anchor").children(".jstree-checkbox").removeClass("jstree-checkbox-disabled");
              }
              this.trigger("enable_checkbox", { "node": obj });
            }
          };
          this.activate_node = function(obj, e) {
            if ($2(e.target).hasClass("jstree-checkbox-disabled")) {
              return false;
            }
            if (this.settings.checkbox.tie_selection && (this.settings.checkbox.whole_node || $2(e.target).hasClass("jstree-checkbox"))) {
              e.ctrlKey = true;
            }
            if (this.settings.checkbox.tie_selection || !this.settings.checkbox.whole_node && !$2(e.target).hasClass("jstree-checkbox")) {
              return parent.activate_node.call(this, obj, e);
            }
            if (this.is_disabled(obj)) {
              return false;
            }
            if (this.is_checked(obj)) {
              this.uncheck_node(obj, e);
            } else {
              this.check_node(obj, e);
            }
            this.trigger("activate_node", { "node": this.get_node(obj) });
          };
          this._cascade_new_checked_state = function(id, checkedState) {
            var self2 = this;
            var t = this.settings.checkbox.tie_selection;
            var node = this._model.data[id];
            var selectedNodeIds = [];
            var selectedChildrenIds = [], i, j, selectedChildIds;
            if ((this.settings.checkbox.cascade_to_disabled || !node.state.disabled) && (this.settings.checkbox.cascade_to_hidden || !node.state.hidden)) {
              if (node.children) {
                for (i = 0, j = node.children.length; i < j; i++) {
                  var childId = node.children[i];
                  selectedChildIds = self2._cascade_new_checked_state(childId, checkedState);
                  selectedNodeIds = selectedNodeIds.concat(selectedChildIds);
                  if (selectedChildIds.indexOf(childId) > -1) {
                    selectedChildrenIds.push(childId);
                  }
                }
              }
              var dom = self2.get_node(node, true);
              var undetermined = selectedChildrenIds.length > 0 && selectedChildrenIds.length < node.children.length;
              if (node.original && node.original.state && node.original.state.undetermined) {
                node.original.state.undetermined = undetermined;
              }
              if (undetermined) {
                node.state[t ? "selected" : "checked"] = false;
                dom.attr("aria-selected", false).children(".jstree-anchor").removeClass(t ? "jstree-clicked" : "jstree-checked");
              } else if (checkedState && selectedChildrenIds.length === node.children.length) {
                node.state[t ? "selected" : "checked"] = checkedState;
                selectedNodeIds.push(node.id);
                dom.attr("aria-selected", true).children(".jstree-anchor").addClass(t ? "jstree-clicked" : "jstree-checked");
              } else {
                node.state[t ? "selected" : "checked"] = false;
                dom.attr("aria-selected", false).children(".jstree-anchor").removeClass(t ? "jstree-clicked" : "jstree-checked");
              }
            } else {
              selectedChildIds = this.get_checked_descendants(id);
              if (node.state[t ? "selected" : "checked"]) {
                selectedChildIds.push(node.id);
              }
              selectedNodeIds = selectedNodeIds.concat(selectedChildIds);
            }
            return selectedNodeIds;
          };
          this.get_checked_descendants = function(id) {
            var self2 = this;
            var t = self2.settings.checkbox.tie_selection;
            var node = self2._model.data[id];
            return $2.vakata.array_filter(node.children_d, function(_id) {
              return self2._model.data[_id].state[t ? "selected" : "checked"];
            });
          };
          this.check_node = function(obj, e) {
            if (this.settings.checkbox.tie_selection) {
              return this.select_node(obj, false, true, e);
            }
            var dom, t1, t2, th;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.check_node(obj[t1], e);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (!obj.state.checked) {
              obj.state.checked = true;
              this._data.checkbox.selected.push(obj.id);
              if (dom && dom.length) {
                dom.children(".jstree-anchor").addClass("jstree-checked");
              }
              this.trigger("check_node", { "node": obj, "selected": this._data.checkbox.selected, "event": e });
            }
          };
          this.uncheck_node = function(obj, e) {
            if (this.settings.checkbox.tie_selection) {
              return this.deselect_node(obj, false, e);
            }
            var t1, t2, dom;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.uncheck_node(obj[t1], e);
              }
              return true;
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            dom = this.get_node(obj, true);
            if (obj.state.checked) {
              obj.state.checked = false;
              this._data.checkbox.selected = $2.vakata.array_remove_item(this._data.checkbox.selected, obj.id);
              if (dom.length) {
                dom.children(".jstree-anchor").removeClass("jstree-checked");
              }
              this.trigger("uncheck_node", { "node": obj, "selected": this._data.checkbox.selected, "event": e });
            }
          };
          this.check_all = function() {
            if (this.settings.checkbox.tie_selection) {
              return this.select_all();
            }
            var tmp = this._data.checkbox.selected.concat([]), i, j;
            this._data.checkbox.selected = this._model.data[$2.jstree.root].children_d.concat();
            for (i = 0, j = this._data.checkbox.selected.length; i < j; i++) {
              if (this._model.data[this._data.checkbox.selected[i]]) {
                this._model.data[this._data.checkbox.selected[i]].state.checked = true;
              }
            }
            this.redraw(true);
            this.trigger("check_all", { "selected": this._data.checkbox.selected });
          };
          this.uncheck_all = function() {
            if (this.settings.checkbox.tie_selection) {
              return this.deselect_all();
            }
            var tmp = this._data.checkbox.selected.concat([]), i, j;
            for (i = 0, j = this._data.checkbox.selected.length; i < j; i++) {
              if (this._model.data[this._data.checkbox.selected[i]]) {
                this._model.data[this._data.checkbox.selected[i]].state.checked = false;
              }
            }
            this._data.checkbox.selected = [];
            this.element.find(".jstree-checked").removeClass("jstree-checked");
            this.trigger("uncheck_all", { "selected": this._data.checkbox.selected, "node": tmp });
          };
          this.is_checked = function(obj) {
            if (this.settings.checkbox.tie_selection) {
              return this.is_selected(obj);
            }
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            return obj.state.checked;
          };
          this.get_checked = function(full) {
            if (this.settings.checkbox.tie_selection) {
              return this.get_selected(full);
            }
            return full ? $2.map(this._data.checkbox.selected, $2.proxy(function(i) {
              return this.get_node(i);
            }, this)) : this._data.checkbox.selected.slice();
          };
          this.get_top_checked = function(full) {
            if (this.settings.checkbox.tie_selection) {
              return this.get_top_selected(full);
            }
            var tmp = this.get_checked(true), obj = {}, i, j, k, l;
            for (i = 0, j = tmp.length; i < j; i++) {
              obj[tmp[i].id] = tmp[i];
            }
            for (i = 0, j = tmp.length; i < j; i++) {
              for (k = 0, l = tmp[i].children_d.length; k < l; k++) {
                if (obj[tmp[i].children_d[k]]) {
                  delete obj[tmp[i].children_d[k]];
                }
              }
            }
            tmp = [];
            for (i in obj) {
              if (obj.hasOwnProperty(i)) {
                tmp.push(i);
              }
            }
            return full ? $2.map(tmp, $2.proxy(function(i2) {
              return this.get_node(i2);
            }, this)) : tmp;
          };
          this.get_bottom_checked = function(full) {
            if (this.settings.checkbox.tie_selection) {
              return this.get_bottom_selected(full);
            }
            var tmp = this.get_checked(true), obj = [], i, j;
            for (i = 0, j = tmp.length; i < j; i++) {
              if (!tmp[i].children.length) {
                obj.push(tmp[i].id);
              }
            }
            return full ? $2.map(obj, $2.proxy(function(i2) {
              return this.get_node(i2);
            }, this)) : obj;
          };
          this.load_node = function(obj, callback) {
            var k, l, i, j, c, tmp;
            if (!$2.isArray(obj) && !this.settings.checkbox.tie_selection) {
              tmp = this.get_node(obj);
              if (tmp && tmp.state.loaded) {
                for (k = 0, l = tmp.children_d.length; k < l; k++) {
                  if (this._model.data[tmp.children_d[k]].state.checked) {
                    c = true;
                    this._data.checkbox.selected = $2.vakata.array_remove_item(this._data.checkbox.selected, tmp.children_d[k]);
                  }
                }
              }
            }
            return parent.load_node.apply(this, arguments);
          };
          this.get_state = function() {
            var state = parent.get_state.apply(this, arguments);
            if (this.settings.checkbox.tie_selection) {
              return state;
            }
            state.checkbox = this._data.checkbox.selected.slice();
            return state;
          };
          this.set_state = function(state, callback) {
            var res = parent.set_state.apply(this, arguments);
            if (res && state.checkbox) {
              if (!this.settings.checkbox.tie_selection) {
                this.uncheck_all();
                var _this = this;
                $2.each(state.checkbox, function(i, v) {
                  _this.check_node(v);
                });
              }
              delete state.checkbox;
              this.set_state(state, callback);
              return false;
            }
            return res;
          };
          this.refresh = function(skip_loading, forget_state) {
            if (this.settings.checkbox.tie_selection) {
              this._data.checkbox.selected = [];
            }
            return parent.refresh.apply(this, arguments);
          };
        };
        $2.jstree.defaults.conditionalselect = function() {
          return true;
        };
        $2.jstree.plugins.conditionalselect = function(options, parent) {
          this.activate_node = function(obj, e) {
            if (this.settings.conditionalselect.call(this, this.get_node(obj), e)) {
              return parent.activate_node.call(this, obj, e);
            }
          };
        };
        $2.jstree.defaults.contextmenu = {
          /**
           * a boolean indicating if the node should be selected when the context menu is invoked on it. Defaults to `true`.
           * @name $.jstree.defaults.contextmenu.select_node
           * @plugin contextmenu
           */
          select_node: true,
          /**
           * a boolean indicating if the menu should be shown aligned with the node. Defaults to `true`, otherwise the mouse coordinates are used.
           * @name $.jstree.defaults.contextmenu.show_at_node
           * @plugin contextmenu
           */
          show_at_node: true,
          /**
           * an object of actions, or a function that accepts a node and a callback function and calls the callback function with an object of actions available for that node (you can also return the items too).
           *
           * Each action consists of a key (a unique name) and a value which is an object with the following properties (only label and action are required). Once a menu item is activated the `action` function will be invoked with an object containing the following keys: item - the contextmenu item definition as seen below, reference - the DOM node that was used (the tree node), element - the contextmenu DOM element, position - an object with x/y properties indicating the position of the menu.
           *
           * * `separator_before` - a boolean indicating if there should be a separator before this item
           * * `separator_after` - a boolean indicating if there should be a separator after this item
           * * `_disabled` - a boolean indicating if this action should be disabled
           * * `label` - a string - the name of the action (could be a function returning a string)
           * * `title` - a string - an optional tooltip for the item
           * * `action` - a function to be executed if this item is chosen, the function will receive 
           * * `icon` - a string, can be a path to an icon or a className, if using an image that is in the current directory use a `./` prefix, otherwise it will be detected as a class
           * * `shortcut` - keyCode which will trigger the action if the menu is open (for example `113` for rename, which equals F2)
           * * `shortcut_label` - shortcut label (like for example `F2` for rename)
           * * `submenu` - an object with the same structure as $.jstree.defaults.contextmenu.items which can be used to create a submenu - each key will be rendered as a separate option in a submenu that will appear once the current item is hovered
           *
           * @name $.jstree.defaults.contextmenu.items
           * @plugin contextmenu
           */
          items: function(o, cb) {
            return {
              "create": {
                "separator_before": false,
                "separator_after": true,
                "_disabled": false,
                //(this.check("create_node", data.reference, {}, "last")),
                "label": "Create",
                "action": function(data) {
                  var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                  inst.create_node(obj, {}, "last", function(new_node) {
                    try {
                      inst.edit(new_node);
                    } catch (ex) {
                      setTimeout(function() {
                        inst.edit(new_node);
                      }, 0);
                    }
                  });
                }
              },
              "rename": {
                "separator_before": false,
                "separator_after": false,
                "_disabled": false,
                //(this.check("rename_node", data.reference, this.get_parent(data.reference), "")),
                "label": "Rename",
                /*!
                "shortcut"			: 113,
                "shortcut_label"	: 'F2',
                "icon"				: "glyphicon glyphicon-leaf",
                */
                "action": function(data) {
                  var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                  inst.edit(obj);
                }
              },
              "remove": {
                "separator_before": false,
                "icon": false,
                "separator_after": false,
                "_disabled": false,
                //(this.check("delete_node", data.reference, this.get_parent(data.reference), "")),
                "label": "Delete",
                "action": function(data) {
                  var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                  if (inst.is_selected(obj)) {
                    inst.delete_node(inst.get_selected());
                  } else {
                    inst.delete_node(obj);
                  }
                }
              },
              "ccp": {
                "separator_before": true,
                "icon": false,
                "separator_after": false,
                "label": "Edit",
                "action": false,
                "submenu": {
                  "cut": {
                    "separator_before": false,
                    "separator_after": false,
                    "label": "Cut",
                    "action": function(data) {
                      var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                      if (inst.is_selected(obj)) {
                        inst.cut(inst.get_top_selected());
                      } else {
                        inst.cut(obj);
                      }
                    }
                  },
                  "copy": {
                    "separator_before": false,
                    "icon": false,
                    "separator_after": false,
                    "label": "Copy",
                    "action": function(data) {
                      var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                      if (inst.is_selected(obj)) {
                        inst.copy(inst.get_top_selected());
                      } else {
                        inst.copy(obj);
                      }
                    }
                  },
                  "paste": {
                    "separator_before": false,
                    "icon": false,
                    "_disabled": function(data) {
                      return !$2.jstree.reference(data.reference).can_paste();
                    },
                    "separator_after": false,
                    "label": "Paste",
                    "action": function(data) {
                      var inst = $2.jstree.reference(data.reference), obj = inst.get_node(data.reference);
                      inst.paste(obj);
                    }
                  }
                }
              }
            };
          }
        };
        $2.jstree.plugins.contextmenu = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            var last_ts = 0, cto = null, ex, ey;
            this.element.on("init.jstree loading.jstree ready.jstree", $2.proxy(function() {
              this.get_container_ul().addClass("jstree-contextmenu");
            }, this)).on("contextmenu.jstree", ".jstree-anchor", $2.proxy(function(e, data) {
              if (e.target.tagName.toLowerCase() === "input") {
                return;
              }
              e.preventDefault();
              last_ts = e.ctrlKey ? +/* @__PURE__ */ new Date() : 0;
              if (data || cto) {
                last_ts = +/* @__PURE__ */ new Date() + 1e4;
              }
              if (cto) {
                clearTimeout(cto);
              }
              if (!this.is_loading(e.currentTarget)) {
                this.show_contextmenu(e.currentTarget, e.pageX, e.pageY, e);
              }
            }, this)).on("click.jstree", ".jstree-anchor", $2.proxy(function(e) {
              if (this._data.contextmenu.visible && (!last_ts || +/* @__PURE__ */ new Date() - last_ts > 250)) {
                $2.vakata.context.hide();
              }
              last_ts = 0;
            }, this)).on("touchstart.jstree", ".jstree-anchor", function(e) {
              if (!e.originalEvent || !e.originalEvent.changedTouches || !e.originalEvent.changedTouches[0]) {
                return;
              }
              ex = e.originalEvent.changedTouches[0].clientX;
              ey = e.originalEvent.changedTouches[0].clientY;
              cto = setTimeout(function() {
                $2(e.currentTarget).trigger("contextmenu", true);
              }, 750);
            }).on("touchmove.vakata.jstree", function(e) {
              if (cto && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0] && (Math.abs(ex - e.originalEvent.changedTouches[0].clientX) > 10 || Math.abs(ey - e.originalEvent.changedTouches[0].clientY) > 10)) {
                clearTimeout(cto);
                $2.vakata.context.hide();
              }
            }).on("touchend.vakata.jstree", function(e) {
              if (cto) {
                clearTimeout(cto);
              }
            });
            $2(document2).on("context_hide.vakata.jstree", $2.proxy(function(e, data) {
              this._data.contextmenu.visible = false;
              $2(data.reference).removeClass("jstree-context");
            }, this));
          };
          this.teardown = function() {
            if (this._data.contextmenu.visible) {
              $2.vakata.context.hide();
            }
            parent.teardown.call(this);
          };
          this.show_contextmenu = function(obj, x, y, e) {
            obj = this.get_node(obj);
            if (!obj || obj.id === $2.jstree.root) {
              return false;
            }
            var s = this.settings.contextmenu, d = this.get_node(obj, true), a = d.children(".jstree-anchor"), o = false, i = false;
            if (s.show_at_node || x === undefined2 || y === undefined2) {
              o = a.offset();
              x = o.left;
              y = o.top + this._data.core.li_height;
            }
            if (this.settings.contextmenu.select_node && !this.is_selected(obj)) {
              this.activate_node(obj, e);
            }
            i = s.items;
            if ($2.isFunction(i)) {
              i = i.call(this, obj, $2.proxy(function(i2) {
                this._show_contextmenu(obj, x, y, i2);
              }, this));
            }
            if ($2.isPlainObject(i)) {
              this._show_contextmenu(obj, x, y, i);
            }
          };
          this._show_contextmenu = function(obj, x, y, i) {
            var d = this.get_node(obj, true), a = d.children(".jstree-anchor");
            $2(document2).one("context_show.vakata.jstree", $2.proxy(function(e, data) {
              var cls = "jstree-contextmenu jstree-" + this.get_theme() + "-contextmenu";
              $2(data.element).addClass(cls);
              a.addClass("jstree-context");
            }, this));
            this._data.contextmenu.visible = true;
            $2.vakata.context.show(a, { "x": x, "y": y }, i);
            this.trigger("show_contextmenu", { "node": obj, "x": x, "y": y });
          };
        };
        (function($3) {
          var right_to_left = false, vakata_context = {
            element: false,
            reference: false,
            position_x: 0,
            position_y: 0,
            items: [],
            html: "",
            is_visible: false
          };
          $3.vakata.context = {
            settings: {
              hide_onmouseleave: 0,
              icons: true
            },
            _trigger: function(event_name) {
              $3(document2).triggerHandler("context_" + event_name + ".vakata", {
                "reference": vakata_context.reference,
                "element": vakata_context.element,
                "position": {
                  "x": vakata_context.position_x,
                  "y": vakata_context.position_y
                }
              });
            },
            _execute: function(i) {
              i = vakata_context.items[i];
              return i && (!i._disabled || $3.isFunction(i._disabled) && !i._disabled({ "item": i, "reference": vakata_context.reference, "element": vakata_context.element })) && i.action ? i.action.call(null, {
                "item": i,
                "reference": vakata_context.reference,
                "element": vakata_context.element,
                "position": {
                  "x": vakata_context.position_x,
                  "y": vakata_context.position_y
                }
              }) : false;
            },
            _parse: function(o, is_callback) {
              if (!o) {
                return false;
              }
              if (!is_callback) {
                vakata_context.html = "";
                vakata_context.items = [];
              }
              var str = "", sep = false, tmp;
              if (is_callback) {
                str += "<ul>";
              }
              $3.each(o, function(i, val) {
                if (!val) {
                  return true;
                }
                vakata_context.items.push(val);
                if (!sep && val.separator_before) {
                  str += "<li class='vakata-context-separator'><a href='#' " + ($3.vakata.context.settings.icons ? "" : 'style="margin-left:0px;"') + ">&#160;</a></li>";
                }
                sep = false;
                str += "<li class='" + (val._class || "") + (val._disabled === true || $3.isFunction(val._disabled) && val._disabled({ "item": val, "reference": vakata_context.reference, "element": vakata_context.element }) ? " vakata-contextmenu-disabled " : "") + "' " + (val.shortcut ? " data-shortcut='" + val.shortcut + "' " : "") + ">";
                str += "<a href='#' rel='" + (vakata_context.items.length - 1) + "' " + (val.title ? "title='" + val.title + "'" : "") + ">";
                if ($3.vakata.context.settings.icons) {
                  str += "<i ";
                  if (val.icon) {
                    if (val.icon.indexOf("/") !== -1 || val.icon.indexOf(".") !== -1) {
                      str += ` style='background:url("` + val.icon + `") center center no-repeat' `;
                    } else {
                      str += " class='" + val.icon + "' ";
                    }
                  }
                  str += "></i><span class='vakata-contextmenu-sep'>&#160;</span>";
                }
                str += ($3.isFunction(val.label) ? val.label({ "item": i, "reference": vakata_context.reference, "element": vakata_context.element }) : val.label) + (val.shortcut ? ' <span class="vakata-contextmenu-shortcut vakata-contextmenu-shortcut-' + val.shortcut + '">' + (val.shortcut_label || "") + "</span>" : "") + "</a>";
                if (val.submenu) {
                  tmp = $3.vakata.context._parse(val.submenu, true);
                  if (tmp) {
                    str += tmp;
                  }
                }
                str += "</li>";
                if (val.separator_after) {
                  str += "<li class='vakata-context-separator'><a href='#' " + ($3.vakata.context.settings.icons ? "" : 'style="margin-left:0px;"') + ">&#160;</a></li>";
                  sep = true;
                }
              });
              str = str.replace(/<li class\='vakata-context-separator'\><\/li\>$/, "");
              if (is_callback) {
                str += "</ul>";
              }
              if (!is_callback) {
                vakata_context.html = str;
                $3.vakata.context._trigger("parse");
              }
              return str.length > 10 ? str : false;
            },
            _show_submenu: function(o) {
              o = $3(o);
              if (!o.length || !o.children("ul").length) {
                return;
              }
              var e = o.children("ul"), xl = o.offset().left, x = xl + o.outerWidth(), y = o.offset().top, w = e.width(), h = e.height(), dw = $3(window).width() + $3(window).scrollLeft(), dh = $3(window).height() + $3(window).scrollTop();
              if (right_to_left) {
                o[x - (w + 10 + o.outerWidth()) < 0 ? "addClass" : "removeClass"]("vakata-context-left");
              } else {
                o[x + w > dw && xl > dw - x ? "addClass" : "removeClass"]("vakata-context-right");
              }
              if (y + h + 10 > dh) {
                e.css("bottom", "-1px");
              }
              if (o.hasClass("vakata-context-right")) {
                if (xl < w) {
                  e.css("margin-right", xl - w);
                }
              } else {
                if (dw - x < w) {
                  e.css("margin-left", dw - x - w);
                }
              }
              e.show();
            },
            show: function(reference, position, data) {
              var o, e, x, y, w, h, dw, dh, cond = true;
              if (vakata_context.element && vakata_context.element.length) {
                vakata_context.element.width("");
              }
              switch (cond) {
                case (!position && !reference):
                  return false;
                case (!!position && !!reference):
                  vakata_context.reference = reference;
                  vakata_context.position_x = position.x;
                  vakata_context.position_y = position.y;
                  break;
                case (!position && !!reference):
                  vakata_context.reference = reference;
                  o = reference.offset();
                  vakata_context.position_x = o.left + reference.outerHeight();
                  vakata_context.position_y = o.top;
                  break;
                case (!!position && !reference):
                  vakata_context.position_x = position.x;
                  vakata_context.position_y = position.y;
                  break;
              }
              if (!!reference && !data && $3(reference).data("vakata_contextmenu")) {
                data = $3(reference).data("vakata_contextmenu");
              }
              if ($3.vakata.context._parse(data)) {
                vakata_context.element.html(vakata_context.html);
              }
              if (vakata_context.items.length) {
                vakata_context.element.appendTo(document2.body);
                e = vakata_context.element;
                x = vakata_context.position_x;
                y = vakata_context.position_y;
                w = e.width();
                h = e.height();
                dw = $3(window).width() + $3(window).scrollLeft();
                dh = $3(window).height() + $3(window).scrollTop();
                if (right_to_left) {
                  x -= e.outerWidth() - $3(reference).outerWidth();
                  if (x < $3(window).scrollLeft() + 20) {
                    x = $3(window).scrollLeft() + 20;
                  }
                }
                if (x + w + 20 > dw) {
                  x = dw - (w + 20);
                }
                if (y + h + 20 > dh) {
                  y = dh - (h + 20);
                }
                vakata_context.element.css({ "left": x, "top": y }).show().find("a").first().focus().parent().addClass("vakata-context-hover");
                vakata_context.is_visible = true;
                $3.vakata.context._trigger("show");
              }
            },
            hide: function() {
              if (vakata_context.is_visible) {
                vakata_context.element.hide().find("ul").hide().end().find(":focus").blur().end().detach();
                vakata_context.is_visible = false;
                $3.vakata.context._trigger("hide");
              }
            }
          };
          $3(function() {
            right_to_left = $3(document2.body).css("direction") === "rtl";
            var to2 = false;
            vakata_context.element = $3("<ul class='vakata-context'></ul>");
            vakata_context.element.on("mouseenter", "li", function(e) {
              e.stopImmediatePropagation();
              if ($3.contains(this, e.relatedTarget)) {
                return;
              }
              if (to2) {
                clearTimeout(to2);
              }
              vakata_context.element.find(".vakata-context-hover").removeClass("vakata-context-hover").end();
              $3(this).siblings().find("ul").hide().end().end().parentsUntil(".vakata-context", "li").addBack().addClass("vakata-context-hover");
              $3.vakata.context._show_submenu(this);
            }).on("mouseleave", "li", function(e) {
              if ($3.contains(this, e.relatedTarget)) {
                return;
              }
              $3(this).find(".vakata-context-hover").addBack().removeClass("vakata-context-hover");
            }).on("mouseleave", function(e) {
              $3(this).find(".vakata-context-hover").removeClass("vakata-context-hover");
              if ($3.vakata.context.settings.hide_onmouseleave) {
                to2 = setTimeout(
                  function(t) {
                    return function() {
                      $3.vakata.context.hide();
                    };
                  }(this),
                  $3.vakata.context.settings.hide_onmouseleave
                );
              }
            }).on("click", "a", function(e) {
              e.preventDefault();
              if (!$3(this).blur().parent().hasClass("vakata-context-disabled") && $3.vakata.context._execute($3(this).attr("rel")) !== false) {
                $3.vakata.context.hide();
              }
            }).on("keydown", "a", function(e) {
              var o = null;
              switch (e.which) {
                case 13:
                case 32:
                  e.type = "click";
                  e.preventDefault();
                  $3(e.currentTarget).trigger(e);
                  break;
                case 37:
                  if (vakata_context.is_visible) {
                    vakata_context.element.find(".vakata-context-hover").last().closest("li").first().find("ul").hide().find(".vakata-context-hover").removeClass("vakata-context-hover").end().end().children("a").focus();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                  }
                  break;
                case 38:
                  if (vakata_context.is_visible) {
                    o = vakata_context.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").prevAll("li:not(.vakata-context-separator)").first();
                    if (!o.length) {
                      o = vakata_context.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").last();
                    }
                    o.addClass("vakata-context-hover").children("a").focus();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                  }
                  break;
                case 39:
                  if (vakata_context.is_visible) {
                    vakata_context.element.find(".vakata-context-hover").last().children("ul").show().children("li:not(.vakata-context-separator)").removeClass("vakata-context-hover").first().addClass("vakata-context-hover").children("a").focus();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                  }
                  break;
                case 40:
                  if (vakata_context.is_visible) {
                    o = vakata_context.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").nextAll("li:not(.vakata-context-separator)").first();
                    if (!o.length) {
                      o = vakata_context.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").first();
                    }
                    o.addClass("vakata-context-hover").children("a").focus();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                  }
                  break;
                case 27:
                  $3.vakata.context.hide();
                  e.preventDefault();
                  break;
                default:
                  break;
              }
            }).on("keydown", function(e) {
              e.preventDefault();
              var a = vakata_context.element.find(".vakata-contextmenu-shortcut-" + e.which).parent();
              if (a.parent().not(".vakata-context-disabled")) {
                a.click();
              }
            });
            $3(document2).on("mousedown.vakata.jstree", function(e) {
              if (vakata_context.is_visible && vakata_context.element[0] !== e.target && !$3.contains(vakata_context.element[0], e.target)) {
                $3.vakata.context.hide();
              }
            }).on("context_show.vakata.jstree", function(e, data) {
              vakata_context.element.find("li:has(ul)").children("a").addClass("vakata-context-parent");
              if (right_to_left) {
                vakata_context.element.addClass("vakata-context-rtl").css("direction", "rtl");
              }
              vakata_context.element.find("ul").hide().end();
            });
          });
        })($2);
        $2.jstree.defaults.dnd = {
          /**
           * a boolean indicating if a copy should be possible while dragging (by pressint the meta key or Ctrl). Defaults to `true`.
           * @name $.jstree.defaults.dnd.copy
           * @plugin dnd
           */
          copy: true,
          /**
           * a number indicating how long a node should remain hovered while dragging to be opened. Defaults to `500`.
           * @name $.jstree.defaults.dnd.open_timeout
           * @plugin dnd
           */
          open_timeout: 500,
          /**
           * a function invoked each time a node is about to be dragged, invoked in the tree's scope and receives the nodes about to be dragged as an argument (array) and the event that started the drag - return `false` to prevent dragging
           * @name $.jstree.defaults.dnd.is_draggable
           * @plugin dnd
           */
          is_draggable: true,
          /**
           * a boolean indicating if checks should constantly be made while the user is dragging the node (as opposed to checking only on drop), default is `true`
           * @name $.jstree.defaults.dnd.check_while_dragging
           * @plugin dnd
           */
          check_while_dragging: true,
          /**
           * a boolean indicating if nodes from this tree should only be copied with dnd (as opposed to moved), default is `false`
           * @name $.jstree.defaults.dnd.always_copy
           * @plugin dnd
           */
          always_copy: false,
          /**
           * when dropping a node "inside", this setting indicates the position the node should go to - it can be an integer or a string: "first" (same as 0) or "last", default is `0`
           * @name $.jstree.defaults.dnd.inside_pos
           * @plugin dnd
           */
          inside_pos: 0,
          /**
           * when starting the drag on a node that is selected this setting controls if all selected nodes are dragged or only the single node, default is `true`, which means all selected nodes are dragged when the drag is started on a selected node
           * @name $.jstree.defaults.dnd.drag_selection
           * @plugin dnd
           */
          drag_selection: true,
          /**
           * controls whether dnd works on touch devices. If left as boolean true dnd will work the same as in desktop browsers, which in some cases may impair scrolling. If set to boolean false dnd will not work on touch devices. There is a special third option - string "selected" which means only selected nodes can be dragged on touch devices.
           * @name $.jstree.defaults.dnd.touch
           * @plugin dnd
           */
          touch: true,
          /**
           * controls whether items can be dropped anywhere on the node, not just on the anchor, by default only the node anchor is a valid drop target. Works best with the wholerow plugin. If enabled on mobile depending on the interface it might be hard for the user to cancel the drop, since the whole tree container will be a valid drop target.
           * @name $.jstree.defaults.dnd.large_drop_target
           * @plugin dnd
           */
          large_drop_target: false,
          /**
           * controls whether a drag can be initiated from any part of the node and not just the text/icon part, works best with the wholerow plugin. Keep in mind it can cause problems with tree scrolling on mobile depending on the interface - in that case set the touch option to "selected".
           * @name $.jstree.defaults.dnd.large_drag_target
           * @plugin dnd
           */
          large_drag_target: false,
          /**
           * controls whether use HTML5 dnd api instead of classical. That will allow better integration of dnd events with other HTML5 controls.
           * @reference http://caniuse.com/#feat=dragndrop
           * @name $.jstree.defaults.dnd.use_html5
           * @plugin dnd
           */
          use_html5: false
        };
        var drg, elm;
        $2.jstree.plugins.dnd = function(options, parent) {
          this.init = function(el, options2) {
            parent.init.call(this, el, options2);
            this.settings.dnd.use_html5 = this.settings.dnd.use_html5 && "draggable" in document2.createElement("span");
          };
          this.bind = function() {
            parent.bind.call(this);
            this.element.on(this.settings.dnd.use_html5 ? "dragstart.jstree" : "mousedown.jstree touchstart.jstree", this.settings.dnd.large_drag_target ? ".jstree-node" : ".jstree-anchor", $2.proxy(function(e) {
              if (this.settings.dnd.large_drag_target && $2(e.target).closest(".jstree-node")[0] !== e.currentTarget) {
                return true;
              }
              if (e.type === "touchstart" && (!this.settings.dnd.touch || this.settings.dnd.touch === "selected" && !$2(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").hasClass("jstree-clicked"))) {
                return true;
              }
              var obj = this.get_node(e.target), mlt = this.is_selected(obj) && this.settings.dnd.drag_selection ? this.get_top_selected().length : 1, txt = mlt > 1 ? mlt + " " + this.get_string("nodes") : this.get_text(e.currentTarget);
              if (this.settings.core.force_text) {
                txt = $2.vakata.html.escape(txt);
              }
              if (obj && obj.id && obj.id !== $2.jstree.root && (e.which === 1 || e.type === "touchstart" || e.type === "dragstart") && (this.settings.dnd.is_draggable === true || $2.isFunction(this.settings.dnd.is_draggable) && this.settings.dnd.is_draggable.call(this, mlt > 1 ? this.get_top_selected(true) : [obj], e))) {
                drg = { "jstree": true, "origin": this, "obj": this.get_node(obj, true), "nodes": mlt > 1 ? this.get_top_selected() : [obj.id] };
                elm = e.currentTarget;
                if (this.settings.dnd.use_html5) {
                  $2.vakata.dnd._trigger("start", e, { "helper": $2(), "element": elm, "data": drg });
                } else {
                  this.element.trigger("mousedown.jstree");
                  return $2.vakata.dnd.start(e, drg, '<div id="jstree-dnd" class="jstree-' + this.get_theme() + " jstree-" + this.get_theme() + "-" + this.get_theme_variant() + " " + (this.settings.core.themes.responsive ? " jstree-dnd-responsive" : "") + '"><i class="jstree-icon jstree-er"></i>' + txt + '<ins class="jstree-copy" style="display:none;">+</ins></div>');
                }
              }
            }, this));
            if (this.settings.dnd.use_html5) {
              this.element.on("dragover.jstree", function(e) {
                e.preventDefault();
                $2.vakata.dnd._trigger("move", e, { "helper": $2(), "element": elm, "data": drg });
                return false;
              }).on("drop.jstree", $2.proxy(function(e) {
                e.preventDefault();
                $2.vakata.dnd._trigger("stop", e, { "helper": $2(), "element": elm, "data": drg });
                return false;
              }, this));
            }
          };
          this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj && this.settings.dnd.use_html5) {
              if (this.settings.dnd.large_drag_target) {
                obj.setAttribute("draggable", true);
              } else {
                var i, j, tmp = null;
                for (i = 0, j = obj.childNodes.length; i < j; i++) {
                  if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                    tmp = obj.childNodes[i];
                    break;
                  }
                }
                if (tmp) {
                  tmp.setAttribute("draggable", true);
                }
              }
            }
            return obj;
          };
        };
        $2(function() {
          var lastmv = false, laster = false, lastev = false, opento = false, marker = $2('<div id="jstree-marker">&#160;</div>').hide();
          $2(document2).on("dragover.vakata.jstree", function(e) {
            if (elm) {
              $2.vakata.dnd._trigger("move", e, { "helper": $2(), "element": elm, "data": drg });
            }
          }).on("drop.vakata.jstree", function(e) {
            if (elm) {
              $2.vakata.dnd._trigger("stop", e, { "helper": $2(), "element": elm, "data": drg });
              elm = null;
              drg = null;
            }
          }).on("dnd_start.vakata.jstree", function(e, data) {
            lastmv = false;
            lastev = false;
            if (!data || !data.data || !data.data.jstree) {
              return;
            }
            marker.appendTo(document2.body);
          }).on("dnd_move.vakata.jstree", function(e, data) {
            var isDifferentNode = data.event.target !== lastev.target;
            if (opento) {
              if (!data.event || data.event.type !== "dragover" || isDifferentNode) {
                clearTimeout(opento);
              }
            }
            if (!data || !data.data || !data.data.jstree) {
              return;
            }
            if (data.event.target.id && data.event.target.id === "jstree-marker") {
              return;
            }
            lastev = data.event;
            var ins = $2.jstree.reference(data.event.target), ref = false, off = false, rel = false, tmp, l, t, h, p, i, o, ok, t1, t2, op, ps, pr, ip, tm, is_copy, pn, c;
            if (ins && ins._data && ins._data.dnd) {
              marker.attr("class", "jstree-" + ins.get_theme() + (ins.settings.core.themes.responsive ? " jstree-dnd-responsive" : ""));
              is_copy = data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey));
              data.helper.children().attr("class", "jstree-" + ins.get_theme() + " jstree-" + ins.get_theme() + "-" + ins.get_theme_variant() + " " + (ins.settings.core.themes.responsive ? " jstree-dnd-responsive" : "")).find(".jstree-copy").first()[is_copy ? "show" : "hide"]();
              if ((data.event.target === ins.element[0] || data.event.target === ins.get_container_ul()[0]) && ins.get_container_ul().children().length === 0) {
                ok = true;
                for (t1 = 0, t2 = data.data.nodes.length; t1 < t2; t1++) {
                  ok = ok && ins.check(data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node", data.data.origin && data.data.origin !== ins ? data.data.origin.get_node(data.data.nodes[t1]) : data.data.nodes[t1], $2.jstree.root, "last", { "dnd": true, "ref": ins.get_node($2.jstree.root), "pos": "i", "origin": data.data.origin, "is_multi": data.data.origin && data.data.origin !== ins, "is_foreign": !data.data.origin });
                  if (!ok) {
                    break;
                  }
                }
                if (ok) {
                  lastmv = { "ins": ins, "par": $2.jstree.root, "pos": "last" };
                  marker.hide();
                  data.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok");
                  if (data.event.originalEvent && data.event.originalEvent.dataTransfer) {
                    data.event.originalEvent.dataTransfer.dropEffect = is_copy ? "copy" : "move";
                  }
                  return;
                }
              } else {
                ref = ins.settings.dnd.large_drop_target ? $2(data.event.target).closest(".jstree-node").children(".jstree-anchor") : $2(data.event.target).closest(".jstree-anchor");
                if (ref && ref.length && ref.parent().is(".jstree-closed, .jstree-open, .jstree-leaf")) {
                  off = ref.offset();
                  rel = (data.event.pageY !== undefined2 ? data.event.pageY : data.event.originalEvent.pageY) - off.top;
                  h = ref.outerHeight();
                  if (rel < h / 3) {
                    o = ["b", "i", "a"];
                  } else if (rel > h - h / 3) {
                    o = ["a", "i", "b"];
                  } else {
                    o = rel > h / 2 ? ["i", "a", "b"] : ["i", "b", "a"];
                  }
                  $2.each(o, function(j, v) {
                    switch (v) {
                      case "b":
                        l = off.left - 6;
                        t = off.top;
                        p = ins.get_parent(ref);
                        i = ref.parent().index();
                        c = "jstree-below";
                        break;
                      case "i":
                        ip = ins.settings.dnd.inside_pos;
                        tm = ins.get_node(ref.parent());
                        l = off.left - 2;
                        t = off.top + h / 2 + 1;
                        p = tm.id;
                        i = ip === "first" ? 0 : ip === "last" ? tm.children.length : Math.min(ip, tm.children.length);
                        c = "jstree-inside";
                        break;
                      case "a":
                        l = off.left - 6;
                        t = off.top + h;
                        p = ins.get_parent(ref);
                        i = ref.parent().index() + 1;
                        c = "jstree-above";
                        break;
                    }
                    ok = true;
                    for (t1 = 0, t2 = data.data.nodes.length; t1 < t2; t1++) {
                      op = data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node";
                      ps = i;
                      if (op === "move_node" && v === "a" && (data.data.origin && data.data.origin === ins) && p === ins.get_parent(data.data.nodes[t1])) {
                        pr = ins.get_node(p);
                        if (ps > $2.inArray(data.data.nodes[t1], pr.children)) {
                          ps -= 1;
                        }
                      }
                      ok = ok && (ins && ins.settings && ins.settings.dnd && ins.settings.dnd.check_while_dragging === false || ins.check(op, data.data.origin && data.data.origin !== ins ? data.data.origin.get_node(data.data.nodes[t1]) : data.data.nodes[t1], p, ps, { "dnd": true, "ref": ins.get_node(ref.parent()), "pos": v, "origin": data.data.origin, "is_multi": data.data.origin && data.data.origin !== ins, "is_foreign": !data.data.origin }));
                      if (!ok) {
                        if (ins && ins.last_error) {
                          laster = ins.last_error();
                        }
                        break;
                      }
                    }
                    if (v === "i" && ref.parent().is(".jstree-closed") && ins.settings.dnd.open_timeout) {
                      if (!data.event || data.event.type !== "dragover" || isDifferentNode) {
                        if (opento) {
                          clearTimeout(opento);
                        }
                        opento = setTimeout(function(x, z) {
                          return function() {
                            x.open_node(z);
                          };
                        }(ins, ref), ins.settings.dnd.open_timeout);
                      }
                    }
                    if (ok) {
                      pn = ins.get_node(p, true);
                      if (!pn.hasClass(".jstree-dnd-parent")) {
                        $2(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
                        pn.addClass("jstree-dnd-parent");
                      }
                      lastmv = { "ins": ins, "par": p, "pos": v === "i" && ip === "last" && i === 0 && !ins.is_loaded(tm) ? "last" : i };
                      marker.css({ "left": l + "px", "top": t + "px" }).show();
                      marker.removeClass("jstree-above jstree-inside jstree-below").addClass(c);
                      data.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok");
                      if (data.event.originalEvent && data.event.originalEvent.dataTransfer) {
                        data.event.originalEvent.dataTransfer.dropEffect = is_copy ? "copy" : "move";
                      }
                      laster = {};
                      o = true;
                      return false;
                    }
                  });
                  if (o === true) {
                    return;
                  }
                }
              }
            }
            $2(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
            lastmv = false;
            data.helper.find(".jstree-icon").removeClass("jstree-ok").addClass("jstree-er");
            if (data.event.originalEvent && data.event.originalEvent.dataTransfer) {
            }
            marker.hide();
          }).on("dnd_scroll.vakata.jstree", function(e, data) {
            if (!data || !data.data || !data.data.jstree) {
              return;
            }
            marker.hide();
            lastmv = false;
            lastev = false;
            data.helper.find(".jstree-icon").first().removeClass("jstree-ok").addClass("jstree-er");
          }).on("dnd_stop.vakata.jstree", function(e, data) {
            $2(".jstree-dnd-parent").removeClass("jstree-dnd-parent");
            if (opento) {
              clearTimeout(opento);
            }
            if (!data || !data.data || !data.data.jstree) {
              return;
            }
            marker.hide().detach();
            var i, j, nodes = [];
            if (lastmv) {
              for (i = 0, j = data.data.nodes.length; i < j; i++) {
                nodes[i] = data.data.origin ? data.data.origin.get_node(data.data.nodes[i]) : data.data.nodes[i];
              }
              lastmv.ins[data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (data.event.metaKey || data.event.ctrlKey)) ? "copy_node" : "move_node"](nodes, lastmv.par, lastmv.pos, false, false, false, data.data.origin);
            } else {
              i = $2(data.event.target).closest(".jstree");
              if (i.length && laster && laster.error && laster.error === "check") {
                i = i.jstree(true);
                if (i) {
                  i.settings.core.error.call(this, laster);
                }
              }
            }
            lastev = false;
            lastmv = false;
          }).on("keyup.jstree keydown.jstree", function(e, data) {
            data = $2.vakata.dnd._get();
            if (data && data.data && data.data.jstree) {
              if (e.type === "keyup" && e.which === 27) {
                if (opento) {
                  clearTimeout(opento);
                }
                lastmv = false;
                laster = false;
                lastev = false;
                opento = false;
                marker.hide().detach();
                $2.vakata.dnd._clean();
              } else {
                data.helper.find(".jstree-copy").first()[data.data.origin && (data.data.origin.settings.dnd.always_copy || data.data.origin.settings.dnd.copy && (e.metaKey || e.ctrlKey)) ? "show" : "hide"]();
                if (lastev) {
                  lastev.metaKey = e.metaKey;
                  lastev.ctrlKey = e.ctrlKey;
                  $2.vakata.dnd._trigger("move", lastev);
                }
              }
            }
          });
        });
        (function($3) {
          $3.vakata.html = {
            div: $3("<div></div>"),
            escape: function(str) {
              return $3.vakata.html.div.text(str).html();
            },
            strip: function(str) {
              return $3.vakata.html.div.empty().append($3.parseHTML(str)).text();
            }
          };
          var vakata_dnd = {
            element: false,
            target: false,
            is_down: false,
            is_drag: false,
            helper: false,
            helper_w: 0,
            data: false,
            init_x: 0,
            init_y: 0,
            scroll_l: 0,
            scroll_t: 0,
            scroll_e: false,
            scroll_i: false,
            is_touch: false
          };
          $3.vakata.dnd = {
            settings: {
              scroll_speed: 10,
              scroll_proximity: 20,
              helper_left: 5,
              helper_top: 10,
              threshold: 5,
              threshold_touch: 10
            },
            _trigger: function(event_name, e, data) {
              if (data === undefined2) {
                data = $3.vakata.dnd._get();
              }
              data.event = e;
              $3(document2).triggerHandler("dnd_" + event_name + ".vakata", data);
            },
            _get: function() {
              return {
                "data": vakata_dnd.data,
                "element": vakata_dnd.element,
                "helper": vakata_dnd.helper
              };
            },
            _clean: function() {
              if (vakata_dnd.helper) {
                vakata_dnd.helper.remove();
              }
              if (vakata_dnd.scroll_i) {
                clearInterval(vakata_dnd.scroll_i);
                vakata_dnd.scroll_i = false;
              }
              vakata_dnd = {
                element: false,
                target: false,
                is_down: false,
                is_drag: false,
                helper: false,
                helper_w: 0,
                data: false,
                init_x: 0,
                init_y: 0,
                scroll_l: 0,
                scroll_t: 0,
                scroll_e: false,
                scroll_i: false,
                is_touch: false
              };
              elm = null;
              $3(document2).off("mousemove.vakata.jstree touchmove.vakata.jstree", $3.vakata.dnd.drag);
              $3(document2).off("mouseup.vakata.jstree touchend.vakata.jstree", $3.vakata.dnd.stop);
            },
            _scroll: function(init_only) {
              if (!vakata_dnd.scroll_e || !vakata_dnd.scroll_l && !vakata_dnd.scroll_t) {
                if (vakata_dnd.scroll_i) {
                  clearInterval(vakata_dnd.scroll_i);
                  vakata_dnd.scroll_i = false;
                }
                return false;
              }
              if (!vakata_dnd.scroll_i) {
                vakata_dnd.scroll_i = setInterval($3.vakata.dnd._scroll, 100);
                return false;
              }
              if (init_only === true) {
                return false;
              }
              var i = vakata_dnd.scroll_e.scrollTop(), j = vakata_dnd.scroll_e.scrollLeft();
              vakata_dnd.scroll_e.scrollTop(i + vakata_dnd.scroll_t * $3.vakata.dnd.settings.scroll_speed);
              vakata_dnd.scroll_e.scrollLeft(j + vakata_dnd.scroll_l * $3.vakata.dnd.settings.scroll_speed);
              if (i !== vakata_dnd.scroll_e.scrollTop() || j !== vakata_dnd.scroll_e.scrollLeft()) {
                $3.vakata.dnd._trigger("scroll", vakata_dnd.scroll_e);
              }
            },
            start: function(e, data, html) {
              if (e.type === "touchstart" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                e.pageX = e.originalEvent.changedTouches[0].pageX;
                e.pageY = e.originalEvent.changedTouches[0].pageY;
                e.target = document2.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
              }
              if (vakata_dnd.is_drag) {
                $3.vakata.dnd.stop({});
              }
              try {
                e.currentTarget.unselectable = "on";
                e.currentTarget.onselectstart = function() {
                  return false;
                };
                if (e.currentTarget.style) {
                  e.currentTarget.style.touchAction = "none";
                  e.currentTarget.style.msTouchAction = "none";
                  e.currentTarget.style.MozUserSelect = "none";
                }
              } catch (ignore) {
              }
              vakata_dnd.init_x = e.pageX;
              vakata_dnd.init_y = e.pageY;
              vakata_dnd.data = data;
              vakata_dnd.is_down = true;
              vakata_dnd.element = e.currentTarget;
              vakata_dnd.target = e.target;
              vakata_dnd.is_touch = e.type === "touchstart";
              if (html !== false) {
                vakata_dnd.helper = $3("<div id='vakata-dnd'></div>").html(html).css({
                  "display": "block",
                  "margin": "0",
                  "padding": "0",
                  "position": "absolute",
                  "top": "-2000px",
                  "lineHeight": "16px",
                  "zIndex": "10000"
                });
              }
              $3(document2).on("mousemove.vakata.jstree touchmove.vakata.jstree", $3.vakata.dnd.drag);
              $3(document2).on("mouseup.vakata.jstree touchend.vakata.jstree", $3.vakata.dnd.stop);
              return false;
            },
            drag: function(e) {
              if (e.type === "touchmove" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                e.pageX = e.originalEvent.changedTouches[0].pageX;
                e.pageY = e.originalEvent.changedTouches[0].pageY;
                e.target = document2.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
              }
              if (!vakata_dnd.is_down) {
                return;
              }
              if (!vakata_dnd.is_drag) {
                if (Math.abs(e.pageX - vakata_dnd.init_x) > (vakata_dnd.is_touch ? $3.vakata.dnd.settings.threshold_touch : $3.vakata.dnd.settings.threshold) || Math.abs(e.pageY - vakata_dnd.init_y) > (vakata_dnd.is_touch ? $3.vakata.dnd.settings.threshold_touch : $3.vakata.dnd.settings.threshold)) {
                  if (vakata_dnd.helper) {
                    vakata_dnd.helper.appendTo(document2.body);
                    vakata_dnd.helper_w = vakata_dnd.helper.outerWidth();
                  }
                  vakata_dnd.is_drag = true;
                  $3(vakata_dnd.target).one("click.vakata", false);
                  $3.vakata.dnd._trigger("start", e);
                } else {
                  return;
                }
              }
              var d = false, w = false, dh = false, wh = false, dw = false, ww = false, dt = false, dl = false, ht = false, hl = false;
              vakata_dnd.scroll_t = 0;
              vakata_dnd.scroll_l = 0;
              vakata_dnd.scroll_e = false;
              $3($3(e.target).parentsUntil("body").addBack().get().reverse()).filter(function() {
                return /^auto|scroll$/.test($3(this).css("overflow")) && (this.scrollHeight > this.offsetHeight || this.scrollWidth > this.offsetWidth);
              }).each(function() {
                var t = $3(this), o = t.offset();
                if (this.scrollHeight > this.offsetHeight) {
                  if (o.top + t.height() - e.pageY < $3.vakata.dnd.settings.scroll_proximity) {
                    vakata_dnd.scroll_t = 1;
                  }
                  if (e.pageY - o.top < $3.vakata.dnd.settings.scroll_proximity) {
                    vakata_dnd.scroll_t = -1;
                  }
                }
                if (this.scrollWidth > this.offsetWidth) {
                  if (o.left + t.width() - e.pageX < $3.vakata.dnd.settings.scroll_proximity) {
                    vakata_dnd.scroll_l = 1;
                  }
                  if (e.pageX - o.left < $3.vakata.dnd.settings.scroll_proximity) {
                    vakata_dnd.scroll_l = -1;
                  }
                }
                if (vakata_dnd.scroll_t || vakata_dnd.scroll_l) {
                  vakata_dnd.scroll_e = $3(this);
                  return false;
                }
              });
              if (!vakata_dnd.scroll_e) {
                d = $3(document2);
                w = $3(window);
                dh = d.height();
                wh = w.height();
                dw = d.width();
                ww = w.width();
                dt = d.scrollTop();
                dl = d.scrollLeft();
                if (dh > wh && e.pageY - dt < $3.vakata.dnd.settings.scroll_proximity) {
                  vakata_dnd.scroll_t = -1;
                }
                if (dh > wh && wh - (e.pageY - dt) < $3.vakata.dnd.settings.scroll_proximity) {
                  vakata_dnd.scroll_t = 1;
                }
                if (dw > ww && e.pageX - dl < $3.vakata.dnd.settings.scroll_proximity) {
                  vakata_dnd.scroll_l = -1;
                }
                if (dw > ww && ww - (e.pageX - dl) < $3.vakata.dnd.settings.scroll_proximity) {
                  vakata_dnd.scroll_l = 1;
                }
                if (vakata_dnd.scroll_t || vakata_dnd.scroll_l) {
                  vakata_dnd.scroll_e = d;
                }
              }
              if (vakata_dnd.scroll_e) {
                $3.vakata.dnd._scroll(true);
              }
              if (vakata_dnd.helper) {
                ht = parseInt(e.pageY + $3.vakata.dnd.settings.helper_top, 10);
                hl = parseInt(e.pageX + $3.vakata.dnd.settings.helper_left, 10);
                if (dh && ht + 25 > dh) {
                  ht = dh - 50;
                }
                if (dw && hl + vakata_dnd.helper_w > dw) {
                  hl = dw - (vakata_dnd.helper_w + 2);
                }
                vakata_dnd.helper.css({
                  left: hl + "px",
                  top: ht + "px"
                });
              }
              $3.vakata.dnd._trigger("move", e);
              return false;
            },
            stop: function(e) {
              if (e.type === "touchend" && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
                e.pageX = e.originalEvent.changedTouches[0].pageX;
                e.pageY = e.originalEvent.changedTouches[0].pageY;
                e.target = document2.elementFromPoint(e.originalEvent.changedTouches[0].pageX - window.pageXOffset, e.originalEvent.changedTouches[0].pageY - window.pageYOffset);
              }
              if (vakata_dnd.is_drag) {
                if (e.target !== vakata_dnd.target) {
                  $3(vakata_dnd.target).off("click.vakata");
                }
                $3.vakata.dnd._trigger("stop", e);
              } else {
                if (e.type === "touchend" && e.target === vakata_dnd.target) {
                  var to2 = setTimeout(function() {
                    $3(e.target).click();
                  }, 100);
                  $3(e.target).one("click", function() {
                    if (to2) {
                      clearTimeout(to2);
                    }
                  });
                }
              }
              $3.vakata.dnd._clean();
              return false;
            }
          };
        })($2);
        $2.jstree.defaults.massload = null;
        $2.jstree.plugins.massload = function(options, parent) {
          this.init = function(el, options2) {
            this._data.massload = {};
            parent.init.call(this, el, options2);
          };
          this._load_nodes = function(nodes, callback, is_callback, force_reload) {
            var s = this.settings.massload, toLoad = [], m = this._model.data, i, j, dom;
            if (!is_callback) {
              for (i = 0, j = nodes.length; i < j; i++) {
                if (!m[nodes[i]] || (!m[nodes[i]].state.loaded && !m[nodes[i]].state.failed || force_reload)) {
                  toLoad.push(nodes[i]);
                  dom = this.get_node(nodes[i], true);
                  if (dom && dom.length) {
                    dom.addClass("jstree-loading").attr("aria-busy", true);
                  }
                }
              }
              this._data.massload = {};
              if (toLoad.length) {
                if ($2.isFunction(s)) {
                  return s.call(this, toLoad, $2.proxy(function(data) {
                    var i2, j2;
                    if (data) {
                      for (i2 in data) {
                        if (data.hasOwnProperty(i2)) {
                          this._data.massload[i2] = data[i2];
                        }
                      }
                    }
                    for (i2 = 0, j2 = nodes.length; i2 < j2; i2++) {
                      dom = this.get_node(nodes[i2], true);
                      if (dom && dom.length) {
                        dom.removeClass("jstree-loading").attr("aria-busy", false);
                      }
                    }
                    parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                  }, this));
                }
                if (typeof s === "object" && s && s.url) {
                  s = $2.extend(true, {}, s);
                  if ($2.isFunction(s.url)) {
                    s.url = s.url.call(this, toLoad);
                  }
                  if ($2.isFunction(s.data)) {
                    s.data = s.data.call(this, toLoad);
                  }
                  return $2.ajax(s).done($2.proxy(function(data, t, x) {
                    var i2, j2;
                    if (data) {
                      for (i2 in data) {
                        if (data.hasOwnProperty(i2)) {
                          this._data.massload[i2] = data[i2];
                        }
                      }
                    }
                    for (i2 = 0, j2 = nodes.length; i2 < j2; i2++) {
                      dom = this.get_node(nodes[i2], true);
                      if (dom && dom.length) {
                        dom.removeClass("jstree-loading").attr("aria-busy", false);
                      }
                    }
                    parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                  }, this)).fail($2.proxy(function(f) {
                    parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
                  }, this));
                }
              }
            }
            return parent._load_nodes.call(this, nodes, callback, is_callback, force_reload);
          };
          this._load_node = function(obj, callback) {
            var data = this._data.massload[obj.id], rslt = null, dom;
            if (data) {
              rslt = this[typeof data === "string" ? "_append_html_data" : "_append_json_data"](
                obj,
                typeof data === "string" ? $2($2.parseHTML(data)).filter(function() {
                  return this.nodeType !== 3;
                }) : data,
                function(status) {
                  callback.call(this, status);
                }
              );
              dom = this.get_node(obj.id, true);
              if (dom && dom.length) {
                dom.removeClass("jstree-loading").attr("aria-busy", false);
              }
              delete this._data.massload[obj.id];
              return rslt;
            }
            return parent._load_node.call(this, obj, callback);
          };
        };
        $2.jstree.defaults.search = {
          /**
           * a jQuery-like AJAX config, which jstree uses if a server should be queried for results.
           *
           * A `str` (which is the search string) parameter will be added with the request, an optional `inside` parameter will be added if the search is limited to a node id. The expected result is a JSON array with nodes that need to be opened so that matching nodes will be revealed.
           * Leave this setting as `false` to not query the server. You can also set this to a function, which will be invoked in the instance's scope and receive 3 parameters - the search string, the callback to call with the array of nodes to load, and the optional node ID to limit the search to
           * @name $.jstree.defaults.search.ajax
           * @plugin search
           */
          ajax: false,
          /**
           * Indicates if the search should be fuzzy or not (should `chnd3` match `child node 3`). Default is `false`.
           * @name $.jstree.defaults.search.fuzzy
           * @plugin search
           */
          fuzzy: false,
          /**
           * Indicates if the search should be case sensitive. Default is `false`.
           * @name $.jstree.defaults.search.case_sensitive
           * @plugin search
           */
          case_sensitive: false,
          /**
           * Indicates if the tree should be filtered (by default) to show only matching nodes (keep in mind this can be a heavy on large trees in old browsers).
           * This setting can be changed at runtime when calling the search method. Default is `false`.
           * @name $.jstree.defaults.search.show_only_matches
           * @plugin search
           */
          show_only_matches: false,
          /**
           * Indicates if the children of matched element are shown (when show_only_matches is true)
           * This setting can be changed at runtime when calling the search method. Default is `false`.
           * @name $.jstree.defaults.search.show_only_matches_children
           * @plugin search
           */
          show_only_matches_children: false,
          /**
           * Indicates if all nodes opened to reveal the search result, should be closed when the search is cleared or a new search is performed. Default is `true`.
           * @name $.jstree.defaults.search.close_opened_onclear
           * @plugin search
           */
          close_opened_onclear: true,
          /**
           * Indicates if only leaf nodes should be included in search results. Default is `false`.
           * @name $.jstree.defaults.search.search_leaves_only
           * @plugin search
           */
          search_leaves_only: false,
          /**
           * If set to a function it wil be called in the instance's scope with two arguments - search string and node (where node will be every node in the structure, so use with caution).
           * If the function returns a truthy value the node will be considered a match (it might not be displayed if search_only_leaves is set to true and the node is not a leaf). Default is `false`.
           * @name $.jstree.defaults.search.search_callback
           * @plugin search
           */
          search_callback: false
        };
        $2.jstree.plugins.search = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            this._data.search.str = "";
            this._data.search.dom = $2();
            this._data.search.res = [];
            this._data.search.opn = [];
            this._data.search.som = false;
            this._data.search.smc = false;
            this._data.search.hdn = [];
            this.element.on("search.jstree", $2.proxy(function(e, data) {
              if (this._data.search.som && data.res.length) {
                var m = this._model.data, i, j, p = [], k, l;
                for (i = 0, j = data.res.length; i < j; i++) {
                  if (m[data.res[i]] && !m[data.res[i]].state.hidden) {
                    p.push(data.res[i]);
                    p = p.concat(m[data.res[i]].parents);
                    if (this._data.search.smc) {
                      for (k = 0, l = m[data.res[i]].children_d.length; k < l; k++) {
                        if (m[m[data.res[i]].children_d[k]] && !m[m[data.res[i]].children_d[k]].state.hidden) {
                          p.push(m[data.res[i]].children_d[k]);
                        }
                      }
                    }
                  }
                }
                p = $2.vakata.array_remove_item($2.vakata.array_unique(p), $2.jstree.root);
                this._data.search.hdn = this.hide_all(true);
                this.show_node(p, true);
                this.redraw(true);
              }
            }, this)).on("clear_search.jstree", $2.proxy(function(e, data) {
              if (this._data.search.som && data.res.length) {
                this.show_node(this._data.search.hdn, true);
                this.redraw(true);
              }
            }, this));
          };
          this.search = function(str, skip_async, show_only_matches, inside, append, show_only_matches_children) {
            if (str === false || $2.trim(str.toString()) === "") {
              return this.clear_search();
            }
            inside = this.get_node(inside);
            inside = inside && inside.id ? inside.id : null;
            str = str.toString();
            var s = this.settings.search, a = s.ajax ? s.ajax : false, m = this._model.data, f = null, r = [], p = [], i, j;
            if (this._data.search.res.length && !append) {
              this.clear_search();
            }
            if (show_only_matches === undefined2) {
              show_only_matches = s.show_only_matches;
            }
            if (show_only_matches_children === undefined2) {
              show_only_matches_children = s.show_only_matches_children;
            }
            if (!skip_async && a !== false) {
              if ($2.isFunction(a)) {
                return a.call(this, str, $2.proxy(function(d) {
                  if (d && d.d) {
                    d = d.d;
                  }
                  this._load_nodes(!$2.isArray(d) ? [] : $2.vakata.array_unique(d), function() {
                    this.search(str, true, show_only_matches, inside, append, show_only_matches_children);
                  });
                }, this), inside);
              } else {
                a = $2.extend({}, a);
                if (!a.data) {
                  a.data = {};
                }
                a.data.str = str;
                if (inside) {
                  a.data.inside = inside;
                }
                if (this._data.search.lastRequest) {
                  this._data.search.lastRequest.abort();
                }
                this._data.search.lastRequest = $2.ajax(a).fail($2.proxy(function() {
                  this._data.core.last_error = { "error": "ajax", "plugin": "search", "id": "search_01", "reason": "Could not load search parents", "data": JSON.stringify(a) };
                  this.settings.core.error.call(this, this._data.core.last_error);
                }, this)).done($2.proxy(function(d) {
                  if (d && d.d) {
                    d = d.d;
                  }
                  this._load_nodes(!$2.isArray(d) ? [] : $2.vakata.array_unique(d), function() {
                    this.search(str, true, show_only_matches, inside, append, show_only_matches_children);
                  });
                }, this));
                return this._data.search.lastRequest;
              }
            }
            if (!append) {
              this._data.search.str = str;
              this._data.search.dom = $2();
              this._data.search.res = [];
              this._data.search.opn = [];
              this._data.search.som = show_only_matches;
              this._data.search.smc = show_only_matches_children;
            }
            f = new $2.vakata.search(str, true, { caseSensitive: s.case_sensitive, fuzzy: s.fuzzy });
            $2.each(m[inside ? inside : $2.jstree.root].children_d, function(ii, i2) {
              var v = m[i2];
              if (v.text && !v.state.hidden && (!s.search_leaves_only || v.state.loaded && v.children.length === 0) && (s.search_callback && s.search_callback.call(this, str, v) || !s.search_callback && f.search(v.text).isMatch)) {
                r.push(i2);
                p = p.concat(v.parents);
              }
            });
            if (r.length) {
              p = $2.vakata.array_unique(p);
              for (i = 0, j = p.length; i < j; i++) {
                if (p[i] !== $2.jstree.root && m[p[i]] && this.open_node(p[i], null, 0) === true) {
                  this._data.search.opn.push(p[i]);
                }
              }
              if (!append) {
                this._data.search.dom = $2(this.element[0].querySelectorAll("#" + $2.map(r, function(v) {
                  return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($2.jstree.idregex, "\\$&") : v.replace($2.jstree.idregex, "\\$&");
                }).join(", #")));
                this._data.search.res = r;
              } else {
                this._data.search.dom = this._data.search.dom.add($2(this.element[0].querySelectorAll("#" + $2.map(r, function(v) {
                  return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($2.jstree.idregex, "\\$&") : v.replace($2.jstree.idregex, "\\$&");
                }).join(", #"))));
                this._data.search.res = $2.vakata.array_unique(this._data.search.res.concat(r));
              }
              this._data.search.dom.children(".jstree-anchor").addClass("jstree-search");
            }
            this.trigger("search", { nodes: this._data.search.dom, str, res: this._data.search.res, show_only_matches });
          };
          this.clear_search = function() {
            if (this.settings.search.close_opened_onclear) {
              this.close_node(this._data.search.opn, 0);
            }
            this.trigger("clear_search", { "nodes": this._data.search.dom, str: this._data.search.str, res: this._data.search.res });
            if (this._data.search.res.length) {
              this._data.search.dom = $2(this.element[0].querySelectorAll("#" + $2.map(this._data.search.res, function(v) {
                return "0123456789".indexOf(v[0]) !== -1 ? "\\3" + v[0] + " " + v.substr(1).replace($2.jstree.idregex, "\\$&") : v.replace($2.jstree.idregex, "\\$&");
              }).join(", #")));
              this._data.search.dom.children(".jstree-anchor").removeClass("jstree-search");
            }
            this._data.search.str = "";
            this._data.search.res = [];
            this._data.search.opn = [];
            this._data.search.dom = $2();
          };
          this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
              if ($2.inArray(obj.id, this._data.search.res) !== -1) {
                var i, j, tmp = null;
                for (i = 0, j = obj.childNodes.length; i < j; i++) {
                  if (obj.childNodes[i] && obj.childNodes[i].className && obj.childNodes[i].className.indexOf("jstree-anchor") !== -1) {
                    tmp = obj.childNodes[i];
                    break;
                  }
                }
                if (tmp) {
                  tmp.className += " jstree-search";
                }
              }
            }
            return obj;
          };
        };
        (function($3) {
          $3.vakata.search = function(pattern, txt, options) {
            options = options || {};
            options = $3.extend({}, $3.vakata.search.defaults, options);
            if (options.fuzzy !== false) {
              options.fuzzy = true;
            }
            pattern = options.caseSensitive ? pattern : pattern.toLowerCase();
            var MATCH_LOCATION = options.location, MATCH_DISTANCE = options.distance, MATCH_THRESHOLD = options.threshold, patternLen = pattern.length, matchmask, pattern_alphabet, match_bitapScore, search;
            if (patternLen > 32) {
              options.fuzzy = false;
            }
            if (options.fuzzy) {
              matchmask = 1 << patternLen - 1;
              pattern_alphabet = function() {
                var mask = {}, i = 0;
                for (i = 0; i < patternLen; i++) {
                  mask[pattern.charAt(i)] = 0;
                }
                for (i = 0; i < patternLen; i++) {
                  mask[pattern.charAt(i)] |= 1 << patternLen - i - 1;
                }
                return mask;
              }();
              match_bitapScore = function(e, x) {
                var accuracy = e / patternLen, proximity = Math.abs(MATCH_LOCATION - x);
                if (!MATCH_DISTANCE) {
                  return proximity ? 1 : accuracy;
                }
                return accuracy + proximity / MATCH_DISTANCE;
              };
            }
            search = function(text) {
              text = options.caseSensitive ? text : text.toLowerCase();
              if (pattern === text || text.indexOf(pattern) !== -1) {
                return {
                  isMatch: true,
                  score: 0
                };
              }
              if (!options.fuzzy) {
                return {
                  isMatch: false,
                  score: 1
                };
              }
              var i, j, textLen = text.length, scoreThreshold = MATCH_THRESHOLD, bestLoc = text.indexOf(pattern, MATCH_LOCATION), binMin, binMid, binMax = patternLen + textLen, lastRd, start, finish, rd, charMatch, score = 1, locations = [];
              if (bestLoc !== -1) {
                scoreThreshold = Math.min(match_bitapScore(0, bestLoc), scoreThreshold);
                bestLoc = text.lastIndexOf(pattern, MATCH_LOCATION + patternLen);
                if (bestLoc !== -1) {
                  scoreThreshold = Math.min(match_bitapScore(0, bestLoc), scoreThreshold);
                }
              }
              bestLoc = -1;
              for (i = 0; i < patternLen; i++) {
                binMin = 0;
                binMid = binMax;
                while (binMin < binMid) {
                  if (match_bitapScore(i, MATCH_LOCATION + binMid) <= scoreThreshold) {
                    binMin = binMid;
                  } else {
                    binMax = binMid;
                  }
                  binMid = Math.floor((binMax - binMin) / 2 + binMin);
                }
                binMax = binMid;
                start = Math.max(1, MATCH_LOCATION - binMid + 1);
                finish = Math.min(MATCH_LOCATION + binMid, textLen) + patternLen;
                rd = new Array(finish + 2);
                rd[finish + 1] = (1 << i) - 1;
                for (j = finish; j >= start; j--) {
                  charMatch = pattern_alphabet[text.charAt(j - 1)];
                  if (i === 0) {
                    rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
                  } else {
                    rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((lastRd[j + 1] | lastRd[j]) << 1 | 1) | lastRd[j + 1];
                  }
                  if (rd[j] & matchmask) {
                    score = match_bitapScore(i, j - 1);
                    if (score <= scoreThreshold) {
                      scoreThreshold = score;
                      bestLoc = j - 1;
                      locations.push(bestLoc);
                      if (bestLoc > MATCH_LOCATION) {
                        start = Math.max(1, 2 * MATCH_LOCATION - bestLoc);
                      } else {
                        break;
                      }
                    }
                  }
                }
                if (match_bitapScore(i + 1, MATCH_LOCATION) > scoreThreshold) {
                  break;
                }
                lastRd = rd;
              }
              return {
                isMatch: bestLoc >= 0,
                score
              };
            };
            return txt === true ? { "search": search } : search(txt);
          };
          $3.vakata.search.defaults = {
            location: 0,
            distance: 100,
            threshold: 0.6,
            fuzzy: false,
            caseSensitive: false
          };
        })($2);
        $2.jstree.defaults.sort = function(a, b) {
          return this.get_text(a) > this.get_text(b) ? 1 : -1;
        };
        $2.jstree.plugins.sort = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            this.element.on("model.jstree", $2.proxy(function(e, data) {
              this.sort(data.parent, true);
            }, this)).on("rename_node.jstree create_node.jstree", $2.proxy(function(e, data) {
              this.sort(data.parent || data.node.parent, false);
              this.redraw_node(data.parent || data.node.parent, true);
            }, this)).on("move_node.jstree copy_node.jstree", $2.proxy(function(e, data) {
              this.sort(data.parent, false);
              this.redraw_node(data.parent, true);
            }, this));
          };
          this.sort = function(obj, deep) {
            var i, j;
            obj = this.get_node(obj);
            if (obj && obj.children && obj.children.length) {
              obj.children.sort($2.proxy(this.settings.sort, this));
              if (deep) {
                for (i = 0, j = obj.children_d.length; i < j; i++) {
                  this.sort(obj.children_d[i], false);
                }
              }
            }
          };
        };
        var to = false;
        $2.jstree.defaults.state = {
          /**
           * A string for the key to use when saving the current tree (change if using multiple trees in your project). Defaults to `jstree`.
           * @name $.jstree.defaults.state.key
           * @plugin state
           */
          key: "jstree",
          /**
           * A space separated list of events that trigger a state save. Defaults to `changed.jstree open_node.jstree close_node.jstree`.
           * @name $.jstree.defaults.state.events
           * @plugin state
           */
          events: "changed.jstree open_node.jstree close_node.jstree check_node.jstree uncheck_node.jstree",
          /**
           * Time in milliseconds after which the state will expire. Defaults to 'false' meaning - no expire.
           * @name $.jstree.defaults.state.ttl
           * @plugin state
           */
          ttl: false,
          /**
           * A function that will be executed prior to restoring state with one argument - the state object. Can be used to clear unwanted parts of the state.
           * @name $.jstree.defaults.state.filter
           * @plugin state
           */
          filter: false,
          /**
           * Should loaded nodes be restored (setting this to true means that it is possible that the whole tree will be loaded for some users - use with caution). Defaults to `false`
           * @name $.jstree.defaults.state.preserve_loaded
           * @plugin state
           */
          preserve_loaded: false
        };
        $2.jstree.plugins.state = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            var bind = $2.proxy(function() {
              this.element.on(this.settings.state.events, $2.proxy(function() {
                if (to) {
                  clearTimeout(to);
                }
                to = setTimeout($2.proxy(function() {
                  this.save_state();
                }, this), 100);
              }, this));
              this.trigger("state_ready");
            }, this);
            this.element.on("ready.jstree", $2.proxy(function(e, data) {
              this.element.one("restore_state.jstree", bind);
              if (!this.restore_state()) {
                bind();
              }
            }, this));
          };
          this.save_state = function() {
            var tm = this.get_state();
            if (!this.settings.state.preserve_loaded) {
              delete tm.core.loaded;
            }
            var st = { "state": tm, "ttl": this.settings.state.ttl, "sec": +/* @__PURE__ */ new Date() };
            $2.vakata.storage.set(this.settings.state.key, JSON.stringify(st));
          };
          this.restore_state = function() {
            var k = $2.vakata.storage.get(this.settings.state.key);
            if (!!k) {
              try {
                k = JSON.parse(k);
              } catch (ex) {
                return false;
              }
            }
            if (!!k && k.ttl && k.sec && +/* @__PURE__ */ new Date() - k.sec > k.ttl) {
              return false;
            }
            if (!!k && k.state) {
              k = k.state;
            }
            if (!!k && $2.isFunction(this.settings.state.filter)) {
              k = this.settings.state.filter.call(this, k);
            }
            if (!!k) {
              if (!this.settings.state.preserve_loaded) {
                delete k.core.loaded;
              }
              this.element.one("set_state.jstree", function(e, data) {
                data.instance.trigger("restore_state", { "state": $2.extend(true, {}, k) });
              });
              this.set_state(k);
              return true;
            }
            return false;
          };
          this.clear_state = function() {
            return $2.vakata.storage.del(this.settings.state.key);
          };
        };
        (function($3, undefined3) {
          $3.vakata.storage = {
            // simply specifying the functions in FF throws an error
            set: function(key, val) {
              return window.localStorage.setItem(key, val);
            },
            get: function(key) {
              return window.localStorage.getItem(key);
            },
            del: function(key) {
              return window.localStorage.removeItem(key);
            }
          };
        })($2);
        $2.jstree.defaults.types = {
          "default": {}
        };
        $2.jstree.defaults.types[$2.jstree.root] = {};
        $2.jstree.plugins.types = function(options, parent) {
          this.init = function(el, options2) {
            var i, j;
            if (options2 && options2.types && options2.types["default"]) {
              for (i in options2.types) {
                if (i !== "default" && i !== $2.jstree.root && options2.types.hasOwnProperty(i)) {
                  for (j in options2.types["default"]) {
                    if (options2.types["default"].hasOwnProperty(j) && options2.types[i][j] === undefined2) {
                      options2.types[i][j] = options2.types["default"][j];
                    }
                  }
                }
              }
            }
            parent.init.call(this, el, options2);
            this._model.data[$2.jstree.root].type = $2.jstree.root;
          };
          this.refresh = function(skip_loading, forget_state) {
            parent.refresh.call(this, skip_loading, forget_state);
            this._model.data[$2.jstree.root].type = $2.jstree.root;
          };
          this.bind = function() {
            this.element.on("model.jstree", $2.proxy(function(e, data) {
              var m = this._model.data, dpc = data.nodes, t = this.settings.types, i, j, c = "default", k;
              for (i = 0, j = dpc.length; i < j; i++) {
                c = "default";
                if (m[dpc[i]].original && m[dpc[i]].original.type && t[m[dpc[i]].original.type]) {
                  c = m[dpc[i]].original.type;
                }
                if (m[dpc[i]].data && m[dpc[i]].data.jstree && m[dpc[i]].data.jstree.type && t[m[dpc[i]].data.jstree.type]) {
                  c = m[dpc[i]].data.jstree.type;
                }
                m[dpc[i]].type = c;
                if (m[dpc[i]].icon === true && t[c].icon !== undefined2) {
                  m[dpc[i]].icon = t[c].icon;
                }
                if (t[c].li_attr !== undefined2 && typeof t[c].li_attr === "object") {
                  for (k in t[c].li_attr) {
                    if (t[c].li_attr.hasOwnProperty(k)) {
                      if (k === "id") {
                        continue;
                      } else if (m[dpc[i]].li_attr[k] === undefined2) {
                        m[dpc[i]].li_attr[k] = t[c].li_attr[k];
                      } else if (k === "class") {
                        m[dpc[i]].li_attr["class"] = t[c].li_attr["class"] + " " + m[dpc[i]].li_attr["class"];
                      }
                    }
                  }
                }
                if (t[c].a_attr !== undefined2 && typeof t[c].a_attr === "object") {
                  for (k in t[c].a_attr) {
                    if (t[c].a_attr.hasOwnProperty(k)) {
                      if (k === "id") {
                        continue;
                      } else if (m[dpc[i]].a_attr[k] === undefined2) {
                        m[dpc[i]].a_attr[k] = t[c].a_attr[k];
                      } else if (k === "href" && m[dpc[i]].a_attr[k] === "#") {
                        m[dpc[i]].a_attr["href"] = t[c].a_attr["href"];
                      } else if (k === "class") {
                        m[dpc[i]].a_attr["class"] = t[c].a_attr["class"] + " " + m[dpc[i]].a_attr["class"];
                      }
                    }
                  }
                }
              }
              m[$2.jstree.root].type = $2.jstree.root;
            }, this));
            parent.bind.call(this);
          };
          this.get_json = function(obj, options2, flat) {
            var i, j, m = this._model.data, opt = options2 ? $2.extend(true, {}, options2, { no_id: false }) : {}, tmp = parent.get_json.call(this, obj, opt, flat);
            if (tmp === false) {
              return false;
            }
            if ($2.isArray(tmp)) {
              for (i = 0, j = tmp.length; i < j; i++) {
                tmp[i].type = tmp[i].id && m[tmp[i].id] && m[tmp[i].id].type ? m[tmp[i].id].type : "default";
                if (options2 && options2.no_id) {
                  delete tmp[i].id;
                  if (tmp[i].li_attr && tmp[i].li_attr.id) {
                    delete tmp[i].li_attr.id;
                  }
                  if (tmp[i].a_attr && tmp[i].a_attr.id) {
                    delete tmp[i].a_attr.id;
                  }
                }
              }
            } else {
              tmp.type = tmp.id && m[tmp.id] && m[tmp.id].type ? m[tmp.id].type : "default";
              if (options2 && options2.no_id) {
                tmp = this._delete_ids(tmp);
              }
            }
            return tmp;
          };
          this._delete_ids = function(tmp) {
            if ($2.isArray(tmp)) {
              for (var i = 0, j = tmp.length; i < j; i++) {
                tmp[i] = this._delete_ids(tmp[i]);
              }
              return tmp;
            }
            delete tmp.id;
            if (tmp.li_attr && tmp.li_attr.id) {
              delete tmp.li_attr.id;
            }
            if (tmp.a_attr && tmp.a_attr.id) {
              delete tmp.a_attr.id;
            }
            if (tmp.children && $2.isArray(tmp.children)) {
              tmp.children = this._delete_ids(tmp.children);
            }
            return tmp;
          };
          this.check = function(chk, obj, par, pos, more) {
            if (parent.check.call(this, chk, obj, par, pos, more) === false) {
              return false;
            }
            obj = obj && obj.id ? obj : this.get_node(obj);
            par = par && par.id ? par : this.get_node(par);
            var m = obj && obj.id ? more && more.origin ? more.origin : $2.jstree.reference(obj.id) : null, tmp, d, i, j;
            m = m && m._model && m._model.data ? m._model.data : null;
            switch (chk) {
              case "create_node":
              case "move_node":
              case "copy_node":
                if (chk !== "move_node" || $2.inArray(obj.id, par.children) === -1) {
                  tmp = this.get_rules(par);
                  if (tmp.max_children !== undefined2 && tmp.max_children !== -1 && tmp.max_children === par.children.length) {
                    this._data.core.last_error = { "error": "check", "plugin": "types", "id": "types_01", "reason": "max_children prevents function: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                    return false;
                  }
                  if (tmp.valid_children !== undefined2 && tmp.valid_children !== -1 && $2.inArray(obj.type || "default", tmp.valid_children) === -1) {
                    this._data.core.last_error = { "error": "check", "plugin": "types", "id": "types_02", "reason": "valid_children prevents function: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                    return false;
                  }
                  if (m && obj.children_d && obj.parents) {
                    d = 0;
                    for (i = 0, j = obj.children_d.length; i < j; i++) {
                      d = Math.max(d, m[obj.children_d[i]].parents.length);
                    }
                    d = d - obj.parents.length + 1;
                  }
                  if (d <= 0 || d === undefined2) {
                    d = 1;
                  }
                  do {
                    if (tmp.max_depth !== undefined2 && tmp.max_depth !== -1 && tmp.max_depth < d) {
                      this._data.core.last_error = { "error": "check", "plugin": "types", "id": "types_03", "reason": "max_depth prevents function: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                      return false;
                    }
                    par = this.get_node(par.parent);
                    tmp = this.get_rules(par);
                    d++;
                  } while (par);
                }
                break;
            }
            return true;
          };
          this.get_rules = function(obj) {
            obj = this.get_node(obj);
            if (!obj) {
              return false;
            }
            var tmp = this.get_type(obj, true);
            if (tmp.max_depth === undefined2) {
              tmp.max_depth = -1;
            }
            if (tmp.max_children === undefined2) {
              tmp.max_children = -1;
            }
            if (tmp.valid_children === undefined2) {
              tmp.valid_children = -1;
            }
            return tmp;
          };
          this.get_type = function(obj, rules) {
            obj = this.get_node(obj);
            return !obj ? false : rules ? $2.extend({ "type": obj.type }, this.settings.types[obj.type]) : obj.type;
          };
          this.set_type = function(obj, type) {
            var m = this._model.data, t, t1, t2, old_type, old_icon, k, d, a;
            if ($2.isArray(obj)) {
              obj = obj.slice();
              for (t1 = 0, t2 = obj.length; t1 < t2; t1++) {
                this.set_type(obj[t1], type);
              }
              return true;
            }
            t = this.settings.types;
            obj = this.get_node(obj);
            if (!t[type] || !obj) {
              return false;
            }
            d = this.get_node(obj, true);
            if (d && d.length) {
              a = d.children(".jstree-anchor");
            }
            old_type = obj.type;
            old_icon = this.get_icon(obj);
            obj.type = type;
            if (old_icon === true || !t[old_type] || t[old_type].icon !== undefined2 && old_icon === t[old_type].icon) {
              this.set_icon(obj, t[type].icon !== undefined2 ? t[type].icon : true);
            }
            if (t[old_type] && t[old_type].li_attr !== undefined2 && typeof t[old_type].li_attr === "object") {
              for (k in t[old_type].li_attr) {
                if (t[old_type].li_attr.hasOwnProperty(k)) {
                  if (k === "id") {
                    continue;
                  } else if (k === "class") {
                    m[obj.id].li_attr["class"] = (m[obj.id].li_attr["class"] || "").replace(t[old_type].li_attr[k], "");
                    if (d) {
                      d.removeClass(t[old_type].li_attr[k]);
                    }
                  } else if (m[obj.id].li_attr[k] === t[old_type].li_attr[k]) {
                    m[obj.id].li_attr[k] = null;
                    if (d) {
                      d.removeAttr(k);
                    }
                  }
                }
              }
            }
            if (t[old_type] && t[old_type].a_attr !== undefined2 && typeof t[old_type].a_attr === "object") {
              for (k in t[old_type].a_attr) {
                if (t[old_type].a_attr.hasOwnProperty(k)) {
                  if (k === "id") {
                    continue;
                  } else if (k === "class") {
                    m[obj.id].a_attr["class"] = (m[obj.id].a_attr["class"] || "").replace(t[old_type].a_attr[k], "");
                    if (a) {
                      a.removeClass(t[old_type].a_attr[k]);
                    }
                  } else if (m[obj.id].a_attr[k] === t[old_type].a_attr[k]) {
                    if (k === "href") {
                      m[obj.id].a_attr[k] = "#";
                      if (a) {
                        a.attr("href", "#");
                      }
                    } else {
                      delete m[obj.id].a_attr[k];
                      if (a) {
                        a.removeAttr(k);
                      }
                    }
                  }
                }
              }
            }
            if (t[type].li_attr !== undefined2 && typeof t[type].li_attr === "object") {
              for (k in t[type].li_attr) {
                if (t[type].li_attr.hasOwnProperty(k)) {
                  if (k === "id") {
                    continue;
                  } else if (m[obj.id].li_attr[k] === undefined2) {
                    m[obj.id].li_attr[k] = t[type].li_attr[k];
                    if (d) {
                      if (k === "class") {
                        d.addClass(t[type].li_attr[k]);
                      } else {
                        d.attr(k, t[type].li_attr[k]);
                      }
                    }
                  } else if (k === "class") {
                    m[obj.id].li_attr["class"] = t[type].li_attr[k] + " " + m[obj.id].li_attr["class"];
                    if (d) {
                      d.addClass(t[type].li_attr[k]);
                    }
                  }
                }
              }
            }
            if (t[type].a_attr !== undefined2 && typeof t[type].a_attr === "object") {
              for (k in t[type].a_attr) {
                if (t[type].a_attr.hasOwnProperty(k)) {
                  if (k === "id") {
                    continue;
                  } else if (m[obj.id].a_attr[k] === undefined2) {
                    m[obj.id].a_attr[k] = t[type].a_attr[k];
                    if (a) {
                      if (k === "class") {
                        a.addClass(t[type].a_attr[k]);
                      } else {
                        a.attr(k, t[type].a_attr[k]);
                      }
                    }
                  } else if (k === "href" && m[obj.id].a_attr[k] === "#") {
                    m[obj.id].a_attr["href"] = t[type].a_attr["href"];
                    if (a) {
                      a.attr("href", t[type].a_attr["href"]);
                    }
                  } else if (k === "class") {
                    m[obj.id].a_attr["class"] = t[type].a_attr["class"] + " " + m[obj.id].a_attr["class"];
                    if (a) {
                      a.addClass(t[type].a_attr[k]);
                    }
                  }
                }
              }
            }
            return true;
          };
        };
        $2.jstree.defaults.unique = {
          /**
           * Indicates if the comparison should be case sensitive. Default is `false`.
           * @name $.jstree.defaults.unique.case_sensitive
           * @plugin unique
           */
          case_sensitive: false,
          /**
           * Indicates if white space should be trimmed before the comparison. Default is `false`.
           * @name $.jstree.defaults.unique.trim_whitespace
           * @plugin unique
           */
          trim_whitespace: false,
          /**
           * A callback executed in the instance's scope when a new node is created and the name is already taken, the two arguments are the conflicting name and the counter. The default will produce results like `New node (2)`.
           * @name $.jstree.defaults.unique.duplicate
           * @plugin unique
           */
          duplicate: function(name, counter) {
            return name + " (" + counter + ")";
          }
        };
        $2.jstree.plugins.unique = function(options, parent) {
          this.check = function(chk, obj, par, pos, more) {
            if (parent.check.call(this, chk, obj, par, pos, more) === false) {
              return false;
            }
            obj = obj && obj.id ? obj : this.get_node(obj);
            par = par && par.id ? par : this.get_node(par);
            if (!par || !par.children) {
              return true;
            }
            var n = chk === "rename_node" ? pos : obj.text, c = [], s = this.settings.unique.case_sensitive, w = this.settings.unique.trim_whitespace, m = this._model.data, i, j, t;
            for (i = 0, j = par.children.length; i < j; i++) {
              t = m[par.children[i]].text;
              if (!s) {
                t = t.toLowerCase();
              }
              if (w) {
                t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
              }
              c.push(t);
            }
            if (!s) {
              n = n.toLowerCase();
            }
            if (w) {
              n = n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
            }
            switch (chk) {
              case "delete_node":
                return true;
              case "rename_node":
                t = obj.text || "";
                if (!s) {
                  t = t.toLowerCase();
                }
                if (w) {
                  t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                }
                i = $2.inArray(n, c) === -1 || obj.text && t === n;
                if (!i) {
                  this._data.core.last_error = { "error": "check", "plugin": "unique", "id": "unique_01", "reason": "Child with name " + n + " already exists. Preventing: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                }
                return i;
              case "create_node":
                i = $2.inArray(n, c) === -1;
                if (!i) {
                  this._data.core.last_error = { "error": "check", "plugin": "unique", "id": "unique_04", "reason": "Child with name " + n + " already exists. Preventing: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                }
                return i;
              case "copy_node":
                i = $2.inArray(n, c) === -1;
                if (!i) {
                  this._data.core.last_error = { "error": "check", "plugin": "unique", "id": "unique_02", "reason": "Child with name " + n + " already exists. Preventing: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                }
                return i;
              case "move_node":
                i = obj.parent === par.id && (!more || !more.is_multi) || $2.inArray(n, c) === -1;
                if (!i) {
                  this._data.core.last_error = { "error": "check", "plugin": "unique", "id": "unique_03", "reason": "Child with name " + n + " already exists. Preventing: " + chk, "data": JSON.stringify({ "chk": chk, "pos": pos, "obj": obj && obj.id ? obj.id : false, "par": par && par.id ? par.id : false }) };
                }
                return i;
            }
            return true;
          };
          this.create_node = function(par, node, pos, callback, is_loaded) {
            if (!node || node.text === undefined2) {
              if (par === null) {
                par = $2.jstree.root;
              }
              par = this.get_node(par);
              if (!par) {
                return parent.create_node.call(this, par, node, pos, callback, is_loaded);
              }
              pos = pos === undefined2 ? "last" : pos;
              if (!pos.toString().match(/^(before|after)$/) && !is_loaded && !this.is_loaded(par)) {
                return parent.create_node.call(this, par, node, pos, callback, is_loaded);
              }
              if (!node) {
                node = {};
              }
              var tmp, n, dpc, i, j, m = this._model.data, s = this.settings.unique.case_sensitive, w = this.settings.unique.trim_whitespace, cb = this.settings.unique.duplicate, t;
              n = tmp = this.get_string("New node");
              dpc = [];
              for (i = 0, j = par.children.length; i < j; i++) {
                t = m[par.children[i]].text;
                if (!s) {
                  t = t.toLowerCase();
                }
                if (w) {
                  t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                }
                dpc.push(t);
              }
              i = 1;
              t = n;
              if (!s) {
                t = t.toLowerCase();
              }
              if (w) {
                t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
              }
              while ($2.inArray(t, dpc) !== -1) {
                n = cb.call(this, tmp, ++i).toString();
                t = n;
                if (!s) {
                  t = t.toLowerCase();
                }
                if (w) {
                  t = t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                }
              }
              node.text = n;
            }
            return parent.create_node.call(this, par, node, pos, callback, is_loaded);
          };
        };
        var div = document2.createElement("DIV");
        div.setAttribute("unselectable", "on");
        div.setAttribute("role", "presentation");
        div.className = "jstree-wholerow";
        div.innerHTML = "&#160;";
        $2.jstree.plugins.wholerow = function(options, parent) {
          this.bind = function() {
            parent.bind.call(this);
            this.element.on("ready.jstree set_state.jstree", $2.proxy(function() {
              this.hide_dots();
            }, this)).on("init.jstree loading.jstree ready.jstree", $2.proxy(function() {
              this.get_container_ul().addClass("jstree-wholerow-ul");
            }, this)).on("deselect_all.jstree", $2.proxy(function(e, data) {
              this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked");
            }, this)).on("changed.jstree", $2.proxy(function(e, data) {
              this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked");
              var tmp = false, i, j;
              for (i = 0, j = data.selected.length; i < j; i++) {
                tmp = this.get_node(data.selected[i], true);
                if (tmp && tmp.length) {
                  tmp.children(".jstree-wholerow").addClass("jstree-wholerow-clicked");
                }
              }
            }, this)).on("open_node.jstree", $2.proxy(function(e, data) {
              this.get_node(data.node, true).find(".jstree-clicked").parent().children(".jstree-wholerow").addClass("jstree-wholerow-clicked");
            }, this)).on("hover_node.jstree dehover_node.jstree", $2.proxy(function(e, data) {
              if (e.type === "hover_node" && this.is_disabled(data.node)) {
                return;
              }
              this.get_node(data.node, true).children(".jstree-wholerow")[e.type === "hover_node" ? "addClass" : "removeClass"]("jstree-wholerow-hovered");
            }, this)).on("contextmenu.jstree", ".jstree-wholerow", $2.proxy(function(e) {
              if (this._data.contextmenu) {
                e.preventDefault();
                var tmp = $2.Event("contextmenu", { metaKey: e.metaKey, ctrlKey: e.ctrlKey, altKey: e.altKey, shiftKey: e.shiftKey, pageX: e.pageX, pageY: e.pageY });
                $2(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp);
              }
            }, this)).on("click.jstree", ".jstree-wholerow", function(e) {
              e.stopImmediatePropagation();
              var tmp = $2.Event("click", { metaKey: e.metaKey, ctrlKey: e.ctrlKey, altKey: e.altKey, shiftKey: e.shiftKey });
              $2(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).focus();
            }).on("dblclick.jstree", ".jstree-wholerow", function(e) {
              e.stopImmediatePropagation();
              var tmp = $2.Event("dblclick", { metaKey: e.metaKey, ctrlKey: e.ctrlKey, altKey: e.altKey, shiftKey: e.shiftKey });
              $2(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).focus();
            }).on("click.jstree", ".jstree-leaf > .jstree-ocl", $2.proxy(function(e) {
              e.stopImmediatePropagation();
              var tmp = $2.Event("click", { metaKey: e.metaKey, ctrlKey: e.ctrlKey, altKey: e.altKey, shiftKey: e.shiftKey });
              $2(e.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(tmp).focus();
            }, this)).on("mouseover.jstree", ".jstree-wholerow, .jstree-icon", $2.proxy(function(e) {
              e.stopImmediatePropagation();
              if (!this.is_disabled(e.currentTarget)) {
                this.hover_node(e.currentTarget);
              }
              return false;
            }, this)).on("mouseleave.jstree", ".jstree-node", $2.proxy(function(e) {
              this.dehover_node(e.currentTarget);
            }, this));
          };
          this.teardown = function() {
            if (this.settings.wholerow) {
              this.element.find(".jstree-wholerow").remove();
            }
            parent.teardown.call(this);
          };
          this.redraw_node = function(obj, deep, callback, force_render) {
            obj = parent.redraw_node.apply(this, arguments);
            if (obj) {
              var tmp = div.cloneNode(true);
              if ($2.inArray(obj.id, this._data.core.selected) !== -1) {
                tmp.className += " jstree-wholerow-clicked";
              }
              if (this._data.core.focused && this._data.core.focused === obj.id) {
                tmp.className += " jstree-wholerow-hovered";
              }
              obj.insertBefore(tmp, obj.childNodes[0]);
            }
            return obj;
          };
        };
        if (window.customElements && Object && Object.create) {
          var proto = Object.create(HTMLElement.prototype);
          proto.createdCallback = function() {
            var c = { core: {}, plugins: [] }, i;
            for (i in $2.jstree.plugins) {
              if ($2.jstree.plugins.hasOwnProperty(i) && this.attributes[i]) {
                c.plugins.push(i);
                if (this.getAttribute(i) && JSON.parse(this.getAttribute(i))) {
                  c[i] = JSON.parse(this.getAttribute(i));
                }
              }
            }
            for (i in $2.jstree.defaults.core) {
              if ($2.jstree.defaults.core.hasOwnProperty(i) && this.attributes[i]) {
                c.core[i] = JSON.parse(this.getAttribute(i)) || this.getAttribute(i);
              }
            }
            $2(this).jstree(c);
          };
          try {
            window.customElements.define("vakata-jstree", function() {
            }, { prototype: proto });
          } catch (ignore) {
          }
        }
      });
    }
  });

  // node_modules/blueimp-file-upload/js/vendor/jquery.ui.widget.js
  var require_jquery_ui_widget = __commonJS({
    "node_modules/blueimp-file-upload/js/vendor/jquery.ui.widget.js"(exports) {
      (function(factory) {
        "use strict";
        if (typeof define === "function" && define.amd) {
          define(["jquery"], factory);
        } else if (typeof exports === "object") {
          factory(require_jquery());
        } else {
          factory(window.jQuery);
        }
      })(function($2) {
        "use strict";
        $2.ui = $2.ui || {};
        $2.ui.version = "1.12.1";
        if (!$2.expr.pseudos) {
          $2.expr.pseudos = $2.expr[":"];
        }
        if (!$2.uniqueSort) {
          $2.uniqueSort = $2.unique;
        }
        var widgetUuid = 0;
        var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
        var widgetSlice = Array.prototype.slice;
        $2.cleanData = function(orig) {
          return function(elems) {
            var events, elem, i;
            for (i = 0; (elem = elems[i]) != null; i++) {
              events = $2._data(elem, "events");
              if (events && events.remove) {
                $2(elem).triggerHandler("remove");
              }
            }
            orig(elems);
          };
        }($2.cleanData);
        $2.widget = function(name, base, prototype) {
          var existingConstructor, constructor, basePrototype;
          var proxiedPrototype = {};
          var namespace = name.split(".")[0];
          name = name.split(".")[1];
          var fullName = namespace + "-" + name;
          if (!prototype) {
            prototype = base;
            base = $2.Widget;
          }
          if ($2.isArray(prototype)) {
            prototype = $2.extend.apply(null, [{}].concat(prototype));
          }
          $2.expr.pseudos[fullName.toLowerCase()] = function(elem) {
            return !!$2.data(elem, fullName);
          };
          $2[namespace] = $2[namespace] || {};
          existingConstructor = $2[namespace][name];
          constructor = $2[namespace][name] = function(options, element) {
            if (!this._createWidget) {
              return new constructor(options, element);
            }
            if (arguments.length) {
              this._createWidget(options, element);
            }
          };
          $2.extend(constructor, existingConstructor, {
            version: prototype.version,
            // Copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $2.extend({}, prototype),
            // Track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
          });
          basePrototype = new base();
          basePrototype.options = $2.widget.extend({}, basePrototype.options);
          $2.each(prototype, function(prop, value) {
            if (!$2.isFunction(value)) {
              proxiedPrototype[prop] = value;
              return;
            }
            proxiedPrototype[prop] = function() {
              function _super() {
                return base.prototype[prop].apply(this, arguments);
              }
              function _superApply(args) {
                return base.prototype[prop].apply(this, args);
              }
              return function() {
                var __super = this._super;
                var __superApply = this._superApply;
                var returnValue;
                this._super = _super;
                this._superApply = _superApply;
                returnValue = value.apply(this, arguments);
                this._super = __super;
                this._superApply = __superApply;
                return returnValue;
              };
            }();
          });
          constructor.prototype = $2.widget.extend(
            basePrototype,
            {
              // TODO: remove support for widgetEventPrefix
              // always use the name + a colon as the prefix, e.g., draggable:start
              // don't prefix for widgets that aren't DOM-based
              widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
            },
            proxiedPrototype,
            {
              constructor,
              namespace,
              widgetName: name,
              widgetFullName: fullName
            }
          );
          if (existingConstructor) {
            $2.each(existingConstructor._childConstructors, function(i, child) {
              var childPrototype = child.prototype;
              $2.widget(
                childPrototype.namespace + "." + childPrototype.widgetName,
                constructor,
                child._proto
              );
            });
            delete existingConstructor._childConstructors;
          } else {
            base._childConstructors.push(constructor);
          }
          $2.widget.bridge(name, constructor);
          return constructor;
        };
        $2.widget.extend = function(target) {
          var input = widgetSlice.call(arguments, 1);
          var inputIndex = 0;
          var inputLength = input.length;
          var key;
          var value;
          for (; inputIndex < inputLength; inputIndex++) {
            for (key in input[inputIndex]) {
              value = input[inputIndex][key];
              if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== void 0) {
                if ($2.isPlainObject(value)) {
                  target[key] = $2.isPlainObject(target[key]) ? $2.widget.extend({}, target[key], value) : (
                    // Don't extend strings, arrays, etc. with objects
                    $2.widget.extend({}, value)
                  );
                } else {
                  target[key] = value;
                }
              }
            }
          }
          return target;
        };
        $2.widget.bridge = function(name, object) {
          var fullName = object.prototype.widgetFullName || name;
          $2.fn[name] = function(options) {
            var isMethodCall = typeof options === "string";
            var args = widgetSlice.call(arguments, 1);
            var returnValue = this;
            if (isMethodCall) {
              if (!this.length && options === "instance") {
                returnValue = void 0;
              } else {
                this.each(function() {
                  var methodValue;
                  var instance = $2.data(this, fullName);
                  if (options === "instance") {
                    returnValue = instance;
                    return false;
                  }
                  if (!instance) {
                    return $2.error(
                      "cannot call methods on " + name + " prior to initialization; attempted to call method '" + options + "'"
                    );
                  }
                  if (!$2.isFunction(instance[options]) || options.charAt(0) === "_") {
                    return $2.error(
                      "no such method '" + options + "' for " + name + " widget instance"
                    );
                  }
                  methodValue = instance[options].apply(instance, args);
                  if (methodValue !== instance && methodValue !== void 0) {
                    returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                    return false;
                  }
                });
              }
            } else {
              if (args.length) {
                options = $2.widget.extend.apply(null, [options].concat(args));
              }
              this.each(function() {
                var instance = $2.data(this, fullName);
                if (instance) {
                  instance.option(options || {});
                  if (instance._init) {
                    instance._init();
                  }
                } else {
                  $2.data(this, fullName, new object(options, this));
                }
              });
            }
            return returnValue;
          };
        };
        $2.Widget = function() {
        };
        $2.Widget._childConstructors = [];
        $2.Widget.prototype = {
          widgetName: "widget",
          widgetEventPrefix: "",
          defaultElement: "<div>",
          options: {
            classes: {},
            disabled: false,
            // Callbacks
            create: null
          },
          _createWidget: function(options, element) {
            element = $2(element || this.defaultElement || this)[0];
            this.element = $2(element);
            this.uuid = widgetUuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.bindings = $2();
            this.hoverable = $2();
            this.focusable = $2();
            this.classesElementLookup = {};
            if (element !== this) {
              $2.data(element, this.widgetFullName, this);
              this._on(true, this.element, {
                remove: function(event2) {
                  if (event2.target === element) {
                    this.destroy();
                  }
                }
              });
              this.document = $2(
                element.style ? (
                  // Element within the document
                  element.ownerDocument
                ) : (
                  // Element is window or document
                  element.document || element
                )
              );
              this.window = $2(
                this.document[0].defaultView || this.document[0].parentWindow
              );
            }
            this.options = $2.widget.extend(
              {},
              this.options,
              this._getCreateOptions(),
              options
            );
            this._create();
            if (this.options.disabled) {
              this._setOptionDisabled(this.options.disabled);
            }
            this._trigger("create", null, this._getCreateEventData());
            this._init();
          },
          _getCreateOptions: function() {
            return {};
          },
          _getCreateEventData: $2.noop,
          _create: $2.noop,
          _init: $2.noop,
          destroy: function() {
            var that = this;
            this._destroy();
            $2.each(this.classesElementLookup, function(key, value) {
              that._removeClass(value, key);
            });
            this.element.off(this.eventNamespace).removeData(this.widgetFullName);
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled");
            this.bindings.off(this.eventNamespace);
          },
          _destroy: $2.noop,
          widget: function() {
            return this.element;
          },
          option: function(key, value) {
            var options = key;
            var parts;
            var curOption;
            var i;
            if (arguments.length === 0) {
              return $2.widget.extend({}, this.options);
            }
            if (typeof key === "string") {
              options = {};
              parts = key.split(".");
              key = parts.shift();
              if (parts.length) {
                curOption = options[key] = $2.widget.extend({}, this.options[key]);
                for (i = 0; i < parts.length - 1; i++) {
                  curOption[parts[i]] = curOption[parts[i]] || {};
                  curOption = curOption[parts[i]];
                }
                key = parts.pop();
                if (arguments.length === 1) {
                  return curOption[key] === void 0 ? null : curOption[key];
                }
                curOption[key] = value;
              } else {
                if (arguments.length === 1) {
                  return this.options[key] === void 0 ? null : this.options[key];
                }
                options[key] = value;
              }
            }
            this._setOptions(options);
            return this;
          },
          _setOptions: function(options) {
            var key;
            for (key in options) {
              this._setOption(key, options[key]);
            }
            return this;
          },
          _setOption: function(key, value) {
            if (key === "classes") {
              this._setOptionClasses(value);
            }
            this.options[key] = value;
            if (key === "disabled") {
              this._setOptionDisabled(value);
            }
            return this;
          },
          _setOptionClasses: function(value) {
            var classKey, elements, currentElements;
            for (classKey in value) {
              currentElements = this.classesElementLookup[classKey];
              if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) {
                continue;
              }
              elements = $2(currentElements.get());
              this._removeClass(currentElements, classKey);
              elements.addClass(
                this._classes({
                  element: elements,
                  keys: classKey,
                  classes: value,
                  add: true
                })
              );
            }
          },
          _setOptionDisabled: function(value) {
            this._toggleClass(
              this.widget(),
              this.widgetFullName + "-disabled",
              null,
              !!value
            );
            if (value) {
              this._removeClass(this.hoverable, null, "ui-state-hover");
              this._removeClass(this.focusable, null, "ui-state-focus");
            }
          },
          enable: function() {
            return this._setOptions({ disabled: false });
          },
          disable: function() {
            return this._setOptions({ disabled: true });
          },
          _classes: function(options) {
            var full = [];
            var that = this;
            options = $2.extend(
              {
                element: this.element,
                classes: this.options.classes || {}
              },
              options
            );
            function bindRemoveEvent() {
              options.element.each(function(_, element) {
                var isTracked = $2.map(that.classesElementLookup, function(elements) {
                  return elements;
                }).some(function(elements) {
                  return elements.is(element);
                });
                if (!isTracked) {
                  that._on($2(element), {
                    remove: "_untrackClassesElement"
                  });
                }
              });
            }
            function processClassString(classes, checkOption) {
              var current, i;
              for (i = 0; i < classes.length; i++) {
                current = that.classesElementLookup[classes[i]] || $2();
                if (options.add) {
                  bindRemoveEvent();
                  current = $2(
                    $2.uniqueSort(current.get().concat(options.element.get()))
                  );
                } else {
                  current = $2(current.not(options.element).get());
                }
                that.classesElementLookup[classes[i]] = current;
                full.push(classes[i]);
                if (checkOption && options.classes[classes[i]]) {
                  full.push(options.classes[classes[i]]);
                }
              }
            }
            if (options.keys) {
              processClassString(options.keys.match(/\S+/g) || [], true);
            }
            if (options.extra) {
              processClassString(options.extra.match(/\S+/g) || []);
            }
            return full.join(" ");
          },
          _untrackClassesElement: function(event2) {
            var that = this;
            $2.each(that.classesElementLookup, function(key, value) {
              if ($2.inArray(event2.target, value) !== -1) {
                that.classesElementLookup[key] = $2(value.not(event2.target).get());
              }
            });
            this._off($2(event2.target));
          },
          _removeClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, false);
          },
          _addClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, true);
          },
          _toggleClass: function(element, keys, extra, add) {
            add = typeof add === "boolean" ? add : extra;
            var shift = typeof element === "string" || element === null, options = {
              extra: shift ? keys : extra,
              keys: shift ? element : keys,
              element: shift ? this.element : element,
              add
            };
            options.element.toggleClass(this._classes(options), add);
            return this;
          },
          _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement;
            var instance = this;
            if (typeof suppressDisabledCheck !== "boolean") {
              handlers = element;
              element = suppressDisabledCheck;
              suppressDisabledCheck = false;
            }
            if (!handlers) {
              handlers = element;
              element = this.element;
              delegateElement = this.widget();
            } else {
              element = delegateElement = $2(element);
              this.bindings = this.bindings.add(element);
            }
            $2.each(handlers, function(event2, handler) {
              function handlerProxy() {
                if (!suppressDisabledCheck && (instance.options.disabled === true || $2(this).hasClass("ui-state-disabled"))) {
                  return;
                }
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
              }
              if (typeof handler !== "string") {
                handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $2.guid++;
              }
              var match = event2.match(/^([\w:-]*)\s*(.*)$/);
              var eventName = match[1] + instance.eventNamespace;
              var selector = match[2];
              if (selector) {
                delegateElement.on(eventName, selector, handlerProxy);
              } else {
                element.on(eventName, handlerProxy);
              }
            });
          },
          _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.off(eventName);
            this.bindings = $2(this.bindings.not(element).get());
            this.focusable = $2(this.focusable.not(element).get());
            this.hoverable = $2(this.hoverable.not(element).get());
          },
          _delay: function(handler, delay) {
            var instance = this;
            function handlerProxy() {
              return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            return setTimeout(handlerProxy, delay || 0);
          },
          _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
              mouseenter: function(event2) {
                this._addClass($2(event2.currentTarget), null, "ui-state-hover");
              },
              mouseleave: function(event2) {
                this._removeClass($2(event2.currentTarget), null, "ui-state-hover");
              }
            });
          },
          _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
              focusin: function(event2) {
                this._addClass($2(event2.currentTarget), null, "ui-state-focus");
              },
              focusout: function(event2) {
                this._removeClass($2(event2.currentTarget), null, "ui-state-focus");
              }
            });
          },
          _trigger: function(type, event2, data) {
            var prop, orig;
            var callback = this.options[type];
            data = data || {};
            event2 = $2.Event(event2);
            event2.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            event2.target = this.element[0];
            orig = event2.originalEvent;
            if (orig) {
              for (prop in orig) {
                if (!(prop in event2)) {
                  event2[prop] = orig[prop];
                }
              }
            }
            this.element.trigger(event2, data);
            return !($2.isFunction(callback) && callback.apply(this.element[0], [event2].concat(data)) === false || event2.isDefaultPrevented());
          }
        };
        $2.each({ show: "fadeIn", hide: "fadeOut" }, function(method, defaultEffect) {
          $2.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") {
              options = { effect: options };
            }
            var hasOptions;
            var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") {
              options = { duration: options };
            }
            hasOptions = !$2.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) {
              element.delay(options.delay);
            }
            if (hasOptions && $2.effects && $2.effects.effect[effectName]) {
              element[method](options);
            } else if (effectName !== method && element[effectName]) {
              element[effectName](options.duration, options.easing, callback);
            } else {
              element.queue(function(next) {
                $2(this)[method]();
                if (callback) {
                  callback.call(element[0]);
                }
                next();
              });
            }
          };
        });
      });
    }
  });

  // node_modules/blueimp-file-upload/js/jquery.fileupload.js
  var require_jquery_fileupload = __commonJS({
    "node_modules/blueimp-file-upload/js/jquery.fileupload.js"(exports) {
      (function(factory) {
        "use strict";
        if (typeof define === "function" && define.amd) {
          define(["jquery", "jquery-ui/ui/widget"], factory);
        } else if (typeof exports === "object") {
          factory(require_jquery(), require_jquery_ui_widget());
        } else {
          factory(window.jQuery);
        }
      })(function($2) {
        "use strict";
        $2.support.fileInput = !(new RegExp(
          // Handle devices which give false positives for the feature detection:
          "(Android (1\\.[0156]|2\\.[01]))|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)|(w(eb)?OSBrowser)|(webOS)|(Kindle/(1\\.0|2\\.[05]|3\\.0))"
        ).test(window.navigator.userAgent) || // Feature detection for all other devices:
        $2('<input type="file"/>').prop("disabled"));
        $2.support.xhrFileUpload = !!(window.ProgressEvent && window.FileReader);
        $2.support.xhrFormDataFileUpload = !!window.FormData;
        $2.support.blobSlice = window.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice);
        function getDragHandler(type) {
          var isDragOver = type === "dragover";
          return function(e) {
            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
            var dataTransfer = e.dataTransfer;
            if (dataTransfer && $2.inArray("Files", dataTransfer.types) !== -1 && this._trigger(type, $2.Event(type, { delegatedEvent: e })) !== false) {
              e.preventDefault();
              if (isDragOver) {
                dataTransfer.dropEffect = "copy";
              }
            }
          };
        }
        $2.widget("blueimp.fileupload", {
          options: {
            // The drop target element(s), by the default the complete document.
            // Set to null to disable drag & drop support:
            dropZone: $2(document),
            // The paste target element(s), by the default undefined.
            // Set to a DOM node or jQuery object to enable file pasting:
            pasteZone: void 0,
            // The file input field(s), that are listened to for change events.
            // If undefined, it is set to the file input fields inside
            // of the widget element on plugin initialization.
            // Set to null to disable the change listener.
            fileInput: void 0,
            // By default, the file input field is replaced with a clone after
            // each input field change event. This is required for iframe transport
            // queues and allows change events to be fired for the same file
            // selection, but can be disabled by setting the following option to false:
            replaceFileInput: true,
            // The parameter name for the file form data (the request argument name).
            // If undefined or empty, the name property of the file input field is
            // used, or "files[]" if the file input name property is also empty,
            // can be a string or an array of strings:
            paramName: void 0,
            // By default, each file of a selection is uploaded using an individual
            // request for XHR type uploads. Set to false to upload file
            // selections in one request each:
            singleFileUploads: true,
            // To limit the number of files uploaded with one XHR request,
            // set the following option to an integer greater than 0:
            limitMultiFileUploads: void 0,
            // The following option limits the number of files uploaded with one
            // XHR request to keep the request size under or equal to the defined
            // limit in bytes:
            limitMultiFileUploadSize: void 0,
            // Multipart file uploads add a number of bytes to each uploaded file,
            // therefore the following option adds an overhead for each file used
            // in the limitMultiFileUploadSize configuration:
            limitMultiFileUploadSizeOverhead: 512,
            // Set the following option to true to issue all file upload requests
            // in a sequential order:
            sequentialUploads: false,
            // To limit the number of concurrent uploads,
            // set the following option to an integer greater than 0:
            limitConcurrentUploads: void 0,
            // Set the following option to true to force iframe transport uploads:
            forceIframeTransport: false,
            // Set the following option to the location of a redirect url on the
            // origin server, for cross-domain iframe transport uploads:
            redirect: void 0,
            // The parameter name for the redirect url, sent as part of the form
            // data and set to 'redirect' if this option is empty:
            redirectParamName: void 0,
            // Set the following option to the location of a postMessage window,
            // to enable postMessage transport uploads:
            postMessage: void 0,
            // By default, XHR file uploads are sent as multipart/form-data.
            // The iframe transport is always using multipart/form-data.
            // Set to false to enable non-multipart XHR uploads:
            multipart: true,
            // To upload large files in smaller chunks, set the following option
            // to a preferred maximum chunk size. If set to 0, null or undefined,
            // or the browser does not support the required Blob API, files will
            // be uploaded as a whole.
            maxChunkSize: void 0,
            // When a non-multipart upload or a chunked multipart upload has been
            // aborted, this option can be used to resume the upload by setting
            // it to the size of the already uploaded bytes. This option is most
            // useful when modifying the options object inside of the "add" or
            // "send" callbacks, as the options are cloned for each file upload.
            uploadedBytes: void 0,
            // By default, failed (abort or error) file uploads are removed from the
            // global progress calculation. Set the following option to false to
            // prevent recalculating the global progress data:
            recalculateProgress: true,
            // Interval in milliseconds to calculate and trigger progress events:
            progressInterval: 100,
            // Interval in milliseconds to calculate progress bitrate:
            bitrateInterval: 500,
            // By default, uploads are started automatically when adding files:
            autoUpload: true,
            // By default, duplicate file names are expected to be handled on
            // the server-side. If this is not possible (e.g. when uploading
            // files directly to Amazon S3), the following option can be set to
            // an empty object or an object mapping existing filenames, e.g.:
            // { "image.jpg": true, "image (1).jpg": true }
            // If it is set, all files will be uploaded with unique filenames,
            // adding increasing number suffixes if necessary, e.g.:
            // "image (2).jpg"
            uniqueFilenames: void 0,
            // Error and info messages:
            messages: {
              uploadedBytes: "Uploaded bytes exceed file size"
            },
            // Translation function, gets the message key to be translated
            // and an object with context specific data as arguments:
            i18n: function(message, context) {
              message = this.messages[message] || message.toString();
              if (context) {
                $2.each(context, function(key, value) {
                  message = message.replace("{" + key + "}", value);
                });
              }
              return message;
            },
            // Additional form data to be sent along with the file uploads can be set
            // using this option, which accepts an array of objects with name and
            // value properties, a function returning such an array, a FormData
            // object (for XHR file uploads), or a simple object.
            // The form of the first fileInput is given as parameter to the function:
            formData: function(form) {
              return form.serializeArray();
            },
            // The add callback is invoked as soon as files are added to the fileupload
            // widget (via file input selection, drag & drop, paste or add API call).
            // If the singleFileUploads option is enabled, this callback will be
            // called once for each file in the selection for XHR file uploads, else
            // once for each file selection.
            //
            // The upload starts when the submit method is invoked on the data parameter.
            // The data object contains a files property holding the added files
            // and allows you to override plugin options as well as define ajax settings.
            //
            // Listeners for this callback can also be bound the following way:
            // .on('fileuploadadd', func);
            //
            // data.submit() returns a Promise object and allows to attach additional
            // handlers using jQuery's Deferred callbacks:
            // data.submit().done(func).fail(func).always(func);
            add: function(e, data) {
              if (e.isDefaultPrevented()) {
                return false;
              }
              if (data.autoUpload || data.autoUpload !== false && $2(this).fileupload("option", "autoUpload")) {
                data.process().done(function() {
                  data.submit();
                });
              }
            },
            // Other callbacks:
            // Callback for the submit event of each file upload:
            // submit: function (e, data) {}, // .on('fileuploadsubmit', func);
            // Callback for the start of each file upload request:
            // send: function (e, data) {}, // .on('fileuploadsend', func);
            // Callback for successful uploads:
            // done: function (e, data) {}, // .on('fileuploaddone', func);
            // Callback for failed (abort or error) uploads:
            // fail: function (e, data) {}, // .on('fileuploadfail', func);
            // Callback for completed (success, abort or error) requests:
            // always: function (e, data) {}, // .on('fileuploadalways', func);
            // Callback for upload progress events:
            // progress: function (e, data) {}, // .on('fileuploadprogress', func);
            // Callback for global upload progress events:
            // progressall: function (e, data) {}, // .on('fileuploadprogressall', func);
            // Callback for uploads start, equivalent to the global ajaxStart event:
            // start: function (e) {}, // .on('fileuploadstart', func);
            // Callback for uploads stop, equivalent to the global ajaxStop event:
            // stop: function (e) {}, // .on('fileuploadstop', func);
            // Callback for change events of the fileInput(s):
            // change: function (e, data) {}, // .on('fileuploadchange', func);
            // Callback for paste events to the pasteZone(s):
            // paste: function (e, data) {}, // .on('fileuploadpaste', func);
            // Callback for drop events of the dropZone(s):
            // drop: function (e, data) {}, // .on('fileuploaddrop', func);
            // Callback for dragover events of the dropZone(s):
            // dragover: function (e) {}, // .on('fileuploaddragover', func);
            // Callback before the start of each chunk upload request (before form data initialization):
            // chunkbeforesend: function (e, data) {}, // .on('fileuploadchunkbeforesend', func);
            // Callback for the start of each chunk upload request:
            // chunksend: function (e, data) {}, // .on('fileuploadchunksend', func);
            // Callback for successful chunk uploads:
            // chunkdone: function (e, data) {}, // .on('fileuploadchunkdone', func);
            // Callback for failed (abort or error) chunk uploads:
            // chunkfail: function (e, data) {}, // .on('fileuploadchunkfail', func);
            // Callback for completed (success, abort or error) chunk upload requests:
            // chunkalways: function (e, data) {}, // .on('fileuploadchunkalways', func);
            // The plugin options are used as settings object for the ajax calls.
            // The following are jQuery ajax settings required for the file uploads:
            processData: false,
            contentType: false,
            cache: false,
            timeout: 0
          },
          // jQuery versions before 1.8 require promise.pipe if the return value is
          // used, as promise.then in older versions has a different behavior, see:
          // https://blog.jquery.com/2012/08/09/jquery-1-8-released/
          // https://bugs.jquery.com/ticket/11010
          // https://github.com/blueimp/jQuery-File-Upload/pull/3435
          _promisePipe: function() {
            var parts = $2.fn.jquery.split(".");
            return Number(parts[0]) > 1 || Number(parts[1]) > 7 ? "then" : "pipe";
          }(),
          // A list of options that require reinitializing event listeners and/or
          // special initialization code:
          _specialOptions: [
            "fileInput",
            "dropZone",
            "pasteZone",
            "multipart",
            "forceIframeTransport"
          ],
          _blobSlice: $2.support.blobSlice && function() {
            var slice = this.slice || this.webkitSlice || this.mozSlice;
            return slice.apply(this, arguments);
          },
          _BitrateTimer: function() {
            this.timestamp = Date.now ? Date.now() : (/* @__PURE__ */ new Date()).getTime();
            this.loaded = 0;
            this.bitrate = 0;
            this.getBitrate = function(now, loaded, interval) {
              var timeDiff = now - this.timestamp;
              if (!this.bitrate || !interval || timeDiff > interval) {
                this.bitrate = (loaded - this.loaded) * (1e3 / timeDiff) * 8;
                this.loaded = loaded;
                this.timestamp = now;
              }
              return this.bitrate;
            };
          },
          _isXHRUpload: function(options) {
            return !options.forceIframeTransport && (!options.multipart && $2.support.xhrFileUpload || $2.support.xhrFormDataFileUpload);
          },
          _getFormData: function(options) {
            var formData;
            if ($2.type(options.formData) === "function") {
              return options.formData(options.form);
            }
            if ($2.isArray(options.formData)) {
              return options.formData;
            }
            if ($2.type(options.formData) === "object") {
              formData = [];
              $2.each(options.formData, function(name, value) {
                formData.push({ name, value });
              });
              return formData;
            }
            return [];
          },
          _getTotal: function(files) {
            var total = 0;
            $2.each(files, function(index, file) {
              total += file.size || 1;
            });
            return total;
          },
          _initProgressObject: function(obj) {
            var progress = {
              loaded: 0,
              total: 0,
              bitrate: 0
            };
            if (obj._progress) {
              $2.extend(obj._progress, progress);
            } else {
              obj._progress = progress;
            }
          },
          _initResponseObject: function(obj) {
            var prop;
            if (obj._response) {
              for (prop in obj._response) {
                if (Object.prototype.hasOwnProperty.call(obj._response, prop)) {
                  delete obj._response[prop];
                }
              }
            } else {
              obj._response = {};
            }
          },
          _onProgress: function(e, data) {
            if (e.lengthComputable) {
              var now = Date.now ? Date.now() : (/* @__PURE__ */ new Date()).getTime(), loaded;
              if (data._time && data.progressInterval && now - data._time < data.progressInterval && e.loaded !== e.total) {
                return;
              }
              data._time = now;
              loaded = Math.floor(
                e.loaded / e.total * (data.chunkSize || data._progress.total)
              ) + (data.uploadedBytes || 0);
              this._progress.loaded += loaded - data._progress.loaded;
              this._progress.bitrate = this._bitrateTimer.getBitrate(
                now,
                this._progress.loaded,
                data.bitrateInterval
              );
              data._progress.loaded = data.loaded = loaded;
              data._progress.bitrate = data.bitrate = data._bitrateTimer.getBitrate(
                now,
                loaded,
                data.bitrateInterval
              );
              this._trigger(
                "progress",
                $2.Event("progress", { delegatedEvent: e }),
                data
              );
              this._trigger(
                "progressall",
                $2.Event("progressall", { delegatedEvent: e }),
                this._progress
              );
            }
          },
          _initProgressListener: function(options) {
            var that = this, xhr = options.xhr ? options.xhr() : $2.ajaxSettings.xhr();
            if (xhr.upload) {
              $2(xhr.upload).on("progress", function(e) {
                var oe = e.originalEvent;
                e.lengthComputable = oe.lengthComputable;
                e.loaded = oe.loaded;
                e.total = oe.total;
                that._onProgress(e, options);
              });
              options.xhr = function() {
                return xhr;
              };
            }
          },
          _deinitProgressListener: function(options) {
            var xhr = options.xhr ? options.xhr() : $2.ajaxSettings.xhr();
            if (xhr.upload) {
              $2(xhr.upload).off("progress");
            }
          },
          _isInstanceOf: function(type, obj) {
            return Object.prototype.toString.call(obj) === "[object " + type + "]";
          },
          _getUniqueFilename: function(name, map) {
            name = String(name);
            if (map[name]) {
              name = name.replace(/(?: \(([\d]+)\))?(\.[^.]+)?$/, function(_, p1, p2) {
                var index = p1 ? Number(p1) + 1 : 1;
                var ext = p2 || "";
                return " (" + index + ")" + ext;
              });
              return this._getUniqueFilename(name, map);
            }
            map[name] = true;
            return name;
          },
          _initXHRData: function(options) {
            var that = this, formData, file = options.files[0], multipart = options.multipart || !$2.support.xhrFileUpload, paramName = $2.type(options.paramName) === "array" ? options.paramName[0] : options.paramName;
            options.headers = $2.extend({}, options.headers);
            if (options.contentRange) {
              options.headers["Content-Range"] = options.contentRange;
            }
            if (!multipart || options.blob || !this._isInstanceOf("File", file)) {
              options.headers["Content-Disposition"] = 'attachment; filename="' + encodeURI(file.uploadName || file.name) + '"';
            }
            if (!multipart) {
              options.contentType = file.type || "application/octet-stream";
              options.data = options.blob || file;
            } else if ($2.support.xhrFormDataFileUpload) {
              if (options.postMessage) {
                formData = this._getFormData(options);
                if (options.blob) {
                  formData.push({
                    name: paramName,
                    value: options.blob
                  });
                } else {
                  $2.each(options.files, function(index, file2) {
                    formData.push({
                      name: $2.type(options.paramName) === "array" && options.paramName[index] || paramName,
                      value: file2
                    });
                  });
                }
              } else {
                if (that._isInstanceOf("FormData", options.formData)) {
                  formData = options.formData;
                } else {
                  formData = new FormData();
                  $2.each(this._getFormData(options), function(index, field) {
                    formData.append(field.name, field.value);
                  });
                }
                if (options.blob) {
                  formData.append(
                    paramName,
                    options.blob,
                    file.uploadName || file.name
                  );
                } else {
                  $2.each(options.files, function(index, file2) {
                    if (that._isInstanceOf("File", file2) || that._isInstanceOf("Blob", file2)) {
                      var fileName = file2.uploadName || file2.name;
                      if (options.uniqueFilenames) {
                        fileName = that._getUniqueFilename(
                          fileName,
                          options.uniqueFilenames
                        );
                      }
                      formData.append(
                        $2.type(options.paramName) === "array" && options.paramName[index] || paramName,
                        file2,
                        fileName
                      );
                    }
                  });
                }
              }
              options.data = formData;
            }
            options.blob = null;
          },
          _initIframeSettings: function(options) {
            var targetHost = $2("<a></a>").prop("href", options.url).prop("host");
            options.dataType = "iframe " + (options.dataType || "");
            options.formData = this._getFormData(options);
            if (options.redirect && targetHost && targetHost !== location.host) {
              options.formData.push({
                name: options.redirectParamName || "redirect",
                value: options.redirect
              });
            }
          },
          _initDataSettings: function(options) {
            if (this._isXHRUpload(options)) {
              if (!this._chunkedUpload(options, true)) {
                if (!options.data) {
                  this._initXHRData(options);
                }
                this._initProgressListener(options);
              }
              if (options.postMessage) {
                options.dataType = "postmessage " + (options.dataType || "");
              }
            } else {
              this._initIframeSettings(options);
            }
          },
          _getParamName: function(options) {
            var fileInput = $2(options.fileInput), paramName = options.paramName;
            if (!paramName) {
              paramName = [];
              fileInput.each(function() {
                var input = $2(this), name = input.prop("name") || "files[]", i = (input.prop("files") || [1]).length;
                while (i) {
                  paramName.push(name);
                  i -= 1;
                }
              });
              if (!paramName.length) {
                paramName = [fileInput.prop("name") || "files[]"];
              }
            } else if (!$2.isArray(paramName)) {
              paramName = [paramName];
            }
            return paramName;
          },
          _initFormSettings: function(options) {
            if (!options.form || !options.form.length) {
              options.form = $2(options.fileInput.prop("form"));
              if (!options.form.length) {
                options.form = $2(this.options.fileInput.prop("form"));
              }
            }
            options.paramName = this._getParamName(options);
            if (!options.url) {
              options.url = options.form.prop("action") || location.href;
            }
            options.type = (options.type || $2.type(options.form.prop("method")) === "string" && options.form.prop("method") || "").toUpperCase();
            if (options.type !== "POST" && options.type !== "PUT" && options.type !== "PATCH") {
              options.type = "POST";
            }
            if (!options.formAcceptCharset) {
              options.formAcceptCharset = options.form.attr("accept-charset");
            }
          },
          _getAJAXSettings: function(data) {
            var options = $2.extend({}, this.options, data);
            this._initFormSettings(options);
            this._initDataSettings(options);
            return options;
          },
          // jQuery 1.6 doesn't provide .state(),
          // while jQuery 1.8+ removed .isRejected() and .isResolved():
          _getDeferredState: function(deferred) {
            if (deferred.state) {
              return deferred.state();
            }
            if (deferred.isResolved()) {
              return "resolved";
            }
            if (deferred.isRejected()) {
              return "rejected";
            }
            return "pending";
          },
          // Maps jqXHR callbacks to the equivalent
          // methods of the given Promise object:
          _enhancePromise: function(promise) {
            promise.success = promise.done;
            promise.error = promise.fail;
            promise.complete = promise.always;
            return promise;
          },
          // Creates and returns a Promise object enhanced with
          // the jqXHR methods abort, success, error and complete:
          _getXHRPromise: function(resolveOrReject, context, args) {
            var dfd = $2.Deferred(), promise = dfd.promise();
            context = context || this.options.context || promise;
            if (resolveOrReject === true) {
              dfd.resolveWith(context, args);
            } else if (resolveOrReject === false) {
              dfd.rejectWith(context, args);
            }
            promise.abort = dfd.promise;
            return this._enhancePromise(promise);
          },
          // Adds convenience methods to the data callback argument:
          _addConvenienceMethods: function(e, data) {
            var that = this, getPromise = function(args) {
              return $2.Deferred().resolveWith(that, args).promise();
            };
            data.process = function(resolveFunc, rejectFunc) {
              if (resolveFunc || rejectFunc) {
                data._processQueue = this._processQueue = (this._processQueue || getPromise([this]))[that._promisePipe](function() {
                  if (data.errorThrown) {
                    return $2.Deferred().rejectWith(that, [data]).promise();
                  }
                  return getPromise(arguments);
                })[that._promisePipe](resolveFunc, rejectFunc);
              }
              return this._processQueue || getPromise([this]);
            };
            data.submit = function() {
              if (this.state() !== "pending") {
                data.jqXHR = this.jqXHR = that._trigger(
                  "submit",
                  $2.Event("submit", { delegatedEvent: e }),
                  this
                ) !== false && that._onSend(e, this);
              }
              return this.jqXHR || that._getXHRPromise();
            };
            data.abort = function() {
              if (this.jqXHR) {
                return this.jqXHR.abort();
              }
              this.errorThrown = "abort";
              that._trigger("fail", null, this);
              return that._getXHRPromise(false);
            };
            data.state = function() {
              if (this.jqXHR) {
                return that._getDeferredState(this.jqXHR);
              }
              if (this._processQueue) {
                return that._getDeferredState(this._processQueue);
              }
            };
            data.processing = function() {
              return !this.jqXHR && this._processQueue && that._getDeferredState(this._processQueue) === "pending";
            };
            data.progress = function() {
              return this._progress;
            };
            data.response = function() {
              return this._response;
            };
          },
          // Parses the Range header from the server response
          // and returns the uploaded bytes:
          _getUploadedBytes: function(jqXHR) {
            var range = jqXHR.getResponseHeader("Range"), parts = range && range.split("-"), upperBytesPos = parts && parts.length > 1 && parseInt(parts[1], 10);
            return upperBytesPos && upperBytesPos + 1;
          },
          // Uploads a file in multiple, sequential requests
          // by splitting the file up in multiple blob chunks.
          // If the second parameter is true, only tests if the file
          // should be uploaded in chunks, but does not invoke any
          // upload requests:
          _chunkedUpload: function(options, testOnly) {
            options.uploadedBytes = options.uploadedBytes || 0;
            var that = this, file = options.files[0], fs = file.size, ub = options.uploadedBytes, mcs = options.maxChunkSize || fs, slice = this._blobSlice, dfd = $2.Deferred(), promise = dfd.promise(), jqXHR, upload;
            if (!(this._isXHRUpload(options) && slice && (ub || ($2.type(mcs) === "function" ? mcs(options) : mcs) < fs)) || options.data) {
              return false;
            }
            if (testOnly) {
              return true;
            }
            if (ub >= fs) {
              file.error = options.i18n("uploadedBytes");
              return this._getXHRPromise(false, options.context, [
                null,
                "error",
                file.error
              ]);
            }
            upload = function() {
              var o = $2.extend({}, options), currentLoaded = o._progress.loaded;
              o.blob = slice.call(
                file,
                ub,
                ub + ($2.type(mcs) === "function" ? mcs(o) : mcs),
                file.type
              );
              o.chunkSize = o.blob.size;
              o.contentRange = "bytes " + ub + "-" + (ub + o.chunkSize - 1) + "/" + fs;
              that._trigger("chunkbeforesend", null, o);
              that._initXHRData(o);
              that._initProgressListener(o);
              jqXHR = (that._trigger("chunksend", null, o) !== false && $2.ajax(o) || that._getXHRPromise(false, o.context)).done(function(result, textStatus, jqXHR2) {
                ub = that._getUploadedBytes(jqXHR2) || ub + o.chunkSize;
                if (currentLoaded + o.chunkSize - o._progress.loaded) {
                  that._onProgress(
                    $2.Event("progress", {
                      lengthComputable: true,
                      loaded: ub - o.uploadedBytes,
                      total: ub - o.uploadedBytes
                    }),
                    o
                  );
                }
                options.uploadedBytes = o.uploadedBytes = ub;
                o.result = result;
                o.textStatus = textStatus;
                o.jqXHR = jqXHR2;
                that._trigger("chunkdone", null, o);
                that._trigger("chunkalways", null, o);
                if (ub < fs) {
                  upload();
                } else {
                  dfd.resolveWith(o.context, [result, textStatus, jqXHR2]);
                }
              }).fail(function(jqXHR2, textStatus, errorThrown) {
                o.jqXHR = jqXHR2;
                o.textStatus = textStatus;
                o.errorThrown = errorThrown;
                that._trigger("chunkfail", null, o);
                that._trigger("chunkalways", null, o);
                dfd.rejectWith(o.context, [jqXHR2, textStatus, errorThrown]);
              }).always(function() {
                that._deinitProgressListener(o);
              });
            };
            this._enhancePromise(promise);
            promise.abort = function() {
              return jqXHR.abort();
            };
            upload();
            return promise;
          },
          _beforeSend: function(e, data) {
            if (this._active === 0) {
              this._trigger("start");
              this._bitrateTimer = new this._BitrateTimer();
              this._progress.loaded = this._progress.total = 0;
              this._progress.bitrate = 0;
            }
            this._initResponseObject(data);
            this._initProgressObject(data);
            data._progress.loaded = data.loaded = data.uploadedBytes || 0;
            data._progress.total = data.total = this._getTotal(data.files) || 1;
            data._progress.bitrate = data.bitrate = 0;
            this._active += 1;
            this._progress.loaded += data.loaded;
            this._progress.total += data.total;
          },
          _onDone: function(result, textStatus, jqXHR, options) {
            var total = options._progress.total, response = options._response;
            if (options._progress.loaded < total) {
              this._onProgress(
                $2.Event("progress", {
                  lengthComputable: true,
                  loaded: total,
                  total
                }),
                options
              );
            }
            response.result = options.result = result;
            response.textStatus = options.textStatus = textStatus;
            response.jqXHR = options.jqXHR = jqXHR;
            this._trigger("done", null, options);
          },
          _onFail: function(jqXHR, textStatus, errorThrown, options) {
            var response = options._response;
            if (options.recalculateProgress) {
              this._progress.loaded -= options._progress.loaded;
              this._progress.total -= options._progress.total;
            }
            response.jqXHR = options.jqXHR = jqXHR;
            response.textStatus = options.textStatus = textStatus;
            response.errorThrown = options.errorThrown = errorThrown;
            this._trigger("fail", null, options);
          },
          _onAlways: function(jqXHRorResult, textStatus, jqXHRorError, options) {
            this._trigger("always", null, options);
          },
          _onSend: function(e, data) {
            if (!data.submit) {
              this._addConvenienceMethods(e, data);
            }
            var that = this, jqXHR, aborted, slot, pipe, options = that._getAJAXSettings(data), send = function() {
              that._sending += 1;
              options._bitrateTimer = new that._BitrateTimer();
              jqXHR = jqXHR || ((aborted || that._trigger(
                "send",
                $2.Event("send", { delegatedEvent: e }),
                options
              ) === false) && that._getXHRPromise(false, options.context, aborted) || that._chunkedUpload(options) || $2.ajax(options)).done(function(result, textStatus, jqXHR2) {
                that._onDone(result, textStatus, jqXHR2, options);
              }).fail(function(jqXHR2, textStatus, errorThrown) {
                that._onFail(jqXHR2, textStatus, errorThrown, options);
              }).always(function(jqXHRorResult, textStatus, jqXHRorError) {
                that._deinitProgressListener(options);
                that._onAlways(
                  jqXHRorResult,
                  textStatus,
                  jqXHRorError,
                  options
                );
                that._sending -= 1;
                that._active -= 1;
                if (options.limitConcurrentUploads && options.limitConcurrentUploads > that._sending) {
                  var nextSlot = that._slots.shift();
                  while (nextSlot) {
                    if (that._getDeferredState(nextSlot) === "pending") {
                      nextSlot.resolve();
                      break;
                    }
                    nextSlot = that._slots.shift();
                  }
                }
                if (that._active === 0) {
                  that._trigger("stop");
                }
              });
              return jqXHR;
            };
            this._beforeSend(e, options);
            if (this.options.sequentialUploads || this.options.limitConcurrentUploads && this.options.limitConcurrentUploads <= this._sending) {
              if (this.options.limitConcurrentUploads > 1) {
                slot = $2.Deferred();
                this._slots.push(slot);
                pipe = slot[that._promisePipe](send);
              } else {
                this._sequence = this._sequence[that._promisePipe](send, send);
                pipe = this._sequence;
              }
              pipe.abort = function() {
                aborted = [void 0, "abort", "abort"];
                if (!jqXHR) {
                  if (slot) {
                    slot.rejectWith(options.context, aborted);
                  }
                  return send();
                }
                return jqXHR.abort();
              };
              return this._enhancePromise(pipe);
            }
            return send();
          },
          _onAdd: function(e, data) {
            var that = this, result = true, options = $2.extend({}, this.options, data), files = data.files, filesLength = files.length, limit = options.limitMultiFileUploads, limitSize = options.limitMultiFileUploadSize, overhead = options.limitMultiFileUploadSizeOverhead, batchSize = 0, paramName = this._getParamName(options), paramNameSet, paramNameSlice, fileSet, i, j = 0;
            if (!filesLength) {
              return false;
            }
            if (limitSize && files[0].size === void 0) {
              limitSize = void 0;
            }
            if (!(options.singleFileUploads || limit || limitSize) || !this._isXHRUpload(options)) {
              fileSet = [files];
              paramNameSet = [paramName];
            } else if (!(options.singleFileUploads || limitSize) && limit) {
              fileSet = [];
              paramNameSet = [];
              for (i = 0; i < filesLength; i += limit) {
                fileSet.push(files.slice(i, i + limit));
                paramNameSlice = paramName.slice(i, i + limit);
                if (!paramNameSlice.length) {
                  paramNameSlice = paramName;
                }
                paramNameSet.push(paramNameSlice);
              }
            } else if (!options.singleFileUploads && limitSize) {
              fileSet = [];
              paramNameSet = [];
              for (i = 0; i < filesLength; i = i + 1) {
                batchSize += files[i].size + overhead;
                if (i + 1 === filesLength || batchSize + files[i + 1].size + overhead > limitSize || limit && i + 1 - j >= limit) {
                  fileSet.push(files.slice(j, i + 1));
                  paramNameSlice = paramName.slice(j, i + 1);
                  if (!paramNameSlice.length) {
                    paramNameSlice = paramName;
                  }
                  paramNameSet.push(paramNameSlice);
                  j = i + 1;
                  batchSize = 0;
                }
              }
            } else {
              paramNameSet = paramName;
            }
            data.originalFiles = files;
            $2.each(fileSet || files, function(index, element) {
              var newData = $2.extend({}, data);
              newData.files = fileSet ? element : [element];
              newData.paramName = paramNameSet[index];
              that._initResponseObject(newData);
              that._initProgressObject(newData);
              that._addConvenienceMethods(e, newData);
              result = that._trigger(
                "add",
                $2.Event("add", { delegatedEvent: e }),
                newData
              );
              return result;
            });
            return result;
          },
          _replaceFileInput: function(data) {
            var input = data.fileInput, inputClone = input.clone(true), restoreFocus = input.is(document.activeElement);
            data.fileInputClone = inputClone;
            $2("<form></form>").append(inputClone)[0].reset();
            input.after(inputClone).detach();
            if (restoreFocus) {
              inputClone.trigger("focus");
            }
            $2.cleanData(input.off("remove"));
            this.options.fileInput = this.options.fileInput.map(function(i, el) {
              if (el === input[0]) {
                return inputClone[0];
              }
              return el;
            });
            if (input[0] === this.element[0]) {
              this.element = inputClone;
            }
          },
          _handleFileTreeEntry: function(entry, path) {
            var that = this, dfd = $2.Deferred(), entries = [], dirReader, errorHandler = function(e) {
              if (e && !e.entry) {
                e.entry = entry;
              }
              dfd.resolve([e]);
            }, successHandler = function(entries2) {
              that._handleFileTreeEntries(entries2, path + entry.name + "/").done(function(files) {
                dfd.resolve(files);
              }).fail(errorHandler);
            }, readEntries = function() {
              dirReader.readEntries(function(results) {
                if (!results.length) {
                  successHandler(entries);
                } else {
                  entries = entries.concat(results);
                  readEntries();
                }
              }, errorHandler);
            };
            path = path || "";
            if (entry.isFile) {
              if (entry._file) {
                entry._file.relativePath = path;
                dfd.resolve(entry._file);
              } else {
                entry.file(function(file) {
                  file.relativePath = path;
                  dfd.resolve(file);
                }, errorHandler);
              }
            } else if (entry.isDirectory) {
              dirReader = entry.createReader();
              readEntries();
            } else {
              dfd.resolve([]);
            }
            return dfd.promise();
          },
          _handleFileTreeEntries: function(entries, path) {
            var that = this;
            return $2.when.apply(
              $2,
              $2.map(entries, function(entry) {
                return that._handleFileTreeEntry(entry, path);
              })
            )[this._promisePipe](function() {
              return Array.prototype.concat.apply([], arguments);
            });
          },
          _getDroppedFiles: function(dataTransfer) {
            dataTransfer = dataTransfer || {};
            var items = dataTransfer.items;
            if (items && items.length && (items[0].webkitGetAsEntry || items[0].getAsEntry)) {
              return this._handleFileTreeEntries(
                $2.map(items, function(item) {
                  var entry;
                  if (item.webkitGetAsEntry) {
                    entry = item.webkitGetAsEntry();
                    if (entry) {
                      entry._file = item.getAsFile();
                    }
                    return entry;
                  }
                  return item.getAsEntry();
                })
              );
            }
            return $2.Deferred().resolve($2.makeArray(dataTransfer.files)).promise();
          },
          _getSingleFileInputFiles: function(fileInput) {
            fileInput = $2(fileInput);
            var entries = fileInput.prop("webkitEntries") || fileInput.prop("entries"), files, value;
            if (entries && entries.length) {
              return this._handleFileTreeEntries(entries);
            }
            files = $2.makeArray(fileInput.prop("files"));
            if (!files.length) {
              value = fileInput.prop("value");
              if (!value) {
                return $2.Deferred().resolve([]).promise();
              }
              files = [{ name: value.replace(/^.*\\/, "") }];
            } else if (files[0].name === void 0 && files[0].fileName) {
              $2.each(files, function(index, file) {
                file.name = file.fileName;
                file.size = file.fileSize;
              });
            }
            return $2.Deferred().resolve(files).promise();
          },
          _getFileInputFiles: function(fileInput) {
            if (!(fileInput instanceof $2) || fileInput.length === 1) {
              return this._getSingleFileInputFiles(fileInput);
            }
            return $2.when.apply($2, $2.map(fileInput, this._getSingleFileInputFiles))[this._promisePipe](function() {
              return Array.prototype.concat.apply([], arguments);
            });
          },
          _onChange: function(e) {
            var that = this, data = {
              fileInput: $2(e.target),
              form: $2(e.target.form)
            };
            this._getFileInputFiles(data.fileInput).always(function(files) {
              data.files = files;
              if (that.options.replaceFileInput) {
                that._replaceFileInput(data);
              }
              if (that._trigger(
                "change",
                $2.Event("change", { delegatedEvent: e }),
                data
              ) !== false) {
                that._onAdd(e, data);
              }
            });
          },
          _onPaste: function(e) {
            var items = e.originalEvent && e.originalEvent.clipboardData && e.originalEvent.clipboardData.items, data = { files: [] };
            if (items && items.length) {
              $2.each(items, function(index, item) {
                var file = item.getAsFile && item.getAsFile();
                if (file) {
                  data.files.push(file);
                }
              });
              if (this._trigger(
                "paste",
                $2.Event("paste", { delegatedEvent: e }),
                data
              ) !== false) {
                this._onAdd(e, data);
              }
            }
          },
          _onDrop: function(e) {
            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
            var that = this, dataTransfer = e.dataTransfer, data = {};
            if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
              e.preventDefault();
              this._getDroppedFiles(dataTransfer).always(function(files) {
                data.files = files;
                if (that._trigger(
                  "drop",
                  $2.Event("drop", { delegatedEvent: e }),
                  data
                ) !== false) {
                  that._onAdd(e, data);
                }
              });
            }
          },
          _onDragOver: getDragHandler("dragover"),
          _onDragEnter: getDragHandler("dragenter"),
          _onDragLeave: getDragHandler("dragleave"),
          _initEventHandlers: function() {
            if (this._isXHRUpload(this.options)) {
              this._on(this.options.dropZone, {
                dragover: this._onDragOver,
                drop: this._onDrop,
                // event.preventDefault() on dragenter is required for IE10+:
                dragenter: this._onDragEnter,
                // dragleave is not required, but added for completeness:
                dragleave: this._onDragLeave
              });
              this._on(this.options.pasteZone, {
                paste: this._onPaste
              });
            }
            if ($2.support.fileInput) {
              this._on(this.options.fileInput, {
                change: this._onChange
              });
            }
          },
          _destroyEventHandlers: function() {
            this._off(this.options.dropZone, "dragenter dragleave dragover drop");
            this._off(this.options.pasteZone, "paste");
            this._off(this.options.fileInput, "change");
          },
          _destroy: function() {
            this._destroyEventHandlers();
          },
          _setOption: function(key, value) {
            var reinit = $2.inArray(key, this._specialOptions) !== -1;
            if (reinit) {
              this._destroyEventHandlers();
            }
            this._super(key, value);
            if (reinit) {
              this._initSpecialOptions();
              this._initEventHandlers();
            }
          },
          _initSpecialOptions: function() {
            var options = this.options;
            if (options.fileInput === void 0) {
              options.fileInput = this.element.is('input[type="file"]') ? this.element : this.element.find('input[type="file"]');
            } else if (!(options.fileInput instanceof $2)) {
              options.fileInput = $2(options.fileInput);
            }
            if (!(options.dropZone instanceof $2)) {
              options.dropZone = $2(options.dropZone);
            }
            if (!(options.pasteZone instanceof $2)) {
              options.pasteZone = $2(options.pasteZone);
            }
          },
          _getRegExp: function(str) {
            var parts = str.split("/"), modifiers = parts.pop();
            parts.shift();
            return new RegExp(parts.join("/"), modifiers);
          },
          _isRegExpOption: function(key, value) {
            return key !== "url" && $2.type(value) === "string" && /^\/.*\/[igm]{0,3}$/.test(value);
          },
          _initDataAttributes: function() {
            var that = this, options = this.options, data = this.element.data();
            $2.each(this.element[0].attributes, function(index, attr) {
              var key = attr.name.toLowerCase(), value;
              if (/^data-/.test(key)) {
                key = key.slice(5).replace(/-[a-z]/g, function(str) {
                  return str.charAt(1).toUpperCase();
                });
                value = data[key];
                if (that._isRegExpOption(key, value)) {
                  value = that._getRegExp(value);
                }
                options[key] = value;
              }
            });
          },
          _create: function() {
            this._initDataAttributes();
            this._initSpecialOptions();
            this._slots = [];
            this._sequence = this._getXHRPromise(true);
            this._sending = this._active = 0;
            this._initProgressObject(this);
            this._initEventHandlers();
          },
          // This method is exposed to the widget API and allows to query
          // the number of active uploads:
          active: function() {
            return this._active;
          },
          // This method is exposed to the widget API and allows to query
          // the widget upload progress.
          // It returns an object with loaded, total and bitrate properties
          // for the running uploads:
          progress: function() {
            return this._progress;
          },
          // This method is exposed to the widget API and allows adding files
          // using the fileupload API. The data parameter accepts an object which
          // must have a files property and can contain additional options:
          // .fileupload('add', {files: filesList});
          add: function(data) {
            var that = this;
            if (!data || this.options.disabled) {
              return;
            }
            if (data.fileInput && !data.files) {
              this._getFileInputFiles(data.fileInput).always(function(files) {
                data.files = files;
                that._onAdd(null, data);
              });
            } else {
              data.files = $2.makeArray(data.files);
              this._onAdd(null, data);
            }
          },
          // This method is exposed to the widget API and allows sending files
          // using the fileupload API. The data parameter accepts an object which
          // must have a files or fileInput property and can contain additional options:
          // .fileupload('send', {files: filesList});
          // The method returns a Promise object for the file upload call.
          send: function(data) {
            if (data && !this.options.disabled) {
              if (data.fileInput && !data.files) {
                var that = this, dfd = $2.Deferred(), promise = dfd.promise(), jqXHR, aborted;
                promise.abort = function() {
                  aborted = true;
                  if (jqXHR) {
                    return jqXHR.abort();
                  }
                  dfd.reject(null, "abort", "abort");
                  return promise;
                };
                this._getFileInputFiles(data.fileInput).always(function(files) {
                  if (aborted) {
                    return;
                  }
                  if (!files.length) {
                    dfd.reject();
                    return;
                  }
                  data.files = files;
                  jqXHR = that._onSend(null, data);
                  jqXHR.then(
                    function(result, textStatus, jqXHR2) {
                      dfd.resolve(result, textStatus, jqXHR2);
                    },
                    function(jqXHR2, textStatus, errorThrown) {
                      dfd.reject(jqXHR2, textStatus, errorThrown);
                    }
                  );
                });
                return this._enhancePromise(promise);
              }
              data.files = $2.makeArray(data.files);
              if (data.files.length) {
                return this._onSend(null, data);
              }
            }
            return this._getXHRPromise(false, data && data.context);
          }
        });
      });
    }
  });

  // resources/js/components/jquery-dependents.js
  var require_jquery_dependents = __commonJS({
    "resources/js/components/jquery-dependents.js"() {
      require_jquery_multi_select();
      require_bootstrap();
      require_parsley();
      $(function() {
        window.Parsley.addValidator("sometimes", function(value, requirement) {
          var field = $(requirement);
          if (value != "" && field.val() == "") {
            return true;
          }
          return false;
        }, 32).addMessage("en", "sometimes", "Bitte f\xFCllen Sie eins der Felder");
        window.Parsley.addValidator("nonemptyequalto", function(value, requirement) {
          var mustMatch = $(requirement).val(), valid = mustMatch.length === 0 ? true : value === mustMatch;
          return valid;
        }, 32).addMessage("en", "nonemptyequalto", "Bitte verwenden Sie mindestens ein Sonderzeichen");
        window.Parsley.addValidator("specialchar", function(value, requirement) {
          var valid = /[^\w\d\s]{1,}/.test(value);
          $(".password-properties .specialchar").toggleClass("valid", valid);
          return value.length === 0 ? true : valid;
        }, 32).addMessage("en", "specialchar", "Bitte verwenden Sie mindestens ein Sonderzeichen");
        window.Parsley.addValidator("uppercasechar", function(value, requirement) {
          var valid = /[A-Z]{1,}/.test(value);
          $(".password-properties .uppercasechar").toggleClass("valid", valid);
          return value.length === 0 ? true : valid;
        }, 32).addMessage("en", "uppercasechar", "Bitte verwenden Sie mindestens einen Gro\xDFbuchstaben");
        window.Parsley.addValidator("onenumber", function(value, requirement) {
          var valid = /[\d]{1,}/.test(value);
          $(".password-properties .onenumber").toggleClass("valid", valid);
          return value.length === 0 ? true : valid;
        }, 32).addMessage("en", "onenumber", "Bitte verwenden Sie mindestens eine Zahl");
        window.Parsley.addValidator("eightchars", function(value, requirement) {
          var valid = value.length >= 8;
          $(".password-properties .eightchars").toggleClass("valid", valid);
          return value.length === 0 ? true : valid;
        }, 32).addMessage("en", "eightchars", "Bitte verwenden Sie mindestens acht Zeichen");
      });
      require_jstree();
      require_jquery_fileupload();
      (function($2) {
        $2.fn.clickHighlight = function(options) {
          var settings = $2.extend(
            {
              color: "#000000",
              size: 30,
              opacity: 0.1,
              duration: 200
            },
            $2.fn.clickHighlight.defaults,
            options
          );
          this.css("position", "relative").click(function(e) {
            var posX = e.pageX - $2(this).position().left, posY = e.pageY - $2(this).position().top, indicator = $2("<div>").css({
              background: settings.color,
              position: "absolute",
              "border-radius": settings.size / 2,
              top: posY + "px",
              left: posX + "px",
              transform: "translate(-25%,-25%)"
            });
            indicator.appendTo($2(this)).animate(
              {
                width: settings.size + "px",
                height: settings.size + "px",
                top: "-=" + settings.size / 4 + "px",
                left: "-=" + settings.size / 4 + "px",
                opacity: settings.opacity
              },
              settings.duration,
              function() {
                indicator.remove();
              }
            );
          });
          return this;
        };
      })(jQuery);
    }
  });

  // node_modules/icanhaz/ICanHaz.js
  var require_ICanHaz = __commonJS({
    "node_modules/icanhaz/ICanHaz.js"(exports, module) {
      (function() {
        var Mustache = function() {
          var _toString = Object.prototype.toString;
          Array.isArray = Array.isArray || function(obj) {
            return _toString.call(obj) == "[object Array]";
          };
          var _trim = String.prototype.trim, trim;
          if (_trim) {
            trim = function(text) {
              return text == null ? "" : _trim.call(text);
            };
          } else {
            var trimLeft, trimRight;
            if (/\S/.test("\xA0")) {
              trimLeft = /^[\s\xA0]+/;
              trimRight = /[\s\xA0]+$/;
            } else {
              trimLeft = /^\s+/;
              trimRight = /\s+$/;
            }
            trim = function(text) {
              return text == null ? "" : text.toString().replace(trimLeft, "").replace(trimRight, "");
            };
          }
          var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          };
          function escapeHTML(string) {
            return String(string).replace(/&(?!\w+;)|[<>"']/g, function(s) {
              return escapeMap[s] || s;
            });
          }
          var regexCache = {};
          var Renderer = function() {
          };
          Renderer.prototype = {
            otag: "{{",
            ctag: "}}",
            pragmas: {},
            buffer: [],
            pragmas_implemented: {
              "IMPLICIT-ITERATOR": true
            },
            context: {},
            render: function(template, context, partials, in_recursion) {
              if (!in_recursion) {
                this.context = context;
                this.buffer = [];
              }
              if (!this.includes("", template)) {
                if (in_recursion) {
                  return template;
                } else {
                  this.send(template);
                  return;
                }
              }
              template = this.render_pragmas(template);
              var html = this.render_section(template, context, partials);
              if (html === false) {
                html = this.render_tags(template, context, partials, in_recursion);
              }
              if (in_recursion) {
                return html;
              } else {
                this.sendLines(html);
              }
            },
            /*
              Sends parsed lines
            */
            send: function(line) {
              if (line !== "") {
                this.buffer.push(line);
              }
            },
            sendLines: function(text) {
              if (text) {
                var lines = text.split("\n");
                for (var i = 0; i < lines.length; i++) {
                  this.send(lines[i]);
                }
              }
            },
            /*
              Looks for %PRAGMAS
            */
            render_pragmas: function(template) {
              if (!this.includes("%", template)) {
                return template;
              }
              var that = this;
              var regex = this.getCachedRegex("render_pragmas", function(otag, ctag) {
                return new RegExp(otag + "%([\\w-]+) ?([\\w]+=[\\w]+)?" + ctag, "g");
              });
              return template.replace(regex, function(match, pragma, options) {
                if (!that.pragmas_implemented[pragma]) {
                  throw { message: "This implementation of mustache doesn't understand the '" + pragma + "' pragma" };
                }
                that.pragmas[pragma] = {};
                if (options) {
                  var opts = options.split("=");
                  that.pragmas[pragma][opts[0]] = opts[1];
                }
                return "";
              });
            },
            /*
              Tries to find a partial in the curent scope and render it
            */
            render_partial: function(name, context, partials) {
              name = trim(name);
              if (!partials || partials[name] === void 0) {
                throw { message: "unknown_partial '" + name + "'" };
              }
              if (!context || typeof context[name] != "object") {
                return this.render(partials[name], context, partials, true);
              }
              return this.render(partials[name], context[name], partials, true);
            },
            /*
              Renders inverted (^) and normal (#) sections
            */
            render_section: function(template, context, partials) {
              if (!this.includes("#", template) && !this.includes("^", template)) {
                return false;
              }
              var that = this;
              var regex = this.getCachedRegex("render_section", function(otag, ctag) {
                return new RegExp(
                  "^([\\s\\S]*?)" + // all the crap at the beginning that is not {{*}} ($1)
                  otag + // {{
                  "(\\^|\\#)\\s*(.+)\\s*" + //  #foo (# == $2, foo == $3)
                  ctag + // }}
                  "\n*([\\s\\S]*?)" + // between the tag ($2). leading newlines are dropped
                  otag + // {{
                  "\\/\\s*\\3\\s*" + //  /foo (backreference to the opening tag).
                  ctag + // }}
                  "\\s*([\\s\\S]*)$",
                  // everything else in the string ($4). leading whitespace is dropped.
                  "g"
                );
              });
              return template.replace(regex, function(match, before, type, name, content, after) {
                var renderedBefore = before ? that.render_tags(before, context, partials, true) : "", renderedAfter = after ? that.render(after, context, partials, true) : "", renderedContent, value = that.find(name, context);
                if (type === "^") {
                  if (!value || Array.isArray(value) && value.length === 0) {
                    renderedContent = that.render(content, context, partials, true);
                  } else {
                    renderedContent = "";
                  }
                } else if (type === "#") {
                  if (Array.isArray(value)) {
                    renderedContent = that.map(value, function(row) {
                      return that.render(content, that.create_context(row), partials, true);
                    }).join("");
                  } else if (that.is_object(value)) {
                    renderedContent = that.render(
                      content,
                      that.create_context(value),
                      partials,
                      true
                    );
                  } else if (typeof value == "function") {
                    renderedContent = value.call(context, content, function(text) {
                      return that.render(text, context, partials, true);
                    });
                  } else if (value) {
                    renderedContent = that.render(content, context, partials, true);
                  } else {
                    renderedContent = "";
                  }
                }
                return renderedBefore + renderedContent + renderedAfter;
              });
            },
            /*
              Replace {{foo}} and friends with values from our view
            */
            render_tags: function(template, context, partials, in_recursion) {
              var that = this;
              var new_regex = function() {
                return that.getCachedRegex("render_tags", function(otag, ctag) {
                  return new RegExp(otag + "(=|!|>|&|\\{|%)?([^#\\^]+?)\\1?" + ctag + "+", "g");
                });
              };
              var regex = new_regex();
              var tag_replace_callback = function(match, operator, name) {
                switch (operator) {
                  case "!":
                    return "";
                  case "=":
                    that.set_delimiters(name);
                    regex = new_regex();
                    return "";
                  case ">":
                    return that.render_partial(name, context, partials);
                  case "{":
                  case "&":
                    return that.find(name, context);
                  default:
                    return escapeHTML(that.find(name, context));
                }
              };
              var lines = template.split("\n");
              for (var i = 0; i < lines.length; i++) {
                lines[i] = lines[i].replace(regex, tag_replace_callback, this);
                if (!in_recursion) {
                  this.send(lines[i]);
                }
              }
              if (in_recursion) {
                return lines.join("\n");
              }
            },
            set_delimiters: function(delimiters) {
              var dels = delimiters.split(" ");
              this.otag = this.escape_regex(dels[0]);
              this.ctag = this.escape_regex(dels[1]);
            },
            escape_regex: function(text) {
              if (!arguments.callee.sRE) {
                var specials = [
                  "/",
                  ".",
                  "*",
                  "+",
                  "?",
                  "|",
                  "(",
                  ")",
                  "[",
                  "]",
                  "{",
                  "}",
                  "\\"
                ];
                arguments.callee.sRE = new RegExp(
                  "(\\" + specials.join("|\\") + ")",
                  "g"
                );
              }
              return text.replace(arguments.callee.sRE, "\\$1");
            },
            /*
              find `name` in current `context`. That is find me a value
              from the view object
            */
            find: function(name, context) {
              name = trim(name);
              function is_kinda_truthy(bool) {
                return bool === false || bool === 0 || bool;
              }
              var value;
              if (name.match(/([a-z_]+)\./ig)) {
                var childValue = this.walk_context(name, context);
                if (is_kinda_truthy(childValue)) {
                  value = childValue;
                }
              } else {
                if (is_kinda_truthy(context[name])) {
                  value = context[name];
                } else if (is_kinda_truthy(this.context[name])) {
                  value = this.context[name];
                }
              }
              if (typeof value == "function") {
                return value.apply(context);
              }
              if (value !== void 0) {
                return value;
              }
              return "";
            },
            walk_context: function(name, context) {
              var path = name.split(".");
              var value_context = context[path[0]] != void 0 ? context : this.context;
              var value = value_context[path.shift()];
              while (value != void 0 && path.length > 0) {
                value_context = value;
                value = value[path.shift()];
              }
              if (typeof value == "function") {
                return value.apply(value_context);
              }
              return value;
            },
            // Utility methods
            /* includes tag */
            includes: function(needle, haystack) {
              return haystack.indexOf(this.otag + needle) != -1;
            },
            // by @langalex, support for arrays of strings
            create_context: function(_context) {
              if (this.is_object(_context)) {
                return _context;
              } else {
                var iterator = ".";
                if (this.pragmas["IMPLICIT-ITERATOR"]) {
                  iterator = this.pragmas["IMPLICIT-ITERATOR"].iterator;
                }
                var ctx = {};
                ctx[iterator] = _context;
                return ctx;
              }
            },
            is_object: function(a) {
              return a && typeof a == "object";
            },
            /*
              Why, why, why? Because IE. Cry, cry cry.
            */
            map: function(array, fn) {
              if (typeof array.map == "function") {
                return array.map(fn);
              } else {
                var r = [];
                var l = array.length;
                for (var i = 0; i < l; i++) {
                  r.push(fn(array[i]));
                }
                return r;
              }
            },
            getCachedRegex: function(name, generator) {
              var byOtag = regexCache[this.otag];
              if (!byOtag) {
                byOtag = regexCache[this.otag] = {};
              }
              var byCtag = byOtag[this.ctag];
              if (!byCtag) {
                byCtag = byOtag[this.ctag] = {};
              }
              var regex = byCtag[name];
              if (!regex) {
                regex = byCtag[name] = generator(this.otag, this.ctag);
              }
              return regex;
            }
          };
          return {
            name: "mustache.js",
            version: "0.4.0",
            /*
              Turns a template and view into HTML
            */
            to_html: function(template, view, partials, send_fun) {
              var renderer = new Renderer();
              if (send_fun) {
                renderer.send = send_fun;
              }
              renderer.render(template, view || {}, partials);
              if (!send_fun) {
                return renderer.buffer.join("\n");
              }
            }
          };
        }();
        (function() {
          function trim(stuff) {
            if ("".trim)
              return stuff.trim();
            else
              return stuff.replace(/^\s+/, "").replace(/\s+$/, "");
          }
          var root = this;
          var ich = {
            VERSION: "0.10.2",
            templates: {},
            // grab jquery or zepto if it's there
            $: typeof window !== "undefined" ? window.jQuery || window.Zepto || null : null,
            // public function for adding templates
            // can take a name and template string arguments
            // or can take an object with name/template pairs
            // We're enforcing uniqueness to avoid accidental template overwrites.
            // If you want a different template, it should have a different name.
            addTemplate: function(name, templateString) {
              if (typeof name === "object") {
                for (var template in name) {
                  this.addTemplate(template, name[template]);
                }
                return;
              }
              if (ich[name]) {
                console.error("Invalid name: " + name + ".");
              } else if (ich.templates[name]) {
                console.error('Template "' + name + '  " exists');
              } else {
                ich.templates[name] = templateString;
                ich[name] = function(data, raw) {
                  data = data || {};
                  var result = Mustache.to_html(ich.templates[name], data, ich.templates);
                  return ich.$ && !raw ? ich.$(trim(result)) : result;
                };
              }
            },
            // clears all retrieval functions and empties cache
            clearAll: function() {
              for (var key in ich.templates) {
                delete ich[key];
              }
              ich.templates = {};
            },
            // clears/grabs
            refresh: function() {
              ich.clearAll();
              ich.grabTemplates();
            },
            // grabs templates from the DOM and caches them.
            // Loop through and add templates.
            // Whitespace at beginning and end of all templates inside <script> tags will
            // be trimmed. If you want whitespace around a partial, add it in the parent,
            // not the partial. Or do it explicitly using <br/> or &nbsp;
            grabTemplates: function() {
              var i, l, scripts = document.getElementsByTagName("script"), script, trash = [];
              for (i = 0, l = scripts.length; i < l; i++) {
                script = scripts[i];
                if (script && script.innerHTML && script.id && (script.type === "text/html" || script.type === "text/x-icanhaz")) {
                  ich.addTemplate(script.id, trim(script.innerHTML));
                  trash.unshift(script);
                }
              }
              for (i = 0, l = trash.length; i < l; i++) {
                trash[i].parentNode.removeChild(trash[i]);
              }
            }
          };
          if (typeof exports !== "undefined") {
            if (typeof module !== "undefined" && module.exports) {
              exports = module.exports = ich;
            }
            exports.ich = ich;
          } else {
            root["ich"] = ich;
          }
          if (typeof document !== "undefined") {
            if (ich.$) {
              ich.$(function() {
                ich.grabTemplates();
              });
            } else {
              document.addEventListener("DOMContentLoaded", function() {
                ich.grabTemplates();
              }, true);
            }
          }
        })();
      })();
    }
  });

  // node_modules/sortablejs/Sortable.js
  var require_Sortable = __commonJS({
    "node_modules/sortablejs/Sortable.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global2 = global2 || self, global2.Sortable = factory());
      })(exports, function() {
        "use strict";
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function(obj2) {
              return typeof obj2;
            };
          } else {
            _typeof = function(obj2) {
              return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
          }
          return _typeof(obj);
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _extends() {
          _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };
          return _extends.apply(this, arguments);
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") {
              ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
              }));
            }
            ownKeys.forEach(function(key) {
              _defineProperty(target, key, source[key]);
            });
          }
          return target;
        }
        function _objectWithoutPropertiesLoose(source, excluded) {
          if (source == null)
            return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i;
          for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0)
              continue;
            target[key] = source[key];
          }
          return target;
        }
        function _objectWithoutProperties(source, excluded) {
          if (source == null)
            return {};
          var target = _objectWithoutPropertiesLoose(source, excluded);
          var key, i;
          if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for (i = 0; i < sourceSymbolKeys.length; i++) {
              key = sourceSymbolKeys[i];
              if (excluded.indexOf(key) >= 0)
                continue;
              if (!Object.prototype.propertyIsEnumerable.call(source, key))
                continue;
              target[key] = source[key];
            }
          }
          return target;
        }
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
              arr2[i] = arr[i];
            return arr2;
          }
        }
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
            return Array.from(iter);
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        var version = "1.10.2";
        function userAgent(pattern) {
          if (typeof window !== "undefined" && window.navigator) {
            return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
          }
        }
        var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
        var Edge = userAgent(/Edge/i);
        var FireFox = userAgent(/firefox/i);
        var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
        var IOS = userAgent(/iP(ad|od|hone)/i);
        var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
        var captureMode = {
          capture: false,
          passive: false
        };
        function on(el, event2, fn) {
          el.addEventListener(event2, fn, !IE11OrLess && captureMode);
        }
        function off(el, event2, fn) {
          el.removeEventListener(event2, fn, !IE11OrLess && captureMode);
        }
        function matches(el, selector) {
          if (!selector)
            return;
          selector[0] === ">" && (selector = selector.substring(1));
          if (el) {
            try {
              if (el.matches) {
                return el.matches(selector);
              } else if (el.msMatchesSelector) {
                return el.msMatchesSelector(selector);
              } else if (el.webkitMatchesSelector) {
                return el.webkitMatchesSelector(selector);
              }
            } catch (_) {
              return false;
            }
          }
          return false;
        }
        function getParentOrHost(el) {
          return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
        }
        function closest(el, selector, ctx, includeCTX) {
          if (el) {
            ctx = ctx || document;
            do {
              if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
                return el;
              }
              if (el === ctx)
                break;
            } while (el = getParentOrHost(el));
          }
          return null;
        }
        var R_SPACE = /\s+/g;
        function toggleClass(el, name, state) {
          if (el && name) {
            if (el.classList) {
              el.classList[state ? "add" : "remove"](name);
            } else {
              var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
              el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
            }
          }
        }
        function css(el, prop, val) {
          var style = el && el.style;
          if (style) {
            if (val === void 0) {
              if (document.defaultView && document.defaultView.getComputedStyle) {
                val = document.defaultView.getComputedStyle(el, "");
              } else if (el.currentStyle) {
                val = el.currentStyle;
              }
              return prop === void 0 ? val : val[prop];
            } else {
              if (!(prop in style) && prop.indexOf("webkit") === -1) {
                prop = "-webkit-" + prop;
              }
              style[prop] = val + (typeof val === "string" ? "" : "px");
            }
          }
        }
        function matrix(el, selfOnly) {
          var appliedTransforms = "";
          if (typeof el === "string") {
            appliedTransforms = el;
          } else {
            do {
              var transform = css(el, "transform");
              if (transform && transform !== "none") {
                appliedTransforms = transform + " " + appliedTransforms;
              }
            } while (!selfOnly && (el = el.parentNode));
          }
          var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
          return matrixFn && new matrixFn(appliedTransforms);
        }
        function find(ctx, tagName, iterator) {
          if (ctx) {
            var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
            if (iterator) {
              for (; i < n; i++) {
                iterator(list[i], i);
              }
            }
            return list;
          }
          return [];
        }
        function getWindowScrollingElement() {
          var scrollingElement = document.scrollingElement;
          if (scrollingElement) {
            return scrollingElement;
          } else {
            return document.documentElement;
          }
        }
        function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
          if (!el.getBoundingClientRect && el !== window)
            return;
          var elRect, top, left, bottom, right, height, width;
          if (el !== window && el !== getWindowScrollingElement()) {
            elRect = el.getBoundingClientRect();
            top = elRect.top;
            left = elRect.left;
            bottom = elRect.bottom;
            right = elRect.right;
            height = elRect.height;
            width = elRect.width;
          } else {
            top = 0;
            left = 0;
            bottom = window.innerHeight;
            right = window.innerWidth;
            height = window.innerHeight;
            width = window.innerWidth;
          }
          if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
            container = container || el.parentNode;
            if (!IE11OrLess) {
              do {
                if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
                  var containerRect = container.getBoundingClientRect();
                  top -= containerRect.top + parseInt(css(container, "border-top-width"));
                  left -= containerRect.left + parseInt(css(container, "border-left-width"));
                  bottom = top + elRect.height;
                  right = left + elRect.width;
                  break;
                }
              } while (container = container.parentNode);
            }
          }
          if (undoScale && el !== window) {
            var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
            if (elMatrix) {
              top /= scaleY;
              left /= scaleX;
              width /= scaleX;
              height /= scaleY;
              bottom = top + height;
              right = left + width;
            }
          }
          return {
            top,
            left,
            bottom,
            right,
            width,
            height
          };
        }
        function isScrolledPast(el, elSide, parentSide) {
          var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
          while (parent) {
            var parentSideVal = getRect(parent)[parentSide], visible = void 0;
            if (parentSide === "top" || parentSide === "left") {
              visible = elSideVal >= parentSideVal;
            } else {
              visible = elSideVal <= parentSideVal;
            }
            if (!visible)
              return parent;
            if (parent === getWindowScrollingElement())
              break;
            parent = getParentAutoScrollElement(parent, false);
          }
          return false;
        }
        function getChild(el, childNum, options) {
          var currentChild = 0, i = 0, children = el.children;
          while (i < children.length) {
            if (children[i].style.display !== "none" && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
              if (currentChild === childNum) {
                return children[i];
              }
              currentChild++;
            }
            i++;
          }
          return null;
        }
        function lastChild(el, selector) {
          var last = el.lastElementChild;
          while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector))) {
            last = last.previousElementSibling;
          }
          return last || null;
        }
        function index(el, selector) {
          var index2 = 0;
          if (!el || !el.parentNode) {
            return -1;
          }
          while (el = el.previousElementSibling) {
            if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
              index2++;
            }
          }
          return index2;
        }
        function getRelativeScrollOffset(el) {
          var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
          if (el) {
            do {
              var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
              offsetLeft += el.scrollLeft * scaleX;
              offsetTop += el.scrollTop * scaleY;
            } while (el !== winScroller && (el = el.parentNode));
          }
          return [offsetLeft, offsetTop];
        }
        function indexOfObject(arr, obj) {
          for (var i in arr) {
            if (!arr.hasOwnProperty(i))
              continue;
            for (var key in obj) {
              if (obj.hasOwnProperty(key) && obj[key] === arr[i][key])
                return Number(i);
            }
          }
          return -1;
        }
        function getParentAutoScrollElement(el, includeSelf) {
          if (!el || !el.getBoundingClientRect)
            return getWindowScrollingElement();
          var elem = el;
          var gotSelf = false;
          do {
            if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
              var elemCSS = css(elem);
              if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
                if (!elem.getBoundingClientRect || elem === document.body)
                  return getWindowScrollingElement();
                if (gotSelf || includeSelf)
                  return elem;
                gotSelf = true;
              }
            }
          } while (elem = elem.parentNode);
          return getWindowScrollingElement();
        }
        function extend(dst, src) {
          if (dst && src) {
            for (var key in src) {
              if (src.hasOwnProperty(key)) {
                dst[key] = src[key];
              }
            }
          }
          return dst;
        }
        function isRectEqual(rect1, rect2) {
          return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
        }
        var _throttleTimeout;
        function throttle(callback, ms) {
          return function() {
            if (!_throttleTimeout) {
              var args = arguments, _this = this;
              if (args.length === 1) {
                callback.call(_this, args[0]);
              } else {
                callback.apply(_this, args);
              }
              _throttleTimeout = setTimeout(function() {
                _throttleTimeout = void 0;
              }, ms);
            }
          };
        }
        function cancelThrottle() {
          clearTimeout(_throttleTimeout);
          _throttleTimeout = void 0;
        }
        function scrollBy(el, x, y) {
          el.scrollLeft += x;
          el.scrollTop += y;
        }
        function clone(el) {
          var Polymer = window.Polymer;
          var $2 = window.jQuery || window.Zepto;
          if (Polymer && Polymer.dom) {
            return Polymer.dom(el).cloneNode(true);
          } else if ($2) {
            return $2(el).clone(true)[0];
          } else {
            return el.cloneNode(true);
          }
        }
        function setRect(el, rect) {
          css(el, "position", "absolute");
          css(el, "top", rect.top);
          css(el, "left", rect.left);
          css(el, "width", rect.width);
          css(el, "height", rect.height);
        }
        function unsetRect(el) {
          css(el, "position", "");
          css(el, "top", "");
          css(el, "left", "");
          css(el, "width", "");
          css(el, "height", "");
        }
        var expando = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
        function AnimationStateManager() {
          var animationStates = [], animationCallbackId;
          return {
            captureAnimationState: function captureAnimationState() {
              animationStates = [];
              if (!this.options.animation)
                return;
              var children = [].slice.call(this.el.children);
              children.forEach(function(child) {
                if (css(child, "display") === "none" || child === Sortable.ghost)
                  return;
                animationStates.push({
                  target: child,
                  rect: getRect(child)
                });
                var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect);
                if (child.thisAnimationDuration) {
                  var childMatrix = matrix(child, true);
                  if (childMatrix) {
                    fromRect.top -= childMatrix.f;
                    fromRect.left -= childMatrix.e;
                  }
                }
                child.fromRect = fromRect;
              });
            },
            addAnimationState: function addAnimationState(state) {
              animationStates.push(state);
            },
            removeAnimationState: function removeAnimationState(target) {
              animationStates.splice(indexOfObject(animationStates, {
                target
              }), 1);
            },
            animateAll: function animateAll(callback) {
              var _this = this;
              if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function")
                  callback();
                return;
              }
              var animating = false, animationTime = 0;
              animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
                if (targetMatrix) {
                  toRect.top -= targetMatrix.f;
                  toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) {
                  if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                  (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
                    time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                  }
                }
                if (!isRectEqual(toRect, fromRect)) {
                  target.prevFromRect = fromRect;
                  target.prevToRect = toRect;
                  if (!time) {
                    time = _this.options.animation;
                  }
                  _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                  animating = true;
                  animationTime = Math.max(animationTime, time);
                  clearTimeout(target.animationResetTimer);
                  target.animationResetTimer = setTimeout(function() {
                    target.animationTime = 0;
                    target.prevFromRect = null;
                    target.fromRect = null;
                    target.prevToRect = null;
                    target.thisAnimationDuration = null;
                  }, time);
                  target.thisAnimationDuration = time;
                }
              });
              clearTimeout(animationCallbackId);
              if (!animating) {
                if (typeof callback === "function")
                  callback();
              } else {
                animationCallbackId = setTimeout(function() {
                  if (typeof callback === "function")
                    callback();
                }, animationTime);
              }
              animationStates = [];
            },
            animate: function animate(target, currentRect, toRect, duration) {
              if (duration) {
                css(target, "transition", "");
                css(target, "transform", "");
                var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                repaint(target);
                css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                  css(target, "transition", "");
                  css(target, "transform", "");
                  target.animated = false;
                  target.animatingX = false;
                  target.animatingY = false;
                }, duration);
              }
            }
          };
        }
        function repaint(target) {
          return target.offsetWidth;
        }
        function calculateRealTime(animatingRect, fromRect, toRect, options) {
          return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
        }
        var plugins = [];
        var defaults = {
          initializeByDefault: true
        };
        var PluginManager = {
          mount: function mount(plugin) {
            for (var option in defaults) {
              if (defaults.hasOwnProperty(option) && !(option in plugin)) {
                plugin[option] = defaults[option];
              }
            }
            plugins.push(plugin);
          },
          pluginEvent: function pluginEvent2(eventName, sortable, evt) {
            var _this = this;
            this.eventCanceled = false;
            evt.cancel = function() {
              _this.eventCanceled = true;
            };
            var eventNameGlobal = eventName + "Global";
            plugins.forEach(function(plugin) {
              if (!sortable[plugin.pluginName])
                return;
              if (sortable[plugin.pluginName][eventNameGlobal]) {
                sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
                  sortable
                }, evt));
              }
              if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
                sortable[plugin.pluginName][eventName](_objectSpread({
                  sortable
                }, evt));
              }
            });
          },
          initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
            plugins.forEach(function(plugin) {
              var pluginName = plugin.pluginName;
              if (!sortable.options[pluginName] && !plugin.initializeByDefault)
                return;
              var initialized = new plugin(sortable, el, sortable.options);
              initialized.sortable = sortable;
              initialized.options = sortable.options;
              sortable[pluginName] = initialized;
              _extends(defaults2, initialized.defaults);
            });
            for (var option in sortable.options) {
              if (!sortable.options.hasOwnProperty(option))
                continue;
              var modified = this.modifyOption(sortable, option, sortable.options[option]);
              if (typeof modified !== "undefined") {
                sortable.options[option] = modified;
              }
            }
          },
          getEventProperties: function getEventProperties(name, sortable) {
            var eventProperties = {};
            plugins.forEach(function(plugin) {
              if (typeof plugin.eventProperties !== "function")
                return;
              _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
            });
            return eventProperties;
          },
          modifyOption: function modifyOption(sortable, name, value) {
            var modifiedValue;
            plugins.forEach(function(plugin) {
              if (!sortable[plugin.pluginName])
                return;
              if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
                modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
              }
            });
            return modifiedValue;
          }
        };
        function dispatchEvent(_ref) {
          var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
          sortable = sortable || rootEl2 && rootEl2[expando];
          if (!sortable)
            return;
          var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
          if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent(name, {
              bubbles: true,
              cancelable: true
            });
          } else {
            evt = document.createEvent("Event");
            evt.initEvent(name, true, true);
          }
          evt.to = toEl || rootEl2;
          evt.from = fromEl || rootEl2;
          evt.item = targetEl || rootEl2;
          evt.clone = cloneEl2;
          evt.oldIndex = oldIndex2;
          evt.newIndex = newIndex2;
          evt.oldDraggableIndex = oldDraggableIndex2;
          evt.newDraggableIndex = newDraggableIndex2;
          evt.originalEvent = originalEvent;
          evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
          var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));
          for (var option in allEventProperties) {
            evt[option] = allEventProperties[option];
          }
          if (rootEl2) {
            rootEl2.dispatchEvent(evt);
          }
          if (options[onName]) {
            options[onName].call(sortable, evt);
          }
        }
        var pluginEvent = function pluginEvent2(eventName, sortable) {
          var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, ["evt"]);
          PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
            dragEl,
            parentEl,
            ghostEl,
            rootEl,
            nextEl,
            lastDownEl,
            cloneEl,
            cloneHidden,
            dragStarted: moved,
            putSortable,
            activeSortable: Sortable.active,
            originalEvent,
            oldIndex,
            oldDraggableIndex,
            newIndex,
            newDraggableIndex,
            hideGhostForTarget: _hideGhostForTarget,
            unhideGhostForTarget: _unhideGhostForTarget,
            cloneNowHidden: function cloneNowHidden() {
              cloneHidden = true;
            },
            cloneNowShown: function cloneNowShown() {
              cloneHidden = false;
            },
            dispatchSortableEvent: function dispatchSortableEvent(name) {
              _dispatchEvent({
                sortable,
                name,
                originalEvent
              });
            }
          }, data));
        };
        function _dispatchEvent(info) {
          dispatchEvent(_objectSpread({
            putSortable,
            cloneEl,
            targetEl: dragEl,
            rootEl,
            oldIndex,
            oldDraggableIndex,
            newIndex,
            newDraggableIndex
          }, info));
        }
        var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
        var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
          if (!documentExists)
            return;
          if (IE11OrLess) {
            return false;
          }
          var el = document.createElement("x");
          el.style.cssText = "pointer-events:auto";
          return el.style.pointerEvents === "auto";
        }(), _detectDirection = function _detectDirection2(el, options) {
          var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
          if (elCSS.display === "flex") {
            return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
          }
          if (elCSS.display === "grid") {
            return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
          }
          if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
            var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
            return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
          }
          return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
        }, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
          var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
          return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
        }, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x, y) {
          var ret;
          sortables.some(function(sortable) {
            if (lastChild(sortable))
              return;
            var rect = getRect(sortable), threshold = sortable[expando].options.emptyInsertThreshold, insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
            if (threshold && insideHorizontally && insideVertically) {
              return ret = sortable;
            }
          });
          return ret;
        }, _prepareGroup = function _prepareGroup2(options) {
          function toFn(value, pull) {
            return function(to, from, dragEl2, evt) {
              var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
              if (value == null && (pull || sameGroup)) {
                return true;
              } else if (value == null || value === false) {
                return false;
              } else if (pull && value === "clone") {
                return value;
              } else if (typeof value === "function") {
                return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
              } else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
              }
            };
          }
          var group = {};
          var originalGroup = options.group;
          if (!originalGroup || _typeof(originalGroup) != "object") {
            originalGroup = {
              name: originalGroup
            };
          }
          group.name = originalGroup.name;
          group.checkPull = toFn(originalGroup.pull, true);
          group.checkPut = toFn(originalGroup.put);
          group.revertClone = originalGroup.revertClone;
          options.group = group;
        }, _hideGhostForTarget = function _hideGhostForTarget2() {
          if (!supportCssPointerEvents && ghostEl) {
            css(ghostEl, "display", "none");
          }
        }, _unhideGhostForTarget = function _unhideGhostForTarget2() {
          if (!supportCssPointerEvents && ghostEl) {
            css(ghostEl, "display", "");
          }
        };
        if (documentExists) {
          document.addEventListener("click", function(evt) {
            if (ignoreNextClick) {
              evt.preventDefault();
              evt.stopPropagation && evt.stopPropagation();
              evt.stopImmediatePropagation && evt.stopImmediatePropagation();
              ignoreNextClick = false;
              return false;
            }
          }, true);
        }
        var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
          if (dragEl) {
            evt = evt.touches ? evt.touches[0] : evt;
            var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
            if (nearest) {
              var event2 = {};
              for (var i in evt) {
                if (evt.hasOwnProperty(i)) {
                  event2[i] = evt[i];
                }
              }
              event2.target = event2.rootEl = nearest;
              event2.preventDefault = void 0;
              event2.stopPropagation = void 0;
              nearest[expando]._onDragOver(event2);
            }
          }
        };
        var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
          if (dragEl) {
            dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
          }
        };
        function Sortable(el, options) {
          if (!(el && el.nodeType && el.nodeType === 1)) {
            throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
          }
          this.el = el;
          this.options = options = _extends({}, options);
          el[expando] = this;
          var defaults2 = {
            group: null,
            sort: true,
            disabled: false,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
            swapThreshold: 1,
            // percentage; 0 <= x <= 1
            invertSwap: false,
            // invert always
            invertedSwapThreshold: null,
            // will be set to same as swapThreshold if default
            removeCloneOnHide: true,
            direction: function direction() {
              return _detectDirection(el, this.options);
            },
            ghostClass: "sortable-ghost",
            chosenClass: "sortable-chosen",
            dragClass: "sortable-drag",
            ignore: "a, img",
            filter: null,
            preventOnFilter: true,
            animation: 0,
            easing: null,
            setData: function setData(dataTransfer, dragEl2) {
              dataTransfer.setData("Text", dragEl2.textContent);
            },
            dropBubble: false,
            dragoverBubble: false,
            dataIdAttr: "data-id",
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: false,
            fallbackClass: "sortable-fallback",
            fallbackOnBody: false,
            fallbackTolerance: 0,
            fallbackOffset: {
              x: 0,
              y: 0
            },
            supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window,
            emptyInsertThreshold: 5
          };
          PluginManager.initializePlugins(this, el, defaults2);
          for (var name in defaults2) {
            !(name in options) && (options[name] = defaults2[name]);
          }
          _prepareGroup(options);
          for (var fn in this) {
            if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
              this[fn] = this[fn].bind(this);
            }
          }
          this.nativeDraggable = options.forceFallback ? false : supportDraggable;
          if (this.nativeDraggable) {
            this.options.touchStartThreshold = 1;
          }
          if (options.supportPointer) {
            on(el, "pointerdown", this._onTapStart);
          } else {
            on(el, "mousedown", this._onTapStart);
            on(el, "touchstart", this._onTapStart);
          }
          if (this.nativeDraggable) {
            on(el, "dragover", this);
            on(el, "dragenter", this);
          }
          sortables.push(this.el);
          options.store && options.store.get && this.sort(options.store.get(this) || []);
          _extends(this, AnimationStateManager());
        }
        Sortable.prototype = /** @lends Sortable.prototype */
        {
          constructor: Sortable,
          _isOutsideThisEl: function _isOutsideThisEl(target) {
            if (!this.el.contains(target) && target !== this.el) {
              lastTarget = null;
            }
          },
          _getDirection: function _getDirection(evt, target) {
            return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
          },
          _onTapStart: function _onTapStart(evt) {
            if (!evt.cancelable)
              return;
            var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
            _saveInputCheckedState(el);
            if (dragEl) {
              return;
            }
            if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
              return;
            }
            if (originalTarget.isContentEditable) {
              return;
            }
            target = closest(target, options.draggable, el, false);
            if (target && target.animated) {
              return;
            }
            if (lastDownEl === target) {
              return;
            }
            oldIndex = index(target);
            oldDraggableIndex = index(target, options.draggable);
            if (typeof filter === "function") {
              if (filter.call(this, evt, target, this)) {
                _dispatchEvent({
                  sortable: _this,
                  rootEl: originalTarget,
                  name: "filter",
                  targetEl: target,
                  toEl: el,
                  fromEl: el
                });
                pluginEvent("filter", _this, {
                  evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return;
              }
            } else if (filter) {
              filter = filter.split(",").some(function(criteria) {
                criteria = closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                  _dispatchEvent({
                    sortable: _this,
                    rootEl: criteria,
                    name: "filter",
                    targetEl: target,
                    fromEl: el,
                    toEl: el
                  });
                  pluginEvent("filter", _this, {
                    evt
                  });
                  return true;
                }
              });
              if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return;
              }
            }
            if (options.handle && !closest(originalTarget, options.handle, el, false)) {
              return;
            }
            this._prepareDragStart(evt, touch, target);
          },
          _prepareDragStart: function _prepareDragStart(evt, touch, target) {
            var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
            if (target && !dragEl && target.parentNode === el) {
              var dragRect = getRect(target);
              rootEl = el;
              dragEl = target;
              parentEl = dragEl.parentNode;
              nextEl = dragEl.nextSibling;
              lastDownEl = target;
              activeGroup = options.group;
              Sortable.dragged = dragEl;
              tapEvt = {
                target: dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
              };
              tapDistanceLeft = tapEvt.clientX - dragRect.left;
              tapDistanceTop = tapEvt.clientY - dragRect.top;
              this._lastX = (touch || evt).clientX;
              this._lastY = (touch || evt).clientY;
              dragEl.style["will-change"] = "all";
              dragStartFn = function dragStartFn2() {
                pluginEvent("delayEnded", _this, {
                  evt
                });
                if (Sortable.eventCanceled) {
                  _this._onDrop();
                  return;
                }
                _this._disableDelayedDragEvents();
                if (!FireFox && _this.nativeDraggable) {
                  dragEl.draggable = true;
                }
                _this._triggerDragStart(evt, touch);
                _dispatchEvent({
                  sortable: _this,
                  name: "choose",
                  originalEvent: evt
                });
                toggleClass(dragEl, options.chosenClass, true);
              };
              options.ignore.split(",").forEach(function(criteria) {
                find(dragEl, criteria.trim(), _disableDraggable);
              });
              on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
              on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
              on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
              on(ownerDocument, "mouseup", _this._onDrop);
              on(ownerDocument, "touchend", _this._onDrop);
              on(ownerDocument, "touchcancel", _this._onDrop);
              if (FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                dragEl.draggable = true;
              }
              pluginEvent("delayStart", this, {
                evt
              });
              if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                if (Sortable.eventCanceled) {
                  this._onDrop();
                  return;
                }
                on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                on(ownerDocument, "touchend", _this._disableDelayedDrag);
                on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
              } else {
                dragStartFn();
              }
            }
          },
          _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
            var touch = e.touches ? e.touches[0] : e;
            if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
              this._disableDelayedDrag();
            }
          },
          _disableDelayedDrag: function _disableDelayedDrag() {
            dragEl && _disableDraggable(dragEl);
            clearTimeout(this._dragStartTimer);
            this._disableDelayedDragEvents();
          },
          _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, "mouseup", this._disableDelayedDrag);
            off(ownerDocument, "touchend", this._disableDelayedDrag);
            off(ownerDocument, "touchcancel", this._disableDelayedDrag);
            off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
            off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
            off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
          },
          _triggerDragStart: function _triggerDragStart(evt, touch) {
            touch = touch || evt.pointerType == "touch" && evt;
            if (!this.nativeDraggable || touch) {
              if (this.options.supportPointer) {
                on(document, "pointermove", this._onTouchMove);
              } else if (touch) {
                on(document, "touchmove", this._onTouchMove);
              } else {
                on(document, "mousemove", this._onTouchMove);
              }
            } else {
              on(dragEl, "dragend", this);
              on(rootEl, "dragstart", this._onDragStart);
            }
            try {
              if (document.selection) {
                _nextTick(function() {
                  document.selection.empty();
                });
              } else {
                window.getSelection().removeAllRanges();
              }
            } catch (err) {
            }
          },
          _dragStarted: function _dragStarted(fallback, evt) {
            awaitingDragStarted = false;
            if (rootEl && dragEl) {
              pluginEvent("dragStarted", this, {
                evt
              });
              if (this.nativeDraggable) {
                on(document, "dragover", _checkOutsideTargetEl);
              }
              var options = this.options;
              !fallback && toggleClass(dragEl, options.dragClass, false);
              toggleClass(dragEl, options.ghostClass, true);
              Sortable.active = this;
              fallback && this._appendGhost();
              _dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
              });
            } else {
              this._nulling();
            }
          },
          _emulateDragOver: function _emulateDragOver() {
            if (touchEvt) {
              this._lastX = touchEvt.clientX;
              this._lastY = touchEvt.clientY;
              _hideGhostForTarget();
              var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
              var parent = target;
              while (target && target.shadowRoot) {
                target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                if (target === parent)
                  break;
                parent = target;
              }
              dragEl.parentNode[expando]._isOutsideThisEl(target);
              if (parent) {
                do {
                  if (parent[expando]) {
                    var inserted = void 0;
                    inserted = parent[expando]._onDragOver({
                      clientX: touchEvt.clientX,
                      clientY: touchEvt.clientY,
                      target,
                      rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) {
                      break;
                    }
                  }
                  target = parent;
                } while (parent = parent.parentNode);
              }
              _unhideGhostForTarget();
            }
          },
          _onTouchMove: function _onTouchMove(evt) {
            if (tapEvt) {
              var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
              if (!Sortable.active && !awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
                  return;
                }
                this._onDragStart(evt, true);
              }
              if (ghostEl) {
                if (ghostMatrix) {
                  ghostMatrix.e += dx - (lastDx || 0);
                  ghostMatrix.f += dy - (lastDy || 0);
                } else {
                  ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                  };
                }
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                css(ghostEl, "webkitTransform", cssMatrix);
                css(ghostEl, "mozTransform", cssMatrix);
                css(ghostEl, "msTransform", cssMatrix);
                css(ghostEl, "transform", cssMatrix);
                lastDx = dx;
                lastDy = dy;
                touchEvt = touch;
              }
              evt.cancelable && evt.preventDefault();
            }
          },
          _appendGhost: function _appendGhost() {
            if (!ghostEl) {
              var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
              if (PositionGhostAbsolutely) {
                ghostRelativeParent = container;
                while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
                  ghostRelativeParent = ghostRelativeParent.parentNode;
                }
                if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                  if (ghostRelativeParent === document)
                    ghostRelativeParent = getWindowScrollingElement();
                  rect.top += ghostRelativeParent.scrollTop;
                  rect.left += ghostRelativeParent.scrollLeft;
                } else {
                  ghostRelativeParent = getWindowScrollingElement();
                }
                ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
              }
              ghostEl = dragEl.cloneNode(true);
              toggleClass(ghostEl, options.ghostClass, false);
              toggleClass(ghostEl, options.fallbackClass, true);
              toggleClass(ghostEl, options.dragClass, true);
              css(ghostEl, "transition", "");
              css(ghostEl, "transform", "");
              css(ghostEl, "box-sizing", "border-box");
              css(ghostEl, "margin", 0);
              css(ghostEl, "top", rect.top);
              css(ghostEl, "left", rect.left);
              css(ghostEl, "width", rect.width);
              css(ghostEl, "height", rect.height);
              css(ghostEl, "opacity", "0.8");
              css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
              css(ghostEl, "zIndex", "100000");
              css(ghostEl, "pointerEvents", "none");
              Sortable.ghost = ghostEl;
              container.appendChild(ghostEl);
              css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
            }
          },
          _onDragStart: function _onDragStart(evt, fallback) {
            var _this = this;
            var dataTransfer = evt.dataTransfer;
            var options = _this.options;
            pluginEvent("dragStart", this, {
              evt
            });
            if (Sortable.eventCanceled) {
              this._onDrop();
              return;
            }
            pluginEvent("setupClone", this);
            if (!Sortable.eventCanceled) {
              cloneEl = clone(dragEl);
              cloneEl.draggable = false;
              cloneEl.style["will-change"] = "";
              this._hideClone();
              toggleClass(cloneEl, this.options.chosenClass, false);
              Sortable.clone = cloneEl;
            }
            _this.cloneId = _nextTick(function() {
              pluginEvent("clone", _this);
              if (Sortable.eventCanceled)
                return;
              if (!_this.options.removeCloneOnHide) {
                rootEl.insertBefore(cloneEl, dragEl);
              }
              _this._hideClone();
              _dispatchEvent({
                sortable: _this,
                name: "clone"
              });
            });
            !fallback && toggleClass(dragEl, options.dragClass, true);
            if (fallback) {
              ignoreNextClick = true;
              _this._loopId = setInterval(_this._emulateDragOver, 50);
            } else {
              off(document, "mouseup", _this._onDrop);
              off(document, "touchend", _this._onDrop);
              off(document, "touchcancel", _this._onDrop);
              if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, dragEl);
              }
              on(document, "drop", _this);
              css(dragEl, "transform", "translateZ(0)");
            }
            awaitingDragStarted = true;
            _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
            on(document, "selectstart", _this);
            moved = true;
            if (Safari) {
              css(document.body, "user-select", "none");
            }
          },
          // Returns true - if no further action is needed (either inserted or another condition)
          _onDragOver: function _onDragOver(evt) {
            var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
            if (_silent)
              return;
            function dragOverEvent(name, extra) {
              pluginEvent(name, _this, _objectSpread({
                evt,
                isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert,
                dragRect,
                targetRect,
                canSort,
                fromSortable,
                target,
                completed,
                onMove: function onMove(target2, after2) {
                  return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
                },
                changed
              }, extra));
            }
            function capture() {
              dragOverEvent("dragOverAnimationCapture");
              _this.captureAnimationState();
              if (_this !== fromSortable) {
                fromSortable.captureAnimationState();
              }
            }
            function completed(insertion) {
              dragOverEvent("dragOverCompleted", {
                insertion
              });
              if (insertion) {
                if (isOwner) {
                  activeSortable._hideClone();
                } else {
                  activeSortable._showClone(_this);
                }
                if (_this !== fromSortable) {
                  toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                  toggleClass(dragEl, options.ghostClass, true);
                }
                if (putSortable !== _this && _this !== Sortable.active) {
                  putSortable = _this;
                } else if (_this === Sortable.active && putSortable) {
                  putSortable = null;
                }
                if (fromSortable === _this) {
                  _this._ignoreWhileAnimating = target;
                }
                _this.animateAll(function() {
                  dragOverEvent("dragOverAnimationComplete");
                  _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                  fromSortable.animateAll();
                  fromSortable._ignoreWhileAnimating = null;
                }
              }
              if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
                lastTarget = null;
              }
              if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
                !insertion && nearestEmptyInsertDetectEvent(evt);
              }
              !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
              return completedFired = true;
            }
            function changed() {
              newIndex = index(dragEl);
              newDraggableIndex = index(dragEl, options.draggable);
              _dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex,
                newDraggableIndex,
                originalEvent: evt
              });
            }
            if (evt.preventDefault !== void 0) {
              evt.cancelable && evt.preventDefault();
            }
            target = closest(target, options.draggable, el, true);
            dragOverEvent("dragOver");
            if (Sortable.eventCanceled)
              return completedFired;
            if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
              return completed(false);
            }
            ignoreNextClick = false;
            if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
              vertical = this._getDirection(evt, target) === "vertical";
              dragRect = getRect(dragEl);
              dragOverEvent("dragOverValid");
              if (Sortable.eventCanceled)
                return completedFired;
              if (revert) {
                parentEl = rootEl;
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!Sortable.eventCanceled) {
                  if (nextEl) {
                    rootEl.insertBefore(dragEl, nextEl);
                  } else {
                    rootEl.appendChild(dragEl);
                  }
                }
                return completed(true);
              }
              var elLastChild = lastChild(el, options.draggable);
              if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                if (elLastChild === dragEl) {
                  return completed(false);
                }
                if (elLastChild && el === evt.target) {
                  target = elLastChild;
                }
                if (target) {
                  targetRect = getRect(target);
                }
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                  capture();
                  el.appendChild(dragEl);
                  parentEl = el;
                  changed();
                  return completed(true);
                }
              } else if (target.parentNode === el) {
                targetRect = getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if (lastTarget !== target) {
                  targetBeforeFirstSwap = targetRect[side1];
                  pastFirstInvertThresh = false;
                  isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                var sibling;
                if (direction !== 0) {
                  var dragIndex = index(dragEl);
                  do {
                    dragIndex -= direction;
                    sibling = parentEl.children[dragIndex];
                  } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
                }
                if (direction === 0 || sibling === target) {
                  return completed(false);
                }
                lastTarget = target;
                lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                  if (moveVector === 1 || moveVector === -1) {
                    after = moveVector === 1;
                  }
                  _silent = true;
                  setTimeout(_unsilent, 30);
                  capture();
                  if (after && !nextSibling) {
                    el.appendChild(dragEl);
                  } else {
                    target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                  }
                  if (scrolledPastTop) {
                    scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                  }
                  parentEl = dragEl.parentNode;
                  if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
                    targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                  }
                  changed();
                  return completed(true);
                }
              }
              if (el.contains(dragEl)) {
                return completed(false);
              }
            }
            return false;
          },
          _ignoreWhileAnimating: null,
          _offMoveEvents: function _offMoveEvents() {
            off(document, "mousemove", this._onTouchMove);
            off(document, "touchmove", this._onTouchMove);
            off(document, "pointermove", this._onTouchMove);
            off(document, "dragover", nearestEmptyInsertDetectEvent);
            off(document, "mousemove", nearestEmptyInsertDetectEvent);
            off(document, "touchmove", nearestEmptyInsertDetectEvent);
          },
          _offUpEvents: function _offUpEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, "mouseup", this._onDrop);
            off(ownerDocument, "touchend", this._onDrop);
            off(ownerDocument, "pointerup", this._onDrop);
            off(ownerDocument, "touchcancel", this._onDrop);
            off(document, "selectstart", this);
          },
          _onDrop: function _onDrop(evt) {
            var el = this.el, options = this.options;
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            pluginEvent("drop", this, {
              evt
            });
            parentEl = dragEl && dragEl.parentNode;
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            if (Sortable.eventCanceled) {
              this._nulling();
              return;
            }
            awaitingDragStarted = false;
            isCircumstantialInvert = false;
            pastFirstInvertThresh = false;
            clearInterval(this._loopId);
            clearTimeout(this._dragStartTimer);
            _cancelNextTick(this.cloneId);
            _cancelNextTick(this._dragStartId);
            if (this.nativeDraggable) {
              off(document, "drop", this);
              off(el, "dragstart", this._onDragStart);
            }
            this._offMoveEvents();
            this._offUpEvents();
            if (Safari) {
              css(document.body, "user-select", "");
            }
            css(dragEl, "transform", "");
            if (evt) {
              if (moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
              }
              ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
              if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
                cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
              }
              if (dragEl) {
                if (this.nativeDraggable) {
                  off(dragEl, "dragend", this);
                }
                _disableDraggable(dragEl);
                dragEl.style["will-change"] = "";
                if (moved && !awaitingDragStarted) {
                  toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                }
                toggleClass(dragEl, this.options.chosenClass, false);
                _dispatchEvent({
                  sortable: this,
                  name: "unchoose",
                  toEl: parentEl,
                  newIndex: null,
                  newDraggableIndex: null,
                  originalEvent: evt
                });
                if (rootEl !== parentEl) {
                  if (newIndex >= 0) {
                    _dispatchEvent({
                      rootEl: parentEl,
                      name: "add",
                      toEl: parentEl,
                      fromEl: rootEl,
                      originalEvent: evt
                    });
                    _dispatchEvent({
                      sortable: this,
                      name: "remove",
                      toEl: parentEl,
                      originalEvent: evt
                    });
                    _dispatchEvent({
                      rootEl: parentEl,
                      name: "sort",
                      toEl: parentEl,
                      fromEl: rootEl,
                      originalEvent: evt
                    });
                    _dispatchEvent({
                      sortable: this,
                      name: "sort",
                      toEl: parentEl,
                      originalEvent: evt
                    });
                  }
                  putSortable && putSortable.save();
                } else {
                  if (newIndex !== oldIndex) {
                    if (newIndex >= 0) {
                      _dispatchEvent({
                        sortable: this,
                        name: "update",
                        toEl: parentEl,
                        originalEvent: evt
                      });
                      _dispatchEvent({
                        sortable: this,
                        name: "sort",
                        toEl: parentEl,
                        originalEvent: evt
                      });
                    }
                  }
                }
                if (Sortable.active) {
                  if (newIndex == null || newIndex === -1) {
                    newIndex = oldIndex;
                    newDraggableIndex = oldDraggableIndex;
                  }
                  _dispatchEvent({
                    sortable: this,
                    name: "end",
                    toEl: parentEl,
                    originalEvent: evt
                  });
                  this.save();
                }
              }
            }
            this._nulling();
          },
          _nulling: function _nulling() {
            pluginEvent("nulling", this);
            rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
            savedInputChecked.forEach(function(el) {
              el.checked = true;
            });
            savedInputChecked.length = lastDx = lastDy = 0;
          },
          handleEvent: function handleEvent(evt) {
            switch (evt.type) {
              case "drop":
              case "dragend":
                this._onDrop(evt);
                break;
              case "dragenter":
              case "dragover":
                if (dragEl) {
                  this._onDragOver(evt);
                  _globalDragOver(evt);
                }
                break;
              case "selectstart":
                evt.preventDefault();
                break;
            }
          },
          /**
           * Serializes the item into an array of string.
           * @returns {String[]}
           */
          toArray: function toArray() {
            var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
            for (; i < n; i++) {
              el = children[i];
              if (closest(el, options.draggable, this.el, false)) {
                order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
              }
            }
            return order;
          },
          /**
           * Sorts the elements according to the array.
           * @param  {String[]}  order  order of the items
           */
          sort: function sort(order) {
            var items = {}, rootEl2 = this.el;
            this.toArray().forEach(function(id, i) {
              var el = rootEl2.children[i];
              if (closest(el, this.options.draggable, rootEl2, false)) {
                items[id] = el;
              }
            }, this);
            order.forEach(function(id) {
              if (items[id]) {
                rootEl2.removeChild(items[id]);
                rootEl2.appendChild(items[id]);
              }
            });
          },
          /**
           * Save the current sorting
           */
          save: function save() {
            var store = this.options.store;
            store && store.set && store.set(this);
          },
          /**
           * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
           * @param   {HTMLElement}  el
           * @param   {String}       [selector]  default: `options.draggable`
           * @returns {HTMLElement|null}
           */
          closest: function closest$1(el, selector) {
            return closest(el, selector || this.options.draggable, this.el, false);
          },
          /**
           * Set/get option
           * @param   {string} name
           * @param   {*}      [value]
           * @returns {*}
           */
          option: function option(name, value) {
            var options = this.options;
            if (value === void 0) {
              return options[name];
            } else {
              var modifiedValue = PluginManager.modifyOption(this, name, value);
              if (typeof modifiedValue !== "undefined") {
                options[name] = modifiedValue;
              } else {
                options[name] = value;
              }
              if (name === "group") {
                _prepareGroup(options);
              }
            }
          },
          /**
           * Destroy
           */
          destroy: function destroy() {
            pluginEvent("destroy", this);
            var el = this.el;
            el[expando] = null;
            off(el, "mousedown", this._onTapStart);
            off(el, "touchstart", this._onTapStart);
            off(el, "pointerdown", this._onTapStart);
            if (this.nativeDraggable) {
              off(el, "dragover", this);
              off(el, "dragenter", this);
            }
            Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
              el2.removeAttribute("draggable");
            });
            this._onDrop();
            this._disableDelayedDragEvents();
            sortables.splice(sortables.indexOf(this.el), 1);
            this.el = el = null;
          },
          _hideClone: function _hideClone() {
            if (!cloneHidden) {
              pluginEvent("hideClone", this);
              if (Sortable.eventCanceled)
                return;
              css(cloneEl, "display", "none");
              if (this.options.removeCloneOnHide && cloneEl.parentNode) {
                cloneEl.parentNode.removeChild(cloneEl);
              }
              cloneHidden = true;
            }
          },
          _showClone: function _showClone(putSortable2) {
            if (putSortable2.lastPutMode !== "clone") {
              this._hideClone();
              return;
            }
            if (cloneHidden) {
              pluginEvent("showClone", this);
              if (Sortable.eventCanceled)
                return;
              if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
                rootEl.insertBefore(cloneEl, dragEl);
              } else if (nextEl) {
                rootEl.insertBefore(cloneEl, nextEl);
              } else {
                rootEl.appendChild(cloneEl);
              }
              if (this.options.group.revertClone) {
                this.animate(dragEl, cloneEl);
              }
              css(cloneEl, "display", "");
              cloneHidden = false;
            }
          }
        };
        function _globalDragOver(evt) {
          if (evt.dataTransfer) {
            evt.dataTransfer.dropEffect = "move";
          }
          evt.cancelable && evt.preventDefault();
        }
        function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
          var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
          if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent("move", {
              bubbles: true,
              cancelable: true
            });
          } else {
            evt = document.createEvent("Event");
            evt.initEvent("move", true, true);
          }
          evt.to = toEl;
          evt.from = fromEl;
          evt.dragged = dragEl2;
          evt.draggedRect = dragRect;
          evt.related = targetEl || toEl;
          evt.relatedRect = targetRect || getRect(toEl);
          evt.willInsertAfter = willInsertAfter;
          evt.originalEvent = originalEvent;
          fromEl.dispatchEvent(evt);
          if (onMoveFn) {
            retVal = onMoveFn.call(sortable, evt, originalEvent);
          }
          return retVal;
        }
        function _disableDraggable(el) {
          el.draggable = false;
        }
        function _unsilent() {
          _silent = false;
        }
        function _ghostIsLast(evt, vertical, sortable) {
          var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
          var spacer = 10;
          return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
        }
        function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
          var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
          if (!invertSwap) {
            if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
              if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
                pastFirstInvertThresh = true;
              }
              if (!pastFirstInvertThresh) {
                if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
                  return -lastDirection;
                }
              } else {
                invert = true;
              }
            } else {
              if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
                return _getInsertDirection(target);
              }
            }
          }
          invert = invert || invertSwap;
          if (invert) {
            if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
              return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
            }
          }
          return 0;
        }
        function _getInsertDirection(target) {
          if (index(dragEl) < index(target)) {
            return 1;
          } else {
            return -1;
          }
        }
        function _generateId(el) {
          var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
          while (i--) {
            sum += str.charCodeAt(i);
          }
          return sum.toString(36);
        }
        function _saveInputCheckedState(root) {
          savedInputChecked.length = 0;
          var inputs = root.getElementsByTagName("input");
          var idx = inputs.length;
          while (idx--) {
            var el = inputs[idx];
            el.checked && savedInputChecked.push(el);
          }
        }
        function _nextTick(fn) {
          return setTimeout(fn, 0);
        }
        function _cancelNextTick(id) {
          return clearTimeout(id);
        }
        if (documentExists) {
          on(document, "touchmove", function(evt) {
            if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
              evt.preventDefault();
            }
          });
        }
        Sortable.utils = {
          on,
          off,
          css,
          find,
          is: function is(el, selector) {
            return !!closest(el, selector, el, false);
          },
          extend,
          throttle,
          closest,
          toggleClass,
          clone,
          index,
          nextTick: _nextTick,
          cancelNextTick: _cancelNextTick,
          detectDirection: _detectDirection,
          getChild
        };
        Sortable.get = function(element) {
          return element[expando];
        };
        Sortable.mount = function() {
          for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
            plugins2[_key] = arguments[_key];
          }
          if (plugins2[0].constructor === Array)
            plugins2 = plugins2[0];
          plugins2.forEach(function(plugin) {
            if (!plugin.prototype || !plugin.prototype.constructor) {
              throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
            }
            if (plugin.utils)
              Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
            PluginManager.mount(plugin);
          });
        };
        Sortable.create = function(el, options) {
          return new Sortable(el, options);
        };
        Sortable.version = version;
        var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
        function AutoScrollPlugin() {
          function AutoScroll() {
            this.defaults = {
              scroll: true,
              scrollSensitivity: 30,
              scrollSpeed: 10,
              bubbleScroll: true
            };
            for (var fn in this) {
              if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
                this[fn] = this[fn].bind(this);
              }
            }
          }
          AutoScroll.prototype = {
            dragStarted: function dragStarted2(_ref) {
              var originalEvent = _ref.originalEvent;
              if (this.sortable.nativeDraggable) {
                on(document, "dragover", this._handleAutoScroll);
              } else {
                if (this.options.supportPointer) {
                  on(document, "pointermove", this._handleFallbackAutoScroll);
                } else if (originalEvent.touches) {
                  on(document, "touchmove", this._handleFallbackAutoScroll);
                } else {
                  on(document, "mousemove", this._handleFallbackAutoScroll);
                }
              }
            },
            dragOverCompleted: function dragOverCompleted(_ref2) {
              var originalEvent = _ref2.originalEvent;
              if (!this.options.dragOverBubble && !originalEvent.rootEl) {
                this._handleAutoScroll(originalEvent);
              }
            },
            drop: function drop2() {
              if (this.sortable.nativeDraggable) {
                off(document, "dragover", this._handleAutoScroll);
              } else {
                off(document, "pointermove", this._handleFallbackAutoScroll);
                off(document, "touchmove", this._handleFallbackAutoScroll);
                off(document, "mousemove", this._handleFallbackAutoScroll);
              }
              clearPointerElemChangedInterval();
              clearAutoScrolls();
              cancelThrottle();
            },
            nulling: function nulling() {
              touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
              autoScrolls.length = 0;
            },
            _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
              this._handleAutoScroll(evt, true);
            },
            _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
              var _this = this;
              var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
              touchEvt$1 = evt;
              if (fallback || Edge || IE11OrLess || Safari) {
                autoScroll(evt, this.options, elem, fallback);
                var ogElemScroller = getParentAutoScrollElement(elem, true);
                if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                  pointerElemChangedInterval && clearPointerElemChangedInterval();
                  pointerElemChangedInterval = setInterval(function() {
                    var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                    if (newElem !== ogElemScroller) {
                      ogElemScroller = newElem;
                      clearAutoScrolls();
                    }
                    autoScroll(evt, _this.options, newElem, fallback);
                  }, 10);
                  lastAutoScrollX = x;
                  lastAutoScrollY = y;
                }
              } else {
                if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                  clearAutoScrolls();
                  return;
                }
                autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
              }
            }
          };
          return _extends(AutoScroll, {
            pluginName: "scroll",
            initializeByDefault: true
          });
        }
        function clearAutoScrolls() {
          autoScrolls.forEach(function(autoScroll2) {
            clearInterval(autoScroll2.pid);
          });
          autoScrolls = [];
        }
        function clearPointerElemChangedInterval() {
          clearInterval(pointerElemChangedInterval);
        }
        var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
          if (!options.scroll)
            return;
          var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
          var scrollThisInstance = false, scrollCustomFn;
          if (scrollRootEl !== rootEl2) {
            scrollRootEl = rootEl2;
            clearAutoScrolls();
            scrollEl = options.scroll;
            scrollCustomFn = options.scrollFn;
            if (scrollEl === true) {
              scrollEl = getParentAutoScrollElement(rootEl2, true);
            }
          }
          var layersOut = 0;
          var currentParent = scrollEl;
          do {
            var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
            if (el === winScroller) {
              canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
              canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
            } else {
              canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
              canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
            }
            var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
            var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
            if (!autoScrolls[layersOut]) {
              for (var i = 0; i <= layersOut; i++) {
                if (!autoScrolls[i]) {
                  autoScrolls[i] = {};
                }
              }
            }
            if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
              autoScrolls[layersOut].el = el;
              autoScrolls[layersOut].vx = vx;
              autoScrolls[layersOut].vy = vy;
              clearInterval(autoScrolls[layersOut].pid);
              if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                autoScrolls[layersOut].pid = setInterval(function() {
                  if (isFallback && this.layer === 0) {
                    Sortable.active._onTouchMove(touchEvt$1);
                  }
                  var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                  var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
                  if (typeof scrollCustomFn === "function") {
                    if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
                      return;
                    }
                  }
                  scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }.bind({
                  layer: layersOut
                }), 24);
              }
            }
            layersOut++;
          } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
          scrolling = scrollThisInstance;
        }, 30);
        var drop = function drop2(_ref) {
          var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
          if (!originalEvent)
            return;
          var toSortable = putSortable2 || activeSortable;
          hideGhostForTarget();
          var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
          var target = document.elementFromPoint(touch.clientX, touch.clientY);
          unhideGhostForTarget();
          if (toSortable && !toSortable.el.contains(target)) {
            dispatchSortableEvent("spill");
            this.onSpill({
              dragEl: dragEl2,
              putSortable: putSortable2
            });
          }
        };
        function Revert() {
        }
        Revert.prototype = {
          startIndex: null,
          dragStart: function dragStart(_ref2) {
            var oldDraggableIndex2 = _ref2.oldDraggableIndex;
            this.startIndex = oldDraggableIndex2;
          },
          onSpill: function onSpill(_ref3) {
            var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
            this.sortable.captureAnimationState();
            if (putSortable2) {
              putSortable2.captureAnimationState();
            }
            var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
            if (nextSibling) {
              this.sortable.el.insertBefore(dragEl2, nextSibling);
            } else {
              this.sortable.el.appendChild(dragEl2);
            }
            this.sortable.animateAll();
            if (putSortable2) {
              putSortable2.animateAll();
            }
          },
          drop
        };
        _extends(Revert, {
          pluginName: "revertOnSpill"
        });
        function Remove() {
        }
        Remove.prototype = {
          onSpill: function onSpill(_ref4) {
            var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
            var parentSortable = putSortable2 || this.sortable;
            parentSortable.captureAnimationState();
            dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
            parentSortable.animateAll();
          },
          drop
        };
        _extends(Remove, {
          pluginName: "removeOnSpill"
        });
        var lastSwapEl;
        function SwapPlugin() {
          function Swap() {
            this.defaults = {
              swapClass: "sortable-swap-highlight"
            };
          }
          Swap.prototype = {
            dragStart: function dragStart(_ref) {
              var dragEl2 = _ref.dragEl;
              lastSwapEl = dragEl2;
            },
            dragOverValid: function dragOverValid(_ref2) {
              var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
              if (!activeSortable.options.swap)
                return;
              var el = this.sortable.el, options = this.options;
              if (target && target !== el) {
                var prevSwapEl = lastSwapEl;
                if (onMove(target) !== false) {
                  toggleClass(target, options.swapClass, true);
                  lastSwapEl = target;
                } else {
                  lastSwapEl = null;
                }
                if (prevSwapEl && prevSwapEl !== lastSwapEl) {
                  toggleClass(prevSwapEl, options.swapClass, false);
                }
              }
              changed();
              completed(true);
              cancel();
            },
            drop: function drop2(_ref3) {
              var activeSortable = _ref3.activeSortable, putSortable2 = _ref3.putSortable, dragEl2 = _ref3.dragEl;
              var toSortable = putSortable2 || this.sortable;
              var options = this.options;
              lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
              if (lastSwapEl && (options.swap || putSortable2 && putSortable2.options.swap)) {
                if (dragEl2 !== lastSwapEl) {
                  toSortable.captureAnimationState();
                  if (toSortable !== activeSortable)
                    activeSortable.captureAnimationState();
                  swapNodes(dragEl2, lastSwapEl);
                  toSortable.animateAll();
                  if (toSortable !== activeSortable)
                    activeSortable.animateAll();
                }
              }
            },
            nulling: function nulling() {
              lastSwapEl = null;
            }
          };
          return _extends(Swap, {
            pluginName: "swap",
            eventProperties: function eventProperties() {
              return {
                swapItem: lastSwapEl
              };
            }
          });
        }
        function swapNodes(n1, n2) {
          var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
          if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1))
            return;
          i1 = index(n1);
          i2 = index(n2);
          if (p1.isEqualNode(p2) && i1 < i2) {
            i2++;
          }
          p1.insertBefore(n2, p1.children[i1]);
          p2.insertBefore(n1, p2.children[i2]);
        }
        var multiDragElements = [], multiDragClones = [], lastMultiDragSelect, multiDragSortable, initialFolding = false, folding = false, dragStarted = false, dragEl$1, clonesFromRect, clonesHidden;
        function MultiDragPlugin() {
          function MultiDrag(sortable) {
            for (var fn in this) {
              if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
                this[fn] = this[fn].bind(this);
              }
            }
            if (sortable.options.supportPointer) {
              on(document, "pointerup", this._deselectMultiDrag);
            } else {
              on(document, "mouseup", this._deselectMultiDrag);
              on(document, "touchend", this._deselectMultiDrag);
            }
            on(document, "keydown", this._checkKeyDown);
            on(document, "keyup", this._checkKeyUp);
            this.defaults = {
              selectedClass: "sortable-selected",
              multiDragKey: null,
              setData: function setData(dataTransfer, dragEl2) {
                var data = "";
                if (multiDragElements.length && multiDragSortable === sortable) {
                  multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                  });
                } else {
                  data = dragEl2.textContent;
                }
                dataTransfer.setData("Text", data);
              }
            };
          }
          MultiDrag.prototype = {
            multiDragKeyDown: false,
            isMultiDrag: false,
            delayStartGlobal: function delayStartGlobal(_ref) {
              var dragged = _ref.dragEl;
              dragEl$1 = dragged;
            },
            delayEnded: function delayEnded() {
              this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
            },
            setupClone: function setupClone(_ref2) {
              var sortable = _ref2.sortable, cancel = _ref2.cancel;
              if (!this.isMultiDrag)
                return;
              for (var i = 0; i < multiDragElements.length; i++) {
                multiDragClones.push(clone(multiDragElements[i]));
                multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                multiDragClones[i].draggable = false;
                multiDragClones[i].style["will-change"] = "";
                toggleClass(multiDragClones[i], this.options.selectedClass, false);
                multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
              }
              sortable._hideClone();
              cancel();
            },
            clone: function clone2(_ref3) {
              var sortable = _ref3.sortable, rootEl2 = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
              if (!this.isMultiDrag)
                return;
              if (!this.options.removeCloneOnHide) {
                if (multiDragElements.length && multiDragSortable === sortable) {
                  insertMultiDragClones(true, rootEl2);
                  dispatchSortableEvent("clone");
                  cancel();
                }
              }
            },
            showClone: function showClone(_ref4) {
              var cloneNowShown = _ref4.cloneNowShown, rootEl2 = _ref4.rootEl, cancel = _ref4.cancel;
              if (!this.isMultiDrag)
                return;
              insertMultiDragClones(false, rootEl2);
              multiDragClones.forEach(function(clone2) {
                css(clone2, "display", "");
              });
              cloneNowShown();
              clonesHidden = false;
              cancel();
            },
            hideClone: function hideClone(_ref5) {
              var _this = this;
              var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
              if (!this.isMultiDrag)
                return;
              multiDragClones.forEach(function(clone2) {
                css(clone2, "display", "none");
                if (_this.options.removeCloneOnHide && clone2.parentNode) {
                  clone2.parentNode.removeChild(clone2);
                }
              });
              cloneNowHidden();
              clonesHidden = true;
              cancel();
            },
            dragStartGlobal: function dragStartGlobal(_ref6) {
              var sortable = _ref6.sortable;
              if (!this.isMultiDrag && multiDragSortable) {
                multiDragSortable.multiDrag._deselectMultiDrag();
              }
              multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = index(multiDragElement);
              });
              multiDragElements = multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
              });
              dragStarted = true;
            },
            dragStarted: function dragStarted2(_ref7) {
              var _this2 = this;
              var sortable = _ref7.sortable;
              if (!this.isMultiDrag)
                return;
              if (this.options.sort) {
                sortable.captureAnimationState();
                if (this.options.animation) {
                  multiDragElements.forEach(function(multiDragElement) {
                    if (multiDragElement === dragEl$1)
                      return;
                    css(multiDragElement, "position", "absolute");
                  });
                  var dragRect = getRect(dragEl$1, false, true, true);
                  multiDragElements.forEach(function(multiDragElement) {
                    if (multiDragElement === dragEl$1)
                      return;
                    setRect(multiDragElement, dragRect);
                  });
                  folding = true;
                  initialFolding = true;
                }
              }
              sortable.animateAll(function() {
                folding = false;
                initialFolding = false;
                if (_this2.options.animation) {
                  multiDragElements.forEach(function(multiDragElement) {
                    unsetRect(multiDragElement);
                  });
                }
                if (_this2.options.sort) {
                  removeMultiDragElements();
                }
              });
            },
            dragOver: function dragOver(_ref8) {
              var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
              if (folding && ~multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
              }
            },
            revert: function revert(_ref9) {
              var fromSortable = _ref9.fromSortable, rootEl2 = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
              if (multiDragElements.length > 1) {
                multiDragElements.forEach(function(multiDragElement) {
                  sortable.addAnimationState({
                    target: multiDragElement,
                    rect: folding ? getRect(multiDragElement) : dragRect
                  });
                  unsetRect(multiDragElement);
                  multiDragElement.fromRect = dragRect;
                  fromSortable.removeAnimationState(multiDragElement);
                });
                folding = false;
                insertMultiDragElements(!this.options.removeCloneOnHide, rootEl2);
              }
            },
            dragOverCompleted: function dragOverCompleted(_ref10) {
              var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl2 = _ref10.parentEl, putSortable2 = _ref10.putSortable;
              var options = this.options;
              if (insertion) {
                if (isOwner) {
                  activeSortable._hideClone();
                }
                initialFolding = false;
                if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable2)) {
                  var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                  multiDragElements.forEach(function(multiDragElement) {
                    if (multiDragElement === dragEl$1)
                      return;
                    setRect(multiDragElement, dragRectAbsolute);
                    parentEl2.appendChild(multiDragElement);
                  });
                  folding = true;
                }
                if (!isOwner) {
                  if (!folding) {
                    removeMultiDragElements();
                  }
                  if (multiDragElements.length > 1) {
                    var clonesHiddenBefore = clonesHidden;
                    activeSortable._showClone(sortable);
                    if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                      multiDragClones.forEach(function(clone2) {
                        activeSortable.addAnimationState({
                          target: clone2,
                          rect: clonesFromRect
                        });
                        clone2.fromRect = clonesFromRect;
                        clone2.thisAnimationDuration = null;
                      });
                    }
                  } else {
                    activeSortable._showClone(sortable);
                  }
                }
              }
            },
            dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
              var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
              multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
              });
              if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                clonesFromRect = _extends({}, dragRect);
                var dragMatrix = matrix(dragEl$1, true);
                clonesFromRect.top -= dragMatrix.f;
                clonesFromRect.left -= dragMatrix.e;
              }
            },
            dragOverAnimationComplete: function dragOverAnimationComplete() {
              if (folding) {
                folding = false;
                removeMultiDragElements();
              }
            },
            drop: function drop2(_ref12) {
              var evt = _ref12.originalEvent, rootEl2 = _ref12.rootEl, parentEl2 = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex2 = _ref12.oldIndex, putSortable2 = _ref12.putSortable;
              var toSortable = putSortable2 || this.sortable;
              if (!evt)
                return;
              var options = this.options, children = parentEl2.children;
              if (!dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) {
                  this._deselectMultiDrag();
                }
                toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
                if (!~multiDragElements.indexOf(dragEl$1)) {
                  multiDragElements.push(dragEl$1);
                  dispatchEvent({
                    sortable,
                    rootEl: rootEl2,
                    name: "select",
                    targetEl: dragEl$1,
                    originalEvt: evt
                  });
                  if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                    var lastIndex = index(lastMultiDragSelect), currentIndex = index(dragEl$1);
                    if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                      var n, i;
                      if (currentIndex > lastIndex) {
                        i = lastIndex;
                        n = currentIndex;
                      } else {
                        i = currentIndex;
                        n = lastIndex + 1;
                      }
                      for (; i < n; i++) {
                        if (~multiDragElements.indexOf(children[i]))
                          continue;
                        toggleClass(children[i], options.selectedClass, true);
                        multiDragElements.push(children[i]);
                        dispatchEvent({
                          sortable,
                          rootEl: rootEl2,
                          name: "select",
                          targetEl: children[i],
                          originalEvt: evt
                        });
                      }
                    }
                  } else {
                    lastMultiDragSelect = dragEl$1;
                  }
                  multiDragSortable = toSortable;
                } else {
                  multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                  lastMultiDragSelect = null;
                  dispatchEvent({
                    sortable,
                    rootEl: rootEl2,
                    name: "deselect",
                    targetEl: dragEl$1,
                    originalEvt: evt
                  });
                }
              }
              if (dragStarted && this.isMultiDrag) {
                if ((parentEl2[expando].options.sort || parentEl2 !== rootEl2) && multiDragElements.length > 1) {
                  var dragRect = getRect(dragEl$1), multiDragIndex = index(dragEl$1, ":not(." + this.options.selectedClass + ")");
                  if (!initialFolding && options.animation)
                    dragEl$1.thisAnimationDuration = null;
                  toSortable.captureAnimationState();
                  if (!initialFolding) {
                    if (options.animation) {
                      dragEl$1.fromRect = dragRect;
                      multiDragElements.forEach(function(multiDragElement) {
                        multiDragElement.thisAnimationDuration = null;
                        if (multiDragElement !== dragEl$1) {
                          var rect = folding ? getRect(multiDragElement) : dragRect;
                          multiDragElement.fromRect = rect;
                          toSortable.addAnimationState({
                            target: multiDragElement,
                            rect
                          });
                        }
                      });
                    }
                    removeMultiDragElements();
                    multiDragElements.forEach(function(multiDragElement) {
                      if (children[multiDragIndex]) {
                        parentEl2.insertBefore(multiDragElement, children[multiDragIndex]);
                      } else {
                        parentEl2.appendChild(multiDragElement);
                      }
                      multiDragIndex++;
                    });
                    if (oldIndex2 === index(dragEl$1)) {
                      var update = false;
                      multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                          update = true;
                          return;
                        }
                      });
                      if (update) {
                        dispatchSortableEvent("update");
                      }
                    }
                  }
                  multiDragElements.forEach(function(multiDragElement) {
                    unsetRect(multiDragElement);
                  });
                  toSortable.animateAll();
                }
                multiDragSortable = toSortable;
              }
              if (rootEl2 === parentEl2 || putSortable2 && putSortable2.lastPutMode !== "clone") {
                multiDragClones.forEach(function(clone2) {
                  clone2.parentNode && clone2.parentNode.removeChild(clone2);
                });
              }
            },
            nullingGlobal: function nullingGlobal() {
              this.isMultiDrag = dragStarted = false;
              multiDragClones.length = 0;
            },
            destroyGlobal: function destroyGlobal() {
              this._deselectMultiDrag();
              off(document, "pointerup", this._deselectMultiDrag);
              off(document, "mouseup", this._deselectMultiDrag);
              off(document, "touchend", this._deselectMultiDrag);
              off(document, "keydown", this._checkKeyDown);
              off(document, "keyup", this._checkKeyUp);
            },
            _deselectMultiDrag: function _deselectMultiDrag(evt) {
              if (typeof dragStarted !== "undefined" && dragStarted)
                return;
              if (multiDragSortable !== this.sortable)
                return;
              if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false))
                return;
              if (evt && evt.button !== 0)
                return;
              while (multiDragElements.length) {
                var el = multiDragElements[0];
                toggleClass(el, this.options.selectedClass, false);
                multiDragElements.shift();
                dispatchEvent({
                  sortable: this.sortable,
                  rootEl: this.sortable.el,
                  name: "deselect",
                  targetEl: el,
                  originalEvt: evt
                });
              }
            },
            _checkKeyDown: function _checkKeyDown(evt) {
              if (evt.key === this.options.multiDragKey) {
                this.multiDragKeyDown = true;
              }
            },
            _checkKeyUp: function _checkKeyUp(evt) {
              if (evt.key === this.options.multiDragKey) {
                this.multiDragKeyDown = false;
              }
            }
          };
          return _extends(MultiDrag, {
            // Static methods & properties
            pluginName: "multiDrag",
            utils: {
              /**
               * Selects the provided multi-drag item
               * @param  {HTMLElement} el    The element to be selected
               */
              select: function select(el) {
                var sortable = el.parentNode[expando];
                if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el))
                  return;
                if (multiDragSortable && multiDragSortable !== sortable) {
                  multiDragSortable.multiDrag._deselectMultiDrag();
                  multiDragSortable = sortable;
                }
                toggleClass(el, sortable.options.selectedClass, true);
                multiDragElements.push(el);
              },
              /**
               * Deselects the provided multi-drag item
               * @param  {HTMLElement} el    The element to be deselected
               */
              deselect: function deselect(el) {
                var sortable = el.parentNode[expando], index2 = multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index2)
                  return;
                toggleClass(el, sortable.options.selectedClass, false);
                multiDragElements.splice(index2, 1);
              }
            },
            eventProperties: function eventProperties() {
              var _this3 = this;
              var oldIndicies = [], newIndicies = [];
              multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                  multiDragElement,
                  index: multiDragElement.sortableIndex
                });
                var newIndex2;
                if (folding && multiDragElement !== dragEl$1) {
                  newIndex2 = -1;
                } else if (folding) {
                  newIndex2 = index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                } else {
                  newIndex2 = index(multiDragElement);
                }
                newIndicies.push({
                  multiDragElement,
                  index: newIndex2
                });
              });
              return {
                items: _toConsumableArray(multiDragElements),
                clones: [].concat(multiDragClones),
                oldIndicies,
                newIndicies
              };
            },
            optionListeners: {
              multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") {
                  key = "Control";
                } else if (key.length > 1) {
                  key = key.charAt(0).toUpperCase() + key.substr(1);
                }
                return key;
              }
            }
          });
        }
        function insertMultiDragElements(clonesInserted, rootEl2) {
          multiDragElements.forEach(function(multiDragElement, i) {
            var target = rootEl2.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
            if (target) {
              rootEl2.insertBefore(multiDragElement, target);
            } else {
              rootEl2.appendChild(multiDragElement);
            }
          });
        }
        function insertMultiDragClones(elementsInserted, rootEl2) {
          multiDragClones.forEach(function(clone2, i) {
            var target = rootEl2.children[clone2.sortableIndex + (elementsInserted ? Number(i) : 0)];
            if (target) {
              rootEl2.insertBefore(clone2, target);
            } else {
              rootEl2.appendChild(clone2);
            }
          });
        }
        function removeMultiDragElements() {
          multiDragElements.forEach(function(multiDragElement) {
            if (multiDragElement === dragEl$1)
              return;
            multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
          });
        }
        Sortable.mount(new AutoScrollPlugin());
        Sortable.mount(Remove, Revert);
        Sortable.mount(new SwapPlugin());
        Sortable.mount(new MultiDragPlugin());
        return Sortable;
      });
    }
  });

  // resources/js/common.js
  window.$ = require_jquery();
  window.jQuery = window.$;
  require_jquery_dependents();
  window.ich = require_ICanHaz();
  window.Sortable = require_Sortable();
})();
/*! Bundled license information:

jquery/dist/jquery.js:
  (*!
   * jQuery JavaScript Library v1.11.2
   * http://jquery.com/
   *
   * Includes Sizzle.js
   * http://sizzlejs.com/
   *
   * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
   * Released under the MIT license
   * http://jquery.org/license
   *
   * Date: 2014-12-17T15:27Z
   *)

bootstrap-sass/assets/javascripts/bootstrap.js:
  (*!
   * Bootstrap v3.4.1 (https://getbootstrap.com/)
   * Copyright 2011-2019 Twitter, Inc.
   * Licensed under the MIT license
   *)

parsleyjs/dist/parsley.js:
  (*!
  * Parsley.js
  * Version 2.9.2 - built Tue, Dec 10th 2019, 6:18 pm
  * http://parsleyjs.org
  * Guillaume Potier - <guillaume@wisembly.com>
  * Marc-Andre Lafortune - <petroselinum@marc-andre.ca>
  * MIT Licensed
  *)

jstree/dist/jstree.js:
  (*!
   * jsTree 3.3.10
   * http://jstree.com/
   *
   * Copyright (c) 2014 Ivan Bozhanov (http://vakata.com)
   *
   * Licensed same as jquery - under the terms of the MIT License
   *   http://www.opensource.org/licenses/mit-license.php
   *)
  (*!
   * if using jslint please allow for the jQuery global and use following options:
   * jslint: loopfunc: true, browser: true, ass: true, bitwise: true, continue: true, nomen: true, plusplus: true, regexp: true, unparam: true, todo: true, white: true
   *)
  (*!
  oi = obj.children("i:visible"),
  ai = a.children("i:visible"),
  w1 = oi.width() * oi.length,
  w2 = ai.width() * ai.length,
  *)
  (*!
  if(!('oncontextmenu' in document.body) && ('ontouchstart' in document.body)) {
  	var el = null, tm = null;
  	this.element
  		.on("touchstart", ".jstree-anchor", function (e) {
  			el = e.currentTarget;
  			tm = +new Date();
  			$(document).one("touchend", function (e) {
  				e.target = document.elementFromPoint(e.originalEvent.targetTouches[0].pageX - window.pageXOffset, e.originalEvent.targetTouches[0].pageY - window.pageYOffset);
  				e.currentTarget = e.target;
  				tm = ((+(new Date())) - tm);
  				if(e.target === el && tm > 600 && tm < 1000) {
  					e.preventDefault();
  					$(el).trigger('contextmenu', e);
  				}
  				el = null;
  				tm = null;
  			});
  		});
  }
  *)

blueimp-file-upload/js/vendor/jquery.ui.widget.js:
  (*! jQuery UI - v1.12.1+0b7246b6eeadfa9e2696e22f3230f6452f8129dc - 2020-02-20
   * http://jqueryui.com
   * Includes: widget.js
   * Copyright jQuery Foundation and other contributors; Licensed MIT *)
  (*!
   * jQuery UI Widget 1.12.1
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *)

icanhaz/ICanHaz.js:
  (*!
  ICanHaz.js version 0.10.2 -- by @HenrikJoreteg
  More info at: http://icanhazjs.com
  *)
  (*!
    ICanHaz.js -- by @HenrikJoreteg
  *)

sortablejs/Sortable.js:
  (**!
   * Sortable 1.10.2
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   *)
*/
